/**
 * Auto-generated icon exports for lucide and prismacide icons
 * Generated on: 2025-09-23T14:16:44.911Z
 * Total icons: 1630 (1628 lucide, 2 prismacide)
 *
 * This file provides named exports for all available icons wrapped with the Icon component
 * Usage: import { SettingsIcon, UserIcon } from 'src/components/media-and-icons/icons'
 */

import { Icon, type IconProps } from 'src/components/media-and-icons/icon';

import { default as DefaultAArrowDownIcon } from '~icons/lucide/a-arrow-down';

/**
 * @see https://lucide.dev/icons/a-arrow-down
 */
export const AArrowDownIcon = (props: IconProps) => (
  <Icon icon={DefaultAArrowDownIcon} {...props} />
);

import { default as DefaultAArrowUpIcon } from '~icons/lucide/a-arrow-up';

/**
 * @see https://lucide.dev/icons/a-arrow-up
 */
export const AArrowUpIcon = (props: IconProps) => (
  <Icon icon={DefaultAArrowUpIcon} {...props} />
);

import { default as DefaultALargeSmallIcon } from '~icons/lucide/a-large-small';

/**
 * @see https://lucide.dev/icons/a-large-small
 */
export const ALargeSmallIcon = (props: IconProps) => (
  <Icon icon={DefaultALargeSmallIcon} {...props} />
);

import { default as DefaultAccessibilityIcon } from '~icons/lucide/accessibility';

/**
 * @see https://lucide.dev/icons/accessibility
 */
export const AccessibilityIcon = (props: IconProps) => (
  <Icon icon={DefaultAccessibilityIcon} {...props} />
);

import { default as DefaultActivityIcon } from '~icons/lucide/activity';

/**
 * @see https://lucide.dev/icons/activity
 */
export const ActivityIcon = (props: IconProps) => (
  <Icon icon={DefaultActivityIcon} {...props} />
);

import { default as DefaultAirVentIcon } from '~icons/lucide/air-vent';

/**
 * @see https://lucide.dev/icons/air-vent
 */
export const AirVentIcon = (props: IconProps) => (
  <Icon icon={DefaultAirVentIcon} {...props} />
);

import { default as DefaultAirplayIcon } from '~icons/lucide/airplay';

/**
 * @see https://lucide.dev/icons/airplay
 */
export const AirplayIcon = (props: IconProps) => (
  <Icon icon={DefaultAirplayIcon} {...props} />
);

import { default as DefaultAlarmClockIcon } from '~icons/lucide/alarm-clock';

/**
 * @see https://lucide.dev/icons/alarm-clock
 */
export const AlarmClockIcon = (props: IconProps) => (
  <Icon icon={DefaultAlarmClockIcon} {...props} />
);

import { default as DefaultAlarmClockCheckIcon } from '~icons/lucide/alarm-clock-check';

/**
 * @see https://lucide.dev/icons/alarm-clock-check
 */
export const AlarmClockCheckIcon = (props: IconProps) => (
  <Icon icon={DefaultAlarmClockCheckIcon} {...props} />
);

import { default as DefaultAlarmClockMinusIcon } from '~icons/lucide/alarm-clock-minus';

/**
 * @see https://lucide.dev/icons/alarm-clock-minus
 */
export const AlarmClockMinusIcon = (props: IconProps) => (
  <Icon icon={DefaultAlarmClockMinusIcon} {...props} />
);

import { default as DefaultAlarmClockOffIcon } from '~icons/lucide/alarm-clock-off';

/**
 * @see https://lucide.dev/icons/alarm-clock-off
 */
export const AlarmClockOffIcon = (props: IconProps) => (
  <Icon icon={DefaultAlarmClockOffIcon} {...props} />
);

import { default as DefaultAlarmClockPlusIcon } from '~icons/lucide/alarm-clock-plus';

/**
 * @see https://lucide.dev/icons/alarm-clock-plus
 */
export const AlarmClockPlusIcon = (props: IconProps) => (
  <Icon icon={DefaultAlarmClockPlusIcon} {...props} />
);

import { default as DefaultAlarmSmokeIcon } from '~icons/lucide/alarm-smoke';

/**
 * @see https://lucide.dev/icons/alarm-smoke
 */
export const AlarmSmokeIcon = (props: IconProps) => (
  <Icon icon={DefaultAlarmSmokeIcon} {...props} />
);

import { default as DefaultAlbumIcon } from '~icons/lucide/album';

/**
 * @see https://lucide.dev/icons/album
 */
export const AlbumIcon = (props: IconProps) => (
  <Icon icon={DefaultAlbumIcon} {...props} />
);

import { default as DefaultAlignCenterIcon } from '~icons/lucide/align-center';

/**
 * @see https://lucide.dev/icons/align-center
 */
export const AlignCenterIcon = (props: IconProps) => (
  <Icon icon={DefaultAlignCenterIcon} {...props} />
);

import { default as DefaultAlignCenterHorizontalIcon } from '~icons/lucide/align-center-horizontal';

/**
 * @see https://lucide.dev/icons/align-center-horizontal
 */
export const AlignCenterHorizontalIcon = (props: IconProps) => (
  <Icon icon={DefaultAlignCenterHorizontalIcon} {...props} />
);

import { default as DefaultAlignCenterVerticalIcon } from '~icons/lucide/align-center-vertical';

/**
 * @see https://lucide.dev/icons/align-center-vertical
 */
export const AlignCenterVerticalIcon = (props: IconProps) => (
  <Icon icon={DefaultAlignCenterVerticalIcon} {...props} />
);

import { default as DefaultAlignEndHorizontalIcon } from '~icons/lucide/align-end-horizontal';

/**
 * @see https://lucide.dev/icons/align-end-horizontal
 */
export const AlignEndHorizontalIcon = (props: IconProps) => (
  <Icon icon={DefaultAlignEndHorizontalIcon} {...props} />
);

import { default as DefaultAlignEndVerticalIcon } from '~icons/lucide/align-end-vertical';

/**
 * @see https://lucide.dev/icons/align-end-vertical
 */
export const AlignEndVerticalIcon = (props: IconProps) => (
  <Icon icon={DefaultAlignEndVerticalIcon} {...props} />
);

import { default as DefaultAlignHorizontalDistributeCenterIcon } from '~icons/lucide/align-horizontal-distribute-center';

/**
 * @see https://lucide.dev/icons/align-horizontal-distribute-center
 */
export const AlignHorizontalDistributeCenterIcon = (props: IconProps) => (
  <Icon icon={DefaultAlignHorizontalDistributeCenterIcon} {...props} />
);

import { default as DefaultAlignHorizontalDistributeEndIcon } from '~icons/lucide/align-horizontal-distribute-end';

/**
 * @see https://lucide.dev/icons/align-horizontal-distribute-end
 */
export const AlignHorizontalDistributeEndIcon = (props: IconProps) => (
  <Icon icon={DefaultAlignHorizontalDistributeEndIcon} {...props} />
);

import { default as DefaultAlignHorizontalDistributeStartIcon } from '~icons/lucide/align-horizontal-distribute-start';

/**
 * @see https://lucide.dev/icons/align-horizontal-distribute-start
 */
export const AlignHorizontalDistributeStartIcon = (props: IconProps) => (
  <Icon icon={DefaultAlignHorizontalDistributeStartIcon} {...props} />
);

import { default as DefaultAlignHorizontalJustifyCenterIcon } from '~icons/lucide/align-horizontal-justify-center';

/**
 * @see https://lucide.dev/icons/align-horizontal-justify-center
 */
export const AlignHorizontalJustifyCenterIcon = (props: IconProps) => (
  <Icon icon={DefaultAlignHorizontalJustifyCenterIcon} {...props} />
);

import { default as DefaultAlignHorizontalJustifyEndIcon } from '~icons/lucide/align-horizontal-justify-end';

/**
 * @see https://lucide.dev/icons/align-horizontal-justify-end
 */
export const AlignHorizontalJustifyEndIcon = (props: IconProps) => (
  <Icon icon={DefaultAlignHorizontalJustifyEndIcon} {...props} />
);

import { default as DefaultAlignHorizontalJustifyStartIcon } from '~icons/lucide/align-horizontal-justify-start';

/**
 * @see https://lucide.dev/icons/align-horizontal-justify-start
 */
export const AlignHorizontalJustifyStartIcon = (props: IconProps) => (
  <Icon icon={DefaultAlignHorizontalJustifyStartIcon} {...props} />
);

import { default as DefaultAlignHorizontalSpaceAroundIcon } from '~icons/lucide/align-horizontal-space-around';

/**
 * @see https://lucide.dev/icons/align-horizontal-space-around
 */
export const AlignHorizontalSpaceAroundIcon = (props: IconProps) => (
  <Icon icon={DefaultAlignHorizontalSpaceAroundIcon} {...props} />
);

import { default as DefaultAlignHorizontalSpaceBetweenIcon } from '~icons/lucide/align-horizontal-space-between';

/**
 * @see https://lucide.dev/icons/align-horizontal-space-between
 */
export const AlignHorizontalSpaceBetweenIcon = (props: IconProps) => (
  <Icon icon={DefaultAlignHorizontalSpaceBetweenIcon} {...props} />
);

import { default as DefaultAlignJustifyIcon } from '~icons/lucide/align-justify';

/**
 * @see https://lucide.dev/icons/align-justify
 */
export const AlignJustifyIcon = (props: IconProps) => (
  <Icon icon={DefaultAlignJustifyIcon} {...props} />
);

import { default as DefaultAlignLeftIcon } from '~icons/lucide/align-left';

/**
 * @see https://lucide.dev/icons/align-left
 */
export const AlignLeftIcon = (props: IconProps) => (
  <Icon icon={DefaultAlignLeftIcon} {...props} />
);

import { default as DefaultAlignRightIcon } from '~icons/lucide/align-right';

/**
 * @see https://lucide.dev/icons/align-right
 */
export const AlignRightIcon = (props: IconProps) => (
  <Icon icon={DefaultAlignRightIcon} {...props} />
);

import { default as DefaultAlignStartHorizontalIcon } from '~icons/lucide/align-start-horizontal';

/**
 * @see https://lucide.dev/icons/align-start-horizontal
 */
export const AlignStartHorizontalIcon = (props: IconProps) => (
  <Icon icon={DefaultAlignStartHorizontalIcon} {...props} />
);

import { default as DefaultAlignStartVerticalIcon } from '~icons/lucide/align-start-vertical';

/**
 * @see https://lucide.dev/icons/align-start-vertical
 */
export const AlignStartVerticalIcon = (props: IconProps) => (
  <Icon icon={DefaultAlignStartVerticalIcon} {...props} />
);

import { default as DefaultAlignVerticalDistributeCenterIcon } from '~icons/lucide/align-vertical-distribute-center';

/**
 * @see https://lucide.dev/icons/align-vertical-distribute-center
 */
export const AlignVerticalDistributeCenterIcon = (props: IconProps) => (
  <Icon icon={DefaultAlignVerticalDistributeCenterIcon} {...props} />
);

import { default as DefaultAlignVerticalDistributeEndIcon } from '~icons/lucide/align-vertical-distribute-end';

/**
 * @see https://lucide.dev/icons/align-vertical-distribute-end
 */
export const AlignVerticalDistributeEndIcon = (props: IconProps) => (
  <Icon icon={DefaultAlignVerticalDistributeEndIcon} {...props} />
);

import { default as DefaultAlignVerticalDistributeStartIcon } from '~icons/lucide/align-vertical-distribute-start';

/**
 * @see https://lucide.dev/icons/align-vertical-distribute-start
 */
export const AlignVerticalDistributeStartIcon = (props: IconProps) => (
  <Icon icon={DefaultAlignVerticalDistributeStartIcon} {...props} />
);

import { default as DefaultAlignVerticalJustifyCenterIcon } from '~icons/lucide/align-vertical-justify-center';

/**
 * @see https://lucide.dev/icons/align-vertical-justify-center
 */
export const AlignVerticalJustifyCenterIcon = (props: IconProps) => (
  <Icon icon={DefaultAlignVerticalJustifyCenterIcon} {...props} />
);

import { default as DefaultAlignVerticalJustifyEndIcon } from '~icons/lucide/align-vertical-justify-end';

/**
 * @see https://lucide.dev/icons/align-vertical-justify-end
 */
export const AlignVerticalJustifyEndIcon = (props: IconProps) => (
  <Icon icon={DefaultAlignVerticalJustifyEndIcon} {...props} />
);

import { default as DefaultAlignVerticalJustifyStartIcon } from '~icons/lucide/align-vertical-justify-start';

/**
 * @see https://lucide.dev/icons/align-vertical-justify-start
 */
export const AlignVerticalJustifyStartIcon = (props: IconProps) => (
  <Icon icon={DefaultAlignVerticalJustifyStartIcon} {...props} />
);

import { default as DefaultAlignVerticalSpaceAroundIcon } from '~icons/lucide/align-vertical-space-around';

/**
 * @see https://lucide.dev/icons/align-vertical-space-around
 */
export const AlignVerticalSpaceAroundIcon = (props: IconProps) => (
  <Icon icon={DefaultAlignVerticalSpaceAroundIcon} {...props} />
);

import { default as DefaultAlignVerticalSpaceBetweenIcon } from '~icons/lucide/align-vertical-space-between';

/**
 * @see https://lucide.dev/icons/align-vertical-space-between
 */
export const AlignVerticalSpaceBetweenIcon = (props: IconProps) => (
  <Icon icon={DefaultAlignVerticalSpaceBetweenIcon} {...props} />
);

import { default as DefaultAmbulanceIcon } from '~icons/lucide/ambulance';

/**
 * @see https://lucide.dev/icons/ambulance
 */
export const AmbulanceIcon = (props: IconProps) => (
  <Icon icon={DefaultAmbulanceIcon} {...props} />
);

import { default as DefaultAmpersandIcon } from '~icons/lucide/ampersand';

/**
 * @see https://lucide.dev/icons/ampersand
 */
export const AmpersandIcon = (props: IconProps) => (
  <Icon icon={DefaultAmpersandIcon} {...props} />
);

import { default as DefaultAmpersandsIcon } from '~icons/lucide/ampersands';

/**
 * @see https://lucide.dev/icons/ampersands
 */
export const AmpersandsIcon = (props: IconProps) => (
  <Icon icon={DefaultAmpersandsIcon} {...props} />
);

import { default as DefaultAmphoraIcon } from '~icons/lucide/amphora';

/**
 * @see https://lucide.dev/icons/amphora
 */
export const AmphoraIcon = (props: IconProps) => (
  <Icon icon={DefaultAmphoraIcon} {...props} />
);

import { default as DefaultAnchorIcon } from '~icons/lucide/anchor';

/**
 * @see https://lucide.dev/icons/anchor
 */
export const AnchorIcon = (props: IconProps) => (
  <Icon icon={DefaultAnchorIcon} {...props} />
);

import { default as DefaultAngryIcon } from '~icons/lucide/angry';

/**
 * @see https://lucide.dev/icons/angry
 */
export const AngryIcon = (props: IconProps) => (
  <Icon icon={DefaultAngryIcon} {...props} />
);

import { default as DefaultAnnoyedIcon } from '~icons/lucide/annoyed';

/**
 * @see https://lucide.dev/icons/annoyed
 */
export const AnnoyedIcon = (props: IconProps) => (
  <Icon icon={DefaultAnnoyedIcon} {...props} />
);

import { default as DefaultAntennaIcon } from '~icons/lucide/antenna';

/**
 * @see https://lucide.dev/icons/antenna
 */
export const AntennaIcon = (props: IconProps) => (
  <Icon icon={DefaultAntennaIcon} {...props} />
);

import { default as DefaultAnvilIcon } from '~icons/lucide/anvil';

/**
 * @see https://lucide.dev/icons/anvil
 */
export const AnvilIcon = (props: IconProps) => (
  <Icon icon={DefaultAnvilIcon} {...props} />
);

import { default as DefaultApertureIcon } from '~icons/lucide/aperture';

/**
 * @see https://lucide.dev/icons/aperture
 */
export const ApertureIcon = (props: IconProps) => (
  <Icon icon={DefaultApertureIcon} {...props} />
);

import { default as DefaultAppWindowIcon } from '~icons/lucide/app-window';

/**
 * @see https://lucide.dev/icons/app-window
 */
export const AppWindowIcon = (props: IconProps) => (
  <Icon icon={DefaultAppWindowIcon} {...props} />
);

import { default as DefaultAppWindowMacIcon } from '~icons/lucide/app-window-mac';

/**
 * @see https://lucide.dev/icons/app-window-mac
 */
export const AppWindowMacIcon = (props: IconProps) => (
  <Icon icon={DefaultAppWindowMacIcon} {...props} />
);

import { default as DefaultAppleIcon } from '~icons/lucide/apple';

/**
 * @see https://lucide.dev/icons/apple
 */
export const AppleIcon = (props: IconProps) => (
  <Icon icon={DefaultAppleIcon} {...props} />
);

import { default as DefaultArchiveIcon } from '~icons/lucide/archive';

/**
 * @see https://lucide.dev/icons/archive
 */
export const ArchiveIcon = (props: IconProps) => (
  <Icon icon={DefaultArchiveIcon} {...props} />
);

import { default as DefaultArchiveRestoreIcon } from '~icons/lucide/archive-restore';

/**
 * @see https://lucide.dev/icons/archive-restore
 */
export const ArchiveRestoreIcon = (props: IconProps) => (
  <Icon icon={DefaultArchiveRestoreIcon} {...props} />
);

import { default as DefaultArchiveXIcon } from '~icons/lucide/archive-x';

/**
 * @see https://lucide.dev/icons/archive-x
 */
export const ArchiveXIcon = (props: IconProps) => (
  <Icon icon={DefaultArchiveXIcon} {...props} />
);

import { default as DefaultAreaChartIcon } from '~icons/lucide/area-chart';

/**
 * @see https://lucide.dev/icons/area-chart
 */
export const AreaChartIcon = (props: IconProps) => (
  <Icon icon={DefaultAreaChartIcon} {...props} />
);

import { default as DefaultArmchairIcon } from '~icons/lucide/armchair';

/**
 * @see https://lucide.dev/icons/armchair
 */
export const ArmchairIcon = (props: IconProps) => (
  <Icon icon={DefaultArmchairIcon} {...props} />
);

import { default as DefaultArrowBigDownIcon } from '~icons/lucide/arrow-big-down';

/**
 * @see https://lucide.dev/icons/arrow-big-down
 */
export const ArrowBigDownIcon = (props: IconProps) => (
  <Icon icon={DefaultArrowBigDownIcon} {...props} />
);

import { default as DefaultArrowBigDownDashIcon } from '~icons/lucide/arrow-big-down-dash';

/**
 * @see https://lucide.dev/icons/arrow-big-down-dash
 */
export const ArrowBigDownDashIcon = (props: IconProps) => (
  <Icon icon={DefaultArrowBigDownDashIcon} {...props} />
);

import { default as DefaultArrowBigLeftIcon } from '~icons/lucide/arrow-big-left';

/**
 * @see https://lucide.dev/icons/arrow-big-left
 */
export const ArrowBigLeftIcon = (props: IconProps) => (
  <Icon icon={DefaultArrowBigLeftIcon} {...props} />
);

import { default as DefaultArrowBigLeftDashIcon } from '~icons/lucide/arrow-big-left-dash';

/**
 * @see https://lucide.dev/icons/arrow-big-left-dash
 */
export const ArrowBigLeftDashIcon = (props: IconProps) => (
  <Icon icon={DefaultArrowBigLeftDashIcon} {...props} />
);

import { default as DefaultArrowBigRightIcon } from '~icons/lucide/arrow-big-right';

/**
 * @see https://lucide.dev/icons/arrow-big-right
 */
export const ArrowBigRightIcon = (props: IconProps) => (
  <Icon icon={DefaultArrowBigRightIcon} {...props} />
);

import { default as DefaultArrowBigRightDashIcon } from '~icons/lucide/arrow-big-right-dash';

/**
 * @see https://lucide.dev/icons/arrow-big-right-dash
 */
export const ArrowBigRightDashIcon = (props: IconProps) => (
  <Icon icon={DefaultArrowBigRightDashIcon} {...props} />
);

import { default as DefaultArrowBigUpIcon } from '~icons/lucide/arrow-big-up';

/**
 * @see https://lucide.dev/icons/arrow-big-up
 */
export const ArrowBigUpIcon = (props: IconProps) => (
  <Icon icon={DefaultArrowBigUpIcon} {...props} />
);

import { default as DefaultArrowBigUpDashIcon } from '~icons/lucide/arrow-big-up-dash';

/**
 * @see https://lucide.dev/icons/arrow-big-up-dash
 */
export const ArrowBigUpDashIcon = (props: IconProps) => (
  <Icon icon={DefaultArrowBigUpDashIcon} {...props} />
);

import { default as DefaultArrowDownIcon } from '~icons/lucide/arrow-down';

/**
 * @see https://lucide.dev/icons/arrow-down
 */
export const ArrowDownIcon = (props: IconProps) => (
  <Icon icon={DefaultArrowDownIcon} {...props} />
);

import { default as DefaultArrowDown01Icon } from '~icons/lucide/arrow-down-0-1';

/**
 * @see https://lucide.dev/icons/arrow-down-0-1
 */
export const ArrowDown01Icon = (props: IconProps) => (
  <Icon icon={DefaultArrowDown01Icon} {...props} />
);

import { default as DefaultArrowDown10Icon } from '~icons/lucide/arrow-down-1-0';

/**
 * @see https://lucide.dev/icons/arrow-down-1-0
 */
export const ArrowDown10Icon = (props: IconProps) => (
  <Icon icon={DefaultArrowDown10Icon} {...props} />
);

import { default as DefaultArrowDownAZIcon } from '~icons/lucide/arrow-down-a-z';

/**
 * @see https://lucide.dev/icons/arrow-down-a-z
 */
export const ArrowDownAZIcon = (props: IconProps) => (
  <Icon icon={DefaultArrowDownAZIcon} {...props} />
);

import { default as DefaultArrowDownFromLineIcon } from '~icons/lucide/arrow-down-from-line';

/**
 * @see https://lucide.dev/icons/arrow-down-from-line
 */
export const ArrowDownFromLineIcon = (props: IconProps) => (
  <Icon icon={DefaultArrowDownFromLineIcon} {...props} />
);

import { default as DefaultArrowDownLeftIcon } from '~icons/lucide/arrow-down-left';

/**
 * @see https://lucide.dev/icons/arrow-down-left
 */
export const ArrowDownLeftIcon = (props: IconProps) => (
  <Icon icon={DefaultArrowDownLeftIcon} {...props} />
);

import { default as DefaultArrowDownNarrowWideIcon } from '~icons/lucide/arrow-down-narrow-wide';

/**
 * @see https://lucide.dev/icons/arrow-down-narrow-wide
 */
export const ArrowDownNarrowWideIcon = (props: IconProps) => (
  <Icon icon={DefaultArrowDownNarrowWideIcon} {...props} />
);

import { default as DefaultArrowDownRightIcon } from '~icons/lucide/arrow-down-right';

/**
 * @see https://lucide.dev/icons/arrow-down-right
 */
export const ArrowDownRightIcon = (props: IconProps) => (
  <Icon icon={DefaultArrowDownRightIcon} {...props} />
);

import { default as DefaultArrowDownToDotIcon } from '~icons/lucide/arrow-down-to-dot';

/**
 * @see https://lucide.dev/icons/arrow-down-to-dot
 */
export const ArrowDownToDotIcon = (props: IconProps) => (
  <Icon icon={DefaultArrowDownToDotIcon} {...props} />
);

import { default as DefaultArrowDownToLineIcon } from '~icons/lucide/arrow-down-to-line';

/**
 * @see https://lucide.dev/icons/arrow-down-to-line
 */
export const ArrowDownToLineIcon = (props: IconProps) => (
  <Icon icon={DefaultArrowDownToLineIcon} {...props} />
);

import { default as DefaultArrowDownUpIcon } from '~icons/lucide/arrow-down-up';

/**
 * @see https://lucide.dev/icons/arrow-down-up
 */
export const ArrowDownUpIcon = (props: IconProps) => (
  <Icon icon={DefaultArrowDownUpIcon} {...props} />
);

import { default as DefaultArrowDownWideNarrowIcon } from '~icons/lucide/arrow-down-wide-narrow';

/**
 * @see https://lucide.dev/icons/arrow-down-wide-narrow
 */
export const ArrowDownWideNarrowIcon = (props: IconProps) => (
  <Icon icon={DefaultArrowDownWideNarrowIcon} {...props} />
);

import { default as DefaultArrowDownZAIcon } from '~icons/lucide/arrow-down-z-a';

/**
 * @see https://lucide.dev/icons/arrow-down-z-a
 */
export const ArrowDownZAIcon = (props: IconProps) => (
  <Icon icon={DefaultArrowDownZAIcon} {...props} />
);

import { default as DefaultArrowLeftIcon } from '~icons/lucide/arrow-left';

/**
 * @see https://lucide.dev/icons/arrow-left
 */
export const ArrowLeftIcon = (props: IconProps) => (
  <Icon icon={DefaultArrowLeftIcon} {...props} />
);

import { default as DefaultArrowLeftFromLineIcon } from '~icons/lucide/arrow-left-from-line';

/**
 * @see https://lucide.dev/icons/arrow-left-from-line
 */
export const ArrowLeftFromLineIcon = (props: IconProps) => (
  <Icon icon={DefaultArrowLeftFromLineIcon} {...props} />
);

import { default as DefaultArrowLeftRightIcon } from '~icons/lucide/arrow-left-right';

/**
 * @see https://lucide.dev/icons/arrow-left-right
 */
export const ArrowLeftRightIcon = (props: IconProps) => (
  <Icon icon={DefaultArrowLeftRightIcon} {...props} />
);

import { default as DefaultArrowLeftToLineIcon } from '~icons/lucide/arrow-left-to-line';

/**
 * @see https://lucide.dev/icons/arrow-left-to-line
 */
export const ArrowLeftToLineIcon = (props: IconProps) => (
  <Icon icon={DefaultArrowLeftToLineIcon} {...props} />
);

import { default as DefaultArrowRightIcon } from '~icons/lucide/arrow-right';

/**
 * @see https://lucide.dev/icons/arrow-right
 */
export const ArrowRightIcon = (props: IconProps) => (
  <Icon icon={DefaultArrowRightIcon} {...props} />
);

import { default as DefaultArrowRightFromLineIcon } from '~icons/lucide/arrow-right-from-line';

/**
 * @see https://lucide.dev/icons/arrow-right-from-line
 */
export const ArrowRightFromLineIcon = (props: IconProps) => (
  <Icon icon={DefaultArrowRightFromLineIcon} {...props} />
);

import { default as DefaultArrowRightLeftIcon } from '~icons/lucide/arrow-right-left';

/**
 * @see https://lucide.dev/icons/arrow-right-left
 */
export const ArrowRightLeftIcon = (props: IconProps) => (
  <Icon icon={DefaultArrowRightLeftIcon} {...props} />
);

import { default as DefaultArrowRightToLineIcon } from '~icons/lucide/arrow-right-to-line';

/**
 * @see https://lucide.dev/icons/arrow-right-to-line
 */
export const ArrowRightToLineIcon = (props: IconProps) => (
  <Icon icon={DefaultArrowRightToLineIcon} {...props} />
);

import { default as DefaultArrowUpIcon } from '~icons/lucide/arrow-up';

/**
 * @see https://lucide.dev/icons/arrow-up
 */
export const ArrowUpIcon = (props: IconProps) => (
  <Icon icon={DefaultArrowUpIcon} {...props} />
);

import { default as DefaultArrowUp01Icon } from '~icons/lucide/arrow-up-0-1';

/**
 * @see https://lucide.dev/icons/arrow-up-0-1
 */
export const ArrowUp01Icon = (props: IconProps) => (
  <Icon icon={DefaultArrowUp01Icon} {...props} />
);

import { default as DefaultArrowUp10Icon } from '~icons/lucide/arrow-up-1-0';

/**
 * @see https://lucide.dev/icons/arrow-up-1-0
 */
export const ArrowUp10Icon = (props: IconProps) => (
  <Icon icon={DefaultArrowUp10Icon} {...props} />
);

import { default as DefaultArrowUpAZIcon } from '~icons/lucide/arrow-up-a-z';

/**
 * @see https://lucide.dev/icons/arrow-up-a-z
 */
export const ArrowUpAZIcon = (props: IconProps) => (
  <Icon icon={DefaultArrowUpAZIcon} {...props} />
);

import { default as DefaultArrowUpDownIcon } from '~icons/lucide/arrow-up-down';

/**
 * @see https://lucide.dev/icons/arrow-up-down
 */
export const ArrowUpDownIcon = (props: IconProps) => (
  <Icon icon={DefaultArrowUpDownIcon} {...props} />
);

import { default as DefaultArrowUpFromDotIcon } from '~icons/lucide/arrow-up-from-dot';

/**
 * @see https://lucide.dev/icons/arrow-up-from-dot
 */
export const ArrowUpFromDotIcon = (props: IconProps) => (
  <Icon icon={DefaultArrowUpFromDotIcon} {...props} />
);

import { default as DefaultArrowUpFromLineIcon } from '~icons/lucide/arrow-up-from-line';

/**
 * @see https://lucide.dev/icons/arrow-up-from-line
 */
export const ArrowUpFromLineIcon = (props: IconProps) => (
  <Icon icon={DefaultArrowUpFromLineIcon} {...props} />
);

import { default as DefaultArrowUpLeftIcon } from '~icons/lucide/arrow-up-left';

/**
 * @see https://lucide.dev/icons/arrow-up-left
 */
export const ArrowUpLeftIcon = (props: IconProps) => (
  <Icon icon={DefaultArrowUpLeftIcon} {...props} />
);

import { default as DefaultArrowUpNarrowWideIcon } from '~icons/lucide/arrow-up-narrow-wide';

/**
 * @see https://lucide.dev/icons/arrow-up-narrow-wide
 */
export const ArrowUpNarrowWideIcon = (props: IconProps) => (
  <Icon icon={DefaultArrowUpNarrowWideIcon} {...props} />
);

import { default as DefaultArrowUpRightIcon } from '~icons/lucide/arrow-up-right';

/**
 * @see https://lucide.dev/icons/arrow-up-right
 */
export const ArrowUpRightIcon = (props: IconProps) => (
  <Icon icon={DefaultArrowUpRightIcon} {...props} />
);

import { default as DefaultArrowUpToLineIcon } from '~icons/lucide/arrow-up-to-line';

/**
 * @see https://lucide.dev/icons/arrow-up-to-line
 */
export const ArrowUpToLineIcon = (props: IconProps) => (
  <Icon icon={DefaultArrowUpToLineIcon} {...props} />
);

import { default as DefaultArrowUpWideNarrowIcon } from '~icons/lucide/arrow-up-wide-narrow';

/**
 * @see https://lucide.dev/icons/arrow-up-wide-narrow
 */
export const ArrowUpWideNarrowIcon = (props: IconProps) => (
  <Icon icon={DefaultArrowUpWideNarrowIcon} {...props} />
);

import { default as DefaultArrowUpZAIcon } from '~icons/lucide/arrow-up-z-a';

/**
 * @see https://lucide.dev/icons/arrow-up-z-a
 */
export const ArrowUpZAIcon = (props: IconProps) => (
  <Icon icon={DefaultArrowUpZAIcon} {...props} />
);

import { default as DefaultArrowsUpFromLineIcon } from '~icons/lucide/arrows-up-from-line';

/**
 * @see https://lucide.dev/icons/arrows-up-from-line
 */
export const ArrowsUpFromLineIcon = (props: IconProps) => (
  <Icon icon={DefaultArrowsUpFromLineIcon} {...props} />
);

import { default as DefaultAsteriskIcon } from '~icons/lucide/asterisk';

/**
 * @see https://lucide.dev/icons/asterisk
 */
export const AsteriskIcon = (props: IconProps) => (
  <Icon icon={DefaultAsteriskIcon} {...props} />
);

import { default as DefaultAtSignIcon } from '~icons/lucide/at-sign';

/**
 * @see https://lucide.dev/icons/at-sign
 */
export const AtSignIcon = (props: IconProps) => (
  <Icon icon={DefaultAtSignIcon} {...props} />
);

import { default as DefaultAtomIcon } from '~icons/lucide/atom';

/**
 * @see https://lucide.dev/icons/atom
 */
export const AtomIcon = (props: IconProps) => (
  <Icon icon={DefaultAtomIcon} {...props} />
);

import { default as DefaultAudioLinesIcon } from '~icons/lucide/audio-lines';

/**
 * @see https://lucide.dev/icons/audio-lines
 */
export const AudioLinesIcon = (props: IconProps) => (
  <Icon icon={DefaultAudioLinesIcon} {...props} />
);

import { default as DefaultAudioWaveformIcon } from '~icons/lucide/audio-waveform';

/**
 * @see https://lucide.dev/icons/audio-waveform
 */
export const AudioWaveformIcon = (props: IconProps) => (
  <Icon icon={DefaultAudioWaveformIcon} {...props} />
);

import { default as DefaultAwardIcon } from '~icons/lucide/award';

/**
 * @see https://lucide.dev/icons/award
 */
export const AwardIcon = (props: IconProps) => (
  <Icon icon={DefaultAwardIcon} {...props} />
);

import { default as DefaultAxeIcon } from '~icons/lucide/axe';

/**
 * @see https://lucide.dev/icons/axe
 */
export const AxeIcon = (props: IconProps) => (
  <Icon icon={DefaultAxeIcon} {...props} />
);

import { default as DefaultAxis3dIcon } from '~icons/lucide/axis-3d';

/**
 * @see https://lucide.dev/icons/axis-3d
 */
export const Axis3dIcon = (props: IconProps) => (
  <Icon icon={DefaultAxis3dIcon} {...props} />
);

import { default as DefaultBabyIcon } from '~icons/lucide/baby';

/**
 * @see https://lucide.dev/icons/baby
 */
export const BabyIcon = (props: IconProps) => (
  <Icon icon={DefaultBabyIcon} {...props} />
);

import { default as DefaultBackpackIcon } from '~icons/lucide/backpack';

/**
 * @see https://lucide.dev/icons/backpack
 */
export const BackpackIcon = (props: IconProps) => (
  <Icon icon={DefaultBackpackIcon} {...props} />
);

import { default as DefaultBadgeIcon } from '~icons/lucide/badge';

/**
 * @see https://lucide.dev/icons/badge
 */
export const BadgeIcon = (props: IconProps) => (
  <Icon icon={DefaultBadgeIcon} {...props} />
);

import { default as DefaultBadgeAlertIcon } from '~icons/lucide/badge-alert';

/**
 * @see https://lucide.dev/icons/badge-alert
 */
export const BadgeAlertIcon = (props: IconProps) => (
  <Icon icon={DefaultBadgeAlertIcon} {...props} />
);

import { default as DefaultBadgeCentIcon } from '~icons/lucide/badge-cent';

/**
 * @see https://lucide.dev/icons/badge-cent
 */
export const BadgeCentIcon = (props: IconProps) => (
  <Icon icon={DefaultBadgeCentIcon} {...props} />
);

import { default as DefaultBadgeCheckIcon } from '~icons/lucide/badge-check';

/**
 * @see https://lucide.dev/icons/badge-check
 */
export const BadgeCheckIcon = (props: IconProps) => (
  <Icon icon={DefaultBadgeCheckIcon} {...props} />
);

import { default as DefaultBadgeDollarSignIcon } from '~icons/lucide/badge-dollar-sign';

/**
 * @see https://lucide.dev/icons/badge-dollar-sign
 */
export const BadgeDollarSignIcon = (props: IconProps) => (
  <Icon icon={DefaultBadgeDollarSignIcon} {...props} />
);

import { default as DefaultBadgeEuroIcon } from '~icons/lucide/badge-euro';

/**
 * @see https://lucide.dev/icons/badge-euro
 */
export const BadgeEuroIcon = (props: IconProps) => (
  <Icon icon={DefaultBadgeEuroIcon} {...props} />
);

import { default as DefaultBadgeIndianRupeeIcon } from '~icons/lucide/badge-indian-rupee';

/**
 * @see https://lucide.dev/icons/badge-indian-rupee
 */
export const BadgeIndianRupeeIcon = (props: IconProps) => (
  <Icon icon={DefaultBadgeIndianRupeeIcon} {...props} />
);

import { default as DefaultBadgeInfoIcon } from '~icons/lucide/badge-info';

/**
 * @see https://lucide.dev/icons/badge-info
 */
export const BadgeInfoIcon = (props: IconProps) => (
  <Icon icon={DefaultBadgeInfoIcon} {...props} />
);

import { default as DefaultBadgeJapaneseYenIcon } from '~icons/lucide/badge-japanese-yen';

/**
 * @see https://lucide.dev/icons/badge-japanese-yen
 */
export const BadgeJapaneseYenIcon = (props: IconProps) => (
  <Icon icon={DefaultBadgeJapaneseYenIcon} {...props} />
);

import { default as DefaultBadgeMinusIcon } from '~icons/lucide/badge-minus';

/**
 * @see https://lucide.dev/icons/badge-minus
 */
export const BadgeMinusIcon = (props: IconProps) => (
  <Icon icon={DefaultBadgeMinusIcon} {...props} />
);

import { default as DefaultBadgePercentIcon } from '~icons/lucide/badge-percent';

/**
 * @see https://lucide.dev/icons/badge-percent
 */
export const BadgePercentIcon = (props: IconProps) => (
  <Icon icon={DefaultBadgePercentIcon} {...props} />
);

import { default as DefaultBadgePlusIcon } from '~icons/lucide/badge-plus';

/**
 * @see https://lucide.dev/icons/badge-plus
 */
export const BadgePlusIcon = (props: IconProps) => (
  <Icon icon={DefaultBadgePlusIcon} {...props} />
);

import { default as DefaultBadgePoundSterlingIcon } from '~icons/lucide/badge-pound-sterling';

/**
 * @see https://lucide.dev/icons/badge-pound-sterling
 */
export const BadgePoundSterlingIcon = (props: IconProps) => (
  <Icon icon={DefaultBadgePoundSterlingIcon} {...props} />
);

import { default as DefaultBadgeQuestionMarkIcon } from '~icons/lucide/badge-question-mark';

/**
 * @see https://lucide.dev/icons/badge-question-mark
 */
export const BadgeQuestionMarkIcon = (props: IconProps) => (
  <Icon icon={DefaultBadgeQuestionMarkIcon} {...props} />
);

import { default as DefaultBadgeRussianRubleIcon } from '~icons/lucide/badge-russian-ruble';

/**
 * @see https://lucide.dev/icons/badge-russian-ruble
 */
export const BadgeRussianRubleIcon = (props: IconProps) => (
  <Icon icon={DefaultBadgeRussianRubleIcon} {...props} />
);

import { default as DefaultBadgeSwissFrancIcon } from '~icons/lucide/badge-swiss-franc';

/**
 * @see https://lucide.dev/icons/badge-swiss-franc
 */
export const BadgeSwissFrancIcon = (props: IconProps) => (
  <Icon icon={DefaultBadgeSwissFrancIcon} {...props} />
);

import { default as DefaultBadgeTurkishLiraIcon } from '~icons/lucide/badge-turkish-lira';

/**
 * @see https://lucide.dev/icons/badge-turkish-lira
 */
export const BadgeTurkishLiraIcon = (props: IconProps) => (
  <Icon icon={DefaultBadgeTurkishLiraIcon} {...props} />
);

import { default as DefaultBadgeXIcon } from '~icons/lucide/badge-x';

/**
 * @see https://lucide.dev/icons/badge-x
 */
export const BadgeXIcon = (props: IconProps) => (
  <Icon icon={DefaultBadgeXIcon} {...props} />
);

import { default as DefaultBaggageClaimIcon } from '~icons/lucide/baggage-claim';

/**
 * @see https://lucide.dev/icons/baggage-claim
 */
export const BaggageClaimIcon = (props: IconProps) => (
  <Icon icon={DefaultBaggageClaimIcon} {...props} />
);

import { default as DefaultBanIcon } from '~icons/lucide/ban';

/**
 * @see https://lucide.dev/icons/ban
 */
export const BanIcon = (props: IconProps) => (
  <Icon icon={DefaultBanIcon} {...props} />
);

import { default as DefaultBananaIcon } from '~icons/lucide/banana';

/**
 * @see https://lucide.dev/icons/banana
 */
export const BananaIcon = (props: IconProps) => (
  <Icon icon={DefaultBananaIcon} {...props} />
);

import { default as DefaultBandageIcon } from '~icons/lucide/bandage';

/**
 * @see https://lucide.dev/icons/bandage
 */
export const BandageIcon = (props: IconProps) => (
  <Icon icon={DefaultBandageIcon} {...props} />
);

import { default as DefaultBanknoteIcon } from '~icons/lucide/banknote';

/**
 * @see https://lucide.dev/icons/banknote
 */
export const BanknoteIcon = (props: IconProps) => (
  <Icon icon={DefaultBanknoteIcon} {...props} />
);

import { default as DefaultBanknoteArrowDownIcon } from '~icons/lucide/banknote-arrow-down';

/**
 * @see https://lucide.dev/icons/banknote-arrow-down
 */
export const BanknoteArrowDownIcon = (props: IconProps) => (
  <Icon icon={DefaultBanknoteArrowDownIcon} {...props} />
);

import { default as DefaultBanknoteArrowUpIcon } from '~icons/lucide/banknote-arrow-up';

/**
 * @see https://lucide.dev/icons/banknote-arrow-up
 */
export const BanknoteArrowUpIcon = (props: IconProps) => (
  <Icon icon={DefaultBanknoteArrowUpIcon} {...props} />
);

import { default as DefaultBanknoteXIcon } from '~icons/lucide/banknote-x';

/**
 * @see https://lucide.dev/icons/banknote-x
 */
export const BanknoteXIcon = (props: IconProps) => (
  <Icon icon={DefaultBanknoteXIcon} {...props} />
);

import { default as DefaultBarChart3Icon } from '~icons/lucide/bar-chart-3';

/**
 * @see https://lucide.dev/icons/bar-chart-3
 */
export const BarChart3Icon = (props: IconProps) => (
  <Icon icon={DefaultBarChart3Icon} {...props} />
);

import { default as DefaultBarChart4Icon } from '~icons/lucide/bar-chart-4';

/**
 * @see https://lucide.dev/icons/bar-chart-4
 */
export const BarChart4Icon = (props: IconProps) => (
  <Icon icon={DefaultBarChart4Icon} {...props} />
);

import { default as DefaultBarChartBigIcon } from '~icons/lucide/bar-chart-big';

/**
 * @see https://lucide.dev/icons/bar-chart-big
 */
export const BarChartBigIcon = (props: IconProps) => (
  <Icon icon={DefaultBarChartBigIcon} {...props} />
);

import { default as DefaultBarChartHorizontalIcon } from '~icons/lucide/bar-chart-horizontal';

/**
 * @see https://lucide.dev/icons/bar-chart-horizontal
 */
export const BarChartHorizontalIcon = (props: IconProps) => (
  <Icon icon={DefaultBarChartHorizontalIcon} {...props} />
);

import { default as DefaultBarChartHorizontalBigIcon } from '~icons/lucide/bar-chart-horizontal-big';

/**
 * @see https://lucide.dev/icons/bar-chart-horizontal-big
 */
export const BarChartHorizontalBigIcon = (props: IconProps) => (
  <Icon icon={DefaultBarChartHorizontalBigIcon} {...props} />
);

import { default as DefaultBarcodeIcon } from '~icons/lucide/barcode';

/**
 * @see https://lucide.dev/icons/barcode
 */
export const BarcodeIcon = (props: IconProps) => (
  <Icon icon={DefaultBarcodeIcon} {...props} />
);

import { default as DefaultBarrelIcon } from '~icons/lucide/barrel';

/**
 * @see https://lucide.dev/icons/barrel
 */
export const BarrelIcon = (props: IconProps) => (
  <Icon icon={DefaultBarrelIcon} {...props} />
);

import { default as DefaultBaselineIcon } from '~icons/lucide/baseline';

/**
 * @see https://lucide.dev/icons/baseline
 */
export const BaselineIcon = (props: IconProps) => (
  <Icon icon={DefaultBaselineIcon} {...props} />
);

import { default as DefaultBathIcon } from '~icons/lucide/bath';

/**
 * @see https://lucide.dev/icons/bath
 */
export const BathIcon = (props: IconProps) => (
  <Icon icon={DefaultBathIcon} {...props} />
);

import { default as DefaultBatteryIcon } from '~icons/lucide/battery';

/**
 * @see https://lucide.dev/icons/battery
 */
export const BatteryIcon = (props: IconProps) => (
  <Icon icon={DefaultBatteryIcon} {...props} />
);

import { default as DefaultBatteryChargingIcon } from '~icons/lucide/battery-charging';

/**
 * @see https://lucide.dev/icons/battery-charging
 */
export const BatteryChargingIcon = (props: IconProps) => (
  <Icon icon={DefaultBatteryChargingIcon} {...props} />
);

import { default as DefaultBatteryFullIcon } from '~icons/lucide/battery-full';

/**
 * @see https://lucide.dev/icons/battery-full
 */
export const BatteryFullIcon = (props: IconProps) => (
  <Icon icon={DefaultBatteryFullIcon} {...props} />
);

import { default as DefaultBatteryLowIcon } from '~icons/lucide/battery-low';

/**
 * @see https://lucide.dev/icons/battery-low
 */
export const BatteryLowIcon = (props: IconProps) => (
  <Icon icon={DefaultBatteryLowIcon} {...props} />
);

import { default as DefaultBatteryMediumIcon } from '~icons/lucide/battery-medium';

/**
 * @see https://lucide.dev/icons/battery-medium
 */
export const BatteryMediumIcon = (props: IconProps) => (
  <Icon icon={DefaultBatteryMediumIcon} {...props} />
);

import { default as DefaultBatteryPlusIcon } from '~icons/lucide/battery-plus';

/**
 * @see https://lucide.dev/icons/battery-plus
 */
export const BatteryPlusIcon = (props: IconProps) => (
  <Icon icon={DefaultBatteryPlusIcon} {...props} />
);

import { default as DefaultBatteryWarningIcon } from '~icons/lucide/battery-warning';

/**
 * @see https://lucide.dev/icons/battery-warning
 */
export const BatteryWarningIcon = (props: IconProps) => (
  <Icon icon={DefaultBatteryWarningIcon} {...props} />
);

import { default as DefaultBeakerIcon } from '~icons/lucide/beaker';

/**
 * @see https://lucide.dev/icons/beaker
 */
export const BeakerIcon = (props: IconProps) => (
  <Icon icon={DefaultBeakerIcon} {...props} />
);

import { default as DefaultBeanIcon } from '~icons/lucide/bean';

/**
 * @see https://lucide.dev/icons/bean
 */
export const BeanIcon = (props: IconProps) => (
  <Icon icon={DefaultBeanIcon} {...props} />
);

import { default as DefaultBeanOffIcon } from '~icons/lucide/bean-off';

/**
 * @see https://lucide.dev/icons/bean-off
 */
export const BeanOffIcon = (props: IconProps) => (
  <Icon icon={DefaultBeanOffIcon} {...props} />
);

import { default as DefaultBedIcon } from '~icons/lucide/bed';

/**
 * @see https://lucide.dev/icons/bed
 */
export const BedIcon = (props: IconProps) => (
  <Icon icon={DefaultBedIcon} {...props} />
);

import { default as DefaultBedDoubleIcon } from '~icons/lucide/bed-double';

/**
 * @see https://lucide.dev/icons/bed-double
 */
export const BedDoubleIcon = (props: IconProps) => (
  <Icon icon={DefaultBedDoubleIcon} {...props} />
);

import { default as DefaultBedSingleIcon } from '~icons/lucide/bed-single';

/**
 * @see https://lucide.dev/icons/bed-single
 */
export const BedSingleIcon = (props: IconProps) => (
  <Icon icon={DefaultBedSingleIcon} {...props} />
);

import { default as DefaultBeefIcon } from '~icons/lucide/beef';

/**
 * @see https://lucide.dev/icons/beef
 */
export const BeefIcon = (props: IconProps) => (
  <Icon icon={DefaultBeefIcon} {...props} />
);

import { default as DefaultBeerIcon } from '~icons/lucide/beer';

/**
 * @see https://lucide.dev/icons/beer
 */
export const BeerIcon = (props: IconProps) => (
  <Icon icon={DefaultBeerIcon} {...props} />
);

import { default as DefaultBeerOffIcon } from '~icons/lucide/beer-off';

/**
 * @see https://lucide.dev/icons/beer-off
 */
export const BeerOffIcon = (props: IconProps) => (
  <Icon icon={DefaultBeerOffIcon} {...props} />
);

import { default as DefaultBellIcon } from '~icons/lucide/bell';

/**
 * @see https://lucide.dev/icons/bell
 */
export const BellIcon = (props: IconProps) => (
  <Icon icon={DefaultBellIcon} {...props} />
);

import { default as DefaultBellDotIcon } from '~icons/lucide/bell-dot';

/**
 * @see https://lucide.dev/icons/bell-dot
 */
export const BellDotIcon = (props: IconProps) => (
  <Icon icon={DefaultBellDotIcon} {...props} />
);

import { default as DefaultBellElectricIcon } from '~icons/lucide/bell-electric';

/**
 * @see https://lucide.dev/icons/bell-electric
 */
export const BellElectricIcon = (props: IconProps) => (
  <Icon icon={DefaultBellElectricIcon} {...props} />
);

import { default as DefaultBellMinusIcon } from '~icons/lucide/bell-minus';

/**
 * @see https://lucide.dev/icons/bell-minus
 */
export const BellMinusIcon = (props: IconProps) => (
  <Icon icon={DefaultBellMinusIcon} {...props} />
);

import { default as DefaultBellOffIcon } from '~icons/lucide/bell-off';

/**
 * @see https://lucide.dev/icons/bell-off
 */
export const BellOffIcon = (props: IconProps) => (
  <Icon icon={DefaultBellOffIcon} {...props} />
);

import { default as DefaultBellPlusIcon } from '~icons/lucide/bell-plus';

/**
 * @see https://lucide.dev/icons/bell-plus
 */
export const BellPlusIcon = (props: IconProps) => (
  <Icon icon={DefaultBellPlusIcon} {...props} />
);

import { default as DefaultBellRingIcon } from '~icons/lucide/bell-ring';

/**
 * @see https://lucide.dev/icons/bell-ring
 */
export const BellRingIcon = (props: IconProps) => (
  <Icon icon={DefaultBellRingIcon} {...props} />
);

import { default as DefaultBetweenHorizontalEndIcon } from '~icons/lucide/between-horizontal-end';

/**
 * @see https://lucide.dev/icons/between-horizontal-end
 */
export const BetweenHorizontalEndIcon = (props: IconProps) => (
  <Icon icon={DefaultBetweenHorizontalEndIcon} {...props} />
);

import { default as DefaultBetweenHorizontalStartIcon } from '~icons/lucide/between-horizontal-start';

/**
 * @see https://lucide.dev/icons/between-horizontal-start
 */
export const BetweenHorizontalStartIcon = (props: IconProps) => (
  <Icon icon={DefaultBetweenHorizontalStartIcon} {...props} />
);

import { default as DefaultBetweenVerticalEndIcon } from '~icons/lucide/between-vertical-end';

/**
 * @see https://lucide.dev/icons/between-vertical-end
 */
export const BetweenVerticalEndIcon = (props: IconProps) => (
  <Icon icon={DefaultBetweenVerticalEndIcon} {...props} />
);

import { default as DefaultBetweenVerticalStartIcon } from '~icons/lucide/between-vertical-start';

/**
 * @see https://lucide.dev/icons/between-vertical-start
 */
export const BetweenVerticalStartIcon = (props: IconProps) => (
  <Icon icon={DefaultBetweenVerticalStartIcon} {...props} />
);

import { default as DefaultBicepsFlexedIcon } from '~icons/lucide/biceps-flexed';

/**
 * @see https://lucide.dev/icons/biceps-flexed
 */
export const BicepsFlexedIcon = (props: IconProps) => (
  <Icon icon={DefaultBicepsFlexedIcon} {...props} />
);

import { default as DefaultBikeIcon } from '~icons/lucide/bike';

/**
 * @see https://lucide.dev/icons/bike
 */
export const BikeIcon = (props: IconProps) => (
  <Icon icon={DefaultBikeIcon} {...props} />
);

import { default as DefaultBinaryIcon } from '~icons/lucide/binary';

/**
 * @see https://lucide.dev/icons/binary
 */
export const BinaryIcon = (props: IconProps) => (
  <Icon icon={DefaultBinaryIcon} {...props} />
);

import { default as DefaultBinocularsIcon } from '~icons/lucide/binoculars';

/**
 * @see https://lucide.dev/icons/binoculars
 */
export const BinocularsIcon = (props: IconProps) => (
  <Icon icon={DefaultBinocularsIcon} {...props} />
);

import { default as DefaultBiohazardIcon } from '~icons/lucide/biohazard';

/**
 * @see https://lucide.dev/icons/biohazard
 */
export const BiohazardIcon = (props: IconProps) => (
  <Icon icon={DefaultBiohazardIcon} {...props} />
);

import { default as DefaultBirdIcon } from '~icons/lucide/bird';

/**
 * @see https://lucide.dev/icons/bird
 */
export const BirdIcon = (props: IconProps) => (
  <Icon icon={DefaultBirdIcon} {...props} />
);

import { default as DefaultBitcoinIcon } from '~icons/lucide/bitcoin';

/**
 * @see https://lucide.dev/icons/bitcoin
 */
export const BitcoinIcon = (props: IconProps) => (
  <Icon icon={DefaultBitcoinIcon} {...props} />
);

import { default as DefaultBlendIcon } from '~icons/lucide/blend';

/**
 * @see https://lucide.dev/icons/blend
 */
export const BlendIcon = (props: IconProps) => (
  <Icon icon={DefaultBlendIcon} {...props} />
);

import { default as DefaultBlindsIcon } from '~icons/lucide/blinds';

/**
 * @see https://lucide.dev/icons/blinds
 */
export const BlindsIcon = (props: IconProps) => (
  <Icon icon={DefaultBlindsIcon} {...props} />
);

import { default as DefaultBlocksIcon } from '~icons/lucide/blocks';

/**
 * @see https://lucide.dev/icons/blocks
 */
export const BlocksIcon = (props: IconProps) => (
  <Icon icon={DefaultBlocksIcon} {...props} />
);

import { default as DefaultBluetoothIcon } from '~icons/lucide/bluetooth';

/**
 * @see https://lucide.dev/icons/bluetooth
 */
export const BluetoothIcon = (props: IconProps) => (
  <Icon icon={DefaultBluetoothIcon} {...props} />
);

import { default as DefaultBluetoothConnectedIcon } from '~icons/lucide/bluetooth-connected';

/**
 * @see https://lucide.dev/icons/bluetooth-connected
 */
export const BluetoothConnectedIcon = (props: IconProps) => (
  <Icon icon={DefaultBluetoothConnectedIcon} {...props} />
);

import { default as DefaultBluetoothOffIcon } from '~icons/lucide/bluetooth-off';

/**
 * @see https://lucide.dev/icons/bluetooth-off
 */
export const BluetoothOffIcon = (props: IconProps) => (
  <Icon icon={DefaultBluetoothOffIcon} {...props} />
);

import { default as DefaultBluetoothSearchingIcon } from '~icons/lucide/bluetooth-searching';

/**
 * @see https://lucide.dev/icons/bluetooth-searching
 */
export const BluetoothSearchingIcon = (props: IconProps) => (
  <Icon icon={DefaultBluetoothSearchingIcon} {...props} />
);

import { default as DefaultBoldIcon } from '~icons/lucide/bold';

/**
 * @see https://lucide.dev/icons/bold
 */
export const BoldIcon = (props: IconProps) => (
  <Icon icon={DefaultBoldIcon} {...props} />
);

import { default as DefaultBoltIcon } from '~icons/lucide/bolt';

/**
 * @see https://lucide.dev/icons/bolt
 */
export const BoltIcon = (props: IconProps) => (
  <Icon icon={DefaultBoltIcon} {...props} />
);

import { default as DefaultBombIcon } from '~icons/lucide/bomb';

/**
 * @see https://lucide.dev/icons/bomb
 */
export const BombIcon = (props: IconProps) => (
  <Icon icon={DefaultBombIcon} {...props} />
);

import { default as DefaultBoneIcon } from '~icons/lucide/bone';

/**
 * @see https://lucide.dev/icons/bone
 */
export const BoneIcon = (props: IconProps) => (
  <Icon icon={DefaultBoneIcon} {...props} />
);

import { default as DefaultBookIcon } from '~icons/lucide/book';

/**
 * @see https://lucide.dev/icons/book
 */
export const BookIcon = (props: IconProps) => (
  <Icon icon={DefaultBookIcon} {...props} />
);

import { default as DefaultBookAIcon } from '~icons/lucide/book-a';

/**
 * @see https://lucide.dev/icons/book-a
 */
export const BookAIcon = (props: IconProps) => (
  <Icon icon={DefaultBookAIcon} {...props} />
);

import { default as DefaultBookAlertIcon } from '~icons/lucide/book-alert';

/**
 * @see https://lucide.dev/icons/book-alert
 */
export const BookAlertIcon = (props: IconProps) => (
  <Icon icon={DefaultBookAlertIcon} {...props} />
);

import { default as DefaultBookAudioIcon } from '~icons/lucide/book-audio';

/**
 * @see https://lucide.dev/icons/book-audio
 */
export const BookAudioIcon = (props: IconProps) => (
  <Icon icon={DefaultBookAudioIcon} {...props} />
);

import { default as DefaultBookCheckIcon } from '~icons/lucide/book-check';

/**
 * @see https://lucide.dev/icons/book-check
 */
export const BookCheckIcon = (props: IconProps) => (
  <Icon icon={DefaultBookCheckIcon} {...props} />
);

import { default as DefaultBookCopyIcon } from '~icons/lucide/book-copy';

/**
 * @see https://lucide.dev/icons/book-copy
 */
export const BookCopyIcon = (props: IconProps) => (
  <Icon icon={DefaultBookCopyIcon} {...props} />
);

import { default as DefaultBookDashedIcon } from '~icons/lucide/book-dashed';

/**
 * @see https://lucide.dev/icons/book-dashed
 */
export const BookDashedIcon = (props: IconProps) => (
  <Icon icon={DefaultBookDashedIcon} {...props} />
);

import { default as DefaultBookDownIcon } from '~icons/lucide/book-down';

/**
 * @see https://lucide.dev/icons/book-down
 */
export const BookDownIcon = (props: IconProps) => (
  <Icon icon={DefaultBookDownIcon} {...props} />
);

import { default as DefaultBookHeadphonesIcon } from '~icons/lucide/book-headphones';

/**
 * @see https://lucide.dev/icons/book-headphones
 */
export const BookHeadphonesIcon = (props: IconProps) => (
  <Icon icon={DefaultBookHeadphonesIcon} {...props} />
);

import { default as DefaultBookHeartIcon } from '~icons/lucide/book-heart';

/**
 * @see https://lucide.dev/icons/book-heart
 */
export const BookHeartIcon = (props: IconProps) => (
  <Icon icon={DefaultBookHeartIcon} {...props} />
);

import { default as DefaultBookImageIcon } from '~icons/lucide/book-image';

/**
 * @see https://lucide.dev/icons/book-image
 */
export const BookImageIcon = (props: IconProps) => (
  <Icon icon={DefaultBookImageIcon} {...props} />
);

import { default as DefaultBookKeyIcon } from '~icons/lucide/book-key';

/**
 * @see https://lucide.dev/icons/book-key
 */
export const BookKeyIcon = (props: IconProps) => (
  <Icon icon={DefaultBookKeyIcon} {...props} />
);

import { default as DefaultBookLockIcon } from '~icons/lucide/book-lock';

/**
 * @see https://lucide.dev/icons/book-lock
 */
export const BookLockIcon = (props: IconProps) => (
  <Icon icon={DefaultBookLockIcon} {...props} />
);

import { default as DefaultBookMarkedIcon } from '~icons/lucide/book-marked';

/**
 * @see https://lucide.dev/icons/book-marked
 */
export const BookMarkedIcon = (props: IconProps) => (
  <Icon icon={DefaultBookMarkedIcon} {...props} />
);

import { default as DefaultBookMinusIcon } from '~icons/lucide/book-minus';

/**
 * @see https://lucide.dev/icons/book-minus
 */
export const BookMinusIcon = (props: IconProps) => (
  <Icon icon={DefaultBookMinusIcon} {...props} />
);

import { default as DefaultBookOpenIcon } from '~icons/lucide/book-open';

/**
 * @see https://lucide.dev/icons/book-open
 */
export const BookOpenIcon = (props: IconProps) => (
  <Icon icon={DefaultBookOpenIcon} {...props} />
);

import { default as DefaultBookOpenCheckIcon } from '~icons/lucide/book-open-check';

/**
 * @see https://lucide.dev/icons/book-open-check
 */
export const BookOpenCheckIcon = (props: IconProps) => (
  <Icon icon={DefaultBookOpenCheckIcon} {...props} />
);

import { default as DefaultBookOpenTextIcon } from '~icons/lucide/book-open-text';

/**
 * @see https://lucide.dev/icons/book-open-text
 */
export const BookOpenTextIcon = (props: IconProps) => (
  <Icon icon={DefaultBookOpenTextIcon} {...props} />
);

import { default as DefaultBookPlusIcon } from '~icons/lucide/book-plus';

/**
 * @see https://lucide.dev/icons/book-plus
 */
export const BookPlusIcon = (props: IconProps) => (
  <Icon icon={DefaultBookPlusIcon} {...props} />
);

import { default as DefaultBookTextIcon } from '~icons/lucide/book-text';

/**
 * @see https://lucide.dev/icons/book-text
 */
export const BookTextIcon = (props: IconProps) => (
  <Icon icon={DefaultBookTextIcon} {...props} />
);

import { default as DefaultBookTypeIcon } from '~icons/lucide/book-type';

/**
 * @see https://lucide.dev/icons/book-type
 */
export const BookTypeIcon = (props: IconProps) => (
  <Icon icon={DefaultBookTypeIcon} {...props} />
);

import { default as DefaultBookUpIcon } from '~icons/lucide/book-up';

/**
 * @see https://lucide.dev/icons/book-up
 */
export const BookUpIcon = (props: IconProps) => (
  <Icon icon={DefaultBookUpIcon} {...props} />
);

import { default as DefaultBookUp2Icon } from '~icons/lucide/book-up-2';

/**
 * @see https://lucide.dev/icons/book-up-2
 */
export const BookUp2Icon = (props: IconProps) => (
  <Icon icon={DefaultBookUp2Icon} {...props} />
);

import { default as DefaultBookUserIcon } from '~icons/lucide/book-user';

/**
 * @see https://lucide.dev/icons/book-user
 */
export const BookUserIcon = (props: IconProps) => (
  <Icon icon={DefaultBookUserIcon} {...props} />
);

import { default as DefaultBookXIcon } from '~icons/lucide/book-x';

/**
 * @see https://lucide.dev/icons/book-x
 */
export const BookXIcon = (props: IconProps) => (
  <Icon icon={DefaultBookXIcon} {...props} />
);

import { default as DefaultBookmarkIcon } from '~icons/lucide/bookmark';

/**
 * @see https://lucide.dev/icons/bookmark
 */
export const BookmarkIcon = (props: IconProps) => (
  <Icon icon={DefaultBookmarkIcon} {...props} />
);

import { default as DefaultBookmarkCheckIcon } from '~icons/lucide/bookmark-check';

/**
 * @see https://lucide.dev/icons/bookmark-check
 */
export const BookmarkCheckIcon = (props: IconProps) => (
  <Icon icon={DefaultBookmarkCheckIcon} {...props} />
);

import { default as DefaultBookmarkMinusIcon } from '~icons/lucide/bookmark-minus';

/**
 * @see https://lucide.dev/icons/bookmark-minus
 */
export const BookmarkMinusIcon = (props: IconProps) => (
  <Icon icon={DefaultBookmarkMinusIcon} {...props} />
);

import { default as DefaultBookmarkPlusIcon } from '~icons/lucide/bookmark-plus';

/**
 * @see https://lucide.dev/icons/bookmark-plus
 */
export const BookmarkPlusIcon = (props: IconProps) => (
  <Icon icon={DefaultBookmarkPlusIcon} {...props} />
);

import { default as DefaultBookmarkXIcon } from '~icons/lucide/bookmark-x';

/**
 * @see https://lucide.dev/icons/bookmark-x
 */
export const BookmarkXIcon = (props: IconProps) => (
  <Icon icon={DefaultBookmarkXIcon} {...props} />
);

import { default as DefaultBoomBoxIcon } from '~icons/lucide/boom-box';

/**
 * @see https://lucide.dev/icons/boom-box
 */
export const BoomBoxIcon = (props: IconProps) => (
  <Icon icon={DefaultBoomBoxIcon} {...props} />
);

import { default as DefaultBotIcon } from '~icons/lucide/bot';

/**
 * @see https://lucide.dev/icons/bot
 */
export const BotIcon = (props: IconProps) => (
  <Icon icon={DefaultBotIcon} {...props} />
);

import { default as DefaultBotMessageSquareIcon } from '~icons/lucide/bot-message-square';

/**
 * @see https://lucide.dev/icons/bot-message-square
 */
export const BotMessageSquareIcon = (props: IconProps) => (
  <Icon icon={DefaultBotMessageSquareIcon} {...props} />
);

import { default as DefaultBotOffIcon } from '~icons/lucide/bot-off';

/**
 * @see https://lucide.dev/icons/bot-off
 */
export const BotOffIcon = (props: IconProps) => (
  <Icon icon={DefaultBotOffIcon} {...props} />
);

import { default as DefaultBottleWineIcon } from '~icons/lucide/bottle-wine';

/**
 * @see https://lucide.dev/icons/bottle-wine
 */
export const BottleWineIcon = (props: IconProps) => (
  <Icon icon={DefaultBottleWineIcon} {...props} />
);

import { default as DefaultBowArrowIcon } from '~icons/lucide/bow-arrow';

/**
 * @see https://lucide.dev/icons/bow-arrow
 */
export const BowArrowIcon = (props: IconProps) => (
  <Icon icon={DefaultBowArrowIcon} {...props} />
);

import { default as DefaultBoxIcon } from '~icons/lucide/box';

/**
 * @see https://lucide.dev/icons/box
 */
export const BoxIcon = (props: IconProps) => (
  <Icon icon={DefaultBoxIcon} {...props} />
);

import { default as DefaultBoxesIcon } from '~icons/lucide/boxes';

/**
 * @see https://lucide.dev/icons/boxes
 */
export const BoxesIcon = (props: IconProps) => (
  <Icon icon={DefaultBoxesIcon} {...props} />
);

import { default as DefaultBracesIcon } from '~icons/lucide/braces';

/**
 * @see https://lucide.dev/icons/braces
 */
export const BracesIcon = (props: IconProps) => (
  <Icon icon={DefaultBracesIcon} {...props} />
);

import { default as DefaultBracketsIcon } from '~icons/lucide/brackets';

/**
 * @see https://lucide.dev/icons/brackets
 */
export const BracketsIcon = (props: IconProps) => (
  <Icon icon={DefaultBracketsIcon} {...props} />
);

import { default as DefaultBrainIcon } from '~icons/lucide/brain';

/**
 * @see https://lucide.dev/icons/brain
 */
export const BrainIcon = (props: IconProps) => (
  <Icon icon={DefaultBrainIcon} {...props} />
);

import { default as DefaultBrainCircuitIcon } from '~icons/lucide/brain-circuit';

/**
 * @see https://lucide.dev/icons/brain-circuit
 */
export const BrainCircuitIcon = (props: IconProps) => (
  <Icon icon={DefaultBrainCircuitIcon} {...props} />
);

import { default as DefaultBrainCogIcon } from '~icons/lucide/brain-cog';

/**
 * @see https://lucide.dev/icons/brain-cog
 */
export const BrainCogIcon = (props: IconProps) => (
  <Icon icon={DefaultBrainCogIcon} {...props} />
);

import { default as DefaultBrickWallIcon } from '~icons/lucide/brick-wall';

/**
 * @see https://lucide.dev/icons/brick-wall
 */
export const BrickWallIcon = (props: IconProps) => (
  <Icon icon={DefaultBrickWallIcon} {...props} />
);

import { default as DefaultBrickWallFireIcon } from '~icons/lucide/brick-wall-fire';

/**
 * @see https://lucide.dev/icons/brick-wall-fire
 */
export const BrickWallFireIcon = (props: IconProps) => (
  <Icon icon={DefaultBrickWallFireIcon} {...props} />
);

import { default as DefaultBriefcaseIcon } from '~icons/lucide/briefcase';

/**
 * @see https://lucide.dev/icons/briefcase
 */
export const BriefcaseIcon = (props: IconProps) => (
  <Icon icon={DefaultBriefcaseIcon} {...props} />
);

import { default as DefaultBriefcaseBusinessIcon } from '~icons/lucide/briefcase-business';

/**
 * @see https://lucide.dev/icons/briefcase-business
 */
export const BriefcaseBusinessIcon = (props: IconProps) => (
  <Icon icon={DefaultBriefcaseBusinessIcon} {...props} />
);

import { default as DefaultBriefcaseConveyorBeltIcon } from '~icons/lucide/briefcase-conveyor-belt';

/**
 * @see https://lucide.dev/icons/briefcase-conveyor-belt
 */
export const BriefcaseConveyorBeltIcon = (props: IconProps) => (
  <Icon icon={DefaultBriefcaseConveyorBeltIcon} {...props} />
);

import { default as DefaultBriefcaseMedicalIcon } from '~icons/lucide/briefcase-medical';

/**
 * @see https://lucide.dev/icons/briefcase-medical
 */
export const BriefcaseMedicalIcon = (props: IconProps) => (
  <Icon icon={DefaultBriefcaseMedicalIcon} {...props} />
);

import { default as DefaultBringToFrontIcon } from '~icons/lucide/bring-to-front';

/**
 * @see https://lucide.dev/icons/bring-to-front
 */
export const BringToFrontIcon = (props: IconProps) => (
  <Icon icon={DefaultBringToFrontIcon} {...props} />
);

import { default as DefaultBrushIcon } from '~icons/lucide/brush';

/**
 * @see https://lucide.dev/icons/brush
 */
export const BrushIcon = (props: IconProps) => (
  <Icon icon={DefaultBrushIcon} {...props} />
);

import { default as DefaultBrushCleaningIcon } from '~icons/lucide/brush-cleaning';

/**
 * @see https://lucide.dev/icons/brush-cleaning
 */
export const BrushCleaningIcon = (props: IconProps) => (
  <Icon icon={DefaultBrushCleaningIcon} {...props} />
);

import { default as DefaultBubblesIcon } from '~icons/lucide/bubbles';

/**
 * @see https://lucide.dev/icons/bubbles
 */
export const BubblesIcon = (props: IconProps) => (
  <Icon icon={DefaultBubblesIcon} {...props} />
);

import { default as DefaultBugIcon } from '~icons/lucide/bug';

/**
 * @see https://lucide.dev/icons/bug
 */
export const BugIcon = (props: IconProps) => (
  <Icon icon={DefaultBugIcon} {...props} />
);

import { default as DefaultBugOffIcon } from '~icons/lucide/bug-off';

/**
 * @see https://lucide.dev/icons/bug-off
 */
export const BugOffIcon = (props: IconProps) => (
  <Icon icon={DefaultBugOffIcon} {...props} />
);

import { default as DefaultBugPlayIcon } from '~icons/lucide/bug-play';

/**
 * @see https://lucide.dev/icons/bug-play
 */
export const BugPlayIcon = (props: IconProps) => (
  <Icon icon={DefaultBugPlayIcon} {...props} />
);

import { default as DefaultBuildingIcon } from '~icons/lucide/building';

/**
 * @see https://lucide.dev/icons/building
 */
export const BuildingIcon = (props: IconProps) => (
  <Icon icon={DefaultBuildingIcon} {...props} />
);

import { default as DefaultBuilding2Icon } from '~icons/lucide/building-2';

/**
 * @see https://lucide.dev/icons/building-2
 */
export const Building2Icon = (props: IconProps) => (
  <Icon icon={DefaultBuilding2Icon} {...props} />
);

import { default as DefaultBusIcon } from '~icons/lucide/bus';

/**
 * @see https://lucide.dev/icons/bus
 */
export const BusIcon = (props: IconProps) => (
  <Icon icon={DefaultBusIcon} {...props} />
);

import { default as DefaultBusFrontIcon } from '~icons/lucide/bus-front';

/**
 * @see https://lucide.dev/icons/bus-front
 */
export const BusFrontIcon = (props: IconProps) => (
  <Icon icon={DefaultBusFrontIcon} {...props} />
);

import { default as DefaultCableIcon } from '~icons/lucide/cable';

/**
 * @see https://lucide.dev/icons/cable
 */
export const CableIcon = (props: IconProps) => (
  <Icon icon={DefaultCableIcon} {...props} />
);

import { default as DefaultCableCarIcon } from '~icons/lucide/cable-car';

/**
 * @see https://lucide.dev/icons/cable-car
 */
export const CableCarIcon = (props: IconProps) => (
  <Icon icon={DefaultCableCarIcon} {...props} />
);

import { default as DefaultCakeIcon } from '~icons/lucide/cake';

/**
 * @see https://lucide.dev/icons/cake
 */
export const CakeIcon = (props: IconProps) => (
  <Icon icon={DefaultCakeIcon} {...props} />
);

import { default as DefaultCakeSliceIcon } from '~icons/lucide/cake-slice';

/**
 * @see https://lucide.dev/icons/cake-slice
 */
export const CakeSliceIcon = (props: IconProps) => (
  <Icon icon={DefaultCakeSliceIcon} {...props} />
);

import { default as DefaultCalculatorIcon } from '~icons/lucide/calculator';

/**
 * @see https://lucide.dev/icons/calculator
 */
export const CalculatorIcon = (props: IconProps) => (
  <Icon icon={DefaultCalculatorIcon} {...props} />
);

import { default as DefaultCalendarIcon } from '~icons/lucide/calendar';

/**
 * @see https://lucide.dev/icons/calendar
 */
export const CalendarIcon = (props: IconProps) => (
  <Icon icon={DefaultCalendarIcon} {...props} />
);

import { default as DefaultCalendar1Icon } from '~icons/lucide/calendar-1';

/**
 * @see https://lucide.dev/icons/calendar-1
 */
export const Calendar1Icon = (props: IconProps) => (
  <Icon icon={DefaultCalendar1Icon} {...props} />
);

import { default as DefaultCalendarArrowDownIcon } from '~icons/lucide/calendar-arrow-down';

/**
 * @see https://lucide.dev/icons/calendar-arrow-down
 */
export const CalendarArrowDownIcon = (props: IconProps) => (
  <Icon icon={DefaultCalendarArrowDownIcon} {...props} />
);

import { default as DefaultCalendarArrowUpIcon } from '~icons/lucide/calendar-arrow-up';

/**
 * @see https://lucide.dev/icons/calendar-arrow-up
 */
export const CalendarArrowUpIcon = (props: IconProps) => (
  <Icon icon={DefaultCalendarArrowUpIcon} {...props} />
);

import { default as DefaultCalendarCheckIcon } from '~icons/lucide/calendar-check';

/**
 * @see https://lucide.dev/icons/calendar-check
 */
export const CalendarCheckIcon = (props: IconProps) => (
  <Icon icon={DefaultCalendarCheckIcon} {...props} />
);

import { default as DefaultCalendarCheck2Icon } from '~icons/lucide/calendar-check-2';

/**
 * @see https://lucide.dev/icons/calendar-check-2
 */
export const CalendarCheck2Icon = (props: IconProps) => (
  <Icon icon={DefaultCalendarCheck2Icon} {...props} />
);

import { default as DefaultCalendarClockIcon } from '~icons/lucide/calendar-clock';

/**
 * @see https://lucide.dev/icons/calendar-clock
 */
export const CalendarClockIcon = (props: IconProps) => (
  <Icon icon={DefaultCalendarClockIcon} {...props} />
);

import { default as DefaultCalendarCogIcon } from '~icons/lucide/calendar-cog';

/**
 * @see https://lucide.dev/icons/calendar-cog
 */
export const CalendarCogIcon = (props: IconProps) => (
  <Icon icon={DefaultCalendarCogIcon} {...props} />
);

import { default as DefaultCalendarDaysIcon } from '~icons/lucide/calendar-days';

/**
 * @see https://lucide.dev/icons/calendar-days
 */
export const CalendarDaysIcon = (props: IconProps) => (
  <Icon icon={DefaultCalendarDaysIcon} {...props} />
);

import { default as DefaultCalendarFoldIcon } from '~icons/lucide/calendar-fold';

/**
 * @see https://lucide.dev/icons/calendar-fold
 */
export const CalendarFoldIcon = (props: IconProps) => (
  <Icon icon={DefaultCalendarFoldIcon} {...props} />
);

import { default as DefaultCalendarHeartIcon } from '~icons/lucide/calendar-heart';

/**
 * @see https://lucide.dev/icons/calendar-heart
 */
export const CalendarHeartIcon = (props: IconProps) => (
  <Icon icon={DefaultCalendarHeartIcon} {...props} />
);

import { default as DefaultCalendarMinusIcon } from '~icons/lucide/calendar-minus';

/**
 * @see https://lucide.dev/icons/calendar-minus
 */
export const CalendarMinusIcon = (props: IconProps) => (
  <Icon icon={DefaultCalendarMinusIcon} {...props} />
);

import { default as DefaultCalendarMinus2Icon } from '~icons/lucide/calendar-minus-2';

/**
 * @see https://lucide.dev/icons/calendar-minus-2
 */
export const CalendarMinus2Icon = (props: IconProps) => (
  <Icon icon={DefaultCalendarMinus2Icon} {...props} />
);

import { default as DefaultCalendarOffIcon } from '~icons/lucide/calendar-off';

/**
 * @see https://lucide.dev/icons/calendar-off
 */
export const CalendarOffIcon = (props: IconProps) => (
  <Icon icon={DefaultCalendarOffIcon} {...props} />
);

import { default as DefaultCalendarPlusIcon } from '~icons/lucide/calendar-plus';

/**
 * @see https://lucide.dev/icons/calendar-plus
 */
export const CalendarPlusIcon = (props: IconProps) => (
  <Icon icon={DefaultCalendarPlusIcon} {...props} />
);

import { default as DefaultCalendarPlus2Icon } from '~icons/lucide/calendar-plus-2';

/**
 * @see https://lucide.dev/icons/calendar-plus-2
 */
export const CalendarPlus2Icon = (props: IconProps) => (
  <Icon icon={DefaultCalendarPlus2Icon} {...props} />
);

import { default as DefaultCalendarRangeIcon } from '~icons/lucide/calendar-range';

/**
 * @see https://lucide.dev/icons/calendar-range
 */
export const CalendarRangeIcon = (props: IconProps) => (
  <Icon icon={DefaultCalendarRangeIcon} {...props} />
);

import { default as DefaultCalendarSearchIcon } from '~icons/lucide/calendar-search';

/**
 * @see https://lucide.dev/icons/calendar-search
 */
export const CalendarSearchIcon = (props: IconProps) => (
  <Icon icon={DefaultCalendarSearchIcon} {...props} />
);

import { default as DefaultCalendarSyncIcon } from '~icons/lucide/calendar-sync';

/**
 * @see https://lucide.dev/icons/calendar-sync
 */
export const CalendarSyncIcon = (props: IconProps) => (
  <Icon icon={DefaultCalendarSyncIcon} {...props} />
);

import { default as DefaultCalendarXIcon } from '~icons/lucide/calendar-x';

/**
 * @see https://lucide.dev/icons/calendar-x
 */
export const CalendarXIcon = (props: IconProps) => (
  <Icon icon={DefaultCalendarXIcon} {...props} />
);

import { default as DefaultCalendarX2Icon } from '~icons/lucide/calendar-x-2';

/**
 * @see https://lucide.dev/icons/calendar-x-2
 */
export const CalendarX2Icon = (props: IconProps) => (
  <Icon icon={DefaultCalendarX2Icon} {...props} />
);

import { default as DefaultCameraIcon } from '~icons/lucide/camera';

/**
 * @see https://lucide.dev/icons/camera
 */
export const CameraIcon = (props: IconProps) => (
  <Icon icon={DefaultCameraIcon} {...props} />
);

import { default as DefaultCameraOffIcon } from '~icons/lucide/camera-off';

/**
 * @see https://lucide.dev/icons/camera-off
 */
export const CameraOffIcon = (props: IconProps) => (
  <Icon icon={DefaultCameraOffIcon} {...props} />
);

import { default as DefaultCandlestickChartIcon } from '~icons/lucide/candlestick-chart';

/**
 * @see https://lucide.dev/icons/candlestick-chart
 */
export const CandlestickChartIcon = (props: IconProps) => (
  <Icon icon={DefaultCandlestickChartIcon} {...props} />
);

import { default as DefaultCandyIcon } from '~icons/lucide/candy';

/**
 * @see https://lucide.dev/icons/candy
 */
export const CandyIcon = (props: IconProps) => (
  <Icon icon={DefaultCandyIcon} {...props} />
);

import { default as DefaultCandyCaneIcon } from '~icons/lucide/candy-cane';

/**
 * @see https://lucide.dev/icons/candy-cane
 */
export const CandyCaneIcon = (props: IconProps) => (
  <Icon icon={DefaultCandyCaneIcon} {...props} />
);

import { default as DefaultCandyOffIcon } from '~icons/lucide/candy-off';

/**
 * @see https://lucide.dev/icons/candy-off
 */
export const CandyOffIcon = (props: IconProps) => (
  <Icon icon={DefaultCandyOffIcon} {...props} />
);

import { default as DefaultCannabisIcon } from '~icons/lucide/cannabis';

/**
 * @see https://lucide.dev/icons/cannabis
 */
export const CannabisIcon = (props: IconProps) => (
  <Icon icon={DefaultCannabisIcon} {...props} />
);

import { default as DefaultCaptionsIcon } from '~icons/lucide/captions';

/**
 * @see https://lucide.dev/icons/captions
 */
export const CaptionsIcon = (props: IconProps) => (
  <Icon icon={DefaultCaptionsIcon} {...props} />
);

import { default as DefaultCaptionsOffIcon } from '~icons/lucide/captions-off';

/**
 * @see https://lucide.dev/icons/captions-off
 */
export const CaptionsOffIcon = (props: IconProps) => (
  <Icon icon={DefaultCaptionsOffIcon} {...props} />
);

import { default as DefaultCarIcon } from '~icons/lucide/car';

/**
 * @see https://lucide.dev/icons/car
 */
export const CarIcon = (props: IconProps) => (
  <Icon icon={DefaultCarIcon} {...props} />
);

import { default as DefaultCarFrontIcon } from '~icons/lucide/car-front';

/**
 * @see https://lucide.dev/icons/car-front
 */
export const CarFrontIcon = (props: IconProps) => (
  <Icon icon={DefaultCarFrontIcon} {...props} />
);

import { default as DefaultCarTaxiFrontIcon } from '~icons/lucide/car-taxi-front';

/**
 * @see https://lucide.dev/icons/car-taxi-front
 */
export const CarTaxiFrontIcon = (props: IconProps) => (
  <Icon icon={DefaultCarTaxiFrontIcon} {...props} />
);

import { default as DefaultCaravanIcon } from '~icons/lucide/caravan';

/**
 * @see https://lucide.dev/icons/caravan
 */
export const CaravanIcon = (props: IconProps) => (
  <Icon icon={DefaultCaravanIcon} {...props} />
);

import { default as DefaultCardSimIcon } from '~icons/lucide/card-sim';

/**
 * @see https://lucide.dev/icons/card-sim
 */
export const CardSimIcon = (props: IconProps) => (
  <Icon icon={DefaultCardSimIcon} {...props} />
);

import { default as DefaultCarrotIcon } from '~icons/lucide/carrot';

/**
 * @see https://lucide.dev/icons/carrot
 */
export const CarrotIcon = (props: IconProps) => (
  <Icon icon={DefaultCarrotIcon} {...props} />
);

import { default as DefaultCaseLowerIcon } from '~icons/lucide/case-lower';

/**
 * @see https://lucide.dev/icons/case-lower
 */
export const CaseLowerIcon = (props: IconProps) => (
  <Icon icon={DefaultCaseLowerIcon} {...props} />
);

import { default as DefaultCaseSensitiveIcon } from '~icons/lucide/case-sensitive';

/**
 * @see https://lucide.dev/icons/case-sensitive
 */
export const CaseSensitiveIcon = (props: IconProps) => (
  <Icon icon={DefaultCaseSensitiveIcon} {...props} />
);

import { default as DefaultCaseUpperIcon } from '~icons/lucide/case-upper';

/**
 * @see https://lucide.dev/icons/case-upper
 */
export const CaseUpperIcon = (props: IconProps) => (
  <Icon icon={DefaultCaseUpperIcon} {...props} />
);

import { default as DefaultCassetteTapeIcon } from '~icons/lucide/cassette-tape';

/**
 * @see https://lucide.dev/icons/cassette-tape
 */
export const CassetteTapeIcon = (props: IconProps) => (
  <Icon icon={DefaultCassetteTapeIcon} {...props} />
);

import { default as DefaultCastIcon } from '~icons/lucide/cast';

/**
 * @see https://lucide.dev/icons/cast
 */
export const CastIcon = (props: IconProps) => (
  <Icon icon={DefaultCastIcon} {...props} />
);

import { default as DefaultCastleIcon } from '~icons/lucide/castle';

/**
 * @see https://lucide.dev/icons/castle
 */
export const CastleIcon = (props: IconProps) => (
  <Icon icon={DefaultCastleIcon} {...props} />
);

import { default as DefaultCatIcon } from '~icons/lucide/cat';

/**
 * @see https://lucide.dev/icons/cat
 */
export const CatIcon = (props: IconProps) => (
  <Icon icon={DefaultCatIcon} {...props} />
);

import { default as DefaultCctvIcon } from '~icons/lucide/cctv';

/**
 * @see https://lucide.dev/icons/cctv
 */
export const CctvIcon = (props: IconProps) => (
  <Icon icon={DefaultCctvIcon} {...props} />
);

import { default as DefaultChartAreaIcon } from '~icons/lucide/chart-area';

/**
 * @see https://lucide.dev/icons/chart-area
 */
export const ChartAreaIcon = (props: IconProps) => (
  <Icon icon={DefaultChartAreaIcon} {...props} />
);

import { default as DefaultChartBarIcon } from '~icons/lucide/chart-bar';

/**
 * @see https://lucide.dev/icons/chart-bar
 */
export const ChartBarIcon = (props: IconProps) => (
  <Icon icon={DefaultChartBarIcon} {...props} />
);

import { default as DefaultChartBarBigIcon } from '~icons/lucide/chart-bar-big';

/**
 * @see https://lucide.dev/icons/chart-bar-big
 */
export const ChartBarBigIcon = (props: IconProps) => (
  <Icon icon={DefaultChartBarBigIcon} {...props} />
);

import { default as DefaultChartBarDecreasingIcon } from '~icons/lucide/chart-bar-decreasing';

/**
 * @see https://lucide.dev/icons/chart-bar-decreasing
 */
export const ChartBarDecreasingIcon = (props: IconProps) => (
  <Icon icon={DefaultChartBarDecreasingIcon} {...props} />
);

import { default as DefaultChartBarIncreasingIcon } from '~icons/lucide/chart-bar-increasing';

/**
 * @see https://lucide.dev/icons/chart-bar-increasing
 */
export const ChartBarIncreasingIcon = (props: IconProps) => (
  <Icon icon={DefaultChartBarIncreasingIcon} {...props} />
);

import { default as DefaultChartBarStackedIcon } from '~icons/lucide/chart-bar-stacked';

/**
 * @see https://lucide.dev/icons/chart-bar-stacked
 */
export const ChartBarStackedIcon = (props: IconProps) => (
  <Icon icon={DefaultChartBarStackedIcon} {...props} />
);

import { default as DefaultChartCandlestickIcon } from '~icons/lucide/chart-candlestick';

/**
 * @see https://lucide.dev/icons/chart-candlestick
 */
export const ChartCandlestickIcon = (props: IconProps) => (
  <Icon icon={DefaultChartCandlestickIcon} {...props} />
);

import { default as DefaultChartColumnIcon } from '~icons/lucide/chart-column';

/**
 * @see https://lucide.dev/icons/chart-column
 */
export const ChartColumnIcon = (props: IconProps) => (
  <Icon icon={DefaultChartColumnIcon} {...props} />
);

import { default as DefaultChartColumnBigIcon } from '~icons/lucide/chart-column-big';

/**
 * @see https://lucide.dev/icons/chart-column-big
 */
export const ChartColumnBigIcon = (props: IconProps) => (
  <Icon icon={DefaultChartColumnBigIcon} {...props} />
);

import { default as DefaultChartColumnDecreasingIcon } from '~icons/lucide/chart-column-decreasing';

/**
 * @see https://lucide.dev/icons/chart-column-decreasing
 */
export const ChartColumnDecreasingIcon = (props: IconProps) => (
  <Icon icon={DefaultChartColumnDecreasingIcon} {...props} />
);

import { default as DefaultChartColumnIncreasingIcon } from '~icons/lucide/chart-column-increasing';

/**
 * @see https://lucide.dev/icons/chart-column-increasing
 */
export const ChartColumnIncreasingIcon = (props: IconProps) => (
  <Icon icon={DefaultChartColumnIncreasingIcon} {...props} />
);

import { default as DefaultChartColumnStackedIcon } from '~icons/lucide/chart-column-stacked';

/**
 * @see https://lucide.dev/icons/chart-column-stacked
 */
export const ChartColumnStackedIcon = (props: IconProps) => (
  <Icon icon={DefaultChartColumnStackedIcon} {...props} />
);

import { default as DefaultChartGanttIcon } from '~icons/lucide/chart-gantt';

/**
 * @see https://lucide.dev/icons/chart-gantt
 */
export const ChartGanttIcon = (props: IconProps) => (
  <Icon icon={DefaultChartGanttIcon} {...props} />
);

import { default as DefaultChartLineIcon } from '~icons/lucide/chart-line';

/**
 * @see https://lucide.dev/icons/chart-line
 */
export const ChartLineIcon = (props: IconProps) => (
  <Icon icon={DefaultChartLineIcon} {...props} />
);

import { default as DefaultChartNetworkIcon } from '~icons/lucide/chart-network';

/**
 * @see https://lucide.dev/icons/chart-network
 */
export const ChartNetworkIcon = (props: IconProps) => (
  <Icon icon={DefaultChartNetworkIcon} {...props} />
);

import { default as DefaultChartNoAxesColumnIcon } from '~icons/lucide/chart-no-axes-column';

/**
 * @see https://lucide.dev/icons/chart-no-axes-column
 */
export const ChartNoAxesColumnIcon = (props: IconProps) => (
  <Icon icon={DefaultChartNoAxesColumnIcon} {...props} />
);

import { default as DefaultChartNoAxesColumnDecreasingIcon } from '~icons/lucide/chart-no-axes-column-decreasing';

/**
 * @see https://lucide.dev/icons/chart-no-axes-column-decreasing
 */
export const ChartNoAxesColumnDecreasingIcon = (props: IconProps) => (
  <Icon icon={DefaultChartNoAxesColumnDecreasingIcon} {...props} />
);

import { default as DefaultChartNoAxesColumnIncreasingIcon } from '~icons/lucide/chart-no-axes-column-increasing';

/**
 * @see https://lucide.dev/icons/chart-no-axes-column-increasing
 */
export const ChartNoAxesColumnIncreasingIcon = (props: IconProps) => (
  <Icon icon={DefaultChartNoAxesColumnIncreasingIcon} {...props} />
);

import { default as DefaultChartNoAxesCombinedIcon } from '~icons/lucide/chart-no-axes-combined';

/**
 * @see https://lucide.dev/icons/chart-no-axes-combined
 */
export const ChartNoAxesCombinedIcon = (props: IconProps) => (
  <Icon icon={DefaultChartNoAxesCombinedIcon} {...props} />
);

import { default as DefaultChartNoAxesGanttIcon } from '~icons/lucide/chart-no-axes-gantt';

/**
 * @see https://lucide.dev/icons/chart-no-axes-gantt
 */
export const ChartNoAxesGanttIcon = (props: IconProps) => (
  <Icon icon={DefaultChartNoAxesGanttIcon} {...props} />
);

import { default as DefaultChartPieIcon } from '~icons/lucide/chart-pie';

/**
 * @see https://lucide.dev/icons/chart-pie
 */
export const ChartPieIcon = (props: IconProps) => (
  <Icon icon={DefaultChartPieIcon} {...props} />
);

import { default as DefaultChartScatterIcon } from '~icons/lucide/chart-scatter';

/**
 * @see https://lucide.dev/icons/chart-scatter
 */
export const ChartScatterIcon = (props: IconProps) => (
  <Icon icon={DefaultChartScatterIcon} {...props} />
);

import { default as DefaultChartSplineIcon } from '~icons/lucide/chart-spline';

/**
 * @see https://lucide.dev/icons/chart-spline
 */
export const ChartSplineIcon = (props: IconProps) => (
  <Icon icon={DefaultChartSplineIcon} {...props} />
);

import { default as DefaultCheckIcon } from '~icons/lucide/check';

/**
 * @see https://lucide.dev/icons/check
 */
export const CheckIcon = (props: IconProps) => (
  <Icon icon={DefaultCheckIcon} {...props} />
);

import { default as DefaultCheckCheckIcon } from '~icons/lucide/check-check';

/**
 * @see https://lucide.dev/icons/check-check
 */
export const CheckCheckIcon = (props: IconProps) => (
  <Icon icon={DefaultCheckCheckIcon} {...props} />
);

import { default as DefaultCheckLineIcon } from '~icons/lucide/check-line';

/**
 * @see https://lucide.dev/icons/check-line
 */
export const CheckLineIcon = (props: IconProps) => (
  <Icon icon={DefaultCheckLineIcon} {...props} />
);

import { default as DefaultChefHatIcon } from '~icons/lucide/chef-hat';

/**
 * @see https://lucide.dev/icons/chef-hat
 */
export const ChefHatIcon = (props: IconProps) => (
  <Icon icon={DefaultChefHatIcon} {...props} />
);

import { default as DefaultCherryIcon } from '~icons/lucide/cherry';

/**
 * @see https://lucide.dev/icons/cherry
 */
export const CherryIcon = (props: IconProps) => (
  <Icon icon={DefaultCherryIcon} {...props} />
);

import { default as DefaultChevronDownIcon } from '~icons/lucide/chevron-down';

/**
 * @see https://lucide.dev/icons/chevron-down
 */
export const ChevronDownIcon = (props: IconProps) => (
  <Icon icon={DefaultChevronDownIcon} {...props} />
);

import { default as DefaultChevronFirstIcon } from '~icons/lucide/chevron-first';

/**
 * @see https://lucide.dev/icons/chevron-first
 */
export const ChevronFirstIcon = (props: IconProps) => (
  <Icon icon={DefaultChevronFirstIcon} {...props} />
);

import { default as DefaultChevronLastIcon } from '~icons/lucide/chevron-last';

/**
 * @see https://lucide.dev/icons/chevron-last
 */
export const ChevronLastIcon = (props: IconProps) => (
  <Icon icon={DefaultChevronLastIcon} {...props} />
);

import { default as DefaultChevronLeftIcon } from '~icons/lucide/chevron-left';

/**
 * @see https://lucide.dev/icons/chevron-left
 */
export const ChevronLeftIcon = (props: IconProps) => (
  <Icon icon={DefaultChevronLeftIcon} {...props} />
);

import { default as DefaultChevronRightIcon } from '~icons/lucide/chevron-right';

/**
 * @see https://lucide.dev/icons/chevron-right
 */
export const ChevronRightIcon = (props: IconProps) => (
  <Icon icon={DefaultChevronRightIcon} {...props} />
);

import { default as DefaultChevronUpIcon } from '~icons/lucide/chevron-up';

/**
 * @see https://lucide.dev/icons/chevron-up
 */
export const ChevronUpIcon = (props: IconProps) => (
  <Icon icon={DefaultChevronUpIcon} {...props} />
);

import { default as DefaultChevronsDownIcon } from '~icons/lucide/chevrons-down';

/**
 * @see https://lucide.dev/icons/chevrons-down
 */
export const ChevronsDownIcon = (props: IconProps) => (
  <Icon icon={DefaultChevronsDownIcon} {...props} />
);

import { default as DefaultChevronsDownUpIcon } from '~icons/lucide/chevrons-down-up';

/**
 * @see https://lucide.dev/icons/chevrons-down-up
 */
export const ChevronsDownUpIcon = (props: IconProps) => (
  <Icon icon={DefaultChevronsDownUpIcon} {...props} />
);

import { default as DefaultChevronsLeftIcon } from '~icons/lucide/chevrons-left';

/**
 * @see https://lucide.dev/icons/chevrons-left
 */
export const ChevronsLeftIcon = (props: IconProps) => (
  <Icon icon={DefaultChevronsLeftIcon} {...props} />
);

import { default as DefaultChevronsLeftRightIcon } from '~icons/lucide/chevrons-left-right';

/**
 * @see https://lucide.dev/icons/chevrons-left-right
 */
export const ChevronsLeftRightIcon = (props: IconProps) => (
  <Icon icon={DefaultChevronsLeftRightIcon} {...props} />
);

import { default as DefaultChevronsLeftRightEllipsisIcon } from '~icons/lucide/chevrons-left-right-ellipsis';

/**
 * @see https://lucide.dev/icons/chevrons-left-right-ellipsis
 */
export const ChevronsLeftRightEllipsisIcon = (props: IconProps) => (
  <Icon icon={DefaultChevronsLeftRightEllipsisIcon} {...props} />
);

import { default as DefaultChevronsRightIcon } from '~icons/lucide/chevrons-right';

/**
 * @see https://lucide.dev/icons/chevrons-right
 */
export const ChevronsRightIcon = (props: IconProps) => (
  <Icon icon={DefaultChevronsRightIcon} {...props} />
);

import { default as DefaultChevronsRightLeftIcon } from '~icons/lucide/chevrons-right-left';

/**
 * @see https://lucide.dev/icons/chevrons-right-left
 */
export const ChevronsRightLeftIcon = (props: IconProps) => (
  <Icon icon={DefaultChevronsRightLeftIcon} {...props} />
);

import { default as DefaultChevronsUpIcon } from '~icons/lucide/chevrons-up';

/**
 * @see https://lucide.dev/icons/chevrons-up
 */
export const ChevronsUpIcon = (props: IconProps) => (
  <Icon icon={DefaultChevronsUpIcon} {...props} />
);

import { default as DefaultChevronsUpDownIcon } from '~icons/lucide/chevrons-up-down';

/**
 * @see https://lucide.dev/icons/chevrons-up-down
 */
export const ChevronsUpDownIcon = (props: IconProps) => (
  <Icon icon={DefaultChevronsUpDownIcon} {...props} />
);

import { default as DefaultChromeIcon } from '~icons/lucide/chrome';

/**
 * @see https://lucide.dev/icons/chrome
 */
export const ChromeIcon = (props: IconProps) => (
  <Icon icon={DefaultChromeIcon} {...props} />
);

import { default as DefaultChurchIcon } from '~icons/lucide/church';

/**
 * @see https://lucide.dev/icons/church
 */
export const ChurchIcon = (props: IconProps) => (
  <Icon icon={DefaultChurchIcon} {...props} />
);

import { default as DefaultCigaretteIcon } from '~icons/lucide/cigarette';

/**
 * @see https://lucide.dev/icons/cigarette
 */
export const CigaretteIcon = (props: IconProps) => (
  <Icon icon={DefaultCigaretteIcon} {...props} />
);

import { default as DefaultCigaretteOffIcon } from '~icons/lucide/cigarette-off';

/**
 * @see https://lucide.dev/icons/cigarette-off
 */
export const CigaretteOffIcon = (props: IconProps) => (
  <Icon icon={DefaultCigaretteOffIcon} {...props} />
);

import { default as DefaultCircleIcon } from '~icons/lucide/circle';

/**
 * @see https://lucide.dev/icons/circle
 */
export const CircleIcon = (props: IconProps) => (
  <Icon icon={DefaultCircleIcon} {...props} />
);

import { default as DefaultCircleAlertIcon } from '~icons/lucide/circle-alert';

/**
 * @see https://lucide.dev/icons/circle-alert
 */
export const CircleAlertIcon = (props: IconProps) => (
  <Icon icon={DefaultCircleAlertIcon} {...props} />
);

import { default as DefaultCircleArrowDownIcon } from '~icons/lucide/circle-arrow-down';

/**
 * @see https://lucide.dev/icons/circle-arrow-down
 */
export const CircleArrowDownIcon = (props: IconProps) => (
  <Icon icon={DefaultCircleArrowDownIcon} {...props} />
);

import { default as DefaultCircleArrowLeftIcon } from '~icons/lucide/circle-arrow-left';

/**
 * @see https://lucide.dev/icons/circle-arrow-left
 */
export const CircleArrowLeftIcon = (props: IconProps) => (
  <Icon icon={DefaultCircleArrowLeftIcon} {...props} />
);

import { default as DefaultCircleArrowOutDownLeftIcon } from '~icons/lucide/circle-arrow-out-down-left';

/**
 * @see https://lucide.dev/icons/circle-arrow-out-down-left
 */
export const CircleArrowOutDownLeftIcon = (props: IconProps) => (
  <Icon icon={DefaultCircleArrowOutDownLeftIcon} {...props} />
);

import { default as DefaultCircleArrowOutDownRightIcon } from '~icons/lucide/circle-arrow-out-down-right';

/**
 * @see https://lucide.dev/icons/circle-arrow-out-down-right
 */
export const CircleArrowOutDownRightIcon = (props: IconProps) => (
  <Icon icon={DefaultCircleArrowOutDownRightIcon} {...props} />
);

import { default as DefaultCircleArrowOutUpLeftIcon } from '~icons/lucide/circle-arrow-out-up-left';

/**
 * @see https://lucide.dev/icons/circle-arrow-out-up-left
 */
export const CircleArrowOutUpLeftIcon = (props: IconProps) => (
  <Icon icon={DefaultCircleArrowOutUpLeftIcon} {...props} />
);

import { default as DefaultCircleArrowOutUpRightIcon } from '~icons/lucide/circle-arrow-out-up-right';

/**
 * @see https://lucide.dev/icons/circle-arrow-out-up-right
 */
export const CircleArrowOutUpRightIcon = (props: IconProps) => (
  <Icon icon={DefaultCircleArrowOutUpRightIcon} {...props} />
);

import { default as DefaultCircleArrowRightIcon } from '~icons/lucide/circle-arrow-right';

/**
 * @see https://lucide.dev/icons/circle-arrow-right
 */
export const CircleArrowRightIcon = (props: IconProps) => (
  <Icon icon={DefaultCircleArrowRightIcon} {...props} />
);

import { default as DefaultCircleArrowUpIcon } from '~icons/lucide/circle-arrow-up';

/**
 * @see https://lucide.dev/icons/circle-arrow-up
 */
export const CircleArrowUpIcon = (props: IconProps) => (
  <Icon icon={DefaultCircleArrowUpIcon} {...props} />
);

import { default as DefaultCircleCheckIcon } from '~icons/lucide/circle-check';

/**
 * @see https://lucide.dev/icons/circle-check
 */
export const CircleCheckIcon = (props: IconProps) => (
  <Icon icon={DefaultCircleCheckIcon} {...props} />
);

import { default as DefaultCircleCheckBigIcon } from '~icons/lucide/circle-check-big';

/**
 * @see https://lucide.dev/icons/circle-check-big
 */
export const CircleCheckBigIcon = (props: IconProps) => (
  <Icon icon={DefaultCircleCheckBigIcon} {...props} />
);

import { default as DefaultCircleChevronDownIcon } from '~icons/lucide/circle-chevron-down';

/**
 * @see https://lucide.dev/icons/circle-chevron-down
 */
export const CircleChevronDownIcon = (props: IconProps) => (
  <Icon icon={DefaultCircleChevronDownIcon} {...props} />
);

import { default as DefaultCircleChevronLeftIcon } from '~icons/lucide/circle-chevron-left';

/**
 * @see https://lucide.dev/icons/circle-chevron-left
 */
export const CircleChevronLeftIcon = (props: IconProps) => (
  <Icon icon={DefaultCircleChevronLeftIcon} {...props} />
);

import { default as DefaultCircleChevronRightIcon } from '~icons/lucide/circle-chevron-right';

/**
 * @see https://lucide.dev/icons/circle-chevron-right
 */
export const CircleChevronRightIcon = (props: IconProps) => (
  <Icon icon={DefaultCircleChevronRightIcon} {...props} />
);

import { default as DefaultCircleChevronUpIcon } from '~icons/lucide/circle-chevron-up';

/**
 * @see https://lucide.dev/icons/circle-chevron-up
 */
export const CircleChevronUpIcon = (props: IconProps) => (
  <Icon icon={DefaultCircleChevronUpIcon} {...props} />
);

import { default as DefaultCircleDashedIcon } from '~icons/lucide/circle-dashed';

/**
 * @see https://lucide.dev/icons/circle-dashed
 */
export const CircleDashedIcon = (props: IconProps) => (
  <Icon icon={DefaultCircleDashedIcon} {...props} />
);

import { default as DefaultCircleDivideIcon } from '~icons/lucide/circle-divide';

/**
 * @see https://lucide.dev/icons/circle-divide
 */
export const CircleDivideIcon = (props: IconProps) => (
  <Icon icon={DefaultCircleDivideIcon} {...props} />
);

import { default as DefaultCircleDollarSignIcon } from '~icons/lucide/circle-dollar-sign';

/**
 * @see https://lucide.dev/icons/circle-dollar-sign
 */
export const CircleDollarSignIcon = (props: IconProps) => (
  <Icon icon={DefaultCircleDollarSignIcon} {...props} />
);

import { default as DefaultCircleDotIcon } from '~icons/lucide/circle-dot';

/**
 * @see https://lucide.dev/icons/circle-dot
 */
export const CircleDotIcon = (props: IconProps) => (
  <Icon icon={DefaultCircleDotIcon} {...props} />
);

import { default as DefaultCircleDotDashedIcon } from '~icons/lucide/circle-dot-dashed';

/**
 * @see https://lucide.dev/icons/circle-dot-dashed
 */
export const CircleDotDashedIcon = (props: IconProps) => (
  <Icon icon={DefaultCircleDotDashedIcon} {...props} />
);

import { default as DefaultCircleEllipsisIcon } from '~icons/lucide/circle-ellipsis';

/**
 * @see https://lucide.dev/icons/circle-ellipsis
 */
export const CircleEllipsisIcon = (props: IconProps) => (
  <Icon icon={DefaultCircleEllipsisIcon} {...props} />
);

import { default as DefaultCircleEqualIcon } from '~icons/lucide/circle-equal';

/**
 * @see https://lucide.dev/icons/circle-equal
 */
export const CircleEqualIcon = (props: IconProps) => (
  <Icon icon={DefaultCircleEqualIcon} {...props} />
);

import { default as DefaultCircleFadingArrowUpIcon } from '~icons/lucide/circle-fading-arrow-up';

/**
 * @see https://lucide.dev/icons/circle-fading-arrow-up
 */
export const CircleFadingArrowUpIcon = (props: IconProps) => (
  <Icon icon={DefaultCircleFadingArrowUpIcon} {...props} />
);

import { default as DefaultCircleFadingPlusIcon } from '~icons/lucide/circle-fading-plus';

/**
 * @see https://lucide.dev/icons/circle-fading-plus
 */
export const CircleFadingPlusIcon = (props: IconProps) => (
  <Icon icon={DefaultCircleFadingPlusIcon} {...props} />
);

import { default as DefaultCircleGaugeIcon } from '~icons/lucide/circle-gauge';

/**
 * @see https://lucide.dev/icons/circle-gauge
 */
export const CircleGaugeIcon = (props: IconProps) => (
  <Icon icon={DefaultCircleGaugeIcon} {...props} />
);

import { default as DefaultCircleMinusIcon } from '~icons/lucide/circle-minus';

/**
 * @see https://lucide.dev/icons/circle-minus
 */
export const CircleMinusIcon = (props: IconProps) => (
  <Icon icon={DefaultCircleMinusIcon} {...props} />
);

import { default as DefaultCircleOffIcon } from '~icons/lucide/circle-off';

/**
 * @see https://lucide.dev/icons/circle-off
 */
export const CircleOffIcon = (props: IconProps) => (
  <Icon icon={DefaultCircleOffIcon} {...props} />
);

import { default as DefaultCircleParkingIcon } from '~icons/lucide/circle-parking';

/**
 * @see https://lucide.dev/icons/circle-parking
 */
export const CircleParkingIcon = (props: IconProps) => (
  <Icon icon={DefaultCircleParkingIcon} {...props} />
);

import { default as DefaultCircleParkingOffIcon } from '~icons/lucide/circle-parking-off';

/**
 * @see https://lucide.dev/icons/circle-parking-off
 */
export const CircleParkingOffIcon = (props: IconProps) => (
  <Icon icon={DefaultCircleParkingOffIcon} {...props} />
);

import { default as DefaultCirclePauseIcon } from '~icons/lucide/circle-pause';

/**
 * @see https://lucide.dev/icons/circle-pause
 */
export const CirclePauseIcon = (props: IconProps) => (
  <Icon icon={DefaultCirclePauseIcon} {...props} />
);

import { default as DefaultCirclePercentIcon } from '~icons/lucide/circle-percent';

/**
 * @see https://lucide.dev/icons/circle-percent
 */
export const CirclePercentIcon = (props: IconProps) => (
  <Icon icon={DefaultCirclePercentIcon} {...props} />
);

import { default as DefaultCirclePlayIcon } from '~icons/lucide/circle-play';

/**
 * @see https://lucide.dev/icons/circle-play
 */
export const CirclePlayIcon = (props: IconProps) => (
  <Icon icon={DefaultCirclePlayIcon} {...props} />
);

import { default as DefaultCirclePlusIcon } from '~icons/lucide/circle-plus';

/**
 * @see https://lucide.dev/icons/circle-plus
 */
export const CirclePlusIcon = (props: IconProps) => (
  <Icon icon={DefaultCirclePlusIcon} {...props} />
);

import { default as DefaultCirclePoundSterlingIcon } from '~icons/lucide/circle-pound-sterling';

/**
 * @see https://lucide.dev/icons/circle-pound-sterling
 */
export const CirclePoundSterlingIcon = (props: IconProps) => (
  <Icon icon={DefaultCirclePoundSterlingIcon} {...props} />
);

import { default as DefaultCirclePowerIcon } from '~icons/lucide/circle-power';

/**
 * @see https://lucide.dev/icons/circle-power
 */
export const CirclePowerIcon = (props: IconProps) => (
  <Icon icon={DefaultCirclePowerIcon} {...props} />
);

import { default as DefaultCircleQuestionMarkIcon } from '~icons/lucide/circle-question-mark';

/**
 * @see https://lucide.dev/icons/circle-question-mark
 */
export const CircleQuestionMarkIcon = (props: IconProps) => (
  <Icon icon={DefaultCircleQuestionMarkIcon} {...props} />
);

import { default as DefaultCircleSlashIcon } from '~icons/lucide/circle-slash';

/**
 * @see https://lucide.dev/icons/circle-slash
 */
export const CircleSlashIcon = (props: IconProps) => (
  <Icon icon={DefaultCircleSlashIcon} {...props} />
);

import { default as DefaultCircleSlash2Icon } from '~icons/lucide/circle-slash-2';

/**
 * @see https://lucide.dev/icons/circle-slash-2
 */
export const CircleSlash2Icon = (props: IconProps) => (
  <Icon icon={DefaultCircleSlash2Icon} {...props} />
);

import { default as DefaultCircleSmallIcon } from '~icons/lucide/circle-small';

/**
 * @see https://lucide.dev/icons/circle-small
 */
export const CircleSmallIcon = (props: IconProps) => (
  <Icon icon={DefaultCircleSmallIcon} {...props} />
);

import { default as DefaultCircleStopIcon } from '~icons/lucide/circle-stop';

/**
 * @see https://lucide.dev/icons/circle-stop
 */
export const CircleStopIcon = (props: IconProps) => (
  <Icon icon={DefaultCircleStopIcon} {...props} />
);

import { default as DefaultCircleUserIcon } from '~icons/lucide/circle-user';

/**
 * @see https://lucide.dev/icons/circle-user
 */
export const CircleUserIcon = (props: IconProps) => (
  <Icon icon={DefaultCircleUserIcon} {...props} />
);

import { default as DefaultCircleUserRoundIcon } from '~icons/lucide/circle-user-round';

/**
 * @see https://lucide.dev/icons/circle-user-round
 */
export const CircleUserRoundIcon = (props: IconProps) => (
  <Icon icon={DefaultCircleUserRoundIcon} {...props} />
);

import { default as DefaultCircleXIcon } from '~icons/lucide/circle-x';

/**
 * @see https://lucide.dev/icons/circle-x
 */
export const CircleXIcon = (props: IconProps) => (
  <Icon icon={DefaultCircleXIcon} {...props} />
);

import { default as DefaultCircuitBoardIcon } from '~icons/lucide/circuit-board';

/**
 * @see https://lucide.dev/icons/circuit-board
 */
export const CircuitBoardIcon = (props: IconProps) => (
  <Icon icon={DefaultCircuitBoardIcon} {...props} />
);

import { default as DefaultCitrusIcon } from '~icons/lucide/citrus';

/**
 * @see https://lucide.dev/icons/citrus
 */
export const CitrusIcon = (props: IconProps) => (
  <Icon icon={DefaultCitrusIcon} {...props} />
);

import { default as DefaultClapperboardIcon } from '~icons/lucide/clapperboard';

/**
 * @see https://lucide.dev/icons/clapperboard
 */
export const ClapperboardIcon = (props: IconProps) => (
  <Icon icon={DefaultClapperboardIcon} {...props} />
);

import { default as DefaultClipboardIcon } from '~icons/lucide/clipboard';

/**
 * @see https://lucide.dev/icons/clipboard
 */
export const ClipboardIcon = (props: IconProps) => (
  <Icon icon={DefaultClipboardIcon} {...props} />
);

import { default as DefaultClipboardCheckIcon } from '~icons/lucide/clipboard-check';

/**
 * @see https://lucide.dev/icons/clipboard-check
 */
export const ClipboardCheckIcon = (props: IconProps) => (
  <Icon icon={DefaultClipboardCheckIcon} {...props} />
);

import { default as DefaultClipboardCopyIcon } from '~icons/lucide/clipboard-copy';

/**
 * @see https://lucide.dev/icons/clipboard-copy
 */
export const ClipboardCopyIcon = (props: IconProps) => (
  <Icon icon={DefaultClipboardCopyIcon} {...props} />
);

import { default as DefaultClipboardListIcon } from '~icons/lucide/clipboard-list';

/**
 * @see https://lucide.dev/icons/clipboard-list
 */
export const ClipboardListIcon = (props: IconProps) => (
  <Icon icon={DefaultClipboardListIcon} {...props} />
);

import { default as DefaultClipboardMinusIcon } from '~icons/lucide/clipboard-minus';

/**
 * @see https://lucide.dev/icons/clipboard-minus
 */
export const ClipboardMinusIcon = (props: IconProps) => (
  <Icon icon={DefaultClipboardMinusIcon} {...props} />
);

import { default as DefaultClipboardPasteIcon } from '~icons/lucide/clipboard-paste';

/**
 * @see https://lucide.dev/icons/clipboard-paste
 */
export const ClipboardPasteIcon = (props: IconProps) => (
  <Icon icon={DefaultClipboardPasteIcon} {...props} />
);

import { default as DefaultClipboardPenIcon } from '~icons/lucide/clipboard-pen';

/**
 * @see https://lucide.dev/icons/clipboard-pen
 */
export const ClipboardPenIcon = (props: IconProps) => (
  <Icon icon={DefaultClipboardPenIcon} {...props} />
);

import { default as DefaultClipboardPenLineIcon } from '~icons/lucide/clipboard-pen-line';

/**
 * @see https://lucide.dev/icons/clipboard-pen-line
 */
export const ClipboardPenLineIcon = (props: IconProps) => (
  <Icon icon={DefaultClipboardPenLineIcon} {...props} />
);

import { default as DefaultClipboardPlusIcon } from '~icons/lucide/clipboard-plus';

/**
 * @see https://lucide.dev/icons/clipboard-plus
 */
export const ClipboardPlusIcon = (props: IconProps) => (
  <Icon icon={DefaultClipboardPlusIcon} {...props} />
);

import { default as DefaultClipboardTypeIcon } from '~icons/lucide/clipboard-type';

/**
 * @see https://lucide.dev/icons/clipboard-type
 */
export const ClipboardTypeIcon = (props: IconProps) => (
  <Icon icon={DefaultClipboardTypeIcon} {...props} />
);

import { default as DefaultClipboardXIcon } from '~icons/lucide/clipboard-x';

/**
 * @see https://lucide.dev/icons/clipboard-x
 */
export const ClipboardXIcon = (props: IconProps) => (
  <Icon icon={DefaultClipboardXIcon} {...props} />
);

import { default as DefaultClockIcon } from '~icons/lucide/clock';

/**
 * @see https://lucide.dev/icons/clock
 */
export const ClockIcon = (props: IconProps) => (
  <Icon icon={DefaultClockIcon} {...props} />
);

import { default as DefaultClock1Icon } from '~icons/lucide/clock-1';

/**
 * @see https://lucide.dev/icons/clock-1
 */
export const Clock1Icon = (props: IconProps) => (
  <Icon icon={DefaultClock1Icon} {...props} />
);

import { default as DefaultClock10Icon } from '~icons/lucide/clock-10';

/**
 * @see https://lucide.dev/icons/clock-10
 */
export const Clock10Icon = (props: IconProps) => (
  <Icon icon={DefaultClock10Icon} {...props} />
);

import { default as DefaultClock11Icon } from '~icons/lucide/clock-11';

/**
 * @see https://lucide.dev/icons/clock-11
 */
export const Clock11Icon = (props: IconProps) => (
  <Icon icon={DefaultClock11Icon} {...props} />
);

import { default as DefaultClock12Icon } from '~icons/lucide/clock-12';

/**
 * @see https://lucide.dev/icons/clock-12
 */
export const Clock12Icon = (props: IconProps) => (
  <Icon icon={DefaultClock12Icon} {...props} />
);

import { default as DefaultClock2Icon } from '~icons/lucide/clock-2';

/**
 * @see https://lucide.dev/icons/clock-2
 */
export const Clock2Icon = (props: IconProps) => (
  <Icon icon={DefaultClock2Icon} {...props} />
);

import { default as DefaultClock3Icon } from '~icons/lucide/clock-3';

/**
 * @see https://lucide.dev/icons/clock-3
 */
export const Clock3Icon = (props: IconProps) => (
  <Icon icon={DefaultClock3Icon} {...props} />
);

import { default as DefaultClock4Icon } from '~icons/lucide/clock-4';

/**
 * @see https://lucide.dev/icons/clock-4
 */
export const Clock4Icon = (props: IconProps) => (
  <Icon icon={DefaultClock4Icon} {...props} />
);

import { default as DefaultClock5Icon } from '~icons/lucide/clock-5';

/**
 * @see https://lucide.dev/icons/clock-5
 */
export const Clock5Icon = (props: IconProps) => (
  <Icon icon={DefaultClock5Icon} {...props} />
);

import { default as DefaultClock6Icon } from '~icons/lucide/clock-6';

/**
 * @see https://lucide.dev/icons/clock-6
 */
export const Clock6Icon = (props: IconProps) => (
  <Icon icon={DefaultClock6Icon} {...props} />
);

import { default as DefaultClock7Icon } from '~icons/lucide/clock-7';

/**
 * @see https://lucide.dev/icons/clock-7
 */
export const Clock7Icon = (props: IconProps) => (
  <Icon icon={DefaultClock7Icon} {...props} />
);

import { default as DefaultClock8Icon } from '~icons/lucide/clock-8';

/**
 * @see https://lucide.dev/icons/clock-8
 */
export const Clock8Icon = (props: IconProps) => (
  <Icon icon={DefaultClock8Icon} {...props} />
);

import { default as DefaultClock9Icon } from '~icons/lucide/clock-9';

/**
 * @see https://lucide.dev/icons/clock-9
 */
export const Clock9Icon = (props: IconProps) => (
  <Icon icon={DefaultClock9Icon} {...props} />
);

import { default as DefaultClockAlertIcon } from '~icons/lucide/clock-alert';

/**
 * @see https://lucide.dev/icons/clock-alert
 */
export const ClockAlertIcon = (props: IconProps) => (
  <Icon icon={DefaultClockAlertIcon} {...props} />
);

import { default as DefaultClockArrowDownIcon } from '~icons/lucide/clock-arrow-down';

/**
 * @see https://lucide.dev/icons/clock-arrow-down
 */
export const ClockArrowDownIcon = (props: IconProps) => (
  <Icon icon={DefaultClockArrowDownIcon} {...props} />
);

import { default as DefaultClockArrowUpIcon } from '~icons/lucide/clock-arrow-up';

/**
 * @see https://lucide.dev/icons/clock-arrow-up
 */
export const ClockArrowUpIcon = (props: IconProps) => (
  <Icon icon={DefaultClockArrowUpIcon} {...props} />
);

import { default as DefaultClockFadingIcon } from '~icons/lucide/clock-fading';

/**
 * @see https://lucide.dev/icons/clock-fading
 */
export const ClockFadingIcon = (props: IconProps) => (
  <Icon icon={DefaultClockFadingIcon} {...props} />
);

import { default as DefaultClockPlusIcon } from '~icons/lucide/clock-plus';

/**
 * @see https://lucide.dev/icons/clock-plus
 */
export const ClockPlusIcon = (props: IconProps) => (
  <Icon icon={DefaultClockPlusIcon} {...props} />
);

import { default as DefaultCloudIcon } from '~icons/lucide/cloud';

/**
 * @see https://lucide.dev/icons/cloud
 */
export const CloudIcon = (props: IconProps) => (
  <Icon icon={DefaultCloudIcon} {...props} />
);

import { default as DefaultCloudAlertIcon } from '~icons/lucide/cloud-alert';

/**
 * @see https://lucide.dev/icons/cloud-alert
 */
export const CloudAlertIcon = (props: IconProps) => (
  <Icon icon={DefaultCloudAlertIcon} {...props} />
);

import { default as DefaultCloudCheckIcon } from '~icons/lucide/cloud-check';

/**
 * @see https://lucide.dev/icons/cloud-check
 */
export const CloudCheckIcon = (props: IconProps) => (
  <Icon icon={DefaultCloudCheckIcon} {...props} />
);

import { default as DefaultCloudCogIcon } from '~icons/lucide/cloud-cog';

/**
 * @see https://lucide.dev/icons/cloud-cog
 */
export const CloudCogIcon = (props: IconProps) => (
  <Icon icon={DefaultCloudCogIcon} {...props} />
);

import { default as DefaultCloudDownloadIcon } from '~icons/lucide/cloud-download';

/**
 * @see https://lucide.dev/icons/cloud-download
 */
export const CloudDownloadIcon = (props: IconProps) => (
  <Icon icon={DefaultCloudDownloadIcon} {...props} />
);

import { default as DefaultCloudDrizzleIcon } from '~icons/lucide/cloud-drizzle';

/**
 * @see https://lucide.dev/icons/cloud-drizzle
 */
export const CloudDrizzleIcon = (props: IconProps) => (
  <Icon icon={DefaultCloudDrizzleIcon} {...props} />
);

import { default as DefaultCloudFogIcon } from '~icons/lucide/cloud-fog';

/**
 * @see https://lucide.dev/icons/cloud-fog
 */
export const CloudFogIcon = (props: IconProps) => (
  <Icon icon={DefaultCloudFogIcon} {...props} />
);

import { default as DefaultCloudHailIcon } from '~icons/lucide/cloud-hail';

/**
 * @see https://lucide.dev/icons/cloud-hail
 */
export const CloudHailIcon = (props: IconProps) => (
  <Icon icon={DefaultCloudHailIcon} {...props} />
);

import { default as DefaultCloudLightningIcon } from '~icons/lucide/cloud-lightning';

/**
 * @see https://lucide.dev/icons/cloud-lightning
 */
export const CloudLightningIcon = (props: IconProps) => (
  <Icon icon={DefaultCloudLightningIcon} {...props} />
);

import { default as DefaultCloudMoonIcon } from '~icons/lucide/cloud-moon';

/**
 * @see https://lucide.dev/icons/cloud-moon
 */
export const CloudMoonIcon = (props: IconProps) => (
  <Icon icon={DefaultCloudMoonIcon} {...props} />
);

import { default as DefaultCloudMoonRainIcon } from '~icons/lucide/cloud-moon-rain';

/**
 * @see https://lucide.dev/icons/cloud-moon-rain
 */
export const CloudMoonRainIcon = (props: IconProps) => (
  <Icon icon={DefaultCloudMoonRainIcon} {...props} />
);

import { default as DefaultCloudOffIcon } from '~icons/lucide/cloud-off';

/**
 * @see https://lucide.dev/icons/cloud-off
 */
export const CloudOffIcon = (props: IconProps) => (
  <Icon icon={DefaultCloudOffIcon} {...props} />
);

import { default as DefaultCloudRainIcon } from '~icons/lucide/cloud-rain';

/**
 * @see https://lucide.dev/icons/cloud-rain
 */
export const CloudRainIcon = (props: IconProps) => (
  <Icon icon={DefaultCloudRainIcon} {...props} />
);

import { default as DefaultCloudRainWindIcon } from '~icons/lucide/cloud-rain-wind';

/**
 * @see https://lucide.dev/icons/cloud-rain-wind
 */
export const CloudRainWindIcon = (props: IconProps) => (
  <Icon icon={DefaultCloudRainWindIcon} {...props} />
);

import { default as DefaultCloudSnowIcon } from '~icons/lucide/cloud-snow';

/**
 * @see https://lucide.dev/icons/cloud-snow
 */
export const CloudSnowIcon = (props: IconProps) => (
  <Icon icon={DefaultCloudSnowIcon} {...props} />
);

import { default as DefaultCloudSunIcon } from '~icons/lucide/cloud-sun';

/**
 * @see https://lucide.dev/icons/cloud-sun
 */
export const CloudSunIcon = (props: IconProps) => (
  <Icon icon={DefaultCloudSunIcon} {...props} />
);

import { default as DefaultCloudSunRainIcon } from '~icons/lucide/cloud-sun-rain';

/**
 * @see https://lucide.dev/icons/cloud-sun-rain
 */
export const CloudSunRainIcon = (props: IconProps) => (
  <Icon icon={DefaultCloudSunRainIcon} {...props} />
);

import { default as DefaultCloudUploadIcon } from '~icons/lucide/cloud-upload';

/**
 * @see https://lucide.dev/icons/cloud-upload
 */
export const CloudUploadIcon = (props: IconProps) => (
  <Icon icon={DefaultCloudUploadIcon} {...props} />
);

import { default as DefaultCloudyIcon } from '~icons/lucide/cloudy';

/**
 * @see https://lucide.dev/icons/cloudy
 */
export const CloudyIcon = (props: IconProps) => (
  <Icon icon={DefaultCloudyIcon} {...props} />
);

import { default as DefaultCloverIcon } from '~icons/lucide/clover';

/**
 * @see https://lucide.dev/icons/clover
 */
export const CloverIcon = (props: IconProps) => (
  <Icon icon={DefaultCloverIcon} {...props} />
);

import { default as DefaultClubIcon } from '~icons/lucide/club';

/**
 * @see https://lucide.dev/icons/club
 */
export const ClubIcon = (props: IconProps) => (
  <Icon icon={DefaultClubIcon} {...props} />
);

import { default as DefaultCodeIcon } from '~icons/lucide/code';

/**
 * @see https://lucide.dev/icons/code
 */
export const CodeIcon = (props: IconProps) => (
  <Icon icon={DefaultCodeIcon} {...props} />
);

import { default as DefaultCodeXmlIcon } from '~icons/lucide/code-xml';

/**
 * @see https://lucide.dev/icons/code-xml
 */
export const CodeXmlIcon = (props: IconProps) => (
  <Icon icon={DefaultCodeXmlIcon} {...props} />
);

import { default as DefaultCodepenIcon } from '~icons/lucide/codepen';

/**
 * @see https://lucide.dev/icons/codepen
 */
export const CodepenIcon = (props: IconProps) => (
  <Icon icon={DefaultCodepenIcon} {...props} />
);

import { default as DefaultCodesandboxIcon } from '~icons/lucide/codesandbox';

/**
 * @see https://lucide.dev/icons/codesandbox
 */
export const CodesandboxIcon = (props: IconProps) => (
  <Icon icon={DefaultCodesandboxIcon} {...props} />
);

import { default as DefaultCoffeeIcon } from '~icons/lucide/coffee';

/**
 * @see https://lucide.dev/icons/coffee
 */
export const CoffeeIcon = (props: IconProps) => (
  <Icon icon={DefaultCoffeeIcon} {...props} />
);

import { default as DefaultCogIcon } from '~icons/lucide/cog';

/**
 * @see https://lucide.dev/icons/cog
 */
export const CogIcon = (props: IconProps) => (
  <Icon icon={DefaultCogIcon} {...props} />
);

import { default as DefaultCoinsIcon } from '~icons/lucide/coins';

/**
 * @see https://lucide.dev/icons/coins
 */
export const CoinsIcon = (props: IconProps) => (
  <Icon icon={DefaultCoinsIcon} {...props} />
);

import { default as DefaultColumns2Icon } from '~icons/lucide/columns-2';

/**
 * @see https://lucide.dev/icons/columns-2
 */
export const Columns2Icon = (props: IconProps) => (
  <Icon icon={DefaultColumns2Icon} {...props} />
);

import { default as DefaultColumns3Icon } from '~icons/lucide/columns-3';

/**
 * @see https://lucide.dev/icons/columns-3
 */
export const Columns3Icon = (props: IconProps) => (
  <Icon icon={DefaultColumns3Icon} {...props} />
);

import { default as DefaultColumns3CogIcon } from '~icons/lucide/columns-3-cog';

/**
 * @see https://lucide.dev/icons/columns-3-cog
 */
export const Columns3CogIcon = (props: IconProps) => (
  <Icon icon={DefaultColumns3CogIcon} {...props} />
);

import { default as DefaultColumns4Icon } from '~icons/lucide/columns-4';

/**
 * @see https://lucide.dev/icons/columns-4
 */
export const Columns4Icon = (props: IconProps) => (
  <Icon icon={DefaultColumns4Icon} {...props} />
);

import { default as DefaultCombineIcon } from '~icons/lucide/combine';

/**
 * @see https://lucide.dev/icons/combine
 */
export const CombineIcon = (props: IconProps) => (
  <Icon icon={DefaultCombineIcon} {...props} />
);

import { default as DefaultCommandIcon } from '~icons/lucide/command';

/**
 * @see https://lucide.dev/icons/command
 */
export const CommandIcon = (props: IconProps) => (
  <Icon icon={DefaultCommandIcon} {...props} />
);

import { default as DefaultCompassIcon } from '~icons/lucide/compass';

/**
 * @see https://lucide.dev/icons/compass
 */
export const CompassIcon = (props: IconProps) => (
  <Icon icon={DefaultCompassIcon} {...props} />
);

import { default as DefaultComponentIcon } from '~icons/lucide/component';

/**
 * @see https://lucide.dev/icons/component
 */
export const ComponentIcon = (props: IconProps) => (
  <Icon icon={DefaultComponentIcon} {...props} />
);

import { default as DefaultComputerIcon } from '~icons/lucide/computer';

/**
 * @see https://lucide.dev/icons/computer
 */
export const ComputerIcon = (props: IconProps) => (
  <Icon icon={DefaultComputerIcon} {...props} />
);

import { default as DefaultConciergeBellIcon } from '~icons/lucide/concierge-bell';

/**
 * @see https://lucide.dev/icons/concierge-bell
 */
export const ConciergeBellIcon = (props: IconProps) => (
  <Icon icon={DefaultConciergeBellIcon} {...props} />
);

import { default as DefaultConeIcon } from '~icons/lucide/cone';

/**
 * @see https://lucide.dev/icons/cone
 */
export const ConeIcon = (props: IconProps) => (
  <Icon icon={DefaultConeIcon} {...props} />
);

import { default as DefaultConstructionIcon } from '~icons/lucide/construction';

/**
 * @see https://lucide.dev/icons/construction
 */
export const ConstructionIcon = (props: IconProps) => (
  <Icon icon={DefaultConstructionIcon} {...props} />
);

import { default as DefaultContactIcon } from '~icons/lucide/contact';

/**
 * @see https://lucide.dev/icons/contact
 */
export const ContactIcon = (props: IconProps) => (
  <Icon icon={DefaultContactIcon} {...props} />
);

import { default as DefaultContactRoundIcon } from '~icons/lucide/contact-round';

/**
 * @see https://lucide.dev/icons/contact-round
 */
export const ContactRoundIcon = (props: IconProps) => (
  <Icon icon={DefaultContactRoundIcon} {...props} />
);

import { default as DefaultContainerIcon } from '~icons/lucide/container';

/**
 * @see https://lucide.dev/icons/container
 */
export const ContainerIcon = (props: IconProps) => (
  <Icon icon={DefaultContainerIcon} {...props} />
);

import { default as DefaultContrastIcon } from '~icons/lucide/contrast';

/**
 * @see https://lucide.dev/icons/contrast
 */
export const ContrastIcon = (props: IconProps) => (
  <Icon icon={DefaultContrastIcon} {...props} />
);

import { default as DefaultCookieIcon } from '~icons/lucide/cookie';

/**
 * @see https://lucide.dev/icons/cookie
 */
export const CookieIcon = (props: IconProps) => (
  <Icon icon={DefaultCookieIcon} {...props} />
);

import { default as DefaultCookingPotIcon } from '~icons/lucide/cooking-pot';

/**
 * @see https://lucide.dev/icons/cooking-pot
 */
export const CookingPotIcon = (props: IconProps) => (
  <Icon icon={DefaultCookingPotIcon} {...props} />
);

import { default as DefaultCopyIcon } from '~icons/lucide/copy';

/**
 * @see https://lucide.dev/icons/copy
 */
export const CopyIcon = (props: IconProps) => (
  <Icon icon={DefaultCopyIcon} {...props} />
);

import { default as DefaultCopyCheckIcon } from '~icons/lucide/copy-check';

/**
 * @see https://lucide.dev/icons/copy-check
 */
export const CopyCheckIcon = (props: IconProps) => (
  <Icon icon={DefaultCopyCheckIcon} {...props} />
);

import { default as DefaultCopyMinusIcon } from '~icons/lucide/copy-minus';

/**
 * @see https://lucide.dev/icons/copy-minus
 */
export const CopyMinusIcon = (props: IconProps) => (
  <Icon icon={DefaultCopyMinusIcon} {...props} />
);

import { default as DefaultCopyPlusIcon } from '~icons/lucide/copy-plus';

/**
 * @see https://lucide.dev/icons/copy-plus
 */
export const CopyPlusIcon = (props: IconProps) => (
  <Icon icon={DefaultCopyPlusIcon} {...props} />
);

import { default as DefaultCopySlashIcon } from '~icons/lucide/copy-slash';

/**
 * @see https://lucide.dev/icons/copy-slash
 */
export const CopySlashIcon = (props: IconProps) => (
  <Icon icon={DefaultCopySlashIcon} {...props} />
);

import { default as DefaultCopyXIcon } from '~icons/lucide/copy-x';

/**
 * @see https://lucide.dev/icons/copy-x
 */
export const CopyXIcon = (props: IconProps) => (
  <Icon icon={DefaultCopyXIcon} {...props} />
);

import { default as DefaultCopyleftIcon } from '~icons/lucide/copyleft';

/**
 * @see https://lucide.dev/icons/copyleft
 */
export const CopyleftIcon = (props: IconProps) => (
  <Icon icon={DefaultCopyleftIcon} {...props} />
);

import { default as DefaultCopyrightIcon } from '~icons/lucide/copyright';

/**
 * @see https://lucide.dev/icons/copyright
 */
export const CopyrightIcon = (props: IconProps) => (
  <Icon icon={DefaultCopyrightIcon} {...props} />
);

import { default as DefaultCornerDownLeftIcon } from '~icons/lucide/corner-down-left';

/**
 * @see https://lucide.dev/icons/corner-down-left
 */
export const CornerDownLeftIcon = (props: IconProps) => (
  <Icon icon={DefaultCornerDownLeftIcon} {...props} />
);

import { default as DefaultCornerDownRightIcon } from '~icons/lucide/corner-down-right';

/**
 * @see https://lucide.dev/icons/corner-down-right
 */
export const CornerDownRightIcon = (props: IconProps) => (
  <Icon icon={DefaultCornerDownRightIcon} {...props} />
);

import { default as DefaultCornerLeftDownIcon } from '~icons/lucide/corner-left-down';

/**
 * @see https://lucide.dev/icons/corner-left-down
 */
export const CornerLeftDownIcon = (props: IconProps) => (
  <Icon icon={DefaultCornerLeftDownIcon} {...props} />
);

import { default as DefaultCornerLeftUpIcon } from '~icons/lucide/corner-left-up';

/**
 * @see https://lucide.dev/icons/corner-left-up
 */
export const CornerLeftUpIcon = (props: IconProps) => (
  <Icon icon={DefaultCornerLeftUpIcon} {...props} />
);

import { default as DefaultCornerRightDownIcon } from '~icons/lucide/corner-right-down';

/**
 * @see https://lucide.dev/icons/corner-right-down
 */
export const CornerRightDownIcon = (props: IconProps) => (
  <Icon icon={DefaultCornerRightDownIcon} {...props} />
);

import { default as DefaultCornerRightUpIcon } from '~icons/lucide/corner-right-up';

/**
 * @see https://lucide.dev/icons/corner-right-up
 */
export const CornerRightUpIcon = (props: IconProps) => (
  <Icon icon={DefaultCornerRightUpIcon} {...props} />
);

import { default as DefaultCornerUpLeftIcon } from '~icons/lucide/corner-up-left';

/**
 * @see https://lucide.dev/icons/corner-up-left
 */
export const CornerUpLeftIcon = (props: IconProps) => (
  <Icon icon={DefaultCornerUpLeftIcon} {...props} />
);

import { default as DefaultCornerUpRightIcon } from '~icons/lucide/corner-up-right';

/**
 * @see https://lucide.dev/icons/corner-up-right
 */
export const CornerUpRightIcon = (props: IconProps) => (
  <Icon icon={DefaultCornerUpRightIcon} {...props} />
);

import { default as DefaultCpuIcon } from '~icons/lucide/cpu';

/**
 * @see https://lucide.dev/icons/cpu
 */
export const CpuIcon = (props: IconProps) => (
  <Icon icon={DefaultCpuIcon} {...props} />
);

import { default as DefaultCreativeCommonsIcon } from '~icons/lucide/creative-commons';

/**
 * @see https://lucide.dev/icons/creative-commons
 */
export const CreativeCommonsIcon = (props: IconProps) => (
  <Icon icon={DefaultCreativeCommonsIcon} {...props} />
);

import { default as DefaultCreditCardIcon } from '~icons/lucide/credit-card';

/**
 * @see https://lucide.dev/icons/credit-card
 */
export const CreditCardIcon = (props: IconProps) => (
  <Icon icon={DefaultCreditCardIcon} {...props} />
);

import { default as DefaultCroissantIcon } from '~icons/lucide/croissant';

/**
 * @see https://lucide.dev/icons/croissant
 */
export const CroissantIcon = (props: IconProps) => (
  <Icon icon={DefaultCroissantIcon} {...props} />
);

import { default as DefaultCropIcon } from '~icons/lucide/crop';

/**
 * @see https://lucide.dev/icons/crop
 */
export const CropIcon = (props: IconProps) => (
  <Icon icon={DefaultCropIcon} {...props} />
);

import { default as DefaultCrossIcon } from '~icons/lucide/cross';

/**
 * @see https://lucide.dev/icons/cross
 */
export const CrossIcon = (props: IconProps) => (
  <Icon icon={DefaultCrossIcon} {...props} />
);

import { default as DefaultCrosshairIcon } from '~icons/lucide/crosshair';

/**
 * @see https://lucide.dev/icons/crosshair
 */
export const CrosshairIcon = (props: IconProps) => (
  <Icon icon={DefaultCrosshairIcon} {...props} />
);

import { default as DefaultCrownIcon } from '~icons/lucide/crown';

/**
 * @see https://lucide.dev/icons/crown
 */
export const CrownIcon = (props: IconProps) => (
  <Icon icon={DefaultCrownIcon} {...props} />
);

import { default as DefaultCuboidIcon } from '~icons/lucide/cuboid';

/**
 * @see https://lucide.dev/icons/cuboid
 */
export const CuboidIcon = (props: IconProps) => (
  <Icon icon={DefaultCuboidIcon} {...props} />
);

import { default as DefaultCupSodaIcon } from '~icons/lucide/cup-soda';

/**
 * @see https://lucide.dev/icons/cup-soda
 */
export const CupSodaIcon = (props: IconProps) => (
  <Icon icon={DefaultCupSodaIcon} {...props} />
);

import { default as DefaultCurrencyIcon } from '~icons/lucide/currency';

/**
 * @see https://lucide.dev/icons/currency
 */
export const CurrencyIcon = (props: IconProps) => (
  <Icon icon={DefaultCurrencyIcon} {...props} />
);

import { default as DefaultCylinderIcon } from '~icons/lucide/cylinder';

/**
 * @see https://lucide.dev/icons/cylinder
 */
export const CylinderIcon = (props: IconProps) => (
  <Icon icon={DefaultCylinderIcon} {...props} />
);

import { default as DefaultDamIcon } from '~icons/lucide/dam';

/**
 * @see https://lucide.dev/icons/dam
 */
export const DamIcon = (props: IconProps) => (
  <Icon icon={DefaultDamIcon} {...props} />
);

import { default as DefaultDatabaseIcon } from '~icons/lucide/database';

/**
 * @see https://lucide.dev/icons/database
 */
export const DatabaseIcon = (props: IconProps) => (
  <Icon icon={DefaultDatabaseIcon} {...props} />
);

import { default as DefaultDatabaseBackupIcon } from '~icons/lucide/database-backup';

/**
 * @see https://lucide.dev/icons/database-backup
 */
export const DatabaseBackupIcon = (props: IconProps) => (
  <Icon icon={DefaultDatabaseBackupIcon} {...props} />
);

import { default as DefaultDatabaseZapIcon } from '~icons/lucide/database-zap';

/**
 * @see https://lucide.dev/icons/database-zap
 */
export const DatabaseZapIcon = (props: IconProps) => (
  <Icon icon={DefaultDatabaseZapIcon} {...props} />
);

import { default as DefaultDecimalsArrowLeftIcon } from '~icons/lucide/decimals-arrow-left';

/**
 * @see https://lucide.dev/icons/decimals-arrow-left
 */
export const DecimalsArrowLeftIcon = (props: IconProps) => (
  <Icon icon={DefaultDecimalsArrowLeftIcon} {...props} />
);

import { default as DefaultDecimalsArrowRightIcon } from '~icons/lucide/decimals-arrow-right';

/**
 * @see https://lucide.dev/icons/decimals-arrow-right
 */
export const DecimalsArrowRightIcon = (props: IconProps) => (
  <Icon icon={DefaultDecimalsArrowRightIcon} {...props} />
);

import { default as DefaultDeleteIcon } from '~icons/lucide/delete';

/**
 * @see https://lucide.dev/icons/delete
 */
export const DeleteIcon = (props: IconProps) => (
  <Icon icon={DefaultDeleteIcon} {...props} />
);

import { default as DefaultDessertIcon } from '~icons/lucide/dessert';

/**
 * @see https://lucide.dev/icons/dessert
 */
export const DessertIcon = (props: IconProps) => (
  <Icon icon={DefaultDessertIcon} {...props} />
);

import { default as DefaultDiameterIcon } from '~icons/lucide/diameter';

/**
 * @see https://lucide.dev/icons/diameter
 */
export const DiameterIcon = (props: IconProps) => (
  <Icon icon={DefaultDiameterIcon} {...props} />
);

import { default as DefaultDiamondIcon } from '~icons/lucide/diamond';

/**
 * @see https://lucide.dev/icons/diamond
 */
export const DiamondIcon = (props: IconProps) => (
  <Icon icon={DefaultDiamondIcon} {...props} />
);

import { default as DefaultDiamondMinusIcon } from '~icons/lucide/diamond-minus';

/**
 * @see https://lucide.dev/icons/diamond-minus
 */
export const DiamondMinusIcon = (props: IconProps) => (
  <Icon icon={DefaultDiamondMinusIcon} {...props} />
);

import { default as DefaultDiamondPercentIcon } from '~icons/lucide/diamond-percent';

/**
 * @see https://lucide.dev/icons/diamond-percent
 */
export const DiamondPercentIcon = (props: IconProps) => (
  <Icon icon={DefaultDiamondPercentIcon} {...props} />
);

import { default as DefaultDiamondPlusIcon } from '~icons/lucide/diamond-plus';

/**
 * @see https://lucide.dev/icons/diamond-plus
 */
export const DiamondPlusIcon = (props: IconProps) => (
  <Icon icon={DefaultDiamondPlusIcon} {...props} />
);

import { default as DefaultDice1Icon } from '~icons/lucide/dice-1';

/**
 * @see https://lucide.dev/icons/dice-1
 */
export const Dice1Icon = (props: IconProps) => (
  <Icon icon={DefaultDice1Icon} {...props} />
);

import { default as DefaultDice2Icon } from '~icons/lucide/dice-2';

/**
 * @see https://lucide.dev/icons/dice-2
 */
export const Dice2Icon = (props: IconProps) => (
  <Icon icon={DefaultDice2Icon} {...props} />
);

import { default as DefaultDice3Icon } from '~icons/lucide/dice-3';

/**
 * @see https://lucide.dev/icons/dice-3
 */
export const Dice3Icon = (props: IconProps) => (
  <Icon icon={DefaultDice3Icon} {...props} />
);

import { default as DefaultDice4Icon } from '~icons/lucide/dice-4';

/**
 * @see https://lucide.dev/icons/dice-4
 */
export const Dice4Icon = (props: IconProps) => (
  <Icon icon={DefaultDice4Icon} {...props} />
);

import { default as DefaultDice5Icon } from '~icons/lucide/dice-5';

/**
 * @see https://lucide.dev/icons/dice-5
 */
export const Dice5Icon = (props: IconProps) => (
  <Icon icon={DefaultDice5Icon} {...props} />
);

import { default as DefaultDice6Icon } from '~icons/lucide/dice-6';

/**
 * @see https://lucide.dev/icons/dice-6
 */
export const Dice6Icon = (props: IconProps) => (
  <Icon icon={DefaultDice6Icon} {...props} />
);

import { default as DefaultDicesIcon } from '~icons/lucide/dices';

/**
 * @see https://lucide.dev/icons/dices
 */
export const DicesIcon = (props: IconProps) => (
  <Icon icon={DefaultDicesIcon} {...props} />
);

import { default as DefaultDiffIcon } from '~icons/lucide/diff';

/**
 * @see https://lucide.dev/icons/diff
 */
export const DiffIcon = (props: IconProps) => (
  <Icon icon={DefaultDiffIcon} {...props} />
);

import { default as DefaultDiscIcon } from '~icons/lucide/disc';

/**
 * @see https://lucide.dev/icons/disc
 */
export const DiscIcon = (props: IconProps) => (
  <Icon icon={DefaultDiscIcon} {...props} />
);

import { default as DefaultDisc2Icon } from '~icons/lucide/disc-2';

/**
 * @see https://lucide.dev/icons/disc-2
 */
export const Disc2Icon = (props: IconProps) => (
  <Icon icon={DefaultDisc2Icon} {...props} />
);

import { default as DefaultDisc3Icon } from '~icons/lucide/disc-3';

/**
 * @see https://lucide.dev/icons/disc-3
 */
export const Disc3Icon = (props: IconProps) => (
  <Icon icon={DefaultDisc3Icon} {...props} />
);

import { default as DefaultDiscAlbumIcon } from '~icons/lucide/disc-album';

/**
 * @see https://lucide.dev/icons/disc-album
 */
export const DiscAlbumIcon = (props: IconProps) => (
  <Icon icon={DefaultDiscAlbumIcon} {...props} />
);

import { default as DefaultDivideIcon } from '~icons/lucide/divide';

/**
 * @see https://lucide.dev/icons/divide
 */
export const DivideIcon = (props: IconProps) => (
  <Icon icon={DefaultDivideIcon} {...props} />
);

import { default as DefaultDnaIcon } from '~icons/lucide/dna';

/**
 * @see https://lucide.dev/icons/dna
 */
export const DnaIcon = (props: IconProps) => (
  <Icon icon={DefaultDnaIcon} {...props} />
);

import { default as DefaultDnaOffIcon } from '~icons/lucide/dna-off';

/**
 * @see https://lucide.dev/icons/dna-off
 */
export const DnaOffIcon = (props: IconProps) => (
  <Icon icon={DefaultDnaOffIcon} {...props} />
);

import { default as DefaultDockIcon } from '~icons/lucide/dock';

/**
 * @see https://lucide.dev/icons/dock
 */
export const DockIcon = (props: IconProps) => (
  <Icon icon={DefaultDockIcon} {...props} />
);

import { default as DefaultDogIcon } from '~icons/lucide/dog';

/**
 * @see https://lucide.dev/icons/dog
 */
export const DogIcon = (props: IconProps) => (
  <Icon icon={DefaultDogIcon} {...props} />
);

import { default as DefaultDollarSignIcon } from '~icons/lucide/dollar-sign';

/**
 * @see https://lucide.dev/icons/dollar-sign
 */
export const DollarSignIcon = (props: IconProps) => (
  <Icon icon={DefaultDollarSignIcon} {...props} />
);

import { default as DefaultDonutIcon } from '~icons/lucide/donut';

/**
 * @see https://lucide.dev/icons/donut
 */
export const DonutIcon = (props: IconProps) => (
  <Icon icon={DefaultDonutIcon} {...props} />
);

import { default as DefaultDoorClosedIcon } from '~icons/lucide/door-closed';

/**
 * @see https://lucide.dev/icons/door-closed
 */
export const DoorClosedIcon = (props: IconProps) => (
  <Icon icon={DefaultDoorClosedIcon} {...props} />
);

import { default as DefaultDoorClosedLockedIcon } from '~icons/lucide/door-closed-locked';

/**
 * @see https://lucide.dev/icons/door-closed-locked
 */
export const DoorClosedLockedIcon = (props: IconProps) => (
  <Icon icon={DefaultDoorClosedLockedIcon} {...props} />
);

import { default as DefaultDoorOpenIcon } from '~icons/lucide/door-open';

/**
 * @see https://lucide.dev/icons/door-open
 */
export const DoorOpenIcon = (props: IconProps) => (
  <Icon icon={DefaultDoorOpenIcon} {...props} />
);

import { default as DefaultDotIcon } from '~icons/lucide/dot';

/**
 * @see https://lucide.dev/icons/dot
 */
export const DotIcon = (props: IconProps) => (
  <Icon icon={DefaultDotIcon} {...props} />
);

import { default as DefaultDownloadIcon } from '~icons/lucide/download';

/**
 * @see https://lucide.dev/icons/download
 */
export const DownloadIcon = (props: IconProps) => (
  <Icon icon={DefaultDownloadIcon} {...props} />
);

import { default as DefaultDraftingCompassIcon } from '~icons/lucide/drafting-compass';

/**
 * @see https://lucide.dev/icons/drafting-compass
 */
export const DraftingCompassIcon = (props: IconProps) => (
  <Icon icon={DefaultDraftingCompassIcon} {...props} />
);

import { default as DefaultDramaIcon } from '~icons/lucide/drama';

/**
 * @see https://lucide.dev/icons/drama
 */
export const DramaIcon = (props: IconProps) => (
  <Icon icon={DefaultDramaIcon} {...props} />
);

import { default as DefaultDribbbleIcon } from '~icons/lucide/dribbble';

/**
 * @see https://lucide.dev/icons/dribbble
 */
export const DribbbleIcon = (props: IconProps) => (
  <Icon icon={DefaultDribbbleIcon} {...props} />
);

import { default as DefaultDrillIcon } from '~icons/lucide/drill';

/**
 * @see https://lucide.dev/icons/drill
 */
export const DrillIcon = (props: IconProps) => (
  <Icon icon={DefaultDrillIcon} {...props} />
);

import { default as DefaultDroneIcon } from '~icons/lucide/drone';

/**
 * @see https://lucide.dev/icons/drone
 */
export const DroneIcon = (props: IconProps) => (
  <Icon icon={DefaultDroneIcon} {...props} />
);

import { default as DefaultDropletIcon } from '~icons/lucide/droplet';

/**
 * @see https://lucide.dev/icons/droplet
 */
export const DropletIcon = (props: IconProps) => (
  <Icon icon={DefaultDropletIcon} {...props} />
);

import { default as DefaultDropletOffIcon } from '~icons/lucide/droplet-off';

/**
 * @see https://lucide.dev/icons/droplet-off
 */
export const DropletOffIcon = (props: IconProps) => (
  <Icon icon={DefaultDropletOffIcon} {...props} />
);

import { default as DefaultDropletsIcon } from '~icons/lucide/droplets';

/**
 * @see https://lucide.dev/icons/droplets
 */
export const DropletsIcon = (props: IconProps) => (
  <Icon icon={DefaultDropletsIcon} {...props} />
);

import { default as DefaultDrumIcon } from '~icons/lucide/drum';

/**
 * @see https://lucide.dev/icons/drum
 */
export const DrumIcon = (props: IconProps) => (
  <Icon icon={DefaultDrumIcon} {...props} />
);

import { default as DefaultDrumstickIcon } from '~icons/lucide/drumstick';

/**
 * @see https://lucide.dev/icons/drumstick
 */
export const DrumstickIcon = (props: IconProps) => (
  <Icon icon={DefaultDrumstickIcon} {...props} />
);

import { default as DefaultDumbbellIcon } from '~icons/lucide/dumbbell';

/**
 * @see https://lucide.dev/icons/dumbbell
 */
export const DumbbellIcon = (props: IconProps) => (
  <Icon icon={DefaultDumbbellIcon} {...props} />
);

import { default as DefaultEarIcon } from '~icons/lucide/ear';

/**
 * @see https://lucide.dev/icons/ear
 */
export const EarIcon = (props: IconProps) => (
  <Icon icon={DefaultEarIcon} {...props} />
);

import { default as DefaultEarOffIcon } from '~icons/lucide/ear-off';

/**
 * @see https://lucide.dev/icons/ear-off
 */
export const EarOffIcon = (props: IconProps) => (
  <Icon icon={DefaultEarOffIcon} {...props} />
);

import { default as DefaultEarthIcon } from '~icons/lucide/earth';

/**
 * @see https://lucide.dev/icons/earth
 */
export const EarthIcon = (props: IconProps) => (
  <Icon icon={DefaultEarthIcon} {...props} />
);

import { default as DefaultEarthLockIcon } from '~icons/lucide/earth-lock';

/**
 * @see https://lucide.dev/icons/earth-lock
 */
export const EarthLockIcon = (props: IconProps) => (
  <Icon icon={DefaultEarthLockIcon} {...props} />
);

import { default as DefaultEclipseIcon } from '~icons/lucide/eclipse';

/**
 * @see https://lucide.dev/icons/eclipse
 */
export const EclipseIcon = (props: IconProps) => (
  <Icon icon={DefaultEclipseIcon} {...props} />
);

import { default as DefaultEggIcon } from '~icons/lucide/egg';

/**
 * @see https://lucide.dev/icons/egg
 */
export const EggIcon = (props: IconProps) => (
  <Icon icon={DefaultEggIcon} {...props} />
);

import { default as DefaultEggFriedIcon } from '~icons/lucide/egg-fried';

/**
 * @see https://lucide.dev/icons/egg-fried
 */
export const EggFriedIcon = (props: IconProps) => (
  <Icon icon={DefaultEggFriedIcon} {...props} />
);

import { default as DefaultEggOffIcon } from '~icons/lucide/egg-off';

/**
 * @see https://lucide.dev/icons/egg-off
 */
export const EggOffIcon = (props: IconProps) => (
  <Icon icon={DefaultEggOffIcon} {...props} />
);

import { default as DefaultEllipsisIcon } from '~icons/lucide/ellipsis';

/**
 * @see https://lucide.dev/icons/ellipsis
 */
export const EllipsisIcon = (props: IconProps) => (
  <Icon icon={DefaultEllipsisIcon} {...props} />
);

import { default as DefaultEllipsisVerticalIcon } from '~icons/lucide/ellipsis-vertical';

/**
 * @see https://lucide.dev/icons/ellipsis-vertical
 */
export const EllipsisVerticalIcon = (props: IconProps) => (
  <Icon icon={DefaultEllipsisVerticalIcon} {...props} />
);

import { default as DefaultEqualIcon } from '~icons/lucide/equal';

/**
 * @see https://lucide.dev/icons/equal
 */
export const EqualIcon = (props: IconProps) => (
  <Icon icon={DefaultEqualIcon} {...props} />
);

import { default as DefaultEqualApproximatelyIcon } from '~icons/lucide/equal-approximately';

/**
 * @see https://lucide.dev/icons/equal-approximately
 */
export const EqualApproximatelyIcon = (props: IconProps) => (
  <Icon icon={DefaultEqualApproximatelyIcon} {...props} />
);

import { default as DefaultEqualNotIcon } from '~icons/lucide/equal-not';

/**
 * @see https://lucide.dev/icons/equal-not
 */
export const EqualNotIcon = (props: IconProps) => (
  <Icon icon={DefaultEqualNotIcon} {...props} />
);

import { default as DefaultEraserIcon } from '~icons/lucide/eraser';

/**
 * @see https://lucide.dev/icons/eraser
 */
export const EraserIcon = (props: IconProps) => (
  <Icon icon={DefaultEraserIcon} {...props} />
);

import { default as DefaultEthernetPortIcon } from '~icons/lucide/ethernet-port';

/**
 * @see https://lucide.dev/icons/ethernet-port
 */
export const EthernetPortIcon = (props: IconProps) => (
  <Icon icon={DefaultEthernetPortIcon} {...props} />
);

import { default as DefaultEuroIcon } from '~icons/lucide/euro';

/**
 * @see https://lucide.dev/icons/euro
 */
export const EuroIcon = (props: IconProps) => (
  <Icon icon={DefaultEuroIcon} {...props} />
);

import { default as DefaultExpandIcon } from '~icons/lucide/expand';

/**
 * @see https://lucide.dev/icons/expand
 */
export const ExpandIcon = (props: IconProps) => (
  <Icon icon={DefaultExpandIcon} {...props} />
);

import { default as DefaultExternalLinkIcon } from '~icons/lucide/external-link';

/**
 * @see https://lucide.dev/icons/external-link
 */
export const ExternalLinkIcon = (props: IconProps) => (
  <Icon icon={DefaultExternalLinkIcon} {...props} />
);

import { default as DefaultEyeIcon } from '~icons/lucide/eye';

/**
 * @see https://lucide.dev/icons/eye
 */
export const EyeIcon = (props: IconProps) => (
  <Icon icon={DefaultEyeIcon} {...props} />
);

import { default as DefaultEyeClosedIcon } from '~icons/lucide/eye-closed';

/**
 * @see https://lucide.dev/icons/eye-closed
 */
export const EyeClosedIcon = (props: IconProps) => (
  <Icon icon={DefaultEyeClosedIcon} {...props} />
);

import { default as DefaultEyeOffIcon } from '~icons/lucide/eye-off';

/**
 * @see https://lucide.dev/icons/eye-off
 */
export const EyeOffIcon = (props: IconProps) => (
  <Icon icon={DefaultEyeOffIcon} {...props} />
);

import { default as DefaultFacebookIcon } from '~icons/lucide/facebook';

/**
 * @see https://lucide.dev/icons/facebook
 */
export const FacebookIcon = (props: IconProps) => (
  <Icon icon={DefaultFacebookIcon} {...props} />
);

import { default as DefaultFactoryIcon } from '~icons/lucide/factory';

/**
 * @see https://lucide.dev/icons/factory
 */
export const FactoryIcon = (props: IconProps) => (
  <Icon icon={DefaultFactoryIcon} {...props} />
);

import { default as DefaultFanIcon } from '~icons/lucide/fan';

/**
 * @see https://lucide.dev/icons/fan
 */
export const FanIcon = (props: IconProps) => (
  <Icon icon={DefaultFanIcon} {...props} />
);

import { default as DefaultFastForwardIcon } from '~icons/lucide/fast-forward';

/**
 * @see https://lucide.dev/icons/fast-forward
 */
export const FastForwardIcon = (props: IconProps) => (
  <Icon icon={DefaultFastForwardIcon} {...props} />
);

import { default as DefaultFeatherIcon } from '~icons/lucide/feather';

/**
 * @see https://lucide.dev/icons/feather
 */
export const FeatherIcon = (props: IconProps) => (
  <Icon icon={DefaultFeatherIcon} {...props} />
);

import { default as DefaultFenceIcon } from '~icons/lucide/fence';

/**
 * @see https://lucide.dev/icons/fence
 */
export const FenceIcon = (props: IconProps) => (
  <Icon icon={DefaultFenceIcon} {...props} />
);

import { default as DefaultFerrisWheelIcon } from '~icons/lucide/ferris-wheel';

/**
 * @see https://lucide.dev/icons/ferris-wheel
 */
export const FerrisWheelIcon = (props: IconProps) => (
  <Icon icon={DefaultFerrisWheelIcon} {...props} />
);

import { default as DefaultFigmaIcon } from '~icons/lucide/figma';

/**
 * @see https://lucide.dev/icons/figma
 */
export const FigmaIcon = (props: IconProps) => (
  <Icon icon={DefaultFigmaIcon} {...props} />
);

import { default as DefaultFileIcon } from '~icons/lucide/file';

/**
 * @see https://lucide.dev/icons/file
 */
export const FileIcon = (props: IconProps) => (
  <Icon icon={DefaultFileIcon} {...props} />
);

import { default as DefaultFileArchiveIcon } from '~icons/lucide/file-archive';

/**
 * @see https://lucide.dev/icons/file-archive
 */
export const FileArchiveIcon = (props: IconProps) => (
  <Icon icon={DefaultFileArchiveIcon} {...props} />
);

import { default as DefaultFileAudioIcon } from '~icons/lucide/file-audio';

/**
 * @see https://lucide.dev/icons/file-audio
 */
export const FileAudioIcon = (props: IconProps) => (
  <Icon icon={DefaultFileAudioIcon} {...props} />
);

import { default as DefaultFileAudio2Icon } from '~icons/lucide/file-audio-2';

/**
 * @see https://lucide.dev/icons/file-audio-2
 */
export const FileAudio2Icon = (props: IconProps) => (
  <Icon icon={DefaultFileAudio2Icon} {...props} />
);

import { default as DefaultFileAxis3dIcon } from '~icons/lucide/file-axis-3d';

/**
 * @see https://lucide.dev/icons/file-axis-3d
 */
export const FileAxis3dIcon = (props: IconProps) => (
  <Icon icon={DefaultFileAxis3dIcon} {...props} />
);

import { default as DefaultFileBadgeIcon } from '~icons/lucide/file-badge';

/**
 * @see https://lucide.dev/icons/file-badge
 */
export const FileBadgeIcon = (props: IconProps) => (
  <Icon icon={DefaultFileBadgeIcon} {...props} />
);

import { default as DefaultFileBadge2Icon } from '~icons/lucide/file-badge-2';

/**
 * @see https://lucide.dev/icons/file-badge-2
 */
export const FileBadge2Icon = (props: IconProps) => (
  <Icon icon={DefaultFileBadge2Icon} {...props} />
);

import { default as DefaultFileBoxIcon } from '~icons/lucide/file-box';

/**
 * @see https://lucide.dev/icons/file-box
 */
export const FileBoxIcon = (props: IconProps) => (
  <Icon icon={DefaultFileBoxIcon} {...props} />
);

import { default as DefaultFileChartColumnIcon } from '~icons/lucide/file-chart-column';

/**
 * @see https://lucide.dev/icons/file-chart-column
 */
export const FileChartColumnIcon = (props: IconProps) => (
  <Icon icon={DefaultFileChartColumnIcon} {...props} />
);

import { default as DefaultFileChartColumnIncreasingIcon } from '~icons/lucide/file-chart-column-increasing';

/**
 * @see https://lucide.dev/icons/file-chart-column-increasing
 */
export const FileChartColumnIncreasingIcon = (props: IconProps) => (
  <Icon icon={DefaultFileChartColumnIncreasingIcon} {...props} />
);

import { default as DefaultFileChartLineIcon } from '~icons/lucide/file-chart-line';

/**
 * @see https://lucide.dev/icons/file-chart-line
 */
export const FileChartLineIcon = (props: IconProps) => (
  <Icon icon={DefaultFileChartLineIcon} {...props} />
);

import { default as DefaultFileChartPieIcon } from '~icons/lucide/file-chart-pie';

/**
 * @see https://lucide.dev/icons/file-chart-pie
 */
export const FileChartPieIcon = (props: IconProps) => (
  <Icon icon={DefaultFileChartPieIcon} {...props} />
);

import { default as DefaultFileCheckIcon } from '~icons/lucide/file-check';

/**
 * @see https://lucide.dev/icons/file-check
 */
export const FileCheckIcon = (props: IconProps) => (
  <Icon icon={DefaultFileCheckIcon} {...props} />
);

import { default as DefaultFileCheck2Icon } from '~icons/lucide/file-check-2';

/**
 * @see https://lucide.dev/icons/file-check-2
 */
export const FileCheck2Icon = (props: IconProps) => (
  <Icon icon={DefaultFileCheck2Icon} {...props} />
);

import { default as DefaultFileClockIcon } from '~icons/lucide/file-clock';

/**
 * @see https://lucide.dev/icons/file-clock
 */
export const FileClockIcon = (props: IconProps) => (
  <Icon icon={DefaultFileClockIcon} {...props} />
);

import { default as DefaultFileCodeIcon } from '~icons/lucide/file-code';

/**
 * @see https://lucide.dev/icons/file-code
 */
export const FileCodeIcon = (props: IconProps) => (
  <Icon icon={DefaultFileCodeIcon} {...props} />
);

import { default as DefaultFileCode2Icon } from '~icons/lucide/file-code-2';

/**
 * @see https://lucide.dev/icons/file-code-2
 */
export const FileCode2Icon = (props: IconProps) => (
  <Icon icon={DefaultFileCode2Icon} {...props} />
);

import { default as DefaultFileCogIcon } from '~icons/lucide/file-cog';

/**
 * @see https://lucide.dev/icons/file-cog
 */
export const FileCogIcon = (props: IconProps) => (
  <Icon icon={DefaultFileCogIcon} {...props} />
);

import { default as DefaultFileDiffIcon } from '~icons/lucide/file-diff';

/**
 * @see https://lucide.dev/icons/file-diff
 */
export const FileDiffIcon = (props: IconProps) => (
  <Icon icon={DefaultFileDiffIcon} {...props} />
);

import { default as DefaultFileDigitIcon } from '~icons/lucide/file-digit';

/**
 * @see https://lucide.dev/icons/file-digit
 */
export const FileDigitIcon = (props: IconProps) => (
  <Icon icon={DefaultFileDigitIcon} {...props} />
);

import { default as DefaultFileDownIcon } from '~icons/lucide/file-down';

/**
 * @see https://lucide.dev/icons/file-down
 */
export const FileDownIcon = (props: IconProps) => (
  <Icon icon={DefaultFileDownIcon} {...props} />
);

import { default as DefaultFileHeartIcon } from '~icons/lucide/file-heart';

/**
 * @see https://lucide.dev/icons/file-heart
 */
export const FileHeartIcon = (props: IconProps) => (
  <Icon icon={DefaultFileHeartIcon} {...props} />
);

import { default as DefaultFileImageIcon } from '~icons/lucide/file-image';

/**
 * @see https://lucide.dev/icons/file-image
 */
export const FileImageIcon = (props: IconProps) => (
  <Icon icon={DefaultFileImageIcon} {...props} />
);

import { default as DefaultFileInputIcon } from '~icons/lucide/file-input';

/**
 * @see https://lucide.dev/icons/file-input
 */
export const FileInputIcon = (props: IconProps) => (
  <Icon icon={DefaultFileInputIcon} {...props} />
);

import { default as DefaultFileJsonIcon } from '~icons/lucide/file-json';

/**
 * @see https://lucide.dev/icons/file-json
 */
export const FileJsonIcon = (props: IconProps) => (
  <Icon icon={DefaultFileJsonIcon} {...props} />
);

import { default as DefaultFileJson2Icon } from '~icons/lucide/file-json-2';

/**
 * @see https://lucide.dev/icons/file-json-2
 */
export const FileJson2Icon = (props: IconProps) => (
  <Icon icon={DefaultFileJson2Icon} {...props} />
);

import { default as DefaultFileKeyIcon } from '~icons/lucide/file-key';

/**
 * @see https://lucide.dev/icons/file-key
 */
export const FileKeyIcon = (props: IconProps) => (
  <Icon icon={DefaultFileKeyIcon} {...props} />
);

import { default as DefaultFileKey2Icon } from '~icons/lucide/file-key-2';

/**
 * @see https://lucide.dev/icons/file-key-2
 */
export const FileKey2Icon = (props: IconProps) => (
  <Icon icon={DefaultFileKey2Icon} {...props} />
);

import { default as DefaultFileLockIcon } from '~icons/lucide/file-lock';

/**
 * @see https://lucide.dev/icons/file-lock
 */
export const FileLockIcon = (props: IconProps) => (
  <Icon icon={DefaultFileLockIcon} {...props} />
);

import { default as DefaultFileLock2Icon } from '~icons/lucide/file-lock-2';

/**
 * @see https://lucide.dev/icons/file-lock-2
 */
export const FileLock2Icon = (props: IconProps) => (
  <Icon icon={DefaultFileLock2Icon} {...props} />
);

import { default as DefaultFileMinusIcon } from '~icons/lucide/file-minus';

/**
 * @see https://lucide.dev/icons/file-minus
 */
export const FileMinusIcon = (props: IconProps) => (
  <Icon icon={DefaultFileMinusIcon} {...props} />
);

import { default as DefaultFileMinus2Icon } from '~icons/lucide/file-minus-2';

/**
 * @see https://lucide.dev/icons/file-minus-2
 */
export const FileMinus2Icon = (props: IconProps) => (
  <Icon icon={DefaultFileMinus2Icon} {...props} />
);

import { default as DefaultFileMusicIcon } from '~icons/lucide/file-music';

/**
 * @see https://lucide.dev/icons/file-music
 */
export const FileMusicIcon = (props: IconProps) => (
  <Icon icon={DefaultFileMusicIcon} {...props} />
);

import { default as DefaultFileOutputIcon } from '~icons/lucide/file-output';

/**
 * @see https://lucide.dev/icons/file-output
 */
export const FileOutputIcon = (props: IconProps) => (
  <Icon icon={DefaultFileOutputIcon} {...props} />
);

import { default as DefaultFilePenIcon } from '~icons/lucide/file-pen';

/**
 * @see https://lucide.dev/icons/file-pen
 */
export const FilePenIcon = (props: IconProps) => (
  <Icon icon={DefaultFilePenIcon} {...props} />
);

import { default as DefaultFilePenLineIcon } from '~icons/lucide/file-pen-line';

/**
 * @see https://lucide.dev/icons/file-pen-line
 */
export const FilePenLineIcon = (props: IconProps) => (
  <Icon icon={DefaultFilePenLineIcon} {...props} />
);

import { default as DefaultFilePieChartIcon } from '~icons/lucide/file-pie-chart';

/**
 * @see https://lucide.dev/icons/file-pie-chart
 */
export const FilePieChartIcon = (props: IconProps) => (
  <Icon icon={DefaultFilePieChartIcon} {...props} />
);

import { default as DefaultFilePlusIcon } from '~icons/lucide/file-plus';

/**
 * @see https://lucide.dev/icons/file-plus
 */
export const FilePlusIcon = (props: IconProps) => (
  <Icon icon={DefaultFilePlusIcon} {...props} />
);

import { default as DefaultFilePlus2Icon } from '~icons/lucide/file-plus-2';

/**
 * @see https://lucide.dev/icons/file-plus-2
 */
export const FilePlus2Icon = (props: IconProps) => (
  <Icon icon={DefaultFilePlus2Icon} {...props} />
);

import { default as DefaultFileQuestionMarkIcon } from '~icons/lucide/file-question-mark';

/**
 * @see https://lucide.dev/icons/file-question-mark
 */
export const FileQuestionMarkIcon = (props: IconProps) => (
  <Icon icon={DefaultFileQuestionMarkIcon} {...props} />
);

import { default as DefaultFileScanIcon } from '~icons/lucide/file-scan';

/**
 * @see https://lucide.dev/icons/file-scan
 */
export const FileScanIcon = (props: IconProps) => (
  <Icon icon={DefaultFileScanIcon} {...props} />
);

import { default as DefaultFileSearchIcon } from '~icons/lucide/file-search';

/**
 * @see https://lucide.dev/icons/file-search
 */
export const FileSearchIcon = (props: IconProps) => (
  <Icon icon={DefaultFileSearchIcon} {...props} />
);

import { default as DefaultFileSearch2Icon } from '~icons/lucide/file-search-2';

/**
 * @see https://lucide.dev/icons/file-search-2
 */
export const FileSearch2Icon = (props: IconProps) => (
  <Icon icon={DefaultFileSearch2Icon} {...props} />
);

import { default as DefaultFileSlidersIcon } from '~icons/lucide/file-sliders';

/**
 * @see https://lucide.dev/icons/file-sliders
 */
export const FileSlidersIcon = (props: IconProps) => (
  <Icon icon={DefaultFileSlidersIcon} {...props} />
);

import { default as DefaultFileSpreadsheetIcon } from '~icons/lucide/file-spreadsheet';

/**
 * @see https://lucide.dev/icons/file-spreadsheet
 */
export const FileSpreadsheetIcon = (props: IconProps) => (
  <Icon icon={DefaultFileSpreadsheetIcon} {...props} />
);

import { default as DefaultFileStackIcon } from '~icons/lucide/file-stack';

/**
 * @see https://lucide.dev/icons/file-stack
 */
export const FileStackIcon = (props: IconProps) => (
  <Icon icon={DefaultFileStackIcon} {...props} />
);

import { default as DefaultFileSymlinkIcon } from '~icons/lucide/file-symlink';

/**
 * @see https://lucide.dev/icons/file-symlink
 */
export const FileSymlinkIcon = (props: IconProps) => (
  <Icon icon={DefaultFileSymlinkIcon} {...props} />
);

import { default as DefaultFileTerminalIcon } from '~icons/lucide/file-terminal';

/**
 * @see https://lucide.dev/icons/file-terminal
 */
export const FileTerminalIcon = (props: IconProps) => (
  <Icon icon={DefaultFileTerminalIcon} {...props} />
);

import { default as DefaultFileTextIcon } from '~icons/lucide/file-text';

/**
 * @see https://lucide.dev/icons/file-text
 */
export const FileTextIcon = (props: IconProps) => (
  <Icon icon={DefaultFileTextIcon} {...props} />
);

import { default as DefaultFileTypeIcon } from '~icons/lucide/file-type';

/**
 * @see https://lucide.dev/icons/file-type
 */
export const FileTypeIcon = (props: IconProps) => (
  <Icon icon={DefaultFileTypeIcon} {...props} />
);

import { default as DefaultFileType2Icon } from '~icons/lucide/file-type-2';

/**
 * @see https://lucide.dev/icons/file-type-2
 */
export const FileType2Icon = (props: IconProps) => (
  <Icon icon={DefaultFileType2Icon} {...props} />
);

import { default as DefaultFileUpIcon } from '~icons/lucide/file-up';

/**
 * @see https://lucide.dev/icons/file-up
 */
export const FileUpIcon = (props: IconProps) => (
  <Icon icon={DefaultFileUpIcon} {...props} />
);

import { default as DefaultFileUserIcon } from '~icons/lucide/file-user';

/**
 * @see https://lucide.dev/icons/file-user
 */
export const FileUserIcon = (props: IconProps) => (
  <Icon icon={DefaultFileUserIcon} {...props} />
);

import { default as DefaultFileVideoIcon } from '~icons/lucide/file-video';

/**
 * @see https://lucide.dev/icons/file-video
 */
export const FileVideoIcon = (props: IconProps) => (
  <Icon icon={DefaultFileVideoIcon} {...props} />
);

import { default as DefaultFileVideo2Icon } from '~icons/lucide/file-video-2';

/**
 * @see https://lucide.dev/icons/file-video-2
 */
export const FileVideo2Icon = (props: IconProps) => (
  <Icon icon={DefaultFileVideo2Icon} {...props} />
);

import { default as DefaultFileVolumeIcon } from '~icons/lucide/file-volume';

/**
 * @see https://lucide.dev/icons/file-volume
 */
export const FileVolumeIcon = (props: IconProps) => (
  <Icon icon={DefaultFileVolumeIcon} {...props} />
);

import { default as DefaultFileVolume2Icon } from '~icons/lucide/file-volume-2';

/**
 * @see https://lucide.dev/icons/file-volume-2
 */
export const FileVolume2Icon = (props: IconProps) => (
  <Icon icon={DefaultFileVolume2Icon} {...props} />
);

import { default as DefaultFileWarningIcon } from '~icons/lucide/file-warning';

/**
 * @see https://lucide.dev/icons/file-warning
 */
export const FileWarningIcon = (props: IconProps) => (
  <Icon icon={DefaultFileWarningIcon} {...props} />
);

import { default as DefaultFileXIcon } from '~icons/lucide/file-x';

/**
 * @see https://lucide.dev/icons/file-x
 */
export const FileXIcon = (props: IconProps) => (
  <Icon icon={DefaultFileXIcon} {...props} />
);

import { default as DefaultFileX2Icon } from '~icons/lucide/file-x-2';

/**
 * @see https://lucide.dev/icons/file-x-2
 */
export const FileX2Icon = (props: IconProps) => (
  <Icon icon={DefaultFileX2Icon} {...props} />
);

import { default as DefaultFilesIcon } from '~icons/lucide/files';

/**
 * @see https://lucide.dev/icons/files
 */
export const FilesIcon = (props: IconProps) => (
  <Icon icon={DefaultFilesIcon} {...props} />
);

import { default as DefaultFilmIcon } from '~icons/lucide/film';

/**
 * @see https://lucide.dev/icons/film
 */
export const FilmIcon = (props: IconProps) => (
  <Icon icon={DefaultFilmIcon} {...props} />
);

import { default as DefaultFilterIcon } from '~icons/lucide/filter';

/**
 * @see https://lucide.dev/icons/filter
 */
export const FilterIcon = (props: IconProps) => (
  <Icon icon={DefaultFilterIcon} {...props} />
);

import { default as DefaultFilterXIcon } from '~icons/lucide/filter-x';

/**
 * @see https://lucide.dev/icons/filter-x
 */
export const FilterXIcon = (props: IconProps) => (
  <Icon icon={DefaultFilterXIcon} {...props} />
);

import { default as DefaultFireExtinguisherIcon } from '~icons/lucide/fire-extinguisher';

/**
 * @see https://lucide.dev/icons/fire-extinguisher
 */
export const FireExtinguisherIcon = (props: IconProps) => (
  <Icon icon={DefaultFireExtinguisherIcon} {...props} />
);

import { default as DefaultFishIcon } from '~icons/lucide/fish';

/**
 * @see https://lucide.dev/icons/fish
 */
export const FishIcon = (props: IconProps) => (
  <Icon icon={DefaultFishIcon} {...props} />
);

import { default as DefaultFishOffIcon } from '~icons/lucide/fish-off';

/**
 * @see https://lucide.dev/icons/fish-off
 */
export const FishOffIcon = (props: IconProps) => (
  <Icon icon={DefaultFishOffIcon} {...props} />
);

import { default as DefaultFishSymbolIcon } from '~icons/lucide/fish-symbol';

/**
 * @see https://lucide.dev/icons/fish-symbol
 */
export const FishSymbolIcon = (props: IconProps) => (
  <Icon icon={DefaultFishSymbolIcon} {...props} />
);

import { default as DefaultFlagIcon } from '~icons/lucide/flag';

/**
 * @see https://lucide.dev/icons/flag
 */
export const FlagIcon = (props: IconProps) => (
  <Icon icon={DefaultFlagIcon} {...props} />
);

import { default as DefaultFlagOffIcon } from '~icons/lucide/flag-off';

/**
 * @see https://lucide.dev/icons/flag-off
 */
export const FlagOffIcon = (props: IconProps) => (
  <Icon icon={DefaultFlagOffIcon} {...props} />
);

import { default as DefaultFlagTriangleLeftIcon } from '~icons/lucide/flag-triangle-left';

/**
 * @see https://lucide.dev/icons/flag-triangle-left
 */
export const FlagTriangleLeftIcon = (props: IconProps) => (
  <Icon icon={DefaultFlagTriangleLeftIcon} {...props} />
);

import { default as DefaultFlagTriangleRightIcon } from '~icons/lucide/flag-triangle-right';

/**
 * @see https://lucide.dev/icons/flag-triangle-right
 */
export const FlagTriangleRightIcon = (props: IconProps) => (
  <Icon icon={DefaultFlagTriangleRightIcon} {...props} />
);

import { default as DefaultFlameIcon } from '~icons/lucide/flame';

/**
 * @see https://lucide.dev/icons/flame
 */
export const FlameIcon = (props: IconProps) => (
  <Icon icon={DefaultFlameIcon} {...props} />
);

import { default as DefaultFlameKindlingIcon } from '~icons/lucide/flame-kindling';

/**
 * @see https://lucide.dev/icons/flame-kindling
 */
export const FlameKindlingIcon = (props: IconProps) => (
  <Icon icon={DefaultFlameKindlingIcon} {...props} />
);

import { default as DefaultFlashlightIcon } from '~icons/lucide/flashlight';

/**
 * @see https://lucide.dev/icons/flashlight
 */
export const FlashlightIcon = (props: IconProps) => (
  <Icon icon={DefaultFlashlightIcon} {...props} />
);

import { default as DefaultFlashlightOffIcon } from '~icons/lucide/flashlight-off';

/**
 * @see https://lucide.dev/icons/flashlight-off
 */
export const FlashlightOffIcon = (props: IconProps) => (
  <Icon icon={DefaultFlashlightOffIcon} {...props} />
);

import { default as DefaultFlaskConicalIcon } from '~icons/lucide/flask-conical';

/**
 * @see https://lucide.dev/icons/flask-conical
 */
export const FlaskConicalIcon = (props: IconProps) => (
  <Icon icon={DefaultFlaskConicalIcon} {...props} />
);

import { default as DefaultFlaskConicalOffIcon } from '~icons/lucide/flask-conical-off';

/**
 * @see https://lucide.dev/icons/flask-conical-off
 */
export const FlaskConicalOffIcon = (props: IconProps) => (
  <Icon icon={DefaultFlaskConicalOffIcon} {...props} />
);

import { default as DefaultFlaskRoundIcon } from '~icons/lucide/flask-round';

/**
 * @see https://lucide.dev/icons/flask-round
 */
export const FlaskRoundIcon = (props: IconProps) => (
  <Icon icon={DefaultFlaskRoundIcon} {...props} />
);

import { default as DefaultFlipHorizontalIcon } from '~icons/lucide/flip-horizontal';

/**
 * @see https://lucide.dev/icons/flip-horizontal
 */
export const FlipHorizontalIcon = (props: IconProps) => (
  <Icon icon={DefaultFlipHorizontalIcon} {...props} />
);

import { default as DefaultFlipHorizontal2Icon } from '~icons/lucide/flip-horizontal-2';

/**
 * @see https://lucide.dev/icons/flip-horizontal-2
 */
export const FlipHorizontal2Icon = (props: IconProps) => (
  <Icon icon={DefaultFlipHorizontal2Icon} {...props} />
);

import { default as DefaultFlipVerticalIcon } from '~icons/lucide/flip-vertical';

/**
 * @see https://lucide.dev/icons/flip-vertical
 */
export const FlipVerticalIcon = (props: IconProps) => (
  <Icon icon={DefaultFlipVerticalIcon} {...props} />
);

import { default as DefaultFlipVertical2Icon } from '~icons/lucide/flip-vertical-2';

/**
 * @see https://lucide.dev/icons/flip-vertical-2
 */
export const FlipVertical2Icon = (props: IconProps) => (
  <Icon icon={DefaultFlipVertical2Icon} {...props} />
);

import { default as DefaultFlowerIcon } from '~icons/lucide/flower';

/**
 * @see https://lucide.dev/icons/flower
 */
export const FlowerIcon = (props: IconProps) => (
  <Icon icon={DefaultFlowerIcon} {...props} />
);

import { default as DefaultFlower2Icon } from '~icons/lucide/flower-2';

/**
 * @see https://lucide.dev/icons/flower-2
 */
export const Flower2Icon = (props: IconProps) => (
  <Icon icon={DefaultFlower2Icon} {...props} />
);

import { default as DefaultFocusIcon } from '~icons/lucide/focus';

/**
 * @see https://lucide.dev/icons/focus
 */
export const FocusIcon = (props: IconProps) => (
  <Icon icon={DefaultFocusIcon} {...props} />
);

import { default as DefaultFoldHorizontalIcon } from '~icons/lucide/fold-horizontal';

/**
 * @see https://lucide.dev/icons/fold-horizontal
 */
export const FoldHorizontalIcon = (props: IconProps) => (
  <Icon icon={DefaultFoldHorizontalIcon} {...props} />
);

import { default as DefaultFoldVerticalIcon } from '~icons/lucide/fold-vertical';

/**
 * @see https://lucide.dev/icons/fold-vertical
 */
export const FoldVerticalIcon = (props: IconProps) => (
  <Icon icon={DefaultFoldVerticalIcon} {...props} />
);

import { default as DefaultFolderIcon } from '~icons/lucide/folder';

/**
 * @see https://lucide.dev/icons/folder
 */
export const FolderIcon = (props: IconProps) => (
  <Icon icon={DefaultFolderIcon} {...props} />
);

import { default as DefaultFolderArchiveIcon } from '~icons/lucide/folder-archive';

/**
 * @see https://lucide.dev/icons/folder-archive
 */
export const FolderArchiveIcon = (props: IconProps) => (
  <Icon icon={DefaultFolderArchiveIcon} {...props} />
);

import { default as DefaultFolderCheckIcon } from '~icons/lucide/folder-check';

/**
 * @see https://lucide.dev/icons/folder-check
 */
export const FolderCheckIcon = (props: IconProps) => (
  <Icon icon={DefaultFolderCheckIcon} {...props} />
);

import { default as DefaultFolderClockIcon } from '~icons/lucide/folder-clock';

/**
 * @see https://lucide.dev/icons/folder-clock
 */
export const FolderClockIcon = (props: IconProps) => (
  <Icon icon={DefaultFolderClockIcon} {...props} />
);

import { default as DefaultFolderClosedIcon } from '~icons/lucide/folder-closed';

/**
 * @see https://lucide.dev/icons/folder-closed
 */
export const FolderClosedIcon = (props: IconProps) => (
  <Icon icon={DefaultFolderClosedIcon} {...props} />
);

import { default as DefaultFolderCodeIcon } from '~icons/lucide/folder-code';

/**
 * @see https://lucide.dev/icons/folder-code
 */
export const FolderCodeIcon = (props: IconProps) => (
  <Icon icon={DefaultFolderCodeIcon} {...props} />
);

import { default as DefaultFolderCogIcon } from '~icons/lucide/folder-cog';

/**
 * @see https://lucide.dev/icons/folder-cog
 */
export const FolderCogIcon = (props: IconProps) => (
  <Icon icon={DefaultFolderCogIcon} {...props} />
);

import { default as DefaultFolderDotIcon } from '~icons/lucide/folder-dot';

/**
 * @see https://lucide.dev/icons/folder-dot
 */
export const FolderDotIcon = (props: IconProps) => (
  <Icon icon={DefaultFolderDotIcon} {...props} />
);

import { default as DefaultFolderDownIcon } from '~icons/lucide/folder-down';

/**
 * @see https://lucide.dev/icons/folder-down
 */
export const FolderDownIcon = (props: IconProps) => (
  <Icon icon={DefaultFolderDownIcon} {...props} />
);

import { default as DefaultFolderGitIcon } from '~icons/lucide/folder-git';

/**
 * @see https://lucide.dev/icons/folder-git
 */
export const FolderGitIcon = (props: IconProps) => (
  <Icon icon={DefaultFolderGitIcon} {...props} />
);

import { default as DefaultFolderGit2Icon } from '~icons/lucide/folder-git-2';

/**
 * @see https://lucide.dev/icons/folder-git-2
 */
export const FolderGit2Icon = (props: IconProps) => (
  <Icon icon={DefaultFolderGit2Icon} {...props} />
);

import { default as DefaultFolderHeartIcon } from '~icons/lucide/folder-heart';

/**
 * @see https://lucide.dev/icons/folder-heart
 */
export const FolderHeartIcon = (props: IconProps) => (
  <Icon icon={DefaultFolderHeartIcon} {...props} />
);

import { default as DefaultFolderInputIcon } from '~icons/lucide/folder-input';

/**
 * @see https://lucide.dev/icons/folder-input
 */
export const FolderInputIcon = (props: IconProps) => (
  <Icon icon={DefaultFolderInputIcon} {...props} />
);

import { default as DefaultFolderKanbanIcon } from '~icons/lucide/folder-kanban';

/**
 * @see https://lucide.dev/icons/folder-kanban
 */
export const FolderKanbanIcon = (props: IconProps) => (
  <Icon icon={DefaultFolderKanbanIcon} {...props} />
);

import { default as DefaultFolderKeyIcon } from '~icons/lucide/folder-key';

/**
 * @see https://lucide.dev/icons/folder-key
 */
export const FolderKeyIcon = (props: IconProps) => (
  <Icon icon={DefaultFolderKeyIcon} {...props} />
);

import { default as DefaultFolderLockIcon } from '~icons/lucide/folder-lock';

/**
 * @see https://lucide.dev/icons/folder-lock
 */
export const FolderLockIcon = (props: IconProps) => (
  <Icon icon={DefaultFolderLockIcon} {...props} />
);

import { default as DefaultFolderMinusIcon } from '~icons/lucide/folder-minus';

/**
 * @see https://lucide.dev/icons/folder-minus
 */
export const FolderMinusIcon = (props: IconProps) => (
  <Icon icon={DefaultFolderMinusIcon} {...props} />
);

import { default as DefaultFolderOpenIcon } from '~icons/lucide/folder-open';

/**
 * @see https://lucide.dev/icons/folder-open
 */
export const FolderOpenIcon = (props: IconProps) => (
  <Icon icon={DefaultFolderOpenIcon} {...props} />
);

import { default as DefaultFolderOpenDotIcon } from '~icons/lucide/folder-open-dot';

/**
 * @see https://lucide.dev/icons/folder-open-dot
 */
export const FolderOpenDotIcon = (props: IconProps) => (
  <Icon icon={DefaultFolderOpenDotIcon} {...props} />
);

import { default as DefaultFolderOutputIcon } from '~icons/lucide/folder-output';

/**
 * @see https://lucide.dev/icons/folder-output
 */
export const FolderOutputIcon = (props: IconProps) => (
  <Icon icon={DefaultFolderOutputIcon} {...props} />
);

import { default as DefaultFolderPenIcon } from '~icons/lucide/folder-pen';

/**
 * @see https://lucide.dev/icons/folder-pen
 */
export const FolderPenIcon = (props: IconProps) => (
  <Icon icon={DefaultFolderPenIcon} {...props} />
);

import { default as DefaultFolderPlusIcon } from '~icons/lucide/folder-plus';

/**
 * @see https://lucide.dev/icons/folder-plus
 */
export const FolderPlusIcon = (props: IconProps) => (
  <Icon icon={DefaultFolderPlusIcon} {...props} />
);

import { default as DefaultFolderRootIcon } from '~icons/lucide/folder-root';

/**
 * @see https://lucide.dev/icons/folder-root
 */
export const FolderRootIcon = (props: IconProps) => (
  <Icon icon={DefaultFolderRootIcon} {...props} />
);

import { default as DefaultFolderSearchIcon } from '~icons/lucide/folder-search';

/**
 * @see https://lucide.dev/icons/folder-search
 */
export const FolderSearchIcon = (props: IconProps) => (
  <Icon icon={DefaultFolderSearchIcon} {...props} />
);

import { default as DefaultFolderSearch2Icon } from '~icons/lucide/folder-search-2';

/**
 * @see https://lucide.dev/icons/folder-search-2
 */
export const FolderSearch2Icon = (props: IconProps) => (
  <Icon icon={DefaultFolderSearch2Icon} {...props} />
);

import { default as DefaultFolderSymlinkIcon } from '~icons/lucide/folder-symlink';

/**
 * @see https://lucide.dev/icons/folder-symlink
 */
export const FolderSymlinkIcon = (props: IconProps) => (
  <Icon icon={DefaultFolderSymlinkIcon} {...props} />
);

import { default as DefaultFolderSyncIcon } from '~icons/lucide/folder-sync';

/**
 * @see https://lucide.dev/icons/folder-sync
 */
export const FolderSyncIcon = (props: IconProps) => (
  <Icon icon={DefaultFolderSyncIcon} {...props} />
);

import { default as DefaultFolderTreeIcon } from '~icons/lucide/folder-tree';

/**
 * @see https://lucide.dev/icons/folder-tree
 */
export const FolderTreeIcon = (props: IconProps) => (
  <Icon icon={DefaultFolderTreeIcon} {...props} />
);

import { default as DefaultFolderUpIcon } from '~icons/lucide/folder-up';

/**
 * @see https://lucide.dev/icons/folder-up
 */
export const FolderUpIcon = (props: IconProps) => (
  <Icon icon={DefaultFolderUpIcon} {...props} />
);

import { default as DefaultFolderXIcon } from '~icons/lucide/folder-x';

/**
 * @see https://lucide.dev/icons/folder-x
 */
export const FolderXIcon = (props: IconProps) => (
  <Icon icon={DefaultFolderXIcon} {...props} />
);

import { default as DefaultFoldersIcon } from '~icons/lucide/folders';

/**
 * @see https://lucide.dev/icons/folders
 */
export const FoldersIcon = (props: IconProps) => (
  <Icon icon={DefaultFoldersIcon} {...props} />
);

import { default as DefaultFootprintsIcon } from '~icons/lucide/footprints';

/**
 * @see https://lucide.dev/icons/footprints
 */
export const FootprintsIcon = (props: IconProps) => (
  <Icon icon={DefaultFootprintsIcon} {...props} />
);

import { default as DefaultForkliftIcon } from '~icons/lucide/forklift';

/**
 * @see https://lucide.dev/icons/forklift
 */
export const ForkliftIcon = (props: IconProps) => (
  <Icon icon={DefaultForkliftIcon} {...props} />
);

import { default as DefaultForwardIcon } from '~icons/lucide/forward';

/**
 * @see https://lucide.dev/icons/forward
 */
export const ForwardIcon = (props: IconProps) => (
  <Icon icon={DefaultForwardIcon} {...props} />
);

import { default as DefaultFrameIcon } from '~icons/lucide/frame';

/**
 * @see https://lucide.dev/icons/frame
 */
export const FrameIcon = (props: IconProps) => (
  <Icon icon={DefaultFrameIcon} {...props} />
);

import { default as DefaultFramerIcon } from '~icons/lucide/framer';

/**
 * @see https://lucide.dev/icons/framer
 */
export const FramerIcon = (props: IconProps) => (
  <Icon icon={DefaultFramerIcon} {...props} />
);

import { default as DefaultFrownIcon } from '~icons/lucide/frown';

/**
 * @see https://lucide.dev/icons/frown
 */
export const FrownIcon = (props: IconProps) => (
  <Icon icon={DefaultFrownIcon} {...props} />
);

import { default as DefaultFuelIcon } from '~icons/lucide/fuel';

/**
 * @see https://lucide.dev/icons/fuel
 */
export const FuelIcon = (props: IconProps) => (
  <Icon icon={DefaultFuelIcon} {...props} />
);

import { default as DefaultFullscreenIcon } from '~icons/lucide/fullscreen';

/**
 * @see https://lucide.dev/icons/fullscreen
 */
export const FullscreenIcon = (props: IconProps) => (
  <Icon icon={DefaultFullscreenIcon} {...props} />
);

import { default as DefaultFunnelIcon } from '~icons/lucide/funnel';

/**
 * @see https://lucide.dev/icons/funnel
 */
export const FunnelIcon = (props: IconProps) => (
  <Icon icon={DefaultFunnelIcon} {...props} />
);

import { default as DefaultFunnelPlusIcon } from '~icons/lucide/funnel-plus';

/**
 * @see https://lucide.dev/icons/funnel-plus
 */
export const FunnelPlusIcon = (props: IconProps) => (
  <Icon icon={DefaultFunnelPlusIcon} {...props} />
);

import { default as DefaultFunnelXIcon } from '~icons/lucide/funnel-x';

/**
 * @see https://lucide.dev/icons/funnel-x
 */
export const FunnelXIcon = (props: IconProps) => (
  <Icon icon={DefaultFunnelXIcon} {...props} />
);

import { default as DefaultGalleryHorizontalIcon } from '~icons/lucide/gallery-horizontal';

/**
 * @see https://lucide.dev/icons/gallery-horizontal
 */
export const GalleryHorizontalIcon = (props: IconProps) => (
  <Icon icon={DefaultGalleryHorizontalIcon} {...props} />
);

import { default as DefaultGalleryHorizontalEndIcon } from '~icons/lucide/gallery-horizontal-end';

/**
 * @see https://lucide.dev/icons/gallery-horizontal-end
 */
export const GalleryHorizontalEndIcon = (props: IconProps) => (
  <Icon icon={DefaultGalleryHorizontalEndIcon} {...props} />
);

import { default as DefaultGalleryThumbnailsIcon } from '~icons/lucide/gallery-thumbnails';

/**
 * @see https://lucide.dev/icons/gallery-thumbnails
 */
export const GalleryThumbnailsIcon = (props: IconProps) => (
  <Icon icon={DefaultGalleryThumbnailsIcon} {...props} />
);

import { default as DefaultGalleryVerticalIcon } from '~icons/lucide/gallery-vertical';

/**
 * @see https://lucide.dev/icons/gallery-vertical
 */
export const GalleryVerticalIcon = (props: IconProps) => (
  <Icon icon={DefaultGalleryVerticalIcon} {...props} />
);

import { default as DefaultGalleryVerticalEndIcon } from '~icons/lucide/gallery-vertical-end';

/**
 * @see https://lucide.dev/icons/gallery-vertical-end
 */
export const GalleryVerticalEndIcon = (props: IconProps) => (
  <Icon icon={DefaultGalleryVerticalEndIcon} {...props} />
);

import { default as DefaultGamepadIcon } from '~icons/lucide/gamepad';

/**
 * @see https://lucide.dev/icons/gamepad
 */
export const GamepadIcon = (props: IconProps) => (
  <Icon icon={DefaultGamepadIcon} {...props} />
);

import { default as DefaultGamepad2Icon } from '~icons/lucide/gamepad-2';

/**
 * @see https://lucide.dev/icons/gamepad-2
 */
export const Gamepad2Icon = (props: IconProps) => (
  <Icon icon={DefaultGamepad2Icon} {...props} />
);

import { default as DefaultGaugeIcon } from '~icons/lucide/gauge';

/**
 * @see https://lucide.dev/icons/gauge
 */
export const GaugeIcon = (props: IconProps) => (
  <Icon icon={DefaultGaugeIcon} {...props} />
);

import { default as DefaultGavelIcon } from '~icons/lucide/gavel';

/**
 * @see https://lucide.dev/icons/gavel
 */
export const GavelIcon = (props: IconProps) => (
  <Icon icon={DefaultGavelIcon} {...props} />
);

import { default as DefaultGemIcon } from '~icons/lucide/gem';

/**
 * @see https://lucide.dev/icons/gem
 */
export const GemIcon = (props: IconProps) => (
  <Icon icon={DefaultGemIcon} {...props} />
);

import { default as DefaultGeorgianLariIcon } from '~icons/lucide/georgian-lari';

/**
 * @see https://lucide.dev/icons/georgian-lari
 */
export const GeorgianLariIcon = (props: IconProps) => (
  <Icon icon={DefaultGeorgianLariIcon} {...props} />
);

import { default as DefaultGhostIcon } from '~icons/lucide/ghost';

/**
 * @see https://lucide.dev/icons/ghost
 */
export const GhostIcon = (props: IconProps) => (
  <Icon icon={DefaultGhostIcon} {...props} />
);

import { default as DefaultGiftIcon } from '~icons/lucide/gift';

/**
 * @see https://lucide.dev/icons/gift
 */
export const GiftIcon = (props: IconProps) => (
  <Icon icon={DefaultGiftIcon} {...props} />
);

import { default as DefaultGitBranchIcon } from '~icons/lucide/git-branch';

/**
 * @see https://lucide.dev/icons/git-branch
 */
export const GitBranchIcon = (props: IconProps) => (
  <Icon icon={DefaultGitBranchIcon} {...props} />
);

import { default as DefaultGitBranchPlusIcon } from '~icons/lucide/git-branch-plus';

/**
 * @see https://lucide.dev/icons/git-branch-plus
 */
export const GitBranchPlusIcon = (props: IconProps) => (
  <Icon icon={DefaultGitBranchPlusIcon} {...props} />
);

import { default as DefaultGitCommitHorizontalIcon } from '~icons/lucide/git-commit-horizontal';

/**
 * @see https://lucide.dev/icons/git-commit-horizontal
 */
export const GitCommitHorizontalIcon = (props: IconProps) => (
  <Icon icon={DefaultGitCommitHorizontalIcon} {...props} />
);

import { default as DefaultGitCommitVerticalIcon } from '~icons/lucide/git-commit-vertical';

/**
 * @see https://lucide.dev/icons/git-commit-vertical
 */
export const GitCommitVerticalIcon = (props: IconProps) => (
  <Icon icon={DefaultGitCommitVerticalIcon} {...props} />
);

import { default as DefaultGitCompareIcon } from '~icons/lucide/git-compare';

/**
 * @see https://lucide.dev/icons/git-compare
 */
export const GitCompareIcon = (props: IconProps) => (
  <Icon icon={DefaultGitCompareIcon} {...props} />
);

import { default as DefaultGitCompareArrowsIcon } from '~icons/lucide/git-compare-arrows';

/**
 * @see https://lucide.dev/icons/git-compare-arrows
 */
export const GitCompareArrowsIcon = (props: IconProps) => (
  <Icon icon={DefaultGitCompareArrowsIcon} {...props} />
);

import { default as DefaultGitForkIcon } from '~icons/lucide/git-fork';

/**
 * @see https://lucide.dev/icons/git-fork
 */
export const GitForkIcon = (props: IconProps) => (
  <Icon icon={DefaultGitForkIcon} {...props} />
);

import { default as DefaultGitGraphIcon } from '~icons/lucide/git-graph';

/**
 * @see https://lucide.dev/icons/git-graph
 */
export const GitGraphIcon = (props: IconProps) => (
  <Icon icon={DefaultGitGraphIcon} {...props} />
);

import { default as DefaultGitMergeIcon } from '~icons/lucide/git-merge';

/**
 * @see https://lucide.dev/icons/git-merge
 */
export const GitMergeIcon = (props: IconProps) => (
  <Icon icon={DefaultGitMergeIcon} {...props} />
);

import { default as DefaultGitPullRequestIcon } from '~icons/lucide/git-pull-request';

/**
 * @see https://lucide.dev/icons/git-pull-request
 */
export const GitPullRequestIcon = (props: IconProps) => (
  <Icon icon={DefaultGitPullRequestIcon} {...props} />
);

import { default as DefaultGitPullRequestArrowIcon } from '~icons/lucide/git-pull-request-arrow';

/**
 * @see https://lucide.dev/icons/git-pull-request-arrow
 */
export const GitPullRequestArrowIcon = (props: IconProps) => (
  <Icon icon={DefaultGitPullRequestArrowIcon} {...props} />
);

import { default as DefaultGitPullRequestClosedIcon } from '~icons/lucide/git-pull-request-closed';

/**
 * @see https://lucide.dev/icons/git-pull-request-closed
 */
export const GitPullRequestClosedIcon = (props: IconProps) => (
  <Icon icon={DefaultGitPullRequestClosedIcon} {...props} />
);

import { default as DefaultGitPullRequestCreateIcon } from '~icons/lucide/git-pull-request-create';

/**
 * @see https://lucide.dev/icons/git-pull-request-create
 */
export const GitPullRequestCreateIcon = (props: IconProps) => (
  <Icon icon={DefaultGitPullRequestCreateIcon} {...props} />
);

import { default as DefaultGitPullRequestCreateArrowIcon } from '~icons/lucide/git-pull-request-create-arrow';

/**
 * @see https://lucide.dev/icons/git-pull-request-create-arrow
 */
export const GitPullRequestCreateArrowIcon = (props: IconProps) => (
  <Icon icon={DefaultGitPullRequestCreateArrowIcon} {...props} />
);

import { default as DefaultGitPullRequestDraftIcon } from '~icons/lucide/git-pull-request-draft';

/**
 * @see https://lucide.dev/icons/git-pull-request-draft
 */
export const GitPullRequestDraftIcon = (props: IconProps) => (
  <Icon icon={DefaultGitPullRequestDraftIcon} {...props} />
);

import { default as DefaultGithubIcon } from '~icons/lucide/github';

/**
 * @see https://lucide.dev/icons/github
 */
export const GithubIcon = (props: IconProps) => (
  <Icon icon={DefaultGithubIcon} {...props} />
);

import { default as DefaultGitlabIcon } from '~icons/lucide/gitlab';

/**
 * @see https://lucide.dev/icons/gitlab
 */
export const GitlabIcon = (props: IconProps) => (
  <Icon icon={DefaultGitlabIcon} {...props} />
);

import { default as DefaultGlassWaterIcon } from '~icons/lucide/glass-water';

/**
 * @see https://lucide.dev/icons/glass-water
 */
export const GlassWaterIcon = (props: IconProps) => (
  <Icon icon={DefaultGlassWaterIcon} {...props} />
);

import { default as DefaultGlassesIcon } from '~icons/lucide/glasses';

/**
 * @see https://lucide.dev/icons/glasses
 */
export const GlassesIcon = (props: IconProps) => (
  <Icon icon={DefaultGlassesIcon} {...props} />
);

import { default as DefaultGlobeIcon } from '~icons/lucide/globe';

/**
 * @see https://lucide.dev/icons/globe
 */
export const GlobeIcon = (props: IconProps) => (
  <Icon icon={DefaultGlobeIcon} {...props} />
);

import { default as DefaultGlobeLockIcon } from '~icons/lucide/globe-lock';

/**
 * @see https://lucide.dev/icons/globe-lock
 */
export const GlobeLockIcon = (props: IconProps) => (
  <Icon icon={DefaultGlobeLockIcon} {...props} />
);

import { default as DefaultGoalIcon } from '~icons/lucide/goal';

/**
 * @see https://lucide.dev/icons/goal
 */
export const GoalIcon = (props: IconProps) => (
  <Icon icon={DefaultGoalIcon} {...props} />
);

import { default as DefaultGpuIcon } from '~icons/lucide/gpu';

/**
 * @see https://lucide.dev/icons/gpu
 */
export const GpuIcon = (props: IconProps) => (
  <Icon icon={DefaultGpuIcon} {...props} />
);

import { default as DefaultGrabIcon } from '~icons/lucide/grab';

/**
 * @see https://lucide.dev/icons/grab
 */
export const GrabIcon = (props: IconProps) => (
  <Icon icon={DefaultGrabIcon} {...props} />
);

import { default as DefaultGraduationCapIcon } from '~icons/lucide/graduation-cap';

/**
 * @see https://lucide.dev/icons/graduation-cap
 */
export const GraduationCapIcon = (props: IconProps) => (
  <Icon icon={DefaultGraduationCapIcon} {...props} />
);

import { default as DefaultGrapeIcon } from '~icons/lucide/grape';

/**
 * @see https://lucide.dev/icons/grape
 */
export const GrapeIcon = (props: IconProps) => (
  <Icon icon={DefaultGrapeIcon} {...props} />
);

import { default as DefaultGrid2x2Icon } from '~icons/lucide/grid-2x2';

/**
 * @see https://lucide.dev/icons/grid-2x2
 */
export const Grid2x2Icon = (props: IconProps) => (
  <Icon icon={DefaultGrid2x2Icon} {...props} />
);

import { default as DefaultGrid2x2CheckIcon } from '~icons/lucide/grid-2x2-check';

/**
 * @see https://lucide.dev/icons/grid-2x2-check
 */
export const Grid2x2CheckIcon = (props: IconProps) => (
  <Icon icon={DefaultGrid2x2CheckIcon} {...props} />
);

import { default as DefaultGrid2x2PlusIcon } from '~icons/lucide/grid-2x2-plus';

/**
 * @see https://lucide.dev/icons/grid-2x2-plus
 */
export const Grid2x2PlusIcon = (props: IconProps) => (
  <Icon icon={DefaultGrid2x2PlusIcon} {...props} />
);

import { default as DefaultGrid2x2XIcon } from '~icons/lucide/grid-2x2-x';

/**
 * @see https://lucide.dev/icons/grid-2x2-x
 */
export const Grid2x2XIcon = (props: IconProps) => (
  <Icon icon={DefaultGrid2x2XIcon} {...props} />
);

import { default as DefaultGrid3x2Icon } from '~icons/lucide/grid-3x2';

/**
 * @see https://lucide.dev/icons/grid-3x2
 */
export const Grid3x2Icon = (props: IconProps) => (
  <Icon icon={DefaultGrid3x2Icon} {...props} />
);

import { default as DefaultGrid3x3Icon } from '~icons/lucide/grid-3x3';

/**
 * @see https://lucide.dev/icons/grid-3x3
 */
export const Grid3x3Icon = (props: IconProps) => (
  <Icon icon={DefaultGrid3x3Icon} {...props} />
);

import { default as DefaultGripIcon } from '~icons/lucide/grip';

/**
 * @see https://lucide.dev/icons/grip
 */
export const GripIcon = (props: IconProps) => (
  <Icon icon={DefaultGripIcon} {...props} />
);

import { default as DefaultGripHorizontalIcon } from '~icons/lucide/grip-horizontal';

/**
 * @see https://lucide.dev/icons/grip-horizontal
 */
export const GripHorizontalIcon = (props: IconProps) => (
  <Icon icon={DefaultGripHorizontalIcon} {...props} />
);

import { default as DefaultGripVerticalIcon } from '~icons/lucide/grip-vertical';

/**
 * @see https://lucide.dev/icons/grip-vertical
 */
export const GripVerticalIcon = (props: IconProps) => (
  <Icon icon={DefaultGripVerticalIcon} {...props} />
);

import { default as DefaultGroupIcon } from '~icons/lucide/group';

/**
 * @see https://lucide.dev/icons/group
 */
export const GroupIcon = (props: IconProps) => (
  <Icon icon={DefaultGroupIcon} {...props} />
);

import { default as DefaultGuitarIcon } from '~icons/lucide/guitar';

/**
 * @see https://lucide.dev/icons/guitar
 */
export const GuitarIcon = (props: IconProps) => (
  <Icon icon={DefaultGuitarIcon} {...props} />
);

import { default as DefaultHamIcon } from '~icons/lucide/ham';

/**
 * @see https://lucide.dev/icons/ham
 */
export const HamIcon = (props: IconProps) => (
  <Icon icon={DefaultHamIcon} {...props} />
);

import { default as DefaultHamburgerIcon } from '~icons/lucide/hamburger';

/**
 * @see https://lucide.dev/icons/hamburger
 */
export const HamburgerIcon = (props: IconProps) => (
  <Icon icon={DefaultHamburgerIcon} {...props} />
);

import { default as DefaultHammerIcon } from '~icons/lucide/hammer';

/**
 * @see https://lucide.dev/icons/hammer
 */
export const HammerIcon = (props: IconProps) => (
  <Icon icon={DefaultHammerIcon} {...props} />
);

import { default as DefaultHandIcon } from '~icons/lucide/hand';

/**
 * @see https://lucide.dev/icons/hand
 */
export const HandIcon = (props: IconProps) => (
  <Icon icon={DefaultHandIcon} {...props} />
);

import { default as DefaultHandCoinsIcon } from '~icons/lucide/hand-coins';

/**
 * @see https://lucide.dev/icons/hand-coins
 */
export const HandCoinsIcon = (props: IconProps) => (
  <Icon icon={DefaultHandCoinsIcon} {...props} />
);

import { default as DefaultHandHeartIcon } from '~icons/lucide/hand-heart';

/**
 * @see https://lucide.dev/icons/hand-heart
 */
export const HandHeartIcon = (props: IconProps) => (
  <Icon icon={DefaultHandHeartIcon} {...props} />
);

import { default as DefaultHandHelpingIcon } from '~icons/lucide/hand-helping';

/**
 * @see https://lucide.dev/icons/hand-helping
 */
export const HandHelpingIcon = (props: IconProps) => (
  <Icon icon={DefaultHandHelpingIcon} {...props} />
);

import { default as DefaultHandMetalIcon } from '~icons/lucide/hand-metal';

/**
 * @see https://lucide.dev/icons/hand-metal
 */
export const HandMetalIcon = (props: IconProps) => (
  <Icon icon={DefaultHandMetalIcon} {...props} />
);

import { default as DefaultHandPlatterIcon } from '~icons/lucide/hand-platter';

/**
 * @see https://lucide.dev/icons/hand-platter
 */
export const HandPlatterIcon = (props: IconProps) => (
  <Icon icon={DefaultHandPlatterIcon} {...props} />
);

import { default as DefaultHandshakeIcon } from '~icons/lucide/handshake';

/**
 * @see https://lucide.dev/icons/handshake
 */
export const HandshakeIcon = (props: IconProps) => (
  <Icon icon={DefaultHandshakeIcon} {...props} />
);

import { default as DefaultHardDriveIcon } from '~icons/lucide/hard-drive';

/**
 * @see https://lucide.dev/icons/hard-drive
 */
export const HardDriveIcon = (props: IconProps) => (
  <Icon icon={DefaultHardDriveIcon} {...props} />
);

import { default as DefaultHardDriveDownloadIcon } from '~icons/lucide/hard-drive-download';

/**
 * @see https://lucide.dev/icons/hard-drive-download
 */
export const HardDriveDownloadIcon = (props: IconProps) => (
  <Icon icon={DefaultHardDriveDownloadIcon} {...props} />
);

import { default as DefaultHardDriveUploadIcon } from '~icons/lucide/hard-drive-upload';

/**
 * @see https://lucide.dev/icons/hard-drive-upload
 */
export const HardDriveUploadIcon = (props: IconProps) => (
  <Icon icon={DefaultHardDriveUploadIcon} {...props} />
);

import { default as DefaultHardHatIcon } from '~icons/lucide/hard-hat';

/**
 * @see https://lucide.dev/icons/hard-hat
 */
export const HardHatIcon = (props: IconProps) => (
  <Icon icon={DefaultHardHatIcon} {...props} />
);

import { default as DefaultHashIcon } from '~icons/lucide/hash';

/**
 * @see https://lucide.dev/icons/hash
 */
export const HashIcon = (props: IconProps) => (
  <Icon icon={DefaultHashIcon} {...props} />
);

import { default as DefaultHazeIcon } from '~icons/lucide/haze';

/**
 * @see https://lucide.dev/icons/haze
 */
export const HazeIcon = (props: IconProps) => (
  <Icon icon={DefaultHazeIcon} {...props} />
);

import { default as DefaultHdmiPortIcon } from '~icons/lucide/hdmi-port';

/**
 * @see https://lucide.dev/icons/hdmi-port
 */
export const HdmiPortIcon = (props: IconProps) => (
  <Icon icon={DefaultHdmiPortIcon} {...props} />
);

import { default as DefaultHeadingIcon } from '~icons/lucide/heading';

/**
 * @see https://lucide.dev/icons/heading
 */
export const HeadingIcon = (props: IconProps) => (
  <Icon icon={DefaultHeadingIcon} {...props} />
);

import { default as DefaultHeading1Icon } from '~icons/lucide/heading-1';

/**
 * @see https://lucide.dev/icons/heading-1
 */
export const Heading1Icon = (props: IconProps) => (
  <Icon icon={DefaultHeading1Icon} {...props} />
);

import { default as DefaultHeading2Icon } from '~icons/lucide/heading-2';

/**
 * @see https://lucide.dev/icons/heading-2
 */
export const Heading2Icon = (props: IconProps) => (
  <Icon icon={DefaultHeading2Icon} {...props} />
);

import { default as DefaultHeading3Icon } from '~icons/lucide/heading-3';

/**
 * @see https://lucide.dev/icons/heading-3
 */
export const Heading3Icon = (props: IconProps) => (
  <Icon icon={DefaultHeading3Icon} {...props} />
);

import { default as DefaultHeading4Icon } from '~icons/lucide/heading-4';

/**
 * @see https://lucide.dev/icons/heading-4
 */
export const Heading4Icon = (props: IconProps) => (
  <Icon icon={DefaultHeading4Icon} {...props} />
);

import { default as DefaultHeading5Icon } from '~icons/lucide/heading-5';

/**
 * @see https://lucide.dev/icons/heading-5
 */
export const Heading5Icon = (props: IconProps) => (
  <Icon icon={DefaultHeading5Icon} {...props} />
);

import { default as DefaultHeading6Icon } from '~icons/lucide/heading-6';

/**
 * @see https://lucide.dev/icons/heading-6
 */
export const Heading6Icon = (props: IconProps) => (
  <Icon icon={DefaultHeading6Icon} {...props} />
);

import { default as DefaultHeadphoneOffIcon } from '~icons/lucide/headphone-off';

/**
 * @see https://lucide.dev/icons/headphone-off
 */
export const HeadphoneOffIcon = (props: IconProps) => (
  <Icon icon={DefaultHeadphoneOffIcon} {...props} />
);

import { default as DefaultHeadphonesIcon } from '~icons/lucide/headphones';

/**
 * @see https://lucide.dev/icons/headphones
 */
export const HeadphonesIcon = (props: IconProps) => (
  <Icon icon={DefaultHeadphonesIcon} {...props} />
);

import { default as DefaultHeadsetIcon } from '~icons/lucide/headset';

/**
 * @see https://lucide.dev/icons/headset
 */
export const HeadsetIcon = (props: IconProps) => (
  <Icon icon={DefaultHeadsetIcon} {...props} />
);

import { default as DefaultHeartIcon } from '~icons/lucide/heart';

/**
 * @see https://lucide.dev/icons/heart
 */
export const HeartIcon = (props: IconProps) => (
  <Icon icon={DefaultHeartIcon} {...props} />
);

import { default as DefaultHeartCrackIcon } from '~icons/lucide/heart-crack';

/**
 * @see https://lucide.dev/icons/heart-crack
 */
export const HeartCrackIcon = (props: IconProps) => (
  <Icon icon={DefaultHeartCrackIcon} {...props} />
);

import { default as DefaultHeartHandshakeIcon } from '~icons/lucide/heart-handshake';

/**
 * @see https://lucide.dev/icons/heart-handshake
 */
export const HeartHandshakeIcon = (props: IconProps) => (
  <Icon icon={DefaultHeartHandshakeIcon} {...props} />
);

import { default as DefaultHeartMinusIcon } from '~icons/lucide/heart-minus';

/**
 * @see https://lucide.dev/icons/heart-minus
 */
export const HeartMinusIcon = (props: IconProps) => (
  <Icon icon={DefaultHeartMinusIcon} {...props} />
);

import { default as DefaultHeartOffIcon } from '~icons/lucide/heart-off';

/**
 * @see https://lucide.dev/icons/heart-off
 */
export const HeartOffIcon = (props: IconProps) => (
  <Icon icon={DefaultHeartOffIcon} {...props} />
);

import { default as DefaultHeartPlusIcon } from '~icons/lucide/heart-plus';

/**
 * @see https://lucide.dev/icons/heart-plus
 */
export const HeartPlusIcon = (props: IconProps) => (
  <Icon icon={DefaultHeartPlusIcon} {...props} />
);

import { default as DefaultHeartPulseIcon } from '~icons/lucide/heart-pulse';

/**
 * @see https://lucide.dev/icons/heart-pulse
 */
export const HeartPulseIcon = (props: IconProps) => (
  <Icon icon={DefaultHeartPulseIcon} {...props} />
);

import { default as DefaultHeaterIcon } from '~icons/lucide/heater';

/**
 * @see https://lucide.dev/icons/heater
 */
export const HeaterIcon = (props: IconProps) => (
  <Icon icon={DefaultHeaterIcon} {...props} />
);

import { default as DefaultHexagonIcon } from '~icons/lucide/hexagon';

/**
 * @see https://lucide.dev/icons/hexagon
 */
export const HexagonIcon = (props: IconProps) => (
  <Icon icon={DefaultHexagonIcon} {...props} />
);

import { default as DefaultHighlighterIcon } from '~icons/lucide/highlighter';

/**
 * @see https://lucide.dev/icons/highlighter
 */
export const HighlighterIcon = (props: IconProps) => (
  <Icon icon={DefaultHighlighterIcon} {...props} />
);

import { default as DefaultHistoryIcon } from '~icons/lucide/history';

/**
 * @see https://lucide.dev/icons/history
 */
export const HistoryIcon = (props: IconProps) => (
  <Icon icon={DefaultHistoryIcon} {...props} />
);

import { default as DefaultHopIcon } from '~icons/lucide/hop';

/**
 * @see https://lucide.dev/icons/hop
 */
export const HopIcon = (props: IconProps) => (
  <Icon icon={DefaultHopIcon} {...props} />
);

import { default as DefaultHopOffIcon } from '~icons/lucide/hop-off';

/**
 * @see https://lucide.dev/icons/hop-off
 */
export const HopOffIcon = (props: IconProps) => (
  <Icon icon={DefaultHopOffIcon} {...props} />
);

import { default as DefaultHospitalIcon } from '~icons/lucide/hospital';

/**
 * @see https://lucide.dev/icons/hospital
 */
export const HospitalIcon = (props: IconProps) => (
  <Icon icon={DefaultHospitalIcon} {...props} />
);

import { default as DefaultHotelIcon } from '~icons/lucide/hotel';

/**
 * @see https://lucide.dev/icons/hotel
 */
export const HotelIcon = (props: IconProps) => (
  <Icon icon={DefaultHotelIcon} {...props} />
);

import { default as DefaultHourglassIcon } from '~icons/lucide/hourglass';

/**
 * @see https://lucide.dev/icons/hourglass
 */
export const HourglassIcon = (props: IconProps) => (
  <Icon icon={DefaultHourglassIcon} {...props} />
);

import { default as DefaultHouseIcon } from '~icons/lucide/house';

/**
 * @see https://lucide.dev/icons/house
 */
export const HouseIcon = (props: IconProps) => (
  <Icon icon={DefaultHouseIcon} {...props} />
);

import { default as DefaultHousePlugIcon } from '~icons/lucide/house-plug';

/**
 * @see https://lucide.dev/icons/house-plug
 */
export const HousePlugIcon = (props: IconProps) => (
  <Icon icon={DefaultHousePlugIcon} {...props} />
);

import { default as DefaultHousePlusIcon } from '~icons/lucide/house-plus';

/**
 * @see https://lucide.dev/icons/house-plus
 */
export const HousePlusIcon = (props: IconProps) => (
  <Icon icon={DefaultHousePlusIcon} {...props} />
);

import { default as DefaultHouseWifiIcon } from '~icons/lucide/house-wifi';

/**
 * @see https://lucide.dev/icons/house-wifi
 */
export const HouseWifiIcon = (props: IconProps) => (
  <Icon icon={DefaultHouseWifiIcon} {...props} />
);

import { default as DefaultIceCreamBowlIcon } from '~icons/lucide/ice-cream-bowl';

/**
 * @see https://lucide.dev/icons/ice-cream-bowl
 */
export const IceCreamBowlIcon = (props: IconProps) => (
  <Icon icon={DefaultIceCreamBowlIcon} {...props} />
);

import { default as DefaultIceCreamConeIcon } from '~icons/lucide/ice-cream-cone';

/**
 * @see https://lucide.dev/icons/ice-cream-cone
 */
export const IceCreamConeIcon = (props: IconProps) => (
  <Icon icon={DefaultIceCreamConeIcon} {...props} />
);

import { default as DefaultIdCardIcon } from '~icons/lucide/id-card';

/**
 * @see https://lucide.dev/icons/id-card
 */
export const IdCardIcon = (props: IconProps) => (
  <Icon icon={DefaultIdCardIcon} {...props} />
);

import { default as DefaultIdCardLanyardIcon } from '~icons/lucide/id-card-lanyard';

/**
 * @see https://lucide.dev/icons/id-card-lanyard
 */
export const IdCardLanyardIcon = (props: IconProps) => (
  <Icon icon={DefaultIdCardLanyardIcon} {...props} />
);

import { default as DefaultImageIcon } from '~icons/lucide/image';

/**
 * @see https://lucide.dev/icons/image
 */
export const ImageIcon = (props: IconProps) => (
  <Icon icon={DefaultImageIcon} {...props} />
);

import { default as DefaultImageDownIcon } from '~icons/lucide/image-down';

/**
 * @see https://lucide.dev/icons/image-down
 */
export const ImageDownIcon = (props: IconProps) => (
  <Icon icon={DefaultImageDownIcon} {...props} />
);

import { default as DefaultImageMinusIcon } from '~icons/lucide/image-minus';

/**
 * @see https://lucide.dev/icons/image-minus
 */
export const ImageMinusIcon = (props: IconProps) => (
  <Icon icon={DefaultImageMinusIcon} {...props} />
);

import { default as DefaultImageOffIcon } from '~icons/lucide/image-off';

/**
 * @see https://lucide.dev/icons/image-off
 */
export const ImageOffIcon = (props: IconProps) => (
  <Icon icon={DefaultImageOffIcon} {...props} />
);

import { default as DefaultImagePlayIcon } from '~icons/lucide/image-play';

/**
 * @see https://lucide.dev/icons/image-play
 */
export const ImagePlayIcon = (props: IconProps) => (
  <Icon icon={DefaultImagePlayIcon} {...props} />
);

import { default as DefaultImagePlusIcon } from '~icons/lucide/image-plus';

/**
 * @see https://lucide.dev/icons/image-plus
 */
export const ImagePlusIcon = (props: IconProps) => (
  <Icon icon={DefaultImagePlusIcon} {...props} />
);

import { default as DefaultImageUpIcon } from '~icons/lucide/image-up';

/**
 * @see https://lucide.dev/icons/image-up
 */
export const ImageUpIcon = (props: IconProps) => (
  <Icon icon={DefaultImageUpIcon} {...props} />
);

import { default as DefaultImageUpscaleIcon } from '~icons/lucide/image-upscale';

/**
 * @see https://lucide.dev/icons/image-upscale
 */
export const ImageUpscaleIcon = (props: IconProps) => (
  <Icon icon={DefaultImageUpscaleIcon} {...props} />
);

import { default as DefaultImagesIcon } from '~icons/lucide/images';

/**
 * @see https://lucide.dev/icons/images
 */
export const ImagesIcon = (props: IconProps) => (
  <Icon icon={DefaultImagesIcon} {...props} />
);

import { default as DefaultImportIcon } from '~icons/lucide/import';

/**
 * @see https://lucide.dev/icons/import
 */
export const ImportIcon = (props: IconProps) => (
  <Icon icon={DefaultImportIcon} {...props} />
);

import { default as DefaultInboxIcon } from '~icons/lucide/inbox';

/**
 * @see https://lucide.dev/icons/inbox
 */
export const InboxIcon = (props: IconProps) => (
  <Icon icon={DefaultInboxIcon} {...props} />
);

import { default as DefaultIndentDecreaseIcon } from '~icons/lucide/indent-decrease';

/**
 * @see https://lucide.dev/icons/indent-decrease
 */
export const IndentDecreaseIcon = (props: IconProps) => (
  <Icon icon={DefaultIndentDecreaseIcon} {...props} />
);

import { default as DefaultIndentIncreaseIcon } from '~icons/lucide/indent-increase';

/**
 * @see https://lucide.dev/icons/indent-increase
 */
export const IndentIncreaseIcon = (props: IconProps) => (
  <Icon icon={DefaultIndentIncreaseIcon} {...props} />
);

import { default as DefaultIndianRupeeIcon } from '~icons/lucide/indian-rupee';

/**
 * @see https://lucide.dev/icons/indian-rupee
 */
export const IndianRupeeIcon = (props: IconProps) => (
  <Icon icon={DefaultIndianRupeeIcon} {...props} />
);

import { default as DefaultInfinityIcon } from '~icons/lucide/infinity';

/**
 * @see https://lucide.dev/icons/infinity
 */
export const InfinityIcon = (props: IconProps) => (
  <Icon icon={DefaultInfinityIcon} {...props} />
);

import { default as DefaultInfoIcon } from '~icons/lucide/info';

/**
 * @see https://lucide.dev/icons/info
 */
export const InfoIcon = (props: IconProps) => (
  <Icon icon={DefaultInfoIcon} {...props} />
);

import { default as DefaultInspectionPanelIcon } from '~icons/lucide/inspection-panel';

/**
 * @see https://lucide.dev/icons/inspection-panel
 */
export const InspectionPanelIcon = (props: IconProps) => (
  <Icon icon={DefaultInspectionPanelIcon} {...props} />
);

import { default as DefaultInstagramIcon } from '~icons/lucide/instagram';

/**
 * @see https://lucide.dev/icons/instagram
 */
export const InstagramIcon = (props: IconProps) => (
  <Icon icon={DefaultInstagramIcon} {...props} />
);

import { default as DefaultItalicIcon } from '~icons/lucide/italic';

/**
 * @see https://lucide.dev/icons/italic
 */
export const ItalicIcon = (props: IconProps) => (
  <Icon icon={DefaultItalicIcon} {...props} />
);

import { default as DefaultIterationCcwIcon } from '~icons/lucide/iteration-ccw';

/**
 * @see https://lucide.dev/icons/iteration-ccw
 */
export const IterationCcwIcon = (props: IconProps) => (
  <Icon icon={DefaultIterationCcwIcon} {...props} />
);

import { default as DefaultIterationCwIcon } from '~icons/lucide/iteration-cw';

/**
 * @see https://lucide.dev/icons/iteration-cw
 */
export const IterationCwIcon = (props: IconProps) => (
  <Icon icon={DefaultIterationCwIcon} {...props} />
);

import { default as DefaultJapaneseYenIcon } from '~icons/lucide/japanese-yen';

/**
 * @see https://lucide.dev/icons/japanese-yen
 */
export const JapaneseYenIcon = (props: IconProps) => (
  <Icon icon={DefaultJapaneseYenIcon} {...props} />
);

import { default as DefaultJoystickIcon } from '~icons/lucide/joystick';

/**
 * @see https://lucide.dev/icons/joystick
 */
export const JoystickIcon = (props: IconProps) => (
  <Icon icon={DefaultJoystickIcon} {...props} />
);

import { default as DefaultKanbanIcon } from '~icons/lucide/kanban';

/**
 * @see https://lucide.dev/icons/kanban
 */
export const KanbanIcon = (props: IconProps) => (
  <Icon icon={DefaultKanbanIcon} {...props} />
);

import { default as DefaultKeyIcon } from '~icons/lucide/key';

/**
 * @see https://lucide.dev/icons/key
 */
export const KeyIcon = (props: IconProps) => (
  <Icon icon={DefaultKeyIcon} {...props} />
);

import { default as DefaultKeyRoundIcon } from '~icons/lucide/key-round';

/**
 * @see https://lucide.dev/icons/key-round
 */
export const KeyRoundIcon = (props: IconProps) => (
  <Icon icon={DefaultKeyRoundIcon} {...props} />
);

import { default as DefaultKeySquareIcon } from '~icons/lucide/key-square';

/**
 * @see https://lucide.dev/icons/key-square
 */
export const KeySquareIcon = (props: IconProps) => (
  <Icon icon={DefaultKeySquareIcon} {...props} />
);

import { default as DefaultKeyboardIcon } from '~icons/lucide/keyboard';

/**
 * @see https://lucide.dev/icons/keyboard
 */
export const KeyboardIcon = (props: IconProps) => (
  <Icon icon={DefaultKeyboardIcon} {...props} />
);

import { default as DefaultKeyboardMusicIcon } from '~icons/lucide/keyboard-music';

/**
 * @see https://lucide.dev/icons/keyboard-music
 */
export const KeyboardMusicIcon = (props: IconProps) => (
  <Icon icon={DefaultKeyboardMusicIcon} {...props} />
);

import { default as DefaultKeyboardOffIcon } from '~icons/lucide/keyboard-off';

/**
 * @see https://lucide.dev/icons/keyboard-off
 */
export const KeyboardOffIcon = (props: IconProps) => (
  <Icon icon={DefaultKeyboardOffIcon} {...props} />
);

import { default as DefaultLampIcon } from '~icons/lucide/lamp';

/**
 * @see https://lucide.dev/icons/lamp
 */
export const LampIcon = (props: IconProps) => (
  <Icon icon={DefaultLampIcon} {...props} />
);

import { default as DefaultLampCeilingIcon } from '~icons/lucide/lamp-ceiling';

/**
 * @see https://lucide.dev/icons/lamp-ceiling
 */
export const LampCeilingIcon = (props: IconProps) => (
  <Icon icon={DefaultLampCeilingIcon} {...props} />
);

import { default as DefaultLampDeskIcon } from '~icons/lucide/lamp-desk';

/**
 * @see https://lucide.dev/icons/lamp-desk
 */
export const LampDeskIcon = (props: IconProps) => (
  <Icon icon={DefaultLampDeskIcon} {...props} />
);

import { default as DefaultLampFloorIcon } from '~icons/lucide/lamp-floor';

/**
 * @see https://lucide.dev/icons/lamp-floor
 */
export const LampFloorIcon = (props: IconProps) => (
  <Icon icon={DefaultLampFloorIcon} {...props} />
);

import { default as DefaultLampWallDownIcon } from '~icons/lucide/lamp-wall-down';

/**
 * @see https://lucide.dev/icons/lamp-wall-down
 */
export const LampWallDownIcon = (props: IconProps) => (
  <Icon icon={DefaultLampWallDownIcon} {...props} />
);

import { default as DefaultLampWallUpIcon } from '~icons/lucide/lamp-wall-up';

/**
 * @see https://lucide.dev/icons/lamp-wall-up
 */
export const LampWallUpIcon = (props: IconProps) => (
  <Icon icon={DefaultLampWallUpIcon} {...props} />
);

import { default as DefaultLandPlotIcon } from '~icons/lucide/land-plot';

/**
 * @see https://lucide.dev/icons/land-plot
 */
export const LandPlotIcon = (props: IconProps) => (
  <Icon icon={DefaultLandPlotIcon} {...props} />
);

import { default as DefaultLandmarkIcon } from '~icons/lucide/landmark';

/**
 * @see https://lucide.dev/icons/landmark
 */
export const LandmarkIcon = (props: IconProps) => (
  <Icon icon={DefaultLandmarkIcon} {...props} />
);

import { default as DefaultLanguagesIcon } from '~icons/lucide/languages';

/**
 * @see https://lucide.dev/icons/languages
 */
export const LanguagesIcon = (props: IconProps) => (
  <Icon icon={DefaultLanguagesIcon} {...props} />
);

import { default as DefaultLaptopIcon } from '~icons/lucide/laptop';

/**
 * @see https://lucide.dev/icons/laptop
 */
export const LaptopIcon = (props: IconProps) => (
  <Icon icon={DefaultLaptopIcon} {...props} />
);

import { default as DefaultLaptopMinimalIcon } from '~icons/lucide/laptop-minimal';

/**
 * @see https://lucide.dev/icons/laptop-minimal
 */
export const LaptopMinimalIcon = (props: IconProps) => (
  <Icon icon={DefaultLaptopMinimalIcon} {...props} />
);

import { default as DefaultLaptopMinimalCheckIcon } from '~icons/lucide/laptop-minimal-check';

/**
 * @see https://lucide.dev/icons/laptop-minimal-check
 */
export const LaptopMinimalCheckIcon = (props: IconProps) => (
  <Icon icon={DefaultLaptopMinimalCheckIcon} {...props} />
);

import { default as DefaultLassoIcon } from '~icons/lucide/lasso';

/**
 * @see https://lucide.dev/icons/lasso
 */
export const LassoIcon = (props: IconProps) => (
  <Icon icon={DefaultLassoIcon} {...props} />
);

import { default as DefaultLassoSelectIcon } from '~icons/lucide/lasso-select';

/**
 * @see https://lucide.dev/icons/lasso-select
 */
export const LassoSelectIcon = (props: IconProps) => (
  <Icon icon={DefaultLassoSelectIcon} {...props} />
);

import { default as DefaultLaughIcon } from '~icons/lucide/laugh';

/**
 * @see https://lucide.dev/icons/laugh
 */
export const LaughIcon = (props: IconProps) => (
  <Icon icon={DefaultLaughIcon} {...props} />
);

import { default as DefaultLayersIcon } from '~icons/lucide/layers';

/**
 * @see https://lucide.dev/icons/layers
 */
export const LayersIcon = (props: IconProps) => (
  <Icon icon={DefaultLayersIcon} {...props} />
);

import { default as DefaultLayers2Icon } from '~icons/lucide/layers-2';

/**
 * @see https://lucide.dev/icons/layers-2
 */
export const Layers2Icon = (props: IconProps) => (
  <Icon icon={DefaultLayers2Icon} {...props} />
);

import { default as DefaultLayers3Icon } from '~icons/lucide/layers-3';

/**
 * @see https://lucide.dev/icons/layers-3
 */
export const Layers3Icon = (props: IconProps) => (
  <Icon icon={DefaultLayers3Icon} {...props} />
);

import { default as DefaultLayoutDashboardIcon } from '~icons/lucide/layout-dashboard';

/**
 * @see https://lucide.dev/icons/layout-dashboard
 */
export const LayoutDashboardIcon = (props: IconProps) => (
  <Icon icon={DefaultLayoutDashboardIcon} {...props} />
);

import { default as DefaultLayoutGridIcon } from '~icons/lucide/layout-grid';

/**
 * @see https://lucide.dev/icons/layout-grid
 */
export const LayoutGridIcon = (props: IconProps) => (
  <Icon icon={DefaultLayoutGridIcon} {...props} />
);

import { default as DefaultLayoutListIcon } from '~icons/lucide/layout-list';

/**
 * @see https://lucide.dev/icons/layout-list
 */
export const LayoutListIcon = (props: IconProps) => (
  <Icon icon={DefaultLayoutListIcon} {...props} />
);

import { default as DefaultLayoutPanelLeftIcon } from '~icons/lucide/layout-panel-left';

/**
 * @see https://lucide.dev/icons/layout-panel-left
 */
export const LayoutPanelLeftIcon = (props: IconProps) => (
  <Icon icon={DefaultLayoutPanelLeftIcon} {...props} />
);

import { default as DefaultLayoutPanelTopIcon } from '~icons/lucide/layout-panel-top';

/**
 * @see https://lucide.dev/icons/layout-panel-top
 */
export const LayoutPanelTopIcon = (props: IconProps) => (
  <Icon icon={DefaultLayoutPanelTopIcon} {...props} />
);

import { default as DefaultLayoutTemplateIcon } from '~icons/lucide/layout-template';

/**
 * @see https://lucide.dev/icons/layout-template
 */
export const LayoutTemplateIcon = (props: IconProps) => (
  <Icon icon={DefaultLayoutTemplateIcon} {...props} />
);

import { default as DefaultLeafIcon } from '~icons/lucide/leaf';

/**
 * @see https://lucide.dev/icons/leaf
 */
export const LeafIcon = (props: IconProps) => (
  <Icon icon={DefaultLeafIcon} {...props} />
);

import { default as DefaultLeafyGreenIcon } from '~icons/lucide/leafy-green';

/**
 * @see https://lucide.dev/icons/leafy-green
 */
export const LeafyGreenIcon = (props: IconProps) => (
  <Icon icon={DefaultLeafyGreenIcon} {...props} />
);

import { default as DefaultLecternIcon } from '~icons/lucide/lectern';

/**
 * @see https://lucide.dev/icons/lectern
 */
export const LecternIcon = (props: IconProps) => (
  <Icon icon={DefaultLecternIcon} {...props} />
);

import { default as DefaultLetterTextIcon } from '~icons/lucide/letter-text';

/**
 * @see https://lucide.dev/icons/letter-text
 */
export const LetterTextIcon = (props: IconProps) => (
  <Icon icon={DefaultLetterTextIcon} {...props} />
);

import { default as DefaultLibraryIcon } from '~icons/lucide/library';

/**
 * @see https://lucide.dev/icons/library
 */
export const LibraryIcon = (props: IconProps) => (
  <Icon icon={DefaultLibraryIcon} {...props} />
);

import { default as DefaultLibraryBigIcon } from '~icons/lucide/library-big';

/**
 * @see https://lucide.dev/icons/library-big
 */
export const LibraryBigIcon = (props: IconProps) => (
  <Icon icon={DefaultLibraryBigIcon} {...props} />
);

import { default as DefaultLifeBuoyIcon } from '~icons/lucide/life-buoy';

/**
 * @see https://lucide.dev/icons/life-buoy
 */
export const LifeBuoyIcon = (props: IconProps) => (
  <Icon icon={DefaultLifeBuoyIcon} {...props} />
);

import { default as DefaultLigatureIcon } from '~icons/lucide/ligature';

/**
 * @see https://lucide.dev/icons/ligature
 */
export const LigatureIcon = (props: IconProps) => (
  <Icon icon={DefaultLigatureIcon} {...props} />
);

import { default as DefaultLightbulbIcon } from '~icons/lucide/lightbulb';

/**
 * @see https://lucide.dev/icons/lightbulb
 */
export const LightbulbIcon = (props: IconProps) => (
  <Icon icon={DefaultLightbulbIcon} {...props} />
);

import { default as DefaultLightbulbOffIcon } from '~icons/lucide/lightbulb-off';

/**
 * @see https://lucide.dev/icons/lightbulb-off
 */
export const LightbulbOffIcon = (props: IconProps) => (
  <Icon icon={DefaultLightbulbOffIcon} {...props} />
);

import { default as DefaultLineChartIcon } from '~icons/lucide/line-chart';

/**
 * @see https://lucide.dev/icons/line-chart
 */
export const LineChartIcon = (props: IconProps) => (
  <Icon icon={DefaultLineChartIcon} {...props} />
);

import { default as DefaultLineSquiggleIcon } from '~icons/lucide/line-squiggle';

/**
 * @see https://lucide.dev/icons/line-squiggle
 */
export const LineSquiggleIcon = (props: IconProps) => (
  <Icon icon={DefaultLineSquiggleIcon} {...props} />
);

import { default as DefaultLinkIcon } from '~icons/lucide/link';

/**
 * @see https://lucide.dev/icons/link
 */
export const LinkIcon = (props: IconProps) => (
  <Icon icon={DefaultLinkIcon} {...props} />
);

import { default as DefaultLink2Icon } from '~icons/lucide/link-2';

/**
 * @see https://lucide.dev/icons/link-2
 */
export const Link2Icon = (props: IconProps) => (
  <Icon icon={DefaultLink2Icon} {...props} />
);

import { default as DefaultLink2OffIcon } from '~icons/lucide/link-2-off';

/**
 * @see https://lucide.dev/icons/link-2-off
 */
export const Link2OffIcon = (props: IconProps) => (
  <Icon icon={DefaultLink2OffIcon} {...props} />
);

import { default as DefaultLinkedinIcon } from '~icons/lucide/linkedin';

/**
 * @see https://lucide.dev/icons/linkedin
 */
export const LinkedinIcon = (props: IconProps) => (
  <Icon icon={DefaultLinkedinIcon} {...props} />
);

import { default as DefaultListIcon } from '~icons/lucide/list';

/**
 * @see https://lucide.dev/icons/list
 */
export const ListIcon = (props: IconProps) => (
  <Icon icon={DefaultListIcon} {...props} />
);

import { default as DefaultListCheckIcon } from '~icons/lucide/list-check';

/**
 * @see https://lucide.dev/icons/list-check
 */
export const ListCheckIcon = (props: IconProps) => (
  <Icon icon={DefaultListCheckIcon} {...props} />
);

import { default as DefaultListChecksIcon } from '~icons/lucide/list-checks';

/**
 * @see https://lucide.dev/icons/list-checks
 */
export const ListChecksIcon = (props: IconProps) => (
  <Icon icon={DefaultListChecksIcon} {...props} />
);

import { default as DefaultListCollapseIcon } from '~icons/lucide/list-collapse';

/**
 * @see https://lucide.dev/icons/list-collapse
 */
export const ListCollapseIcon = (props: IconProps) => (
  <Icon icon={DefaultListCollapseIcon} {...props} />
);

import { default as DefaultListEndIcon } from '~icons/lucide/list-end';

/**
 * @see https://lucide.dev/icons/list-end
 */
export const ListEndIcon = (props: IconProps) => (
  <Icon icon={DefaultListEndIcon} {...props} />
);

import { default as DefaultListFilterIcon } from '~icons/lucide/list-filter';

/**
 * @see https://lucide.dev/icons/list-filter
 */
export const ListFilterIcon = (props: IconProps) => (
  <Icon icon={DefaultListFilterIcon} {...props} />
);

import { default as DefaultListFilterPlusIcon } from '~icons/lucide/list-filter-plus';

/**
 * @see https://lucide.dev/icons/list-filter-plus
 */
export const ListFilterPlusIcon = (props: IconProps) => (
  <Icon icon={DefaultListFilterPlusIcon} {...props} />
);

import { default as DefaultListMinusIcon } from '~icons/lucide/list-minus';

/**
 * @see https://lucide.dev/icons/list-minus
 */
export const ListMinusIcon = (props: IconProps) => (
  <Icon icon={DefaultListMinusIcon} {...props} />
);

import { default as DefaultListMusicIcon } from '~icons/lucide/list-music';

/**
 * @see https://lucide.dev/icons/list-music
 */
export const ListMusicIcon = (props: IconProps) => (
  <Icon icon={DefaultListMusicIcon} {...props} />
);

import { default as DefaultListOrderedIcon } from '~icons/lucide/list-ordered';

/**
 * @see https://lucide.dev/icons/list-ordered
 */
export const ListOrderedIcon = (props: IconProps) => (
  <Icon icon={DefaultListOrderedIcon} {...props} />
);

import { default as DefaultListPlusIcon } from '~icons/lucide/list-plus';

/**
 * @see https://lucide.dev/icons/list-plus
 */
export const ListPlusIcon = (props: IconProps) => (
  <Icon icon={DefaultListPlusIcon} {...props} />
);

import { default as DefaultListRestartIcon } from '~icons/lucide/list-restart';

/**
 * @see https://lucide.dev/icons/list-restart
 */
export const ListRestartIcon = (props: IconProps) => (
  <Icon icon={DefaultListRestartIcon} {...props} />
);

import { default as DefaultListStartIcon } from '~icons/lucide/list-start';

/**
 * @see https://lucide.dev/icons/list-start
 */
export const ListStartIcon = (props: IconProps) => (
  <Icon icon={DefaultListStartIcon} {...props} />
);

import { default as DefaultListTodoIcon } from '~icons/lucide/list-todo';

/**
 * @see https://lucide.dev/icons/list-todo
 */
export const ListTodoIcon = (props: IconProps) => (
  <Icon icon={DefaultListTodoIcon} {...props} />
);

import { default as DefaultListTreeIcon } from '~icons/lucide/list-tree';

/**
 * @see https://lucide.dev/icons/list-tree
 */
export const ListTreeIcon = (props: IconProps) => (
  <Icon icon={DefaultListTreeIcon} {...props} />
);

import { default as DefaultListVideoIcon } from '~icons/lucide/list-video';

/**
 * @see https://lucide.dev/icons/list-video
 */
export const ListVideoIcon = (props: IconProps) => (
  <Icon icon={DefaultListVideoIcon} {...props} />
);

import { default as DefaultListXIcon } from '~icons/lucide/list-x';

/**
 * @see https://lucide.dev/icons/list-x
 */
export const ListXIcon = (props: IconProps) => (
  <Icon icon={DefaultListXIcon} {...props} />
);

import { default as DefaultLoaderIcon } from '~icons/lucide/loader';

/**
 * @see https://lucide.dev/icons/loader
 */
export const LoaderIcon = (props: IconProps) => (
  <Icon icon={DefaultLoaderIcon} {...props} />
);

import { default as DefaultLoaderCircleIcon } from '~icons/lucide/loader-circle';

/**
 * @see https://lucide.dev/icons/loader-circle
 */
export const LoaderCircleIcon = (props: IconProps) => (
  <Icon icon={DefaultLoaderCircleIcon} {...props} />
);

import { default as DefaultLoaderPinwheelIcon } from '~icons/lucide/loader-pinwheel';

/**
 * @see https://lucide.dev/icons/loader-pinwheel
 */
export const LoaderPinwheelIcon = (props: IconProps) => (
  <Icon icon={DefaultLoaderPinwheelIcon} {...props} />
);

import { default as DefaultLocateIcon } from '~icons/lucide/locate';

/**
 * @see https://lucide.dev/icons/locate
 */
export const LocateIcon = (props: IconProps) => (
  <Icon icon={DefaultLocateIcon} {...props} />
);

import { default as DefaultLocateFixedIcon } from '~icons/lucide/locate-fixed';

/**
 * @see https://lucide.dev/icons/locate-fixed
 */
export const LocateFixedIcon = (props: IconProps) => (
  <Icon icon={DefaultLocateFixedIcon} {...props} />
);

import { default as DefaultLocateOffIcon } from '~icons/lucide/locate-off';

/**
 * @see https://lucide.dev/icons/locate-off
 */
export const LocateOffIcon = (props: IconProps) => (
  <Icon icon={DefaultLocateOffIcon} {...props} />
);

import { default as DefaultLocationEditIcon } from '~icons/lucide/location-edit';

/**
 * @see https://lucide.dev/icons/location-edit
 */
export const LocationEditIcon = (props: IconProps) => (
  <Icon icon={DefaultLocationEditIcon} {...props} />
);

import { default as DefaultLockIcon } from '~icons/lucide/lock';

/**
 * @see https://lucide.dev/icons/lock
 */
export const LockIcon = (props: IconProps) => (
  <Icon icon={DefaultLockIcon} {...props} />
);

import { default as DefaultLockKeyholeIcon } from '~icons/lucide/lock-keyhole';

/**
 * @see https://lucide.dev/icons/lock-keyhole
 */
export const LockKeyholeIcon = (props: IconProps) => (
  <Icon icon={DefaultLockKeyholeIcon} {...props} />
);

import { default as DefaultLockKeyholeOpenIcon } from '~icons/lucide/lock-keyhole-open';

/**
 * @see https://lucide.dev/icons/lock-keyhole-open
 */
export const LockKeyholeOpenIcon = (props: IconProps) => (
  <Icon icon={DefaultLockKeyholeOpenIcon} {...props} />
);

import { default as DefaultLockOpenIcon } from '~icons/lucide/lock-open';

/**
 * @see https://lucide.dev/icons/lock-open
 */
export const LockOpenIcon = (props: IconProps) => (
  <Icon icon={DefaultLockOpenIcon} {...props} />
);

import { default as DefaultLogInIcon } from '~icons/lucide/log-in';

/**
 * @see https://lucide.dev/icons/log-in
 */
export const LogInIcon = (props: IconProps) => (
  <Icon icon={DefaultLogInIcon} {...props} />
);

import { default as DefaultLogOutIcon } from '~icons/lucide/log-out';

/**
 * @see https://lucide.dev/icons/log-out
 */
export const LogOutIcon = (props: IconProps) => (
  <Icon icon={DefaultLogOutIcon} {...props} />
);

import { default as DefaultLogsIcon } from '~icons/lucide/logs';

/**
 * @see https://lucide.dev/icons/logs
 */
export const LogsIcon = (props: IconProps) => (
  <Icon icon={DefaultLogsIcon} {...props} />
);

import { default as DefaultLollipopIcon } from '~icons/lucide/lollipop';

/**
 * @see https://lucide.dev/icons/lollipop
 */
export const LollipopIcon = (props: IconProps) => (
  <Icon icon={DefaultLollipopIcon} {...props} />
);

import { default as DefaultLuggageIcon } from '~icons/lucide/luggage';

/**
 * @see https://lucide.dev/icons/luggage
 */
export const LuggageIcon = (props: IconProps) => (
  <Icon icon={DefaultLuggageIcon} {...props} />
);

import { default as DefaultMagnetIcon } from '~icons/lucide/magnet';

/**
 * @see https://lucide.dev/icons/magnet
 */
export const MagnetIcon = (props: IconProps) => (
  <Icon icon={DefaultMagnetIcon} {...props} />
);

import { default as DefaultMailIcon } from '~icons/lucide/mail';

/**
 * @see https://lucide.dev/icons/mail
 */
export const MailIcon = (props: IconProps) => (
  <Icon icon={DefaultMailIcon} {...props} />
);

import { default as DefaultMailCheckIcon } from '~icons/lucide/mail-check';

/**
 * @see https://lucide.dev/icons/mail-check
 */
export const MailCheckIcon = (props: IconProps) => (
  <Icon icon={DefaultMailCheckIcon} {...props} />
);

import { default as DefaultMailMinusIcon } from '~icons/lucide/mail-minus';

/**
 * @see https://lucide.dev/icons/mail-minus
 */
export const MailMinusIcon = (props: IconProps) => (
  <Icon icon={DefaultMailMinusIcon} {...props} />
);

import { default as DefaultMailOpenIcon } from '~icons/lucide/mail-open';

/**
 * @see https://lucide.dev/icons/mail-open
 */
export const MailOpenIcon = (props: IconProps) => (
  <Icon icon={DefaultMailOpenIcon} {...props} />
);

import { default as DefaultMailPlusIcon } from '~icons/lucide/mail-plus';

/**
 * @see https://lucide.dev/icons/mail-plus
 */
export const MailPlusIcon = (props: IconProps) => (
  <Icon icon={DefaultMailPlusIcon} {...props} />
);

import { default as DefaultMailQuestionMarkIcon } from '~icons/lucide/mail-question-mark';

/**
 * @see https://lucide.dev/icons/mail-question-mark
 */
export const MailQuestionMarkIcon = (props: IconProps) => (
  <Icon icon={DefaultMailQuestionMarkIcon} {...props} />
);

import { default as DefaultMailSearchIcon } from '~icons/lucide/mail-search';

/**
 * @see https://lucide.dev/icons/mail-search
 */
export const MailSearchIcon = (props: IconProps) => (
  <Icon icon={DefaultMailSearchIcon} {...props} />
);

import { default as DefaultMailWarningIcon } from '~icons/lucide/mail-warning';

/**
 * @see https://lucide.dev/icons/mail-warning
 */
export const MailWarningIcon = (props: IconProps) => (
  <Icon icon={DefaultMailWarningIcon} {...props} />
);

import { default as DefaultMailXIcon } from '~icons/lucide/mail-x';

/**
 * @see https://lucide.dev/icons/mail-x
 */
export const MailXIcon = (props: IconProps) => (
  <Icon icon={DefaultMailXIcon} {...props} />
);

import { default as DefaultMailboxIcon } from '~icons/lucide/mailbox';

/**
 * @see https://lucide.dev/icons/mailbox
 */
export const MailboxIcon = (props: IconProps) => (
  <Icon icon={DefaultMailboxIcon} {...props} />
);

import { default as DefaultMailsIcon } from '~icons/lucide/mails';

/**
 * @see https://lucide.dev/icons/mails
 */
export const MailsIcon = (props: IconProps) => (
  <Icon icon={DefaultMailsIcon} {...props} />
);

import { default as DefaultMapIcon } from '~icons/lucide/map';

/**
 * @see https://lucide.dev/icons/map
 */
export const MapIcon = (props: IconProps) => (
  <Icon icon={DefaultMapIcon} {...props} />
);

import { default as DefaultMapPinIcon } from '~icons/lucide/map-pin';

/**
 * @see https://lucide.dev/icons/map-pin
 */
export const MapPinIcon = (props: IconProps) => (
  <Icon icon={DefaultMapPinIcon} {...props} />
);

import { default as DefaultMapPinCheckIcon } from '~icons/lucide/map-pin-check';

/**
 * @see https://lucide.dev/icons/map-pin-check
 */
export const MapPinCheckIcon = (props: IconProps) => (
  <Icon icon={DefaultMapPinCheckIcon} {...props} />
);

import { default as DefaultMapPinCheckInsideIcon } from '~icons/lucide/map-pin-check-inside';

/**
 * @see https://lucide.dev/icons/map-pin-check-inside
 */
export const MapPinCheckInsideIcon = (props: IconProps) => (
  <Icon icon={DefaultMapPinCheckInsideIcon} {...props} />
);

import { default as DefaultMapPinHouseIcon } from '~icons/lucide/map-pin-house';

/**
 * @see https://lucide.dev/icons/map-pin-house
 */
export const MapPinHouseIcon = (props: IconProps) => (
  <Icon icon={DefaultMapPinHouseIcon} {...props} />
);

import { default as DefaultMapPinMinusIcon } from '~icons/lucide/map-pin-minus';

/**
 * @see https://lucide.dev/icons/map-pin-minus
 */
export const MapPinMinusIcon = (props: IconProps) => (
  <Icon icon={DefaultMapPinMinusIcon} {...props} />
);

import { default as DefaultMapPinMinusInsideIcon } from '~icons/lucide/map-pin-minus-inside';

/**
 * @see https://lucide.dev/icons/map-pin-minus-inside
 */
export const MapPinMinusInsideIcon = (props: IconProps) => (
  <Icon icon={DefaultMapPinMinusInsideIcon} {...props} />
);

import { default as DefaultMapPinOffIcon } from '~icons/lucide/map-pin-off';

/**
 * @see https://lucide.dev/icons/map-pin-off
 */
export const MapPinOffIcon = (props: IconProps) => (
  <Icon icon={DefaultMapPinOffIcon} {...props} />
);

import { default as DefaultMapPinPlusIcon } from '~icons/lucide/map-pin-plus';

/**
 * @see https://lucide.dev/icons/map-pin-plus
 */
export const MapPinPlusIcon = (props: IconProps) => (
  <Icon icon={DefaultMapPinPlusIcon} {...props} />
);

import { default as DefaultMapPinPlusInsideIcon } from '~icons/lucide/map-pin-plus-inside';

/**
 * @see https://lucide.dev/icons/map-pin-plus-inside
 */
export const MapPinPlusInsideIcon = (props: IconProps) => (
  <Icon icon={DefaultMapPinPlusInsideIcon} {...props} />
);

import { default as DefaultMapPinXIcon } from '~icons/lucide/map-pin-x';

/**
 * @see https://lucide.dev/icons/map-pin-x
 */
export const MapPinXIcon = (props: IconProps) => (
  <Icon icon={DefaultMapPinXIcon} {...props} />
);

import { default as DefaultMapPinXInsideIcon } from '~icons/lucide/map-pin-x-inside';

/**
 * @see https://lucide.dev/icons/map-pin-x-inside
 */
export const MapPinXInsideIcon = (props: IconProps) => (
  <Icon icon={DefaultMapPinXInsideIcon} {...props} />
);

import { default as DefaultMapPinnedIcon } from '~icons/lucide/map-pinned';

/**
 * @see https://lucide.dev/icons/map-pinned
 */
export const MapPinnedIcon = (props: IconProps) => (
  <Icon icon={DefaultMapPinnedIcon} {...props} />
);

import { default as DefaultMapPlusIcon } from '~icons/lucide/map-plus';

/**
 * @see https://lucide.dev/icons/map-plus
 */
export const MapPlusIcon = (props: IconProps) => (
  <Icon icon={DefaultMapPlusIcon} {...props} />
);

import { default as DefaultMarsIcon } from '~icons/lucide/mars';

/**
 * @see https://lucide.dev/icons/mars
 */
export const MarsIcon = (props: IconProps) => (
  <Icon icon={DefaultMarsIcon} {...props} />
);

import { default as DefaultMarsStrokeIcon } from '~icons/lucide/mars-stroke';

/**
 * @see https://lucide.dev/icons/mars-stroke
 */
export const MarsStrokeIcon = (props: IconProps) => (
  <Icon icon={DefaultMarsStrokeIcon} {...props} />
);

import { default as DefaultMartiniIcon } from '~icons/lucide/martini';

/**
 * @see https://lucide.dev/icons/martini
 */
export const MartiniIcon = (props: IconProps) => (
  <Icon icon={DefaultMartiniIcon} {...props} />
);

import { default as DefaultMaximizeIcon } from '~icons/lucide/maximize';

/**
 * @see https://lucide.dev/icons/maximize
 */
export const MaximizeIcon = (props: IconProps) => (
  <Icon icon={DefaultMaximizeIcon} {...props} />
);

import { default as DefaultMaximize2Icon } from '~icons/lucide/maximize-2';

/**
 * @see https://lucide.dev/icons/maximize-2
 */
export const Maximize2Icon = (props: IconProps) => (
  <Icon icon={DefaultMaximize2Icon} {...props} />
);

import { default as DefaultMedalIcon } from '~icons/lucide/medal';

/**
 * @see https://lucide.dev/icons/medal
 */
export const MedalIcon = (props: IconProps) => (
  <Icon icon={DefaultMedalIcon} {...props} />
);

import { default as DefaultMegaphoneIcon } from '~icons/lucide/megaphone';

/**
 * @see https://lucide.dev/icons/megaphone
 */
export const MegaphoneIcon = (props: IconProps) => (
  <Icon icon={DefaultMegaphoneIcon} {...props} />
);

import { default as DefaultMegaphoneOffIcon } from '~icons/lucide/megaphone-off';

/**
 * @see https://lucide.dev/icons/megaphone-off
 */
export const MegaphoneOffIcon = (props: IconProps) => (
  <Icon icon={DefaultMegaphoneOffIcon} {...props} />
);

import { default as DefaultMehIcon } from '~icons/lucide/meh';

/**
 * @see https://lucide.dev/icons/meh
 */
export const MehIcon = (props: IconProps) => (
  <Icon icon={DefaultMehIcon} {...props} />
);

import { default as DefaultMemoryStickIcon } from '~icons/lucide/memory-stick';

/**
 * @see https://lucide.dev/icons/memory-stick
 */
export const MemoryStickIcon = (props: IconProps) => (
  <Icon icon={DefaultMemoryStickIcon} {...props} />
);

import { default as DefaultMenuIcon } from '~icons/lucide/menu';

/**
 * @see https://lucide.dev/icons/menu
 */
export const MenuIcon = (props: IconProps) => (
  <Icon icon={DefaultMenuIcon} {...props} />
);

import { default as DefaultMergeIcon } from '~icons/lucide/merge';

/**
 * @see https://lucide.dev/icons/merge
 */
export const MergeIcon = (props: IconProps) => (
  <Icon icon={DefaultMergeIcon} {...props} />
);

import { default as DefaultMessageCircleIcon } from '~icons/lucide/message-circle';

/**
 * @see https://lucide.dev/icons/message-circle
 */
export const MessageCircleIcon = (props: IconProps) => (
  <Icon icon={DefaultMessageCircleIcon} {...props} />
);

import { default as DefaultMessageCircleCodeIcon } from '~icons/lucide/message-circle-code';

/**
 * @see https://lucide.dev/icons/message-circle-code
 */
export const MessageCircleCodeIcon = (props: IconProps) => (
  <Icon icon={DefaultMessageCircleCodeIcon} {...props} />
);

import { default as DefaultMessageCircleDashedIcon } from '~icons/lucide/message-circle-dashed';

/**
 * @see https://lucide.dev/icons/message-circle-dashed
 */
export const MessageCircleDashedIcon = (props: IconProps) => (
  <Icon icon={DefaultMessageCircleDashedIcon} {...props} />
);

import { default as DefaultMessageCircleHeartIcon } from '~icons/lucide/message-circle-heart';

/**
 * @see https://lucide.dev/icons/message-circle-heart
 */
export const MessageCircleHeartIcon = (props: IconProps) => (
  <Icon icon={DefaultMessageCircleHeartIcon} {...props} />
);

import { default as DefaultMessageCircleMoreIcon } from '~icons/lucide/message-circle-more';

/**
 * @see https://lucide.dev/icons/message-circle-more
 */
export const MessageCircleMoreIcon = (props: IconProps) => (
  <Icon icon={DefaultMessageCircleMoreIcon} {...props} />
);

import { default as DefaultMessageCircleOffIcon } from '~icons/lucide/message-circle-off';

/**
 * @see https://lucide.dev/icons/message-circle-off
 */
export const MessageCircleOffIcon = (props: IconProps) => (
  <Icon icon={DefaultMessageCircleOffIcon} {...props} />
);

import { default as DefaultMessageCirclePlusIcon } from '~icons/lucide/message-circle-plus';

/**
 * @see https://lucide.dev/icons/message-circle-plus
 */
export const MessageCirclePlusIcon = (props: IconProps) => (
  <Icon icon={DefaultMessageCirclePlusIcon} {...props} />
);

import { default as DefaultMessageCircleQuestionMarkIcon } from '~icons/lucide/message-circle-question-mark';

/**
 * @see https://lucide.dev/icons/message-circle-question-mark
 */
export const MessageCircleQuestionMarkIcon = (props: IconProps) => (
  <Icon icon={DefaultMessageCircleQuestionMarkIcon} {...props} />
);

import { default as DefaultMessageCircleReplyIcon } from '~icons/lucide/message-circle-reply';

/**
 * @see https://lucide.dev/icons/message-circle-reply
 */
export const MessageCircleReplyIcon = (props: IconProps) => (
  <Icon icon={DefaultMessageCircleReplyIcon} {...props} />
);

import { default as DefaultMessageCircleWarningIcon } from '~icons/lucide/message-circle-warning';

/**
 * @see https://lucide.dev/icons/message-circle-warning
 */
export const MessageCircleWarningIcon = (props: IconProps) => (
  <Icon icon={DefaultMessageCircleWarningIcon} {...props} />
);

import { default as DefaultMessageCircleXIcon } from '~icons/lucide/message-circle-x';

/**
 * @see https://lucide.dev/icons/message-circle-x
 */
export const MessageCircleXIcon = (props: IconProps) => (
  <Icon icon={DefaultMessageCircleXIcon} {...props} />
);

import { default as DefaultMessageSquareIcon } from '~icons/lucide/message-square';

/**
 * @see https://lucide.dev/icons/message-square
 */
export const MessageSquareIcon = (props: IconProps) => (
  <Icon icon={DefaultMessageSquareIcon} {...props} />
);

import { default as DefaultMessageSquareCodeIcon } from '~icons/lucide/message-square-code';

/**
 * @see https://lucide.dev/icons/message-square-code
 */
export const MessageSquareCodeIcon = (props: IconProps) => (
  <Icon icon={DefaultMessageSquareCodeIcon} {...props} />
);

import { default as DefaultMessageSquareDashedIcon } from '~icons/lucide/message-square-dashed';

/**
 * @see https://lucide.dev/icons/message-square-dashed
 */
export const MessageSquareDashedIcon = (props: IconProps) => (
  <Icon icon={DefaultMessageSquareDashedIcon} {...props} />
);

import { default as DefaultMessageSquareDiffIcon } from '~icons/lucide/message-square-diff';

/**
 * @see https://lucide.dev/icons/message-square-diff
 */
export const MessageSquareDiffIcon = (props: IconProps) => (
  <Icon icon={DefaultMessageSquareDiffIcon} {...props} />
);

import { default as DefaultMessageSquareDotIcon } from '~icons/lucide/message-square-dot';

/**
 * @see https://lucide.dev/icons/message-square-dot
 */
export const MessageSquareDotIcon = (props: IconProps) => (
  <Icon icon={DefaultMessageSquareDotIcon} {...props} />
);

import { default as DefaultMessageSquareHeartIcon } from '~icons/lucide/message-square-heart';

/**
 * @see https://lucide.dev/icons/message-square-heart
 */
export const MessageSquareHeartIcon = (props: IconProps) => (
  <Icon icon={DefaultMessageSquareHeartIcon} {...props} />
);

import { default as DefaultMessageSquareLockIcon } from '~icons/lucide/message-square-lock';

/**
 * @see https://lucide.dev/icons/message-square-lock
 */
export const MessageSquareLockIcon = (props: IconProps) => (
  <Icon icon={DefaultMessageSquareLockIcon} {...props} />
);

import { default as DefaultMessageSquareMoreIcon } from '~icons/lucide/message-square-more';

/**
 * @see https://lucide.dev/icons/message-square-more
 */
export const MessageSquareMoreIcon = (props: IconProps) => (
  <Icon icon={DefaultMessageSquareMoreIcon} {...props} />
);

import { default as DefaultMessageSquareOffIcon } from '~icons/lucide/message-square-off';

/**
 * @see https://lucide.dev/icons/message-square-off
 */
export const MessageSquareOffIcon = (props: IconProps) => (
  <Icon icon={DefaultMessageSquareOffIcon} {...props} />
);

import { default as DefaultMessageSquarePlusIcon } from '~icons/lucide/message-square-plus';

/**
 * @see https://lucide.dev/icons/message-square-plus
 */
export const MessageSquarePlusIcon = (props: IconProps) => (
  <Icon icon={DefaultMessageSquarePlusIcon} {...props} />
);

import { default as DefaultMessageSquareQuoteIcon } from '~icons/lucide/message-square-quote';

/**
 * @see https://lucide.dev/icons/message-square-quote
 */
export const MessageSquareQuoteIcon = (props: IconProps) => (
  <Icon icon={DefaultMessageSquareQuoteIcon} {...props} />
);

import { default as DefaultMessageSquareReplyIcon } from '~icons/lucide/message-square-reply';

/**
 * @see https://lucide.dev/icons/message-square-reply
 */
export const MessageSquareReplyIcon = (props: IconProps) => (
  <Icon icon={DefaultMessageSquareReplyIcon} {...props} />
);

import { default as DefaultMessageSquareShareIcon } from '~icons/lucide/message-square-share';

/**
 * @see https://lucide.dev/icons/message-square-share
 */
export const MessageSquareShareIcon = (props: IconProps) => (
  <Icon icon={DefaultMessageSquareShareIcon} {...props} />
);

import { default as DefaultMessageSquareTextIcon } from '~icons/lucide/message-square-text';

/**
 * @see https://lucide.dev/icons/message-square-text
 */
export const MessageSquareTextIcon = (props: IconProps) => (
  <Icon icon={DefaultMessageSquareTextIcon} {...props} />
);

import { default as DefaultMessageSquareWarningIcon } from '~icons/lucide/message-square-warning';

/**
 * @see https://lucide.dev/icons/message-square-warning
 */
export const MessageSquareWarningIcon = (props: IconProps) => (
  <Icon icon={DefaultMessageSquareWarningIcon} {...props} />
);

import { default as DefaultMessageSquareXIcon } from '~icons/lucide/message-square-x';

/**
 * @see https://lucide.dev/icons/message-square-x
 */
export const MessageSquareXIcon = (props: IconProps) => (
  <Icon icon={DefaultMessageSquareXIcon} {...props} />
);

import { default as DefaultMessagesSquareIcon } from '~icons/lucide/messages-square';

/**
 * @see https://lucide.dev/icons/messages-square
 */
export const MessagesSquareIcon = (props: IconProps) => (
  <Icon icon={DefaultMessagesSquareIcon} {...props} />
);

import { default as DefaultMicIcon } from '~icons/lucide/mic';

/**
 * @see https://lucide.dev/icons/mic
 */
export const MicIcon = (props: IconProps) => (
  <Icon icon={DefaultMicIcon} {...props} />
);

import { default as DefaultMicOffIcon } from '~icons/lucide/mic-off';

/**
 * @see https://lucide.dev/icons/mic-off
 */
export const MicOffIcon = (props: IconProps) => (
  <Icon icon={DefaultMicOffIcon} {...props} />
);

import { default as DefaultMicVocalIcon } from '~icons/lucide/mic-vocal';

/**
 * @see https://lucide.dev/icons/mic-vocal
 */
export const MicVocalIcon = (props: IconProps) => (
  <Icon icon={DefaultMicVocalIcon} {...props} />
);

import { default as DefaultMicrochipIcon } from '~icons/lucide/microchip';

/**
 * @see https://lucide.dev/icons/microchip
 */
export const MicrochipIcon = (props: IconProps) => (
  <Icon icon={DefaultMicrochipIcon} {...props} />
);

import { default as DefaultMicroscopeIcon } from '~icons/lucide/microscope';

/**
 * @see https://lucide.dev/icons/microscope
 */
export const MicroscopeIcon = (props: IconProps) => (
  <Icon icon={DefaultMicroscopeIcon} {...props} />
);

import { default as DefaultMicrowaveIcon } from '~icons/lucide/microwave';

/**
 * @see https://lucide.dev/icons/microwave
 */
export const MicrowaveIcon = (props: IconProps) => (
  <Icon icon={DefaultMicrowaveIcon} {...props} />
);

import { default as DefaultMilestoneIcon } from '~icons/lucide/milestone';

/**
 * @see https://lucide.dev/icons/milestone
 */
export const MilestoneIcon = (props: IconProps) => (
  <Icon icon={DefaultMilestoneIcon} {...props} />
);

import { default as DefaultMilkIcon } from '~icons/lucide/milk';

/**
 * @see https://lucide.dev/icons/milk
 */
export const MilkIcon = (props: IconProps) => (
  <Icon icon={DefaultMilkIcon} {...props} />
);

import { default as DefaultMilkOffIcon } from '~icons/lucide/milk-off';

/**
 * @see https://lucide.dev/icons/milk-off
 */
export const MilkOffIcon = (props: IconProps) => (
  <Icon icon={DefaultMilkOffIcon} {...props} />
);

import { default as DefaultMinimizeIcon } from '~icons/lucide/minimize';

/**
 * @see https://lucide.dev/icons/minimize
 */
export const MinimizeIcon = (props: IconProps) => (
  <Icon icon={DefaultMinimizeIcon} {...props} />
);

import { default as DefaultMinimize2Icon } from '~icons/lucide/minimize-2';

/**
 * @see https://lucide.dev/icons/minimize-2
 */
export const Minimize2Icon = (props: IconProps) => (
  <Icon icon={DefaultMinimize2Icon} {...props} />
);

import { default as DefaultMinusIcon } from '~icons/lucide/minus';

/**
 * @see https://lucide.dev/icons/minus
 */
export const MinusIcon = (props: IconProps) => (
  <Icon icon={DefaultMinusIcon} {...props} />
);

import { default as DefaultMonitorIcon } from '~icons/lucide/monitor';

/**
 * @see https://lucide.dev/icons/monitor
 */
export const MonitorIcon = (props: IconProps) => (
  <Icon icon={DefaultMonitorIcon} {...props} />
);

import { default as DefaultMonitorCheckIcon } from '~icons/lucide/monitor-check';

/**
 * @see https://lucide.dev/icons/monitor-check
 */
export const MonitorCheckIcon = (props: IconProps) => (
  <Icon icon={DefaultMonitorCheckIcon} {...props} />
);

import { default as DefaultMonitorCogIcon } from '~icons/lucide/monitor-cog';

/**
 * @see https://lucide.dev/icons/monitor-cog
 */
export const MonitorCogIcon = (props: IconProps) => (
  <Icon icon={DefaultMonitorCogIcon} {...props} />
);

import { default as DefaultMonitorDotIcon } from '~icons/lucide/monitor-dot';

/**
 * @see https://lucide.dev/icons/monitor-dot
 */
export const MonitorDotIcon = (props: IconProps) => (
  <Icon icon={DefaultMonitorDotIcon} {...props} />
);

import { default as DefaultMonitorDownIcon } from '~icons/lucide/monitor-down';

/**
 * @see https://lucide.dev/icons/monitor-down
 */
export const MonitorDownIcon = (props: IconProps) => (
  <Icon icon={DefaultMonitorDownIcon} {...props} />
);

import { default as DefaultMonitorOffIcon } from '~icons/lucide/monitor-off';

/**
 * @see https://lucide.dev/icons/monitor-off
 */
export const MonitorOffIcon = (props: IconProps) => (
  <Icon icon={DefaultMonitorOffIcon} {...props} />
);

import { default as DefaultMonitorPauseIcon } from '~icons/lucide/monitor-pause';

/**
 * @see https://lucide.dev/icons/monitor-pause
 */
export const MonitorPauseIcon = (props: IconProps) => (
  <Icon icon={DefaultMonitorPauseIcon} {...props} />
);

import { default as DefaultMonitorPlayIcon } from '~icons/lucide/monitor-play';

/**
 * @see https://lucide.dev/icons/monitor-play
 */
export const MonitorPlayIcon = (props: IconProps) => (
  <Icon icon={DefaultMonitorPlayIcon} {...props} />
);

import { default as DefaultMonitorSmartphoneIcon } from '~icons/lucide/monitor-smartphone';

/**
 * @see https://lucide.dev/icons/monitor-smartphone
 */
export const MonitorSmartphoneIcon = (props: IconProps) => (
  <Icon icon={DefaultMonitorSmartphoneIcon} {...props} />
);

import { default as DefaultMonitorSpeakerIcon } from '~icons/lucide/monitor-speaker';

/**
 * @see https://lucide.dev/icons/monitor-speaker
 */
export const MonitorSpeakerIcon = (props: IconProps) => (
  <Icon icon={DefaultMonitorSpeakerIcon} {...props} />
);

import { default as DefaultMonitorStopIcon } from '~icons/lucide/monitor-stop';

/**
 * @see https://lucide.dev/icons/monitor-stop
 */
export const MonitorStopIcon = (props: IconProps) => (
  <Icon icon={DefaultMonitorStopIcon} {...props} />
);

import { default as DefaultMonitorUpIcon } from '~icons/lucide/monitor-up';

/**
 * @see https://lucide.dev/icons/monitor-up
 */
export const MonitorUpIcon = (props: IconProps) => (
  <Icon icon={DefaultMonitorUpIcon} {...props} />
);

import { default as DefaultMonitorXIcon } from '~icons/lucide/monitor-x';

/**
 * @see https://lucide.dev/icons/monitor-x
 */
export const MonitorXIcon = (props: IconProps) => (
  <Icon icon={DefaultMonitorXIcon} {...props} />
);

import { default as DefaultMoonIcon } from '~icons/lucide/moon';

/**
 * @see https://lucide.dev/icons/moon
 */
export const MoonIcon = (props: IconProps) => (
  <Icon icon={DefaultMoonIcon} {...props} />
);

import { default as DefaultMoonStarIcon } from '~icons/lucide/moon-star';

/**
 * @see https://lucide.dev/icons/moon-star
 */
export const MoonStarIcon = (props: IconProps) => (
  <Icon icon={DefaultMoonStarIcon} {...props} />
);

import { default as DefaultMountainIcon } from '~icons/lucide/mountain';

/**
 * @see https://lucide.dev/icons/mountain
 */
export const MountainIcon = (props: IconProps) => (
  <Icon icon={DefaultMountainIcon} {...props} />
);

import { default as DefaultMountainSnowIcon } from '~icons/lucide/mountain-snow';

/**
 * @see https://lucide.dev/icons/mountain-snow
 */
export const MountainSnowIcon = (props: IconProps) => (
  <Icon icon={DefaultMountainSnowIcon} {...props} />
);

import { default as DefaultMouseIcon } from '~icons/lucide/mouse';

/**
 * @see https://lucide.dev/icons/mouse
 */
export const MouseIcon = (props: IconProps) => (
  <Icon icon={DefaultMouseIcon} {...props} />
);

import { default as DefaultMouseOffIcon } from '~icons/lucide/mouse-off';

/**
 * @see https://lucide.dev/icons/mouse-off
 */
export const MouseOffIcon = (props: IconProps) => (
  <Icon icon={DefaultMouseOffIcon} {...props} />
);

import { default as DefaultMousePointerIcon } from '~icons/lucide/mouse-pointer';

/**
 * @see https://lucide.dev/icons/mouse-pointer
 */
export const MousePointerIcon = (props: IconProps) => (
  <Icon icon={DefaultMousePointerIcon} {...props} />
);

import { default as DefaultMousePointer2Icon } from '~icons/lucide/mouse-pointer-2';

/**
 * @see https://lucide.dev/icons/mouse-pointer-2
 */
export const MousePointer2Icon = (props: IconProps) => (
  <Icon icon={DefaultMousePointer2Icon} {...props} />
);

import { default as DefaultMousePointerBanIcon } from '~icons/lucide/mouse-pointer-ban';

/**
 * @see https://lucide.dev/icons/mouse-pointer-ban
 */
export const MousePointerBanIcon = (props: IconProps) => (
  <Icon icon={DefaultMousePointerBanIcon} {...props} />
);

import { default as DefaultMousePointerClickIcon } from '~icons/lucide/mouse-pointer-click';

/**
 * @see https://lucide.dev/icons/mouse-pointer-click
 */
export const MousePointerClickIcon = (props: IconProps) => (
  <Icon icon={DefaultMousePointerClickIcon} {...props} />
);

import { default as DefaultMoveIcon } from '~icons/lucide/move';

/**
 * @see https://lucide.dev/icons/move
 */
export const MoveIcon = (props: IconProps) => (
  <Icon icon={DefaultMoveIcon} {...props} />
);

import { default as DefaultMove3dIcon } from '~icons/lucide/move-3d';

/**
 * @see https://lucide.dev/icons/move-3d
 */
export const Move3dIcon = (props: IconProps) => (
  <Icon icon={DefaultMove3dIcon} {...props} />
);

import { default as DefaultMoveDiagonalIcon } from '~icons/lucide/move-diagonal';

/**
 * @see https://lucide.dev/icons/move-diagonal
 */
export const MoveDiagonalIcon = (props: IconProps) => (
  <Icon icon={DefaultMoveDiagonalIcon} {...props} />
);

import { default as DefaultMoveDiagonal2Icon } from '~icons/lucide/move-diagonal-2';

/**
 * @see https://lucide.dev/icons/move-diagonal-2
 */
export const MoveDiagonal2Icon = (props: IconProps) => (
  <Icon icon={DefaultMoveDiagonal2Icon} {...props} />
);

import { default as DefaultMoveDownIcon } from '~icons/lucide/move-down';

/**
 * @see https://lucide.dev/icons/move-down
 */
export const MoveDownIcon = (props: IconProps) => (
  <Icon icon={DefaultMoveDownIcon} {...props} />
);

import { default as DefaultMoveDownLeftIcon } from '~icons/lucide/move-down-left';

/**
 * @see https://lucide.dev/icons/move-down-left
 */
export const MoveDownLeftIcon = (props: IconProps) => (
  <Icon icon={DefaultMoveDownLeftIcon} {...props} />
);

import { default as DefaultMoveDownRightIcon } from '~icons/lucide/move-down-right';

/**
 * @see https://lucide.dev/icons/move-down-right
 */
export const MoveDownRightIcon = (props: IconProps) => (
  <Icon icon={DefaultMoveDownRightIcon} {...props} />
);

import { default as DefaultMoveHorizontalIcon } from '~icons/lucide/move-horizontal';

/**
 * @see https://lucide.dev/icons/move-horizontal
 */
export const MoveHorizontalIcon = (props: IconProps) => (
  <Icon icon={DefaultMoveHorizontalIcon} {...props} />
);

import { default as DefaultMoveLeftIcon } from '~icons/lucide/move-left';

/**
 * @see https://lucide.dev/icons/move-left
 */
export const MoveLeftIcon = (props: IconProps) => (
  <Icon icon={DefaultMoveLeftIcon} {...props} />
);

import { default as DefaultMoveRightIcon } from '~icons/lucide/move-right';

/**
 * @see https://lucide.dev/icons/move-right
 */
export const MoveRightIcon = (props: IconProps) => (
  <Icon icon={DefaultMoveRightIcon} {...props} />
);

import { default as DefaultMoveUpIcon } from '~icons/lucide/move-up';

/**
 * @see https://lucide.dev/icons/move-up
 */
export const MoveUpIcon = (props: IconProps) => (
  <Icon icon={DefaultMoveUpIcon} {...props} />
);

import { default as DefaultMoveUpLeftIcon } from '~icons/lucide/move-up-left';

/**
 * @see https://lucide.dev/icons/move-up-left
 */
export const MoveUpLeftIcon = (props: IconProps) => (
  <Icon icon={DefaultMoveUpLeftIcon} {...props} />
);

import { default as DefaultMoveUpRightIcon } from '~icons/lucide/move-up-right';

/**
 * @see https://lucide.dev/icons/move-up-right
 */
export const MoveUpRightIcon = (props: IconProps) => (
  <Icon icon={DefaultMoveUpRightIcon} {...props} />
);

import { default as DefaultMoveVerticalIcon } from '~icons/lucide/move-vertical';

/**
 * @see https://lucide.dev/icons/move-vertical
 */
export const MoveVerticalIcon = (props: IconProps) => (
  <Icon icon={DefaultMoveVerticalIcon} {...props} />
);

import { default as DefaultMusicIcon } from '~icons/lucide/music';

/**
 * @see https://lucide.dev/icons/music
 */
export const MusicIcon = (props: IconProps) => (
  <Icon icon={DefaultMusicIcon} {...props} />
);

import { default as DefaultMusic2Icon } from '~icons/lucide/music-2';

/**
 * @see https://lucide.dev/icons/music-2
 */
export const Music2Icon = (props: IconProps) => (
  <Icon icon={DefaultMusic2Icon} {...props} />
);

import { default as DefaultMusic3Icon } from '~icons/lucide/music-3';

/**
 * @see https://lucide.dev/icons/music-3
 */
export const Music3Icon = (props: IconProps) => (
  <Icon icon={DefaultMusic3Icon} {...props} />
);

import { default as DefaultMusic4Icon } from '~icons/lucide/music-4';

/**
 * @see https://lucide.dev/icons/music-4
 */
export const Music4Icon = (props: IconProps) => (
  <Icon icon={DefaultMusic4Icon} {...props} />
);

import { default as DefaultNavigationIcon } from '~icons/lucide/navigation';

/**
 * @see https://lucide.dev/icons/navigation
 */
export const NavigationIcon = (props: IconProps) => (
  <Icon icon={DefaultNavigationIcon} {...props} />
);

import { default as DefaultNavigation2Icon } from '~icons/lucide/navigation-2';

/**
 * @see https://lucide.dev/icons/navigation-2
 */
export const Navigation2Icon = (props: IconProps) => (
  <Icon icon={DefaultNavigation2Icon} {...props} />
);

import { default as DefaultNavigation2OffIcon } from '~icons/lucide/navigation-2-off';

/**
 * @see https://lucide.dev/icons/navigation-2-off
 */
export const Navigation2OffIcon = (props: IconProps) => (
  <Icon icon={DefaultNavigation2OffIcon} {...props} />
);

import { default as DefaultNavigationOffIcon } from '~icons/lucide/navigation-off';

/**
 * @see https://lucide.dev/icons/navigation-off
 */
export const NavigationOffIcon = (props: IconProps) => (
  <Icon icon={DefaultNavigationOffIcon} {...props} />
);

import { default as DefaultNetworkIcon } from '~icons/lucide/network';

/**
 * @see https://lucide.dev/icons/network
 */
export const NetworkIcon = (props: IconProps) => (
  <Icon icon={DefaultNetworkIcon} {...props} />
);

import { default as DefaultNewspaperIcon } from '~icons/lucide/newspaper';

/**
 * @see https://lucide.dev/icons/newspaper
 */
export const NewspaperIcon = (props: IconProps) => (
  <Icon icon={DefaultNewspaperIcon} {...props} />
);

import { default as DefaultNfcIcon } from '~icons/lucide/nfc';

/**
 * @see https://lucide.dev/icons/nfc
 */
export const NfcIcon = (props: IconProps) => (
  <Icon icon={DefaultNfcIcon} {...props} />
);

import { default as DefaultNonBinaryIcon } from '~icons/lucide/non-binary';

/**
 * @see https://lucide.dev/icons/non-binary
 */
export const NonBinaryIcon = (props: IconProps) => (
  <Icon icon={DefaultNonBinaryIcon} {...props} />
);

import { default as DefaultNotebookIcon } from '~icons/lucide/notebook';

/**
 * @see https://lucide.dev/icons/notebook
 */
export const NotebookIcon = (props: IconProps) => (
  <Icon icon={DefaultNotebookIcon} {...props} />
);

import { default as DefaultNotebookPenIcon } from '~icons/lucide/notebook-pen';

/**
 * @see https://lucide.dev/icons/notebook-pen
 */
export const NotebookPenIcon = (props: IconProps) => (
  <Icon icon={DefaultNotebookPenIcon} {...props} />
);

import { default as DefaultNotebookTabsIcon } from '~icons/lucide/notebook-tabs';

/**
 * @see https://lucide.dev/icons/notebook-tabs
 */
export const NotebookTabsIcon = (props: IconProps) => (
  <Icon icon={DefaultNotebookTabsIcon} {...props} />
);

import { default as DefaultNotebookTextIcon } from '~icons/lucide/notebook-text';

/**
 * @see https://lucide.dev/icons/notebook-text
 */
export const NotebookTextIcon = (props: IconProps) => (
  <Icon icon={DefaultNotebookTextIcon} {...props} />
);

import { default as DefaultNotepadTextIcon } from '~icons/lucide/notepad-text';

/**
 * @see https://lucide.dev/icons/notepad-text
 */
export const NotepadTextIcon = (props: IconProps) => (
  <Icon icon={DefaultNotepadTextIcon} {...props} />
);

import { default as DefaultNotepadTextDashedIcon } from '~icons/lucide/notepad-text-dashed';

/**
 * @see https://lucide.dev/icons/notepad-text-dashed
 */
export const NotepadTextDashedIcon = (props: IconProps) => (
  <Icon icon={DefaultNotepadTextDashedIcon} {...props} />
);

import { default as DefaultNutIcon } from '~icons/lucide/nut';

/**
 * @see https://lucide.dev/icons/nut
 */
export const NutIcon = (props: IconProps) => (
  <Icon icon={DefaultNutIcon} {...props} />
);

import { default as DefaultNutOffIcon } from '~icons/lucide/nut-off';

/**
 * @see https://lucide.dev/icons/nut-off
 */
export const NutOffIcon = (props: IconProps) => (
  <Icon icon={DefaultNutOffIcon} {...props} />
);

import { default as DefaultOctagonIcon } from '~icons/lucide/octagon';

/**
 * @see https://lucide.dev/icons/octagon
 */
export const OctagonIcon = (props: IconProps) => (
  <Icon icon={DefaultOctagonIcon} {...props} />
);

import { default as DefaultOctagonAlertIcon } from '~icons/lucide/octagon-alert';

/**
 * @see https://lucide.dev/icons/octagon-alert
 */
export const OctagonAlertIcon = (props: IconProps) => (
  <Icon icon={DefaultOctagonAlertIcon} {...props} />
);

import { default as DefaultOctagonMinusIcon } from '~icons/lucide/octagon-minus';

/**
 * @see https://lucide.dev/icons/octagon-minus
 */
export const OctagonMinusIcon = (props: IconProps) => (
  <Icon icon={DefaultOctagonMinusIcon} {...props} />
);

import { default as DefaultOctagonPauseIcon } from '~icons/lucide/octagon-pause';

/**
 * @see https://lucide.dev/icons/octagon-pause
 */
export const OctagonPauseIcon = (props: IconProps) => (
  <Icon icon={DefaultOctagonPauseIcon} {...props} />
);

import { default as DefaultOctagonXIcon } from '~icons/lucide/octagon-x';

/**
 * @see https://lucide.dev/icons/octagon-x
 */
export const OctagonXIcon = (props: IconProps) => (
  <Icon icon={DefaultOctagonXIcon} {...props} />
);

import { default as DefaultOmegaIcon } from '~icons/lucide/omega';

/**
 * @see https://lucide.dev/icons/omega
 */
export const OmegaIcon = (props: IconProps) => (
  <Icon icon={DefaultOmegaIcon} {...props} />
);

import { default as DefaultOptionIcon } from '~icons/lucide/option';

/**
 * @see https://lucide.dev/icons/option
 */
export const OptionIcon = (props: IconProps) => (
  <Icon icon={DefaultOptionIcon} {...props} />
);

import { default as DefaultOrbitIcon } from '~icons/lucide/orbit';

/**
 * @see https://lucide.dev/icons/orbit
 */
export const OrbitIcon = (props: IconProps) => (
  <Icon icon={DefaultOrbitIcon} {...props} />
);

import { default as DefaultOrigamiIcon } from '~icons/lucide/origami';

/**
 * @see https://lucide.dev/icons/origami
 */
export const OrigamiIcon = (props: IconProps) => (
  <Icon icon={DefaultOrigamiIcon} {...props} />
);

import { default as DefaultPackageIcon } from '~icons/lucide/package';

/**
 * @see https://lucide.dev/icons/package
 */
export const PackageIcon = (props: IconProps) => (
  <Icon icon={DefaultPackageIcon} {...props} />
);

import { default as DefaultPackage2Icon } from '~icons/lucide/package-2';

/**
 * @see https://lucide.dev/icons/package-2
 */
export const Package2Icon = (props: IconProps) => (
  <Icon icon={DefaultPackage2Icon} {...props} />
);

import { default as DefaultPackageCheckIcon } from '~icons/lucide/package-check';

/**
 * @see https://lucide.dev/icons/package-check
 */
export const PackageCheckIcon = (props: IconProps) => (
  <Icon icon={DefaultPackageCheckIcon} {...props} />
);

import { default as DefaultPackageMinusIcon } from '~icons/lucide/package-minus';

/**
 * @see https://lucide.dev/icons/package-minus
 */
export const PackageMinusIcon = (props: IconProps) => (
  <Icon icon={DefaultPackageMinusIcon} {...props} />
);

import { default as DefaultPackageOpenIcon } from '~icons/lucide/package-open';

/**
 * @see https://lucide.dev/icons/package-open
 */
export const PackageOpenIcon = (props: IconProps) => (
  <Icon icon={DefaultPackageOpenIcon} {...props} />
);

import { default as DefaultPackagePlusIcon } from '~icons/lucide/package-plus';

/**
 * @see https://lucide.dev/icons/package-plus
 */
export const PackagePlusIcon = (props: IconProps) => (
  <Icon icon={DefaultPackagePlusIcon} {...props} />
);

import { default as DefaultPackageSearchIcon } from '~icons/lucide/package-search';

/**
 * @see https://lucide.dev/icons/package-search
 */
export const PackageSearchIcon = (props: IconProps) => (
  <Icon icon={DefaultPackageSearchIcon} {...props} />
);

import { default as DefaultPackageXIcon } from '~icons/lucide/package-x';

/**
 * @see https://lucide.dev/icons/package-x
 */
export const PackageXIcon = (props: IconProps) => (
  <Icon icon={DefaultPackageXIcon} {...props} />
);

import { default as DefaultPaintBucketIcon } from '~icons/lucide/paint-bucket';

/**
 * @see https://lucide.dev/icons/paint-bucket
 */
export const PaintBucketIcon = (props: IconProps) => (
  <Icon icon={DefaultPaintBucketIcon} {...props} />
);

import { default as DefaultPaintRollerIcon } from '~icons/lucide/paint-roller';

/**
 * @see https://lucide.dev/icons/paint-roller
 */
export const PaintRollerIcon = (props: IconProps) => (
  <Icon icon={DefaultPaintRollerIcon} {...props} />
);

import { default as DefaultPaintbrushIcon } from '~icons/lucide/paintbrush';

/**
 * @see https://lucide.dev/icons/paintbrush
 */
export const PaintbrushIcon = (props: IconProps) => (
  <Icon icon={DefaultPaintbrushIcon} {...props} />
);

import { default as DefaultPaintbrushVerticalIcon } from '~icons/lucide/paintbrush-vertical';

/**
 * @see https://lucide.dev/icons/paintbrush-vertical
 */
export const PaintbrushVerticalIcon = (props: IconProps) => (
  <Icon icon={DefaultPaintbrushVerticalIcon} {...props} />
);

import { default as DefaultPaletteIcon } from '~icons/lucide/palette';

/**
 * @see https://lucide.dev/icons/palette
 */
export const PaletteIcon = (props: IconProps) => (
  <Icon icon={DefaultPaletteIcon} {...props} />
);

import { default as DefaultPandaIcon } from '~icons/lucide/panda';

/**
 * @see https://lucide.dev/icons/panda
 */
export const PandaIcon = (props: IconProps) => (
  <Icon icon={DefaultPandaIcon} {...props} />
);

import { default as DefaultPanelBottomIcon } from '~icons/lucide/panel-bottom';

/**
 * @see https://lucide.dev/icons/panel-bottom
 */
export const PanelBottomIcon = (props: IconProps) => (
  <Icon icon={DefaultPanelBottomIcon} {...props} />
);

import { default as DefaultPanelBottomCloseIcon } from '~icons/lucide/panel-bottom-close';

/**
 * @see https://lucide.dev/icons/panel-bottom-close
 */
export const PanelBottomCloseIcon = (props: IconProps) => (
  <Icon icon={DefaultPanelBottomCloseIcon} {...props} />
);

import { default as DefaultPanelBottomDashedIcon } from '~icons/lucide/panel-bottom-dashed';

/**
 * @see https://lucide.dev/icons/panel-bottom-dashed
 */
export const PanelBottomDashedIcon = (props: IconProps) => (
  <Icon icon={DefaultPanelBottomDashedIcon} {...props} />
);

import { default as DefaultPanelBottomOpenIcon } from '~icons/lucide/panel-bottom-open';

/**
 * @see https://lucide.dev/icons/panel-bottom-open
 */
export const PanelBottomOpenIcon = (props: IconProps) => (
  <Icon icon={DefaultPanelBottomOpenIcon} {...props} />
);

import { default as DefaultPanelLeftIcon } from '~icons/lucide/panel-left';

/**
 * @see https://lucide.dev/icons/panel-left
 */
export const PanelLeftIcon = (props: IconProps) => (
  <Icon icon={DefaultPanelLeftIcon} {...props} />
);

import { default as DefaultPanelLeftCloseIcon } from '~icons/lucide/panel-left-close';

/**
 * @see https://lucide.dev/icons/panel-left-close
 */
export const PanelLeftCloseIcon = (props: IconProps) => (
  <Icon icon={DefaultPanelLeftCloseIcon} {...props} />
);

import { default as DefaultPanelLeftDashedIcon } from '~icons/lucide/panel-left-dashed';

/**
 * @see https://lucide.dev/icons/panel-left-dashed
 */
export const PanelLeftDashedIcon = (props: IconProps) => (
  <Icon icon={DefaultPanelLeftDashedIcon} {...props} />
);

import { default as DefaultPanelLeftOpenIcon } from '~icons/lucide/panel-left-open';

/**
 * @see https://lucide.dev/icons/panel-left-open
 */
export const PanelLeftOpenIcon = (props: IconProps) => (
  <Icon icon={DefaultPanelLeftOpenIcon} {...props} />
);

import { default as DefaultPanelRightIcon } from '~icons/lucide/panel-right';

/**
 * @see https://lucide.dev/icons/panel-right
 */
export const PanelRightIcon = (props: IconProps) => (
  <Icon icon={DefaultPanelRightIcon} {...props} />
);

import { default as DefaultPanelRightCloseIcon } from '~icons/lucide/panel-right-close';

/**
 * @see https://lucide.dev/icons/panel-right-close
 */
export const PanelRightCloseIcon = (props: IconProps) => (
  <Icon icon={DefaultPanelRightCloseIcon} {...props} />
);

import { default as DefaultPanelRightDashedIcon } from '~icons/lucide/panel-right-dashed';

/**
 * @see https://lucide.dev/icons/panel-right-dashed
 */
export const PanelRightDashedIcon = (props: IconProps) => (
  <Icon icon={DefaultPanelRightDashedIcon} {...props} />
);

import { default as DefaultPanelRightOpenIcon } from '~icons/lucide/panel-right-open';

/**
 * @see https://lucide.dev/icons/panel-right-open
 */
export const PanelRightOpenIcon = (props: IconProps) => (
  <Icon icon={DefaultPanelRightOpenIcon} {...props} />
);

import { default as DefaultPanelTopIcon } from '~icons/lucide/panel-top';

/**
 * @see https://lucide.dev/icons/panel-top
 */
export const PanelTopIcon = (props: IconProps) => (
  <Icon icon={DefaultPanelTopIcon} {...props} />
);

import { default as DefaultPanelTopCloseIcon } from '~icons/lucide/panel-top-close';

/**
 * @see https://lucide.dev/icons/panel-top-close
 */
export const PanelTopCloseIcon = (props: IconProps) => (
  <Icon icon={DefaultPanelTopCloseIcon} {...props} />
);

import { default as DefaultPanelTopDashedIcon } from '~icons/lucide/panel-top-dashed';

/**
 * @see https://lucide.dev/icons/panel-top-dashed
 */
export const PanelTopDashedIcon = (props: IconProps) => (
  <Icon icon={DefaultPanelTopDashedIcon} {...props} />
);

import { default as DefaultPanelTopOpenIcon } from '~icons/lucide/panel-top-open';

/**
 * @see https://lucide.dev/icons/panel-top-open
 */
export const PanelTopOpenIcon = (props: IconProps) => (
  <Icon icon={DefaultPanelTopOpenIcon} {...props} />
);

import { default as DefaultPanelsLeftBottomIcon } from '~icons/lucide/panels-left-bottom';

/**
 * @see https://lucide.dev/icons/panels-left-bottom
 */
export const PanelsLeftBottomIcon = (props: IconProps) => (
  <Icon icon={DefaultPanelsLeftBottomIcon} {...props} />
);

import { default as DefaultPanelsRightBottomIcon } from '~icons/lucide/panels-right-bottom';

/**
 * @see https://lucide.dev/icons/panels-right-bottom
 */
export const PanelsRightBottomIcon = (props: IconProps) => (
  <Icon icon={DefaultPanelsRightBottomIcon} {...props} />
);

import { default as DefaultPanelsTopLeftIcon } from '~icons/lucide/panels-top-left';

/**
 * @see https://lucide.dev/icons/panels-top-left
 */
export const PanelsTopLeftIcon = (props: IconProps) => (
  <Icon icon={DefaultPanelsTopLeftIcon} {...props} />
);

import { default as DefaultPaperclipIcon } from '~icons/lucide/paperclip';

/**
 * @see https://lucide.dev/icons/paperclip
 */
export const PaperclipIcon = (props: IconProps) => (
  <Icon icon={DefaultPaperclipIcon} {...props} />
);

import { default as DefaultParenthesesIcon } from '~icons/lucide/parentheses';

/**
 * @see https://lucide.dev/icons/parentheses
 */
export const ParenthesesIcon = (props: IconProps) => (
  <Icon icon={DefaultParenthesesIcon} {...props} />
);

import { default as DefaultParkingMeterIcon } from '~icons/lucide/parking-meter';

/**
 * @see https://lucide.dev/icons/parking-meter
 */
export const ParkingMeterIcon = (props: IconProps) => (
  <Icon icon={DefaultParkingMeterIcon} {...props} />
);

import { default as DefaultPartyPopperIcon } from '~icons/lucide/party-popper';

/**
 * @see https://lucide.dev/icons/party-popper
 */
export const PartyPopperIcon = (props: IconProps) => (
  <Icon icon={DefaultPartyPopperIcon} {...props} />
);

import { default as DefaultPauseIcon } from '~icons/lucide/pause';

/**
 * @see https://lucide.dev/icons/pause
 */
export const PauseIcon = (props: IconProps) => (
  <Icon icon={DefaultPauseIcon} {...props} />
);

import { default as DefaultPawPrintIcon } from '~icons/lucide/paw-print';

/**
 * @see https://lucide.dev/icons/paw-print
 */
export const PawPrintIcon = (props: IconProps) => (
  <Icon icon={DefaultPawPrintIcon} {...props} />
);

import { default as DefaultPcCaseIcon } from '~icons/lucide/pc-case';

/**
 * @see https://lucide.dev/icons/pc-case
 */
export const PcCaseIcon = (props: IconProps) => (
  <Icon icon={DefaultPcCaseIcon} {...props} />
);

import { default as DefaultPenIcon } from '~icons/lucide/pen';

/**
 * @see https://lucide.dev/icons/pen
 */
export const PenIcon = (props: IconProps) => (
  <Icon icon={DefaultPenIcon} {...props} />
);

import { default as DefaultPenLineIcon } from '~icons/lucide/pen-line';

/**
 * @see https://lucide.dev/icons/pen-line
 */
export const PenLineIcon = (props: IconProps) => (
  <Icon icon={DefaultPenLineIcon} {...props} />
);

import { default as DefaultPenOffIcon } from '~icons/lucide/pen-off';

/**
 * @see https://lucide.dev/icons/pen-off
 */
export const PenOffIcon = (props: IconProps) => (
  <Icon icon={DefaultPenOffIcon} {...props} />
);

import { default as DefaultPenToolIcon } from '~icons/lucide/pen-tool';

/**
 * @see https://lucide.dev/icons/pen-tool
 */
export const PenToolIcon = (props: IconProps) => (
  <Icon icon={DefaultPenToolIcon} {...props} />
);

import { default as DefaultPencilIcon } from '~icons/lucide/pencil';

/**
 * @see https://lucide.dev/icons/pencil
 */
export const PencilIcon = (props: IconProps) => (
  <Icon icon={DefaultPencilIcon} {...props} />
);

import { default as DefaultPencilLineIcon } from '~icons/lucide/pencil-line';

/**
 * @see https://lucide.dev/icons/pencil-line
 */
export const PencilLineIcon = (props: IconProps) => (
  <Icon icon={DefaultPencilLineIcon} {...props} />
);

import { default as DefaultPencilOffIcon } from '~icons/lucide/pencil-off';

/**
 * @see https://lucide.dev/icons/pencil-off
 */
export const PencilOffIcon = (props: IconProps) => (
  <Icon icon={DefaultPencilOffIcon} {...props} />
);

import { default as DefaultPencilRulerIcon } from '~icons/lucide/pencil-ruler';

/**
 * @see https://lucide.dev/icons/pencil-ruler
 */
export const PencilRulerIcon = (props: IconProps) => (
  <Icon icon={DefaultPencilRulerIcon} {...props} />
);

import { default as DefaultPentagonIcon } from '~icons/lucide/pentagon';

/**
 * @see https://lucide.dev/icons/pentagon
 */
export const PentagonIcon = (props: IconProps) => (
  <Icon icon={DefaultPentagonIcon} {...props} />
);

import { default as DefaultPercentIcon } from '~icons/lucide/percent';

/**
 * @see https://lucide.dev/icons/percent
 */
export const PercentIcon = (props: IconProps) => (
  <Icon icon={DefaultPercentIcon} {...props} />
);

import { default as DefaultPersonStandingIcon } from '~icons/lucide/person-standing';

/**
 * @see https://lucide.dev/icons/person-standing
 */
export const PersonStandingIcon = (props: IconProps) => (
  <Icon icon={DefaultPersonStandingIcon} {...props} />
);

import { default as DefaultPhilippinePesoIcon } from '~icons/lucide/philippine-peso';

/**
 * @see https://lucide.dev/icons/philippine-peso
 */
export const PhilippinePesoIcon = (props: IconProps) => (
  <Icon icon={DefaultPhilippinePesoIcon} {...props} />
);

import { default as DefaultPhoneIcon } from '~icons/lucide/phone';

/**
 * @see https://lucide.dev/icons/phone
 */
export const PhoneIcon = (props: IconProps) => (
  <Icon icon={DefaultPhoneIcon} {...props} />
);

import { default as DefaultPhoneCallIcon } from '~icons/lucide/phone-call';

/**
 * @see https://lucide.dev/icons/phone-call
 */
export const PhoneCallIcon = (props: IconProps) => (
  <Icon icon={DefaultPhoneCallIcon} {...props} />
);

import { default as DefaultPhoneForwardedIcon } from '~icons/lucide/phone-forwarded';

/**
 * @see https://lucide.dev/icons/phone-forwarded
 */
export const PhoneForwardedIcon = (props: IconProps) => (
  <Icon icon={DefaultPhoneForwardedIcon} {...props} />
);

import { default as DefaultPhoneIncomingIcon } from '~icons/lucide/phone-incoming';

/**
 * @see https://lucide.dev/icons/phone-incoming
 */
export const PhoneIncomingIcon = (props: IconProps) => (
  <Icon icon={DefaultPhoneIncomingIcon} {...props} />
);

import { default as DefaultPhoneMissedIcon } from '~icons/lucide/phone-missed';

/**
 * @see https://lucide.dev/icons/phone-missed
 */
export const PhoneMissedIcon = (props: IconProps) => (
  <Icon icon={DefaultPhoneMissedIcon} {...props} />
);

import { default as DefaultPhoneOffIcon } from '~icons/lucide/phone-off';

/**
 * @see https://lucide.dev/icons/phone-off
 */
export const PhoneOffIcon = (props: IconProps) => (
  <Icon icon={DefaultPhoneOffIcon} {...props} />
);

import { default as DefaultPhoneOutgoingIcon } from '~icons/lucide/phone-outgoing';

/**
 * @see https://lucide.dev/icons/phone-outgoing
 */
export const PhoneOutgoingIcon = (props: IconProps) => (
  <Icon icon={DefaultPhoneOutgoingIcon} {...props} />
);

import { default as DefaultPiIcon } from '~icons/lucide/pi';

/**
 * @see https://lucide.dev/icons/pi
 */
export const PiIcon = (props: IconProps) => (
  <Icon icon={DefaultPiIcon} {...props} />
);

import { default as DefaultPianoIcon } from '~icons/lucide/piano';

/**
 * @see https://lucide.dev/icons/piano
 */
export const PianoIcon = (props: IconProps) => (
  <Icon icon={DefaultPianoIcon} {...props} />
);

import { default as DefaultPickaxeIcon } from '~icons/lucide/pickaxe';

/**
 * @see https://lucide.dev/icons/pickaxe
 */
export const PickaxeIcon = (props: IconProps) => (
  <Icon icon={DefaultPickaxeIcon} {...props} />
);

import { default as DefaultPictureInPictureIcon } from '~icons/lucide/picture-in-picture';

/**
 * @see https://lucide.dev/icons/picture-in-picture
 */
export const PictureInPictureIcon = (props: IconProps) => (
  <Icon icon={DefaultPictureInPictureIcon} {...props} />
);

import { default as DefaultPictureInPicture2Icon } from '~icons/lucide/picture-in-picture-2';

/**
 * @see https://lucide.dev/icons/picture-in-picture-2
 */
export const PictureInPicture2Icon = (props: IconProps) => (
  <Icon icon={DefaultPictureInPicture2Icon} {...props} />
);

import { default as DefaultPieChartIcon } from '~icons/lucide/pie-chart';

/**
 * @see https://lucide.dev/icons/pie-chart
 */
export const PieChartIcon = (props: IconProps) => (
  <Icon icon={DefaultPieChartIcon} {...props} />
);

import { default as DefaultPiggyBankIcon } from '~icons/lucide/piggy-bank';

/**
 * @see https://lucide.dev/icons/piggy-bank
 */
export const PiggyBankIcon = (props: IconProps) => (
  <Icon icon={DefaultPiggyBankIcon} {...props} />
);

import { default as DefaultPilcrowIcon } from '~icons/lucide/pilcrow';

/**
 * @see https://lucide.dev/icons/pilcrow
 */
export const PilcrowIcon = (props: IconProps) => (
  <Icon icon={DefaultPilcrowIcon} {...props} />
);

import { default as DefaultPilcrowLeftIcon } from '~icons/lucide/pilcrow-left';

/**
 * @see https://lucide.dev/icons/pilcrow-left
 */
export const PilcrowLeftIcon = (props: IconProps) => (
  <Icon icon={DefaultPilcrowLeftIcon} {...props} />
);

import { default as DefaultPilcrowRightIcon } from '~icons/lucide/pilcrow-right';

/**
 * @see https://lucide.dev/icons/pilcrow-right
 */
export const PilcrowRightIcon = (props: IconProps) => (
  <Icon icon={DefaultPilcrowRightIcon} {...props} />
);

import { default as DefaultPillIcon } from '~icons/lucide/pill';

/**
 * @see https://lucide.dev/icons/pill
 */
export const PillIcon = (props: IconProps) => (
  <Icon icon={DefaultPillIcon} {...props} />
);

import { default as DefaultPillBottleIcon } from '~icons/lucide/pill-bottle';

/**
 * @see https://lucide.dev/icons/pill-bottle
 */
export const PillBottleIcon = (props: IconProps) => (
  <Icon icon={DefaultPillBottleIcon} {...props} />
);

import { default as DefaultPinIcon } from '~icons/lucide/pin';

/**
 * @see https://lucide.dev/icons/pin
 */
export const PinIcon = (props: IconProps) => (
  <Icon icon={DefaultPinIcon} {...props} />
);

import { default as DefaultPinOffIcon } from '~icons/lucide/pin-off';

/**
 * @see https://lucide.dev/icons/pin-off
 */
export const PinOffIcon = (props: IconProps) => (
  <Icon icon={DefaultPinOffIcon} {...props} />
);

import { default as DefaultPipetteIcon } from '~icons/lucide/pipette';

/**
 * @see https://lucide.dev/icons/pipette
 */
export const PipetteIcon = (props: IconProps) => (
  <Icon icon={DefaultPipetteIcon} {...props} />
);

import { default as DefaultPizzaIcon } from '~icons/lucide/pizza';

/**
 * @see https://lucide.dev/icons/pizza
 */
export const PizzaIcon = (props: IconProps) => (
  <Icon icon={DefaultPizzaIcon} {...props} />
);

import { default as DefaultPlaneIcon } from '~icons/lucide/plane';

/**
 * @see https://lucide.dev/icons/plane
 */
export const PlaneIcon = (props: IconProps) => (
  <Icon icon={DefaultPlaneIcon} {...props} />
);

import { default as DefaultPlaneLandingIcon } from '~icons/lucide/plane-landing';

/**
 * @see https://lucide.dev/icons/plane-landing
 */
export const PlaneLandingIcon = (props: IconProps) => (
  <Icon icon={DefaultPlaneLandingIcon} {...props} />
);

import { default as DefaultPlaneTakeoffIcon } from '~icons/lucide/plane-takeoff';

/**
 * @see https://lucide.dev/icons/plane-takeoff
 */
export const PlaneTakeoffIcon = (props: IconProps) => (
  <Icon icon={DefaultPlaneTakeoffIcon} {...props} />
);

import { default as DefaultPlayIcon } from '~icons/lucide/play';

/**
 * @see https://lucide.dev/icons/play
 */
export const PlayIcon = (props: IconProps) => (
  <Icon icon={DefaultPlayIcon} {...props} />
);

import { default as DefaultPlugIcon } from '~icons/lucide/plug';

/**
 * @see https://lucide.dev/icons/plug
 */
export const PlugIcon = (props: IconProps) => (
  <Icon icon={DefaultPlugIcon} {...props} />
);

import { default as DefaultPlug2Icon } from '~icons/lucide/plug-2';

/**
 * @see https://lucide.dev/icons/plug-2
 */
export const Plug2Icon = (props: IconProps) => (
  <Icon icon={DefaultPlug2Icon} {...props} />
);

import { default as DefaultPlugZapIcon } from '~icons/lucide/plug-zap';

/**
 * @see https://lucide.dev/icons/plug-zap
 */
export const PlugZapIcon = (props: IconProps) => (
  <Icon icon={DefaultPlugZapIcon} {...props} />
);

import { default as DefaultPlusIcon } from '~icons/lucide/plus';

/**
 * @see https://lucide.dev/icons/plus
 */
export const PlusIcon = (props: IconProps) => (
  <Icon icon={DefaultPlusIcon} {...props} />
);

import { default as DefaultPocketIcon } from '~icons/lucide/pocket';

/**
 * @see https://lucide.dev/icons/pocket
 */
export const PocketIcon = (props: IconProps) => (
  <Icon icon={DefaultPocketIcon} {...props} />
);

import { default as DefaultPocketKnifeIcon } from '~icons/lucide/pocket-knife';

/**
 * @see https://lucide.dev/icons/pocket-knife
 */
export const PocketKnifeIcon = (props: IconProps) => (
  <Icon icon={DefaultPocketKnifeIcon} {...props} />
);

import { default as DefaultPodcastIcon } from '~icons/lucide/podcast';

/**
 * @see https://lucide.dev/icons/podcast
 */
export const PodcastIcon = (props: IconProps) => (
  <Icon icon={DefaultPodcastIcon} {...props} />
);

import { default as DefaultPointerIcon } from '~icons/lucide/pointer';

/**
 * @see https://lucide.dev/icons/pointer
 */
export const PointerIcon = (props: IconProps) => (
  <Icon icon={DefaultPointerIcon} {...props} />
);

import { default as DefaultPointerOffIcon } from '~icons/lucide/pointer-off';

/**
 * @see https://lucide.dev/icons/pointer-off
 */
export const PointerOffIcon = (props: IconProps) => (
  <Icon icon={DefaultPointerOffIcon} {...props} />
);

import { default as DefaultPopcornIcon } from '~icons/lucide/popcorn';

/**
 * @see https://lucide.dev/icons/popcorn
 */
export const PopcornIcon = (props: IconProps) => (
  <Icon icon={DefaultPopcornIcon} {...props} />
);

import { default as DefaultPopsicleIcon } from '~icons/lucide/popsicle';

/**
 * @see https://lucide.dev/icons/popsicle
 */
export const PopsicleIcon = (props: IconProps) => (
  <Icon icon={DefaultPopsicleIcon} {...props} />
);

import { default as DefaultPoundSterlingIcon } from '~icons/lucide/pound-sterling';

/**
 * @see https://lucide.dev/icons/pound-sterling
 */
export const PoundSterlingIcon = (props: IconProps) => (
  <Icon icon={DefaultPoundSterlingIcon} {...props} />
);

import { default as DefaultPowerIcon } from '~icons/lucide/power';

/**
 * @see https://lucide.dev/icons/power
 */
export const PowerIcon = (props: IconProps) => (
  <Icon icon={DefaultPowerIcon} {...props} />
);

import { default as DefaultPowerOffIcon } from '~icons/lucide/power-off';

/**
 * @see https://lucide.dev/icons/power-off
 */
export const PowerOffIcon = (props: IconProps) => (
  <Icon icon={DefaultPowerOffIcon} {...props} />
);

import { default as DefaultPresentationIcon } from '~icons/lucide/presentation';

/**
 * @see https://lucide.dev/icons/presentation
 */
export const PresentationIcon = (props: IconProps) => (
  <Icon icon={DefaultPresentationIcon} {...props} />
);

import { default as DefaultPrinterIcon } from '~icons/lucide/printer';

/**
 * @see https://lucide.dev/icons/printer
 */
export const PrinterIcon = (props: IconProps) => (
  <Icon icon={DefaultPrinterIcon} {...props} />
);

import { default as DefaultPrinterCheckIcon } from '~icons/lucide/printer-check';

/**
 * @see https://lucide.dev/icons/printer-check
 */
export const PrinterCheckIcon = (props: IconProps) => (
  <Icon icon={DefaultPrinterCheckIcon} {...props} />
);

import { default as DefaultProjectorIcon } from '~icons/lucide/projector';

/**
 * @see https://lucide.dev/icons/projector
 */
export const ProjectorIcon = (props: IconProps) => (
  <Icon icon={DefaultProjectorIcon} {...props} />
);

import { default as DefaultProportionsIcon } from '~icons/lucide/proportions';

/**
 * @see https://lucide.dev/icons/proportions
 */
export const ProportionsIcon = (props: IconProps) => (
  <Icon icon={DefaultProportionsIcon} {...props} />
);

import { default as DefaultPuzzleIcon } from '~icons/lucide/puzzle';

/**
 * @see https://lucide.dev/icons/puzzle
 */
export const PuzzleIcon = (props: IconProps) => (
  <Icon icon={DefaultPuzzleIcon} {...props} />
);

import { default as DefaultPyramidIcon } from '~icons/lucide/pyramid';

/**
 * @see https://lucide.dev/icons/pyramid
 */
export const PyramidIcon = (props: IconProps) => (
  <Icon icon={DefaultPyramidIcon} {...props} />
);

import { default as DefaultQrCodeIcon } from '~icons/lucide/qr-code';

/**
 * @see https://lucide.dev/icons/qr-code
 */
export const QrCodeIcon = (props: IconProps) => (
  <Icon icon={DefaultQrCodeIcon} {...props} />
);

import { default as DefaultQuoteIcon } from '~icons/lucide/quote';

/**
 * @see https://lucide.dev/icons/quote
 */
export const QuoteIcon = (props: IconProps) => (
  <Icon icon={DefaultQuoteIcon} {...props} />
);

import { default as DefaultRabbitIcon } from '~icons/lucide/rabbit';

/**
 * @see https://lucide.dev/icons/rabbit
 */
export const RabbitIcon = (props: IconProps) => (
  <Icon icon={DefaultRabbitIcon} {...props} />
);

import { default as DefaultRadarIcon } from '~icons/lucide/radar';

/**
 * @see https://lucide.dev/icons/radar
 */
export const RadarIcon = (props: IconProps) => (
  <Icon icon={DefaultRadarIcon} {...props} />
);

import { default as DefaultRadiationIcon } from '~icons/lucide/radiation';

/**
 * @see https://lucide.dev/icons/radiation
 */
export const RadiationIcon = (props: IconProps) => (
  <Icon icon={DefaultRadiationIcon} {...props} />
);

import { default as DefaultRadicalIcon } from '~icons/lucide/radical';

/**
 * @see https://lucide.dev/icons/radical
 */
export const RadicalIcon = (props: IconProps) => (
  <Icon icon={DefaultRadicalIcon} {...props} />
);

import { default as DefaultRadioIcon } from '~icons/lucide/radio';

/**
 * @see https://lucide.dev/icons/radio
 */
export const RadioIcon = (props: IconProps) => (
  <Icon icon={DefaultRadioIcon} {...props} />
);

import { default as DefaultRadioReceiverIcon } from '~icons/lucide/radio-receiver';

/**
 * @see https://lucide.dev/icons/radio-receiver
 */
export const RadioReceiverIcon = (props: IconProps) => (
  <Icon icon={DefaultRadioReceiverIcon} {...props} />
);

import { default as DefaultRadioTowerIcon } from '~icons/lucide/radio-tower';

/**
 * @see https://lucide.dev/icons/radio-tower
 */
export const RadioTowerIcon = (props: IconProps) => (
  <Icon icon={DefaultRadioTowerIcon} {...props} />
);

import { default as DefaultRadiusIcon } from '~icons/lucide/radius';

/**
 * @see https://lucide.dev/icons/radius
 */
export const RadiusIcon = (props: IconProps) => (
  <Icon icon={DefaultRadiusIcon} {...props} />
);

import { default as DefaultRailSymbolIcon } from '~icons/lucide/rail-symbol';

/**
 * @see https://lucide.dev/icons/rail-symbol
 */
export const RailSymbolIcon = (props: IconProps) => (
  <Icon icon={DefaultRailSymbolIcon} {...props} />
);

import { default as DefaultRainbowIcon } from '~icons/lucide/rainbow';

/**
 * @see https://lucide.dev/icons/rainbow
 */
export const RainbowIcon = (props: IconProps) => (
  <Icon icon={DefaultRainbowIcon} {...props} />
);

import { default as DefaultRatIcon } from '~icons/lucide/rat';

/**
 * @see https://lucide.dev/icons/rat
 */
export const RatIcon = (props: IconProps) => (
  <Icon icon={DefaultRatIcon} {...props} />
);

import { default as DefaultRatioIcon } from '~icons/lucide/ratio';

/**
 * @see https://lucide.dev/icons/ratio
 */
export const RatioIcon = (props: IconProps) => (
  <Icon icon={DefaultRatioIcon} {...props} />
);

import { default as DefaultReceiptIcon } from '~icons/lucide/receipt';

/**
 * @see https://lucide.dev/icons/receipt
 */
export const ReceiptIcon = (props: IconProps) => (
  <Icon icon={DefaultReceiptIcon} {...props} />
);

import { default as DefaultReceiptCentIcon } from '~icons/lucide/receipt-cent';

/**
 * @see https://lucide.dev/icons/receipt-cent
 */
export const ReceiptCentIcon = (props: IconProps) => (
  <Icon icon={DefaultReceiptCentIcon} {...props} />
);

import { default as DefaultReceiptEuroIcon } from '~icons/lucide/receipt-euro';

/**
 * @see https://lucide.dev/icons/receipt-euro
 */
export const ReceiptEuroIcon = (props: IconProps) => (
  <Icon icon={DefaultReceiptEuroIcon} {...props} />
);

import { default as DefaultReceiptIndianRupeeIcon } from '~icons/lucide/receipt-indian-rupee';

/**
 * @see https://lucide.dev/icons/receipt-indian-rupee
 */
export const ReceiptIndianRupeeIcon = (props: IconProps) => (
  <Icon icon={DefaultReceiptIndianRupeeIcon} {...props} />
);

import { default as DefaultReceiptJapaneseYenIcon } from '~icons/lucide/receipt-japanese-yen';

/**
 * @see https://lucide.dev/icons/receipt-japanese-yen
 */
export const ReceiptJapaneseYenIcon = (props: IconProps) => (
  <Icon icon={DefaultReceiptJapaneseYenIcon} {...props} />
);

import { default as DefaultReceiptPoundSterlingIcon } from '~icons/lucide/receipt-pound-sterling';

/**
 * @see https://lucide.dev/icons/receipt-pound-sterling
 */
export const ReceiptPoundSterlingIcon = (props: IconProps) => (
  <Icon icon={DefaultReceiptPoundSterlingIcon} {...props} />
);

import { default as DefaultReceiptRussianRubleIcon } from '~icons/lucide/receipt-russian-ruble';

/**
 * @see https://lucide.dev/icons/receipt-russian-ruble
 */
export const ReceiptRussianRubleIcon = (props: IconProps) => (
  <Icon icon={DefaultReceiptRussianRubleIcon} {...props} />
);

import { default as DefaultReceiptSwissFrancIcon } from '~icons/lucide/receipt-swiss-franc';

/**
 * @see https://lucide.dev/icons/receipt-swiss-franc
 */
export const ReceiptSwissFrancIcon = (props: IconProps) => (
  <Icon icon={DefaultReceiptSwissFrancIcon} {...props} />
);

import { default as DefaultReceiptTextIcon } from '~icons/lucide/receipt-text';

/**
 * @see https://lucide.dev/icons/receipt-text
 */
export const ReceiptTextIcon = (props: IconProps) => (
  <Icon icon={DefaultReceiptTextIcon} {...props} />
);

import { default as DefaultReceiptTurkishLiraIcon } from '~icons/lucide/receipt-turkish-lira';

/**
 * @see https://lucide.dev/icons/receipt-turkish-lira
 */
export const ReceiptTurkishLiraIcon = (props: IconProps) => (
  <Icon icon={DefaultReceiptTurkishLiraIcon} {...props} />
);

import { default as DefaultRectangleCircleIcon } from '~icons/lucide/rectangle-circle';

/**
 * @see https://lucide.dev/icons/rectangle-circle
 */
export const RectangleCircleIcon = (props: IconProps) => (
  <Icon icon={DefaultRectangleCircleIcon} {...props} />
);

import { default as DefaultRectangleEllipsisIcon } from '~icons/lucide/rectangle-ellipsis';

/**
 * @see https://lucide.dev/icons/rectangle-ellipsis
 */
export const RectangleEllipsisIcon = (props: IconProps) => (
  <Icon icon={DefaultRectangleEllipsisIcon} {...props} />
);

import { default as DefaultRectangleGogglesIcon } from '~icons/lucide/rectangle-goggles';

/**
 * @see https://lucide.dev/icons/rectangle-goggles
 */
export const RectangleGogglesIcon = (props: IconProps) => (
  <Icon icon={DefaultRectangleGogglesIcon} {...props} />
);

import { default as DefaultRectangleHorizontalIcon } from '~icons/lucide/rectangle-horizontal';

/**
 * @see https://lucide.dev/icons/rectangle-horizontal
 */
export const RectangleHorizontalIcon = (props: IconProps) => (
  <Icon icon={DefaultRectangleHorizontalIcon} {...props} />
);

import { default as DefaultRectangleVerticalIcon } from '~icons/lucide/rectangle-vertical';

/**
 * @see https://lucide.dev/icons/rectangle-vertical
 */
export const RectangleVerticalIcon = (props: IconProps) => (
  <Icon icon={DefaultRectangleVerticalIcon} {...props} />
);

import { default as DefaultRecycleIcon } from '~icons/lucide/recycle';

/**
 * @see https://lucide.dev/icons/recycle
 */
export const RecycleIcon = (props: IconProps) => (
  <Icon icon={DefaultRecycleIcon} {...props} />
);

import { default as DefaultRedoIcon } from '~icons/lucide/redo';

/**
 * @see https://lucide.dev/icons/redo
 */
export const RedoIcon = (props: IconProps) => (
  <Icon icon={DefaultRedoIcon} {...props} />
);

import { default as DefaultRedo2Icon } from '~icons/lucide/redo-2';

/**
 * @see https://lucide.dev/icons/redo-2
 */
export const Redo2Icon = (props: IconProps) => (
  <Icon icon={DefaultRedo2Icon} {...props} />
);

import { default as DefaultRedoDotIcon } from '~icons/lucide/redo-dot';

/**
 * @see https://lucide.dev/icons/redo-dot
 */
export const RedoDotIcon = (props: IconProps) => (
  <Icon icon={DefaultRedoDotIcon} {...props} />
);

import { default as DefaultRefreshCcwIcon } from '~icons/lucide/refresh-ccw';

/**
 * @see https://lucide.dev/icons/refresh-ccw
 */
export const RefreshCcwIcon = (props: IconProps) => (
  <Icon icon={DefaultRefreshCcwIcon} {...props} />
);

import { default as DefaultRefreshCcwDotIcon } from '~icons/lucide/refresh-ccw-dot';

/**
 * @see https://lucide.dev/icons/refresh-ccw-dot
 */
export const RefreshCcwDotIcon = (props: IconProps) => (
  <Icon icon={DefaultRefreshCcwDotIcon} {...props} />
);

import { default as DefaultRefreshCwIcon } from '~icons/lucide/refresh-cw';

/**
 * @see https://lucide.dev/icons/refresh-cw
 */
export const RefreshCwIcon = (props: IconProps) => (
  <Icon icon={DefaultRefreshCwIcon} {...props} />
);

import { default as DefaultRefreshCwOffIcon } from '~icons/lucide/refresh-cw-off';

/**
 * @see https://lucide.dev/icons/refresh-cw-off
 */
export const RefreshCwOffIcon = (props: IconProps) => (
  <Icon icon={DefaultRefreshCwOffIcon} {...props} />
);

import { default as DefaultRefrigeratorIcon } from '~icons/lucide/refrigerator';

/**
 * @see https://lucide.dev/icons/refrigerator
 */
export const RefrigeratorIcon = (props: IconProps) => (
  <Icon icon={DefaultRefrigeratorIcon} {...props} />
);

import { default as DefaultRegexIcon } from '~icons/lucide/regex';

/**
 * @see https://lucide.dev/icons/regex
 */
export const RegexIcon = (props: IconProps) => (
  <Icon icon={DefaultRegexIcon} {...props} />
);

import { default as DefaultRemoveFormattingIcon } from '~icons/lucide/remove-formatting';

/**
 * @see https://lucide.dev/icons/remove-formatting
 */
export const RemoveFormattingIcon = (props: IconProps) => (
  <Icon icon={DefaultRemoveFormattingIcon} {...props} />
);

import { default as DefaultRepeatIcon } from '~icons/lucide/repeat';

/**
 * @see https://lucide.dev/icons/repeat
 */
export const RepeatIcon = (props: IconProps) => (
  <Icon icon={DefaultRepeatIcon} {...props} />
);

import { default as DefaultRepeat1Icon } from '~icons/lucide/repeat-1';

/**
 * @see https://lucide.dev/icons/repeat-1
 */
export const Repeat1Icon = (props: IconProps) => (
  <Icon icon={DefaultRepeat1Icon} {...props} />
);

import { default as DefaultRepeat2Icon } from '~icons/lucide/repeat-2';

/**
 * @see https://lucide.dev/icons/repeat-2
 */
export const Repeat2Icon = (props: IconProps) => (
  <Icon icon={DefaultRepeat2Icon} {...props} />
);

import { default as DefaultReplaceIcon } from '~icons/lucide/replace';

/**
 * @see https://lucide.dev/icons/replace
 */
export const ReplaceIcon = (props: IconProps) => (
  <Icon icon={DefaultReplaceIcon} {...props} />
);

import { default as DefaultReplaceAllIcon } from '~icons/lucide/replace-all';

/**
 * @see https://lucide.dev/icons/replace-all
 */
export const ReplaceAllIcon = (props: IconProps) => (
  <Icon icon={DefaultReplaceAllIcon} {...props} />
);

import { default as DefaultReplyIcon } from '~icons/lucide/reply';

/**
 * @see https://lucide.dev/icons/reply
 */
export const ReplyIcon = (props: IconProps) => (
  <Icon icon={DefaultReplyIcon} {...props} />
);

import { default as DefaultReplyAllIcon } from '~icons/lucide/reply-all';

/**
 * @see https://lucide.dev/icons/reply-all
 */
export const ReplyAllIcon = (props: IconProps) => (
  <Icon icon={DefaultReplyAllIcon} {...props} />
);

import { default as DefaultRewindIcon } from '~icons/lucide/rewind';

/**
 * @see https://lucide.dev/icons/rewind
 */
export const RewindIcon = (props: IconProps) => (
  <Icon icon={DefaultRewindIcon} {...props} />
);

import { default as DefaultRibbonIcon } from '~icons/lucide/ribbon';

/**
 * @see https://lucide.dev/icons/ribbon
 */
export const RibbonIcon = (props: IconProps) => (
  <Icon icon={DefaultRibbonIcon} {...props} />
);

import { default as DefaultRocketIcon } from '~icons/lucide/rocket';

/**
 * @see https://lucide.dev/icons/rocket
 */
export const RocketIcon = (props: IconProps) => (
  <Icon icon={DefaultRocketIcon} {...props} />
);

import { default as DefaultRockingChairIcon } from '~icons/lucide/rocking-chair';

/**
 * @see https://lucide.dev/icons/rocking-chair
 */
export const RockingChairIcon = (props: IconProps) => (
  <Icon icon={DefaultRockingChairIcon} {...props} />
);

import { default as DefaultRollerCoasterIcon } from '~icons/lucide/roller-coaster';

/**
 * @see https://lucide.dev/icons/roller-coaster
 */
export const RollerCoasterIcon = (props: IconProps) => (
  <Icon icon={DefaultRollerCoasterIcon} {...props} />
);

import { default as DefaultRotate3dIcon } from '~icons/lucide/rotate-3d';

/**
 * @see https://lucide.dev/icons/rotate-3d
 */
export const Rotate3dIcon = (props: IconProps) => (
  <Icon icon={DefaultRotate3dIcon} {...props} />
);

import { default as DefaultRotateCcwIcon } from '~icons/lucide/rotate-ccw';

/**
 * @see https://lucide.dev/icons/rotate-ccw
 */
export const RotateCcwIcon = (props: IconProps) => (
  <Icon icon={DefaultRotateCcwIcon} {...props} />
);

import { default as DefaultRotateCcwKeyIcon } from '~icons/lucide/rotate-ccw-key';

/**
 * @see https://lucide.dev/icons/rotate-ccw-key
 */
export const RotateCcwKeyIcon = (props: IconProps) => (
  <Icon icon={DefaultRotateCcwKeyIcon} {...props} />
);

import { default as DefaultRotateCcwSquareIcon } from '~icons/lucide/rotate-ccw-square';

/**
 * @see https://lucide.dev/icons/rotate-ccw-square
 */
export const RotateCcwSquareIcon = (props: IconProps) => (
  <Icon icon={DefaultRotateCcwSquareIcon} {...props} />
);

import { default as DefaultRotateCwIcon } from '~icons/lucide/rotate-cw';

/**
 * @see https://lucide.dev/icons/rotate-cw
 */
export const RotateCwIcon = (props: IconProps) => (
  <Icon icon={DefaultRotateCwIcon} {...props} />
);

import { default as DefaultRotateCwSquareIcon } from '~icons/lucide/rotate-cw-square';

/**
 * @see https://lucide.dev/icons/rotate-cw-square
 */
export const RotateCwSquareIcon = (props: IconProps) => (
  <Icon icon={DefaultRotateCwSquareIcon} {...props} />
);

import { default as DefaultRouteIcon } from '~icons/lucide/route';

/**
 * @see https://lucide.dev/icons/route
 */
export const RouteIcon = (props: IconProps) => (
  <Icon icon={DefaultRouteIcon} {...props} />
);

import { default as DefaultRouteOffIcon } from '~icons/lucide/route-off';

/**
 * @see https://lucide.dev/icons/route-off
 */
export const RouteOffIcon = (props: IconProps) => (
  <Icon icon={DefaultRouteOffIcon} {...props} />
);

import { default as DefaultRouterIcon } from '~icons/lucide/router';

/**
 * @see https://lucide.dev/icons/router
 */
export const RouterIcon = (props: IconProps) => (
  <Icon icon={DefaultRouterIcon} {...props} />
);

import { default as DefaultRows2Icon } from '~icons/lucide/rows-2';

/**
 * @see https://lucide.dev/icons/rows-2
 */
export const Rows2Icon = (props: IconProps) => (
  <Icon icon={DefaultRows2Icon} {...props} />
);

import { default as DefaultRows3Icon } from '~icons/lucide/rows-3';

/**
 * @see https://lucide.dev/icons/rows-3
 */
export const Rows3Icon = (props: IconProps) => (
  <Icon icon={DefaultRows3Icon} {...props} />
);

import { default as DefaultRows4Icon } from '~icons/lucide/rows-4';

/**
 * @see https://lucide.dev/icons/rows-4
 */
export const Rows4Icon = (props: IconProps) => (
  <Icon icon={DefaultRows4Icon} {...props} />
);

import { default as DefaultRssIcon } from '~icons/lucide/rss';

/**
 * @see https://lucide.dev/icons/rss
 */
export const RssIcon = (props: IconProps) => (
  <Icon icon={DefaultRssIcon} {...props} />
);

import { default as DefaultRulerIcon } from '~icons/lucide/ruler';

/**
 * @see https://lucide.dev/icons/ruler
 */
export const RulerIcon = (props: IconProps) => (
  <Icon icon={DefaultRulerIcon} {...props} />
);

import { default as DefaultRulerDimensionLineIcon } from '~icons/lucide/ruler-dimension-line';

/**
 * @see https://lucide.dev/icons/ruler-dimension-line
 */
export const RulerDimensionLineIcon = (props: IconProps) => (
  <Icon icon={DefaultRulerDimensionLineIcon} {...props} />
);

import { default as DefaultRussianRubleIcon } from '~icons/lucide/russian-ruble';

/**
 * @see https://lucide.dev/icons/russian-ruble
 */
export const RussianRubleIcon = (props: IconProps) => (
  <Icon icon={DefaultRussianRubleIcon} {...props} />
);

import { default as DefaultSailboatIcon } from '~icons/lucide/sailboat';

/**
 * @see https://lucide.dev/icons/sailboat
 */
export const SailboatIcon = (props: IconProps) => (
  <Icon icon={DefaultSailboatIcon} {...props} />
);

import { default as DefaultSaladIcon } from '~icons/lucide/salad';

/**
 * @see https://lucide.dev/icons/salad
 */
export const SaladIcon = (props: IconProps) => (
  <Icon icon={DefaultSaladIcon} {...props} />
);

import { default as DefaultSandwichIcon } from '~icons/lucide/sandwich';

/**
 * @see https://lucide.dev/icons/sandwich
 */
export const SandwichIcon = (props: IconProps) => (
  <Icon icon={DefaultSandwichIcon} {...props} />
);

import { default as DefaultSatelliteIcon } from '~icons/lucide/satellite';

/**
 * @see https://lucide.dev/icons/satellite
 */
export const SatelliteIcon = (props: IconProps) => (
  <Icon icon={DefaultSatelliteIcon} {...props} />
);

import { default as DefaultSatelliteDishIcon } from '~icons/lucide/satellite-dish';

/**
 * @see https://lucide.dev/icons/satellite-dish
 */
export const SatelliteDishIcon = (props: IconProps) => (
  <Icon icon={DefaultSatelliteDishIcon} {...props} />
);

import { default as DefaultSaudiRiyalIcon } from '~icons/lucide/saudi-riyal';

/**
 * @see https://lucide.dev/icons/saudi-riyal
 */
export const SaudiRiyalIcon = (props: IconProps) => (
  <Icon icon={DefaultSaudiRiyalIcon} {...props} />
);

import { default as DefaultSaveIcon } from '~icons/lucide/save';

/**
 * @see https://lucide.dev/icons/save
 */
export const SaveIcon = (props: IconProps) => (
  <Icon icon={DefaultSaveIcon} {...props} />
);

import { default as DefaultSaveAllIcon } from '~icons/lucide/save-all';

/**
 * @see https://lucide.dev/icons/save-all
 */
export const SaveAllIcon = (props: IconProps) => (
  <Icon icon={DefaultSaveAllIcon} {...props} />
);

import { default as DefaultSaveOffIcon } from '~icons/lucide/save-off';

/**
 * @see https://lucide.dev/icons/save-off
 */
export const SaveOffIcon = (props: IconProps) => (
  <Icon icon={DefaultSaveOffIcon} {...props} />
);

import { default as DefaultScaleIcon } from '~icons/lucide/scale';

/**
 * @see https://lucide.dev/icons/scale
 */
export const ScaleIcon = (props: IconProps) => (
  <Icon icon={DefaultScaleIcon} {...props} />
);

import { default as DefaultScale3dIcon } from '~icons/lucide/scale-3d';

/**
 * @see https://lucide.dev/icons/scale-3d
 */
export const Scale3dIcon = (props: IconProps) => (
  <Icon icon={DefaultScale3dIcon} {...props} />
);

import { default as DefaultScalingIcon } from '~icons/lucide/scaling';

/**
 * @see https://lucide.dev/icons/scaling
 */
export const ScalingIcon = (props: IconProps) => (
  <Icon icon={DefaultScalingIcon} {...props} />
);

import { default as DefaultScanIcon } from '~icons/lucide/scan';

/**
 * @see https://lucide.dev/icons/scan
 */
export const ScanIcon = (props: IconProps) => (
  <Icon icon={DefaultScanIcon} {...props} />
);

import { default as DefaultScanBarcodeIcon } from '~icons/lucide/scan-barcode';

/**
 * @see https://lucide.dev/icons/scan-barcode
 */
export const ScanBarcodeIcon = (props: IconProps) => (
  <Icon icon={DefaultScanBarcodeIcon} {...props} />
);

import { default as DefaultScanEyeIcon } from '~icons/lucide/scan-eye';

/**
 * @see https://lucide.dev/icons/scan-eye
 */
export const ScanEyeIcon = (props: IconProps) => (
  <Icon icon={DefaultScanEyeIcon} {...props} />
);

import { default as DefaultScanFaceIcon } from '~icons/lucide/scan-face';

/**
 * @see https://lucide.dev/icons/scan-face
 */
export const ScanFaceIcon = (props: IconProps) => (
  <Icon icon={DefaultScanFaceIcon} {...props} />
);

import { default as DefaultScanHeartIcon } from '~icons/lucide/scan-heart';

/**
 * @see https://lucide.dev/icons/scan-heart
 */
export const ScanHeartIcon = (props: IconProps) => (
  <Icon icon={DefaultScanHeartIcon} {...props} />
);

import { default as DefaultScanLineIcon } from '~icons/lucide/scan-line';

/**
 * @see https://lucide.dev/icons/scan-line
 */
export const ScanLineIcon = (props: IconProps) => (
  <Icon icon={DefaultScanLineIcon} {...props} />
);

import { default as DefaultScanQrCodeIcon } from '~icons/lucide/scan-qr-code';

/**
 * @see https://lucide.dev/icons/scan-qr-code
 */
export const ScanQrCodeIcon = (props: IconProps) => (
  <Icon icon={DefaultScanQrCodeIcon} {...props} />
);

import { default as DefaultScanSearchIcon } from '~icons/lucide/scan-search';

/**
 * @see https://lucide.dev/icons/scan-search
 */
export const ScanSearchIcon = (props: IconProps) => (
  <Icon icon={DefaultScanSearchIcon} {...props} />
);

import { default as DefaultScanTextIcon } from '~icons/lucide/scan-text';

/**
 * @see https://lucide.dev/icons/scan-text
 */
export const ScanTextIcon = (props: IconProps) => (
  <Icon icon={DefaultScanTextIcon} {...props} />
);

import { default as DefaultScatterChartIcon } from '~icons/lucide/scatter-chart';

/**
 * @see https://lucide.dev/icons/scatter-chart
 */
export const ScatterChartIcon = (props: IconProps) => (
  <Icon icon={DefaultScatterChartIcon} {...props} />
);

import { default as DefaultSchoolIcon } from '~icons/lucide/school';

/**
 * @see https://lucide.dev/icons/school
 */
export const SchoolIcon = (props: IconProps) => (
  <Icon icon={DefaultSchoolIcon} {...props} />
);

import { default as DefaultScissorsIcon } from '~icons/lucide/scissors';

/**
 * @see https://lucide.dev/icons/scissors
 */
export const ScissorsIcon = (props: IconProps) => (
  <Icon icon={DefaultScissorsIcon} {...props} />
);

import { default as DefaultScissorsLineDashedIcon } from '~icons/lucide/scissors-line-dashed';

/**
 * @see https://lucide.dev/icons/scissors-line-dashed
 */
export const ScissorsLineDashedIcon = (props: IconProps) => (
  <Icon icon={DefaultScissorsLineDashedIcon} {...props} />
);

import { default as DefaultScreenShareIcon } from '~icons/lucide/screen-share';

/**
 * @see https://lucide.dev/icons/screen-share
 */
export const ScreenShareIcon = (props: IconProps) => (
  <Icon icon={DefaultScreenShareIcon} {...props} />
);

import { default as DefaultScreenShareOffIcon } from '~icons/lucide/screen-share-off';

/**
 * @see https://lucide.dev/icons/screen-share-off
 */
export const ScreenShareOffIcon = (props: IconProps) => (
  <Icon icon={DefaultScreenShareOffIcon} {...props} />
);

import { default as DefaultScrollIcon } from '~icons/lucide/scroll';

/**
 * @see https://lucide.dev/icons/scroll
 */
export const ScrollIcon = (props: IconProps) => (
  <Icon icon={DefaultScrollIcon} {...props} />
);

import { default as DefaultScrollTextIcon } from '~icons/lucide/scroll-text';

/**
 * @see https://lucide.dev/icons/scroll-text
 */
export const ScrollTextIcon = (props: IconProps) => (
  <Icon icon={DefaultScrollTextIcon} {...props} />
);

import { default as DefaultSearchIcon } from '~icons/lucide/search';

/**
 * @see https://lucide.dev/icons/search
 */
export const SearchIcon = (props: IconProps) => (
  <Icon icon={DefaultSearchIcon} {...props} />
);

import { default as DefaultSearchCheckIcon } from '~icons/lucide/search-check';

/**
 * @see https://lucide.dev/icons/search-check
 */
export const SearchCheckIcon = (props: IconProps) => (
  <Icon icon={DefaultSearchCheckIcon} {...props} />
);

import { default as DefaultSearchCodeIcon } from '~icons/lucide/search-code';

/**
 * @see https://lucide.dev/icons/search-code
 */
export const SearchCodeIcon = (props: IconProps) => (
  <Icon icon={DefaultSearchCodeIcon} {...props} />
);

import { default as DefaultSearchLargeIcon } from '~icons/lucide/search-large';

/**
 * @see https://lucide.dev/icons/search-large
 */
export const SearchLargeIcon = (props: IconProps) => (
  <Icon icon={DefaultSearchLargeIcon} {...props} />
);

import { default as DefaultSearchSlashIcon } from '~icons/lucide/search-slash';

/**
 * @see https://lucide.dev/icons/search-slash
 */
export const SearchSlashIcon = (props: IconProps) => (
  <Icon icon={DefaultSearchSlashIcon} {...props} />
);

import { default as DefaultSearchXIcon } from '~icons/lucide/search-x';

/**
 * @see https://lucide.dev/icons/search-x
 */
export const SearchXIcon = (props: IconProps) => (
  <Icon icon={DefaultSearchXIcon} {...props} />
);

import { default as DefaultSectionIcon } from '~icons/lucide/section';

/**
 * @see https://lucide.dev/icons/section
 */
export const SectionIcon = (props: IconProps) => (
  <Icon icon={DefaultSectionIcon} {...props} />
);

import { default as DefaultSendIcon } from '~icons/lucide/send';

/**
 * @see https://lucide.dev/icons/send
 */
export const SendIcon = (props: IconProps) => (
  <Icon icon={DefaultSendIcon} {...props} />
);

import { default as DefaultSendHorizontalIcon } from '~icons/lucide/send-horizontal';

/**
 * @see https://lucide.dev/icons/send-horizontal
 */
export const SendHorizontalIcon = (props: IconProps) => (
  <Icon icon={DefaultSendHorizontalIcon} {...props} />
);

import { default as DefaultSendToBackIcon } from '~icons/lucide/send-to-back';

/**
 * @see https://lucide.dev/icons/send-to-back
 */
export const SendToBackIcon = (props: IconProps) => (
  <Icon icon={DefaultSendToBackIcon} {...props} />
);

import { default as DefaultSeparatorHorizontalIcon } from '~icons/lucide/separator-horizontal';

/**
 * @see https://lucide.dev/icons/separator-horizontal
 */
export const SeparatorHorizontalIcon = (props: IconProps) => (
  <Icon icon={DefaultSeparatorHorizontalIcon} {...props} />
);

import { default as DefaultSeparatorVerticalIcon } from '~icons/lucide/separator-vertical';

/**
 * @see https://lucide.dev/icons/separator-vertical
 */
export const SeparatorVerticalIcon = (props: IconProps) => (
  <Icon icon={DefaultSeparatorVerticalIcon} {...props} />
);

import { default as DefaultServerIcon } from '~icons/lucide/server';

/**
 * @see https://lucide.dev/icons/server
 */
export const ServerIcon = (props: IconProps) => (
  <Icon icon={DefaultServerIcon} {...props} />
);

import { default as DefaultServerCogIcon } from '~icons/lucide/server-cog';

/**
 * @see https://lucide.dev/icons/server-cog
 */
export const ServerCogIcon = (props: IconProps) => (
  <Icon icon={DefaultServerCogIcon} {...props} />
);

import { default as DefaultServerCrashIcon } from '~icons/lucide/server-crash';

/**
 * @see https://lucide.dev/icons/server-crash
 */
export const ServerCrashIcon = (props: IconProps) => (
  <Icon icon={DefaultServerCrashIcon} {...props} />
);

import { default as DefaultServerOffIcon } from '~icons/lucide/server-off';

/**
 * @see https://lucide.dev/icons/server-off
 */
export const ServerOffIcon = (props: IconProps) => (
  <Icon icon={DefaultServerOffIcon} {...props} />
);

import { default as DefaultSettingsIcon } from '~icons/lucide/settings';

/**
 * @see https://lucide.dev/icons/settings
 */
export const SettingsIcon = (props: IconProps) => (
  <Icon icon={DefaultSettingsIcon} {...props} />
);

import { default as DefaultSettings2Icon } from '~icons/lucide/settings-2';

/**
 * @see https://lucide.dev/icons/settings-2
 */
export const Settings2Icon = (props: IconProps) => (
  <Icon icon={DefaultSettings2Icon} {...props} />
);

import { default as DefaultShapesIcon } from '~icons/lucide/shapes';

/**
 * @see https://lucide.dev/icons/shapes
 */
export const ShapesIcon = (props: IconProps) => (
  <Icon icon={DefaultShapesIcon} {...props} />
);

import { default as DefaultShareIcon } from '~icons/lucide/share';

/**
 * @see https://lucide.dev/icons/share
 */
export const ShareIcon = (props: IconProps) => (
  <Icon icon={DefaultShareIcon} {...props} />
);

import { default as DefaultShare2Icon } from '~icons/lucide/share-2';

/**
 * @see https://lucide.dev/icons/share-2
 */
export const Share2Icon = (props: IconProps) => (
  <Icon icon={DefaultShare2Icon} {...props} />
);

import { default as DefaultSheetIcon } from '~icons/lucide/sheet';

/**
 * @see https://lucide.dev/icons/sheet
 */
export const SheetIcon = (props: IconProps) => (
  <Icon icon={DefaultSheetIcon} {...props} />
);

import { default as DefaultShellIcon } from '~icons/lucide/shell';

/**
 * @see https://lucide.dev/icons/shell
 */
export const ShellIcon = (props: IconProps) => (
  <Icon icon={DefaultShellIcon} {...props} />
);

import { default as DefaultShieldIcon } from '~icons/lucide/shield';

/**
 * @see https://lucide.dev/icons/shield
 */
export const ShieldIcon = (props: IconProps) => (
  <Icon icon={DefaultShieldIcon} {...props} />
);

import { default as DefaultShieldAlertIcon } from '~icons/lucide/shield-alert';

/**
 * @see https://lucide.dev/icons/shield-alert
 */
export const ShieldAlertIcon = (props: IconProps) => (
  <Icon icon={DefaultShieldAlertIcon} {...props} />
);

import { default as DefaultShieldBanIcon } from '~icons/lucide/shield-ban';

/**
 * @see https://lucide.dev/icons/shield-ban
 */
export const ShieldBanIcon = (props: IconProps) => (
  <Icon icon={DefaultShieldBanIcon} {...props} />
);

import { default as DefaultShieldCheckIcon } from '~icons/lucide/shield-check';

/**
 * @see https://lucide.dev/icons/shield-check
 */
export const ShieldCheckIcon = (props: IconProps) => (
  <Icon icon={DefaultShieldCheckIcon} {...props} />
);

import { default as DefaultShieldEllipsisIcon } from '~icons/lucide/shield-ellipsis';

/**
 * @see https://lucide.dev/icons/shield-ellipsis
 */
export const ShieldEllipsisIcon = (props: IconProps) => (
  <Icon icon={DefaultShieldEllipsisIcon} {...props} />
);

import { default as DefaultShieldHalfIcon } from '~icons/lucide/shield-half';

/**
 * @see https://lucide.dev/icons/shield-half
 */
export const ShieldHalfIcon = (props: IconProps) => (
  <Icon icon={DefaultShieldHalfIcon} {...props} />
);

import { default as DefaultShieldMinusIcon } from '~icons/lucide/shield-minus';

/**
 * @see https://lucide.dev/icons/shield-minus
 */
export const ShieldMinusIcon = (props: IconProps) => (
  <Icon icon={DefaultShieldMinusIcon} {...props} />
);

import { default as DefaultShieldOffIcon } from '~icons/lucide/shield-off';

/**
 * @see https://lucide.dev/icons/shield-off
 */
export const ShieldOffIcon = (props: IconProps) => (
  <Icon icon={DefaultShieldOffIcon} {...props} />
);

import { default as DefaultShieldPlusIcon } from '~icons/lucide/shield-plus';

/**
 * @see https://lucide.dev/icons/shield-plus
 */
export const ShieldPlusIcon = (props: IconProps) => (
  <Icon icon={DefaultShieldPlusIcon} {...props} />
);

import { default as DefaultShieldQuestionMarkIcon } from '~icons/lucide/shield-question-mark';

/**
 * @see https://lucide.dev/icons/shield-question-mark
 */
export const ShieldQuestionMarkIcon = (props: IconProps) => (
  <Icon icon={DefaultShieldQuestionMarkIcon} {...props} />
);

import { default as DefaultShieldUserIcon } from '~icons/lucide/shield-user';

/**
 * @see https://lucide.dev/icons/shield-user
 */
export const ShieldUserIcon = (props: IconProps) => (
  <Icon icon={DefaultShieldUserIcon} {...props} />
);

import { default as DefaultShieldXIcon } from '~icons/lucide/shield-x';

/**
 * @see https://lucide.dev/icons/shield-x
 */
export const ShieldXIcon = (props: IconProps) => (
  <Icon icon={DefaultShieldXIcon} {...props} />
);

import { default as DefaultShipIcon } from '~icons/lucide/ship';

/**
 * @see https://lucide.dev/icons/ship
 */
export const ShipIcon = (props: IconProps) => (
  <Icon icon={DefaultShipIcon} {...props} />
);

import { default as DefaultShipWheelIcon } from '~icons/lucide/ship-wheel';

/**
 * @see https://lucide.dev/icons/ship-wheel
 */
export const ShipWheelIcon = (props: IconProps) => (
  <Icon icon={DefaultShipWheelIcon} {...props} />
);

import { default as DefaultShirtIcon } from '~icons/lucide/shirt';

/**
 * @see https://lucide.dev/icons/shirt
 */
export const ShirtIcon = (props: IconProps) => (
  <Icon icon={DefaultShirtIcon} {...props} />
);

import { default as DefaultShoppingBagIcon } from '~icons/lucide/shopping-bag';

/**
 * @see https://lucide.dev/icons/shopping-bag
 */
export const ShoppingBagIcon = (props: IconProps) => (
  <Icon icon={DefaultShoppingBagIcon} {...props} />
);

import { default as DefaultShoppingBasketIcon } from '~icons/lucide/shopping-basket';

/**
 * @see https://lucide.dev/icons/shopping-basket
 */
export const ShoppingBasketIcon = (props: IconProps) => (
  <Icon icon={DefaultShoppingBasketIcon} {...props} />
);

import { default as DefaultShoppingCartIcon } from '~icons/lucide/shopping-cart';

/**
 * @see https://lucide.dev/icons/shopping-cart
 */
export const ShoppingCartIcon = (props: IconProps) => (
  <Icon icon={DefaultShoppingCartIcon} {...props} />
);

import { default as DefaultShovelIcon } from '~icons/lucide/shovel';

/**
 * @see https://lucide.dev/icons/shovel
 */
export const ShovelIcon = (props: IconProps) => (
  <Icon icon={DefaultShovelIcon} {...props} />
);

import { default as DefaultShowerHeadIcon } from '~icons/lucide/shower-head';

/**
 * @see https://lucide.dev/icons/shower-head
 */
export const ShowerHeadIcon = (props: IconProps) => (
  <Icon icon={DefaultShowerHeadIcon} {...props} />
);

import { default as DefaultShredderIcon } from '~icons/lucide/shredder';

/**
 * @see https://lucide.dev/icons/shredder
 */
export const ShredderIcon = (props: IconProps) => (
  <Icon icon={DefaultShredderIcon} {...props} />
);

import { default as DefaultShrimpIcon } from '~icons/lucide/shrimp';

/**
 * @see https://lucide.dev/icons/shrimp
 */
export const ShrimpIcon = (props: IconProps) => (
  <Icon icon={DefaultShrimpIcon} {...props} />
);

import { default as DefaultShrinkIcon } from '~icons/lucide/shrink';

/**
 * @see https://lucide.dev/icons/shrink
 */
export const ShrinkIcon = (props: IconProps) => (
  <Icon icon={DefaultShrinkIcon} {...props} />
);

import { default as DefaultShrubIcon } from '~icons/lucide/shrub';

/**
 * @see https://lucide.dev/icons/shrub
 */
export const ShrubIcon = (props: IconProps) => (
  <Icon icon={DefaultShrubIcon} {...props} />
);

import { default as DefaultShuffleIcon } from '~icons/lucide/shuffle';

/**
 * @see https://lucide.dev/icons/shuffle
 */
export const ShuffleIcon = (props: IconProps) => (
  <Icon icon={DefaultShuffleIcon} {...props} />
);

import { default as DefaultSigmaIcon } from '~icons/lucide/sigma';

/**
 * @see https://lucide.dev/icons/sigma
 */
export const SigmaIcon = (props: IconProps) => (
  <Icon icon={DefaultSigmaIcon} {...props} />
);

import { default as DefaultSignalIcon } from '~icons/lucide/signal';

/**
 * @see https://lucide.dev/icons/signal
 */
export const SignalIcon = (props: IconProps) => (
  <Icon icon={DefaultSignalIcon} {...props} />
);

import { default as DefaultSignalHighIcon } from '~icons/lucide/signal-high';

/**
 * @see https://lucide.dev/icons/signal-high
 */
export const SignalHighIcon = (props: IconProps) => (
  <Icon icon={DefaultSignalHighIcon} {...props} />
);

import { default as DefaultSignalLowIcon } from '~icons/lucide/signal-low';

/**
 * @see https://lucide.dev/icons/signal-low
 */
export const SignalLowIcon = (props: IconProps) => (
  <Icon icon={DefaultSignalLowIcon} {...props} />
);

import { default as DefaultSignalMediumIcon } from '~icons/lucide/signal-medium';

/**
 * @see https://lucide.dev/icons/signal-medium
 */
export const SignalMediumIcon = (props: IconProps) => (
  <Icon icon={DefaultSignalMediumIcon} {...props} />
);

import { default as DefaultSignalZeroIcon } from '~icons/lucide/signal-zero';

/**
 * @see https://lucide.dev/icons/signal-zero
 */
export const SignalZeroIcon = (props: IconProps) => (
  <Icon icon={DefaultSignalZeroIcon} {...props} />
);

import { default as DefaultSignatureIcon } from '~icons/lucide/signature';

/**
 * @see https://lucide.dev/icons/signature
 */
export const SignatureIcon = (props: IconProps) => (
  <Icon icon={DefaultSignatureIcon} {...props} />
);

import { default as DefaultSignpostIcon } from '~icons/lucide/signpost';

/**
 * @see https://lucide.dev/icons/signpost
 */
export const SignpostIcon = (props: IconProps) => (
  <Icon icon={DefaultSignpostIcon} {...props} />
);

import { default as DefaultSignpostBigIcon } from '~icons/lucide/signpost-big';

/**
 * @see https://lucide.dev/icons/signpost-big
 */
export const SignpostBigIcon = (props: IconProps) => (
  <Icon icon={DefaultSignpostBigIcon} {...props} />
);

import { default as DefaultSirenIcon } from '~icons/lucide/siren';

/**
 * @see https://lucide.dev/icons/siren
 */
export const SirenIcon = (props: IconProps) => (
  <Icon icon={DefaultSirenIcon} {...props} />
);

import { default as DefaultSkipBackIcon } from '~icons/lucide/skip-back';

/**
 * @see https://lucide.dev/icons/skip-back
 */
export const SkipBackIcon = (props: IconProps) => (
  <Icon icon={DefaultSkipBackIcon} {...props} />
);

import { default as DefaultSkipForwardIcon } from '~icons/lucide/skip-forward';

/**
 * @see https://lucide.dev/icons/skip-forward
 */
export const SkipForwardIcon = (props: IconProps) => (
  <Icon icon={DefaultSkipForwardIcon} {...props} />
);

import { default as DefaultSkullIcon } from '~icons/lucide/skull';

/**
 * @see https://lucide.dev/icons/skull
 */
export const SkullIcon = (props: IconProps) => (
  <Icon icon={DefaultSkullIcon} {...props} />
);

import { default as DefaultSlackIcon } from '~icons/lucide/slack';

/**
 * @see https://lucide.dev/icons/slack
 */
export const SlackIcon = (props: IconProps) => (
  <Icon icon={DefaultSlackIcon} {...props} />
);

import { default as DefaultSlashIcon } from '~icons/lucide/slash';

/**
 * @see https://lucide.dev/icons/slash
 */
export const SlashIcon = (props: IconProps) => (
  <Icon icon={DefaultSlashIcon} {...props} />
);

import { default as DefaultSliceIcon } from '~icons/lucide/slice';

/**
 * @see https://lucide.dev/icons/slice
 */
export const SliceIcon = (props: IconProps) => (
  <Icon icon={DefaultSliceIcon} {...props} />
);

import { default as DefaultSlidersHorizontalIcon } from '~icons/lucide/sliders-horizontal';

/**
 * @see https://lucide.dev/icons/sliders-horizontal
 */
export const SlidersHorizontalIcon = (props: IconProps) => (
  <Icon icon={DefaultSlidersHorizontalIcon} {...props} />
);

import { default as DefaultSlidersVerticalIcon } from '~icons/lucide/sliders-vertical';

/**
 * @see https://lucide.dev/icons/sliders-vertical
 */
export const SlidersVerticalIcon = (props: IconProps) => (
  <Icon icon={DefaultSlidersVerticalIcon} {...props} />
);

import { default as DefaultSmartphoneIcon } from '~icons/lucide/smartphone';

/**
 * @see https://lucide.dev/icons/smartphone
 */
export const SmartphoneIcon = (props: IconProps) => (
  <Icon icon={DefaultSmartphoneIcon} {...props} />
);

import { default as DefaultSmartphoneChargingIcon } from '~icons/lucide/smartphone-charging';

/**
 * @see https://lucide.dev/icons/smartphone-charging
 */
export const SmartphoneChargingIcon = (props: IconProps) => (
  <Icon icon={DefaultSmartphoneChargingIcon} {...props} />
);

import { default as DefaultSmartphoneNfcIcon } from '~icons/lucide/smartphone-nfc';

/**
 * @see https://lucide.dev/icons/smartphone-nfc
 */
export const SmartphoneNfcIcon = (props: IconProps) => (
  <Icon icon={DefaultSmartphoneNfcIcon} {...props} />
);

import { default as DefaultSmileIcon } from '~icons/lucide/smile';

/**
 * @see https://lucide.dev/icons/smile
 */
export const SmileIcon = (props: IconProps) => (
  <Icon icon={DefaultSmileIcon} {...props} />
);

import { default as DefaultSmilePlusIcon } from '~icons/lucide/smile-plus';

/**
 * @see https://lucide.dev/icons/smile-plus
 */
export const SmilePlusIcon = (props: IconProps) => (
  <Icon icon={DefaultSmilePlusIcon} {...props} />
);

import { default as DefaultSnailIcon } from '~icons/lucide/snail';

/**
 * @see https://lucide.dev/icons/snail
 */
export const SnailIcon = (props: IconProps) => (
  <Icon icon={DefaultSnailIcon} {...props} />
);

import { default as DefaultSnowflakeIcon } from '~icons/lucide/snowflake';

/**
 * @see https://lucide.dev/icons/snowflake
 */
export const SnowflakeIcon = (props: IconProps) => (
  <Icon icon={DefaultSnowflakeIcon} {...props} />
);

import { default as DefaultSoapDispenserDropletIcon } from '~icons/lucide/soap-dispenser-droplet';

/**
 * @see https://lucide.dev/icons/soap-dispenser-droplet
 */
export const SoapDispenserDropletIcon = (props: IconProps) => (
  <Icon icon={DefaultSoapDispenserDropletIcon} {...props} />
);

import { default as DefaultSofaIcon } from '~icons/lucide/sofa';

/**
 * @see https://lucide.dev/icons/sofa
 */
export const SofaIcon = (props: IconProps) => (
  <Icon icon={DefaultSofaIcon} {...props} />
);

import { default as DefaultSoupIcon } from '~icons/lucide/soup';

/**
 * @see https://lucide.dev/icons/soup
 */
export const SoupIcon = (props: IconProps) => (
  <Icon icon={DefaultSoupIcon} {...props} />
);

import { default as DefaultSpaceIcon } from '~icons/lucide/space';

/**
 * @see https://lucide.dev/icons/space
 */
export const SpaceIcon = (props: IconProps) => (
  <Icon icon={DefaultSpaceIcon} {...props} />
);

import { default as DefaultSpadeIcon } from '~icons/lucide/spade';

/**
 * @see https://lucide.dev/icons/spade
 */
export const SpadeIcon = (props: IconProps) => (
  <Icon icon={DefaultSpadeIcon} {...props} />
);

import { default as DefaultSparkleIcon } from '~icons/lucide/sparkle';

/**
 * @see https://lucide.dev/icons/sparkle
 */
export const SparkleIcon = (props: IconProps) => (
  <Icon icon={DefaultSparkleIcon} {...props} />
);

import { default as DefaultSparklesIcon } from '~icons/lucide/sparkles';

/**
 * @see https://lucide.dev/icons/sparkles
 */
export const SparklesIcon = (props: IconProps) => (
  <Icon icon={DefaultSparklesIcon} {...props} />
);

import { default as DefaultSpeakerIcon } from '~icons/lucide/speaker';

/**
 * @see https://lucide.dev/icons/speaker
 */
export const SpeakerIcon = (props: IconProps) => (
  <Icon icon={DefaultSpeakerIcon} {...props} />
);

import { default as DefaultSpeechIcon } from '~icons/lucide/speech';

/**
 * @see https://lucide.dev/icons/speech
 */
export const SpeechIcon = (props: IconProps) => (
  <Icon icon={DefaultSpeechIcon} {...props} />
);

import { default as DefaultSpellCheckIcon } from '~icons/lucide/spell-check';

/**
 * @see https://lucide.dev/icons/spell-check
 */
export const SpellCheckIcon = (props: IconProps) => (
  <Icon icon={DefaultSpellCheckIcon} {...props} />
);

import { default as DefaultSpellCheck2Icon } from '~icons/lucide/spell-check-2';

/**
 * @see https://lucide.dev/icons/spell-check-2
 */
export const SpellCheck2Icon = (props: IconProps) => (
  <Icon icon={DefaultSpellCheck2Icon} {...props} />
);

import { default as DefaultSplineIcon } from '~icons/lucide/spline';

/**
 * @see https://lucide.dev/icons/spline
 */
export const SplineIcon = (props: IconProps) => (
  <Icon icon={DefaultSplineIcon} {...props} />
);

import { default as DefaultSplinePointerIcon } from '~icons/lucide/spline-pointer';

/**
 * @see https://lucide.dev/icons/spline-pointer
 */
export const SplinePointerIcon = (props: IconProps) => (
  <Icon icon={DefaultSplinePointerIcon} {...props} />
);

import { default as DefaultSplitIcon } from '~icons/lucide/split';

/**
 * @see https://lucide.dev/icons/split
 */
export const SplitIcon = (props: IconProps) => (
  <Icon icon={DefaultSplitIcon} {...props} />
);

import { default as DefaultSpoolIcon } from '~icons/lucide/spool';

/**
 * @see https://lucide.dev/icons/spool
 */
export const SpoolIcon = (props: IconProps) => (
  <Icon icon={DefaultSpoolIcon} {...props} />
);

import { default as DefaultSprayCanIcon } from '~icons/lucide/spray-can';

/**
 * @see https://lucide.dev/icons/spray-can
 */
export const SprayCanIcon = (props: IconProps) => (
  <Icon icon={DefaultSprayCanIcon} {...props} />
);

import { default as DefaultSproutIcon } from '~icons/lucide/sprout';

/**
 * @see https://lucide.dev/icons/sprout
 */
export const SproutIcon = (props: IconProps) => (
  <Icon icon={DefaultSproutIcon} {...props} />
);

import { default as DefaultSquareIcon } from '~icons/lucide/square';

/**
 * @see https://lucide.dev/icons/square
 */
export const SquareIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareIcon} {...props} />
);

import { default as DefaultSquareActivityIcon } from '~icons/lucide/square-activity';

/**
 * @see https://lucide.dev/icons/square-activity
 */
export const SquareActivityIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareActivityIcon} {...props} />
);

import { default as DefaultSquareArrowDownIcon } from '~icons/lucide/square-arrow-down';

/**
 * @see https://lucide.dev/icons/square-arrow-down
 */
export const SquareArrowDownIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareArrowDownIcon} {...props} />
);

import { default as DefaultSquareArrowDownLeftIcon } from '~icons/lucide/square-arrow-down-left';

/**
 * @see https://lucide.dev/icons/square-arrow-down-left
 */
export const SquareArrowDownLeftIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareArrowDownLeftIcon} {...props} />
);

import { default as DefaultSquareArrowDownRightIcon } from '~icons/lucide/square-arrow-down-right';

/**
 * @see https://lucide.dev/icons/square-arrow-down-right
 */
export const SquareArrowDownRightIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareArrowDownRightIcon} {...props} />
);

import { default as DefaultSquareArrowLeftIcon } from '~icons/lucide/square-arrow-left';

/**
 * @see https://lucide.dev/icons/square-arrow-left
 */
export const SquareArrowLeftIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareArrowLeftIcon} {...props} />
);

import { default as DefaultSquareArrowOutDownLeftIcon } from '~icons/lucide/square-arrow-out-down-left';

/**
 * @see https://lucide.dev/icons/square-arrow-out-down-left
 */
export const SquareArrowOutDownLeftIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareArrowOutDownLeftIcon} {...props} />
);

import { default as DefaultSquareArrowOutDownRightIcon } from '~icons/lucide/square-arrow-out-down-right';

/**
 * @see https://lucide.dev/icons/square-arrow-out-down-right
 */
export const SquareArrowOutDownRightIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareArrowOutDownRightIcon} {...props} />
);

import { default as DefaultSquareArrowOutUpLeftIcon } from '~icons/lucide/square-arrow-out-up-left';

/**
 * @see https://lucide.dev/icons/square-arrow-out-up-left
 */
export const SquareArrowOutUpLeftIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareArrowOutUpLeftIcon} {...props} />
);

import { default as DefaultSquareArrowOutUpRightIcon } from '~icons/lucide/square-arrow-out-up-right';

/**
 * @see https://lucide.dev/icons/square-arrow-out-up-right
 */
export const SquareArrowOutUpRightIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareArrowOutUpRightIcon} {...props} />
);

import { default as DefaultSquareArrowRightIcon } from '~icons/lucide/square-arrow-right';

/**
 * @see https://lucide.dev/icons/square-arrow-right
 */
export const SquareArrowRightIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareArrowRightIcon} {...props} />
);

import { default as DefaultSquareArrowUpIcon } from '~icons/lucide/square-arrow-up';

/**
 * @see https://lucide.dev/icons/square-arrow-up
 */
export const SquareArrowUpIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareArrowUpIcon} {...props} />
);

import { default as DefaultSquareArrowUpLeftIcon } from '~icons/lucide/square-arrow-up-left';

/**
 * @see https://lucide.dev/icons/square-arrow-up-left
 */
export const SquareArrowUpLeftIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareArrowUpLeftIcon} {...props} />
);

import { default as DefaultSquareArrowUpRightIcon } from '~icons/lucide/square-arrow-up-right';

/**
 * @see https://lucide.dev/icons/square-arrow-up-right
 */
export const SquareArrowUpRightIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareArrowUpRightIcon} {...props} />
);

import { default as DefaultSquareAsteriskIcon } from '~icons/lucide/square-asterisk';

/**
 * @see https://lucide.dev/icons/square-asterisk
 */
export const SquareAsteriskIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareAsteriskIcon} {...props} />
);

import { default as DefaultSquareBottomDashedScissorsIcon } from '~icons/lucide/square-bottom-dashed-scissors';

/**
 * @see https://lucide.dev/icons/square-bottom-dashed-scissors
 */
export const SquareBottomDashedScissorsIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareBottomDashedScissorsIcon} {...props} />
);

import { default as DefaultSquareChartGanttIcon } from '~icons/lucide/square-chart-gantt';

/**
 * @see https://lucide.dev/icons/square-chart-gantt
 */
export const SquareChartGanttIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareChartGanttIcon} {...props} />
);

import { default as DefaultSquareCheckIcon } from '~icons/lucide/square-check';

/**
 * @see https://lucide.dev/icons/square-check
 */
export const SquareCheckIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareCheckIcon} {...props} />
);

import { default as DefaultSquareCheckBigIcon } from '~icons/lucide/square-check-big';

/**
 * @see https://lucide.dev/icons/square-check-big
 */
export const SquareCheckBigIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareCheckBigIcon} {...props} />
);

import { default as DefaultSquareChevronDownIcon } from '~icons/lucide/square-chevron-down';

/**
 * @see https://lucide.dev/icons/square-chevron-down
 */
export const SquareChevronDownIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareChevronDownIcon} {...props} />
);

import { default as DefaultSquareChevronLeftIcon } from '~icons/lucide/square-chevron-left';

/**
 * @see https://lucide.dev/icons/square-chevron-left
 */
export const SquareChevronLeftIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareChevronLeftIcon} {...props} />
);

import { default as DefaultSquareChevronRightIcon } from '~icons/lucide/square-chevron-right';

/**
 * @see https://lucide.dev/icons/square-chevron-right
 */
export const SquareChevronRightIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareChevronRightIcon} {...props} />
);

import { default as DefaultSquareChevronUpIcon } from '~icons/lucide/square-chevron-up';

/**
 * @see https://lucide.dev/icons/square-chevron-up
 */
export const SquareChevronUpIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareChevronUpIcon} {...props} />
);

import { default as DefaultSquareCodeIcon } from '~icons/lucide/square-code';

/**
 * @see https://lucide.dev/icons/square-code
 */
export const SquareCodeIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareCodeIcon} {...props} />
);

import { default as DefaultSquareDashedIcon } from '~icons/lucide/square-dashed';

/**
 * @see https://lucide.dev/icons/square-dashed
 */
export const SquareDashedIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareDashedIcon} {...props} />
);

import { default as DefaultSquareDashedBottomIcon } from '~icons/lucide/square-dashed-bottom';

/**
 * @see https://lucide.dev/icons/square-dashed-bottom
 */
export const SquareDashedBottomIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareDashedBottomIcon} {...props} />
);

import { default as DefaultSquareDashedBottomCodeIcon } from '~icons/lucide/square-dashed-bottom-code';

/**
 * @see https://lucide.dev/icons/square-dashed-bottom-code
 */
export const SquareDashedBottomCodeIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareDashedBottomCodeIcon} {...props} />
);

import { default as DefaultSquareDashedKanbanIcon } from '~icons/lucide/square-dashed-kanban';

/**
 * @see https://lucide.dev/icons/square-dashed-kanban
 */
export const SquareDashedKanbanIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareDashedKanbanIcon} {...props} />
);

import { default as DefaultSquareDashedMousePointerIcon } from '~icons/lucide/square-dashed-mouse-pointer';

/**
 * @see https://lucide.dev/icons/square-dashed-mouse-pointer
 */
export const SquareDashedMousePointerIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareDashedMousePointerIcon} {...props} />
);

import { default as DefaultSquareDashedTopSolidIcon } from '~icons/lucide/square-dashed-top-solid';

/**
 * @see https://lucide.dev/icons/square-dashed-top-solid
 */
export const SquareDashedTopSolidIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareDashedTopSolidIcon} {...props} />
);

import { default as DefaultSquareDivideIcon } from '~icons/lucide/square-divide';

/**
 * @see https://lucide.dev/icons/square-divide
 */
export const SquareDivideIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareDivideIcon} {...props} />
);

import { default as DefaultSquareDotIcon } from '~icons/lucide/square-dot';

/**
 * @see https://lucide.dev/icons/square-dot
 */
export const SquareDotIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareDotIcon} {...props} />
);

import { default as DefaultSquareEqualIcon } from '~icons/lucide/square-equal';

/**
 * @see https://lucide.dev/icons/square-equal
 */
export const SquareEqualIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareEqualIcon} {...props} />
);

import { default as DefaultSquareFunctionIcon } from '~icons/lucide/square-function';

/**
 * @see https://lucide.dev/icons/square-function
 */
export const SquareFunctionIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareFunctionIcon} {...props} />
);

import { default as DefaultSquareKanbanIcon } from '~icons/lucide/square-kanban';

/**
 * @see https://lucide.dev/icons/square-kanban
 */
export const SquareKanbanIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareKanbanIcon} {...props} />
);

import { default as DefaultSquareLibraryIcon } from '~icons/lucide/square-library';

/**
 * @see https://lucide.dev/icons/square-library
 */
export const SquareLibraryIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareLibraryIcon} {...props} />
);

import { default as DefaultSquareMIcon } from '~icons/lucide/square-m';

/**
 * @see https://lucide.dev/icons/square-m
 */
export const SquareMIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareMIcon} {...props} />
);

import { default as DefaultSquareMenuIcon } from '~icons/lucide/square-menu';

/**
 * @see https://lucide.dev/icons/square-menu
 */
export const SquareMenuIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareMenuIcon} {...props} />
);

import { default as DefaultSquareMinusIcon } from '~icons/lucide/square-minus';

/**
 * @see https://lucide.dev/icons/square-minus
 */
export const SquareMinusIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareMinusIcon} {...props} />
);

import { default as DefaultSquareMousePointerIcon } from '~icons/lucide/square-mouse-pointer';

/**
 * @see https://lucide.dev/icons/square-mouse-pointer
 */
export const SquareMousePointerIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareMousePointerIcon} {...props} />
);

import { default as DefaultSquareParkingIcon } from '~icons/lucide/square-parking';

/**
 * @see https://lucide.dev/icons/square-parking
 */
export const SquareParkingIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareParkingIcon} {...props} />
);

import { default as DefaultSquareParkingOffIcon } from '~icons/lucide/square-parking-off';

/**
 * @see https://lucide.dev/icons/square-parking-off
 */
export const SquareParkingOffIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareParkingOffIcon} {...props} />
);

import { default as DefaultSquarePenIcon } from '~icons/lucide/square-pen';

/**
 * @see https://lucide.dev/icons/square-pen
 */
export const SquarePenIcon = (props: IconProps) => (
  <Icon icon={DefaultSquarePenIcon} {...props} />
);

import { default as DefaultSquarePercentIcon } from '~icons/lucide/square-percent';

/**
 * @see https://lucide.dev/icons/square-percent
 */
export const SquarePercentIcon = (props: IconProps) => (
  <Icon icon={DefaultSquarePercentIcon} {...props} />
);

import { default as DefaultSquarePiIcon } from '~icons/lucide/square-pi';

/**
 * @see https://lucide.dev/icons/square-pi
 */
export const SquarePiIcon = (props: IconProps) => (
  <Icon icon={DefaultSquarePiIcon} {...props} />
);

import { default as DefaultSquarePilcrowIcon } from '~icons/lucide/square-pilcrow';

/**
 * @see https://lucide.dev/icons/square-pilcrow
 */
export const SquarePilcrowIcon = (props: IconProps) => (
  <Icon icon={DefaultSquarePilcrowIcon} {...props} />
);

import { default as DefaultSquarePlayIcon } from '~icons/lucide/square-play';

/**
 * @see https://lucide.dev/icons/square-play
 */
export const SquarePlayIcon = (props: IconProps) => (
  <Icon icon={DefaultSquarePlayIcon} {...props} />
);

import { default as DefaultSquarePlusIcon } from '~icons/lucide/square-plus';

/**
 * @see https://lucide.dev/icons/square-plus
 */
export const SquarePlusIcon = (props: IconProps) => (
  <Icon icon={DefaultSquarePlusIcon} {...props} />
);

import { default as DefaultSquarePowerIcon } from '~icons/lucide/square-power';

/**
 * @see https://lucide.dev/icons/square-power
 */
export const SquarePowerIcon = (props: IconProps) => (
  <Icon icon={DefaultSquarePowerIcon} {...props} />
);

import { default as DefaultSquareRadicalIcon } from '~icons/lucide/square-radical';

/**
 * @see https://lucide.dev/icons/square-radical
 */
export const SquareRadicalIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareRadicalIcon} {...props} />
);

import { default as DefaultSquareRoundCornerIcon } from '~icons/lucide/square-round-corner';

/**
 * @see https://lucide.dev/icons/square-round-corner
 */
export const SquareRoundCornerIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareRoundCornerIcon} {...props} />
);

import { default as DefaultSquareScissorsIcon } from '~icons/lucide/square-scissors';

/**
 * @see https://lucide.dev/icons/square-scissors
 */
export const SquareScissorsIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareScissorsIcon} {...props} />
);

import { default as DefaultSquareSigmaIcon } from '~icons/lucide/square-sigma';

/**
 * @see https://lucide.dev/icons/square-sigma
 */
export const SquareSigmaIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareSigmaIcon} {...props} />
);

import { default as DefaultSquareSlashIcon } from '~icons/lucide/square-slash';

/**
 * @see https://lucide.dev/icons/square-slash
 */
export const SquareSlashIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareSlashIcon} {...props} />
);

import { default as DefaultSquareSplitHorizontalIcon } from '~icons/lucide/square-split-horizontal';

/**
 * @see https://lucide.dev/icons/square-split-horizontal
 */
export const SquareSplitHorizontalIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareSplitHorizontalIcon} {...props} />
);

import { default as DefaultSquareSplitVerticalIcon } from '~icons/lucide/square-split-vertical';

/**
 * @see https://lucide.dev/icons/square-split-vertical
 */
export const SquareSplitVerticalIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareSplitVerticalIcon} {...props} />
);

import { default as DefaultSquareSquareIcon } from '~icons/lucide/square-square';

/**
 * @see https://lucide.dev/icons/square-square
 */
export const SquareSquareIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareSquareIcon} {...props} />
);

import { default as DefaultSquareStackIcon } from '~icons/lucide/square-stack';

/**
 * @see https://lucide.dev/icons/square-stack
 */
export const SquareStackIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareStackIcon} {...props} />
);

import { default as DefaultSquareTerminalIcon } from '~icons/lucide/square-terminal';

/**
 * @see https://lucide.dev/icons/square-terminal
 */
export const SquareTerminalIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareTerminalIcon} {...props} />
);

import { default as DefaultSquareUserIcon } from '~icons/lucide/square-user';

/**
 * @see https://lucide.dev/icons/square-user
 */
export const SquareUserIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareUserIcon} {...props} />
);

import { default as DefaultSquareUserRoundIcon } from '~icons/lucide/square-user-round';

/**
 * @see https://lucide.dev/icons/square-user-round
 */
export const SquareUserRoundIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareUserRoundIcon} {...props} />
);

import { default as DefaultSquareXIcon } from '~icons/lucide/square-x';

/**
 * @see https://lucide.dev/icons/square-x
 */
export const SquareXIcon = (props: IconProps) => (
  <Icon icon={DefaultSquareXIcon} {...props} />
);

import { default as DefaultSquaresExcludeIcon } from '~icons/lucide/squares-exclude';

/**
 * @see https://lucide.dev/icons/squares-exclude
 */
export const SquaresExcludeIcon = (props: IconProps) => (
  <Icon icon={DefaultSquaresExcludeIcon} {...props} />
);

import { default as DefaultSquaresIntersectIcon } from '~icons/lucide/squares-intersect';

/**
 * @see https://lucide.dev/icons/squares-intersect
 */
export const SquaresIntersectIcon = (props: IconProps) => (
  <Icon icon={DefaultSquaresIntersectIcon} {...props} />
);

import { default as DefaultSquaresSubtractIcon } from '~icons/lucide/squares-subtract';

/**
 * @see https://lucide.dev/icons/squares-subtract
 */
export const SquaresSubtractIcon = (props: IconProps) => (
  <Icon icon={DefaultSquaresSubtractIcon} {...props} />
);

import { default as DefaultSquaresUniteIcon } from '~icons/lucide/squares-unite';

/**
 * @see https://lucide.dev/icons/squares-unite
 */
export const SquaresUniteIcon = (props: IconProps) => (
  <Icon icon={DefaultSquaresUniteIcon} {...props} />
);

import { default as DefaultSquircleIcon } from '~icons/lucide/squircle';

/**
 * @see https://lucide.dev/icons/squircle
 */
export const SquircleIcon = (props: IconProps) => (
  <Icon icon={DefaultSquircleIcon} {...props} />
);

import { default as DefaultSquircleDashedIcon } from '~icons/lucide/squircle-dashed';

/**
 * @see https://lucide.dev/icons/squircle-dashed
 */
export const SquircleDashedIcon = (props: IconProps) => (
  <Icon icon={DefaultSquircleDashedIcon} {...props} />
);

import { default as DefaultSquirrelIcon } from '~icons/lucide/squirrel';

/**
 * @see https://lucide.dev/icons/squirrel
 */
export const SquirrelIcon = (props: IconProps) => (
  <Icon icon={DefaultSquirrelIcon} {...props} />
);

import { default as DefaultStampIcon } from '~icons/lucide/stamp';

/**
 * @see https://lucide.dev/icons/stamp
 */
export const StampIcon = (props: IconProps) => (
  <Icon icon={DefaultStampIcon} {...props} />
);

import { default as DefaultStarIcon } from '~icons/lucide/star';

/**
 * @see https://lucide.dev/icons/star
 */
export const StarIcon = (props: IconProps) => (
  <Icon icon={DefaultStarIcon} {...props} />
);

import { default as DefaultStarHalfIcon } from '~icons/lucide/star-half';

/**
 * @see https://lucide.dev/icons/star-half
 */
export const StarHalfIcon = (props: IconProps) => (
  <Icon icon={DefaultStarHalfIcon} {...props} />
);

import { default as DefaultStarOffIcon } from '~icons/lucide/star-off';

/**
 * @see https://lucide.dev/icons/star-off
 */
export const StarOffIcon = (props: IconProps) => (
  <Icon icon={DefaultStarOffIcon} {...props} />
);

import { default as DefaultStepBackIcon } from '~icons/lucide/step-back';

/**
 * @see https://lucide.dev/icons/step-back
 */
export const StepBackIcon = (props: IconProps) => (
  <Icon icon={DefaultStepBackIcon} {...props} />
);

import { default as DefaultStepForwardIcon } from '~icons/lucide/step-forward';

/**
 * @see https://lucide.dev/icons/step-forward
 */
export const StepForwardIcon = (props: IconProps) => (
  <Icon icon={DefaultStepForwardIcon} {...props} />
);

import { default as DefaultStethoscopeIcon } from '~icons/lucide/stethoscope';

/**
 * @see https://lucide.dev/icons/stethoscope
 */
export const StethoscopeIcon = (props: IconProps) => (
  <Icon icon={DefaultStethoscopeIcon} {...props} />
);

import { default as DefaultStickerIcon } from '~icons/lucide/sticker';

/**
 * @see https://lucide.dev/icons/sticker
 */
export const StickerIcon = (props: IconProps) => (
  <Icon icon={DefaultStickerIcon} {...props} />
);

import { default as DefaultStickyNoteIcon } from '~icons/lucide/sticky-note';

/**
 * @see https://lucide.dev/icons/sticky-note
 */
export const StickyNoteIcon = (props: IconProps) => (
  <Icon icon={DefaultStickyNoteIcon} {...props} />
);

import { default as DefaultStoreIcon } from '~icons/lucide/store';

/**
 * @see https://lucide.dev/icons/store
 */
export const StoreIcon = (props: IconProps) => (
  <Icon icon={DefaultStoreIcon} {...props} />
);

import { default as DefaultStretchHorizontalIcon } from '~icons/lucide/stretch-horizontal';

/**
 * @see https://lucide.dev/icons/stretch-horizontal
 */
export const StretchHorizontalIcon = (props: IconProps) => (
  <Icon icon={DefaultStretchHorizontalIcon} {...props} />
);

import { default as DefaultStretchVerticalIcon } from '~icons/lucide/stretch-vertical';

/**
 * @see https://lucide.dev/icons/stretch-vertical
 */
export const StretchVerticalIcon = (props: IconProps) => (
  <Icon icon={DefaultStretchVerticalIcon} {...props} />
);

import { default as DefaultStrikethroughIcon } from '~icons/lucide/strikethrough';

/**
 * @see https://lucide.dev/icons/strikethrough
 */
export const StrikethroughIcon = (props: IconProps) => (
  <Icon icon={DefaultStrikethroughIcon} {...props} />
);

import { default as DefaultSubscriptIcon } from '~icons/lucide/subscript';

/**
 * @see https://lucide.dev/icons/subscript
 */
export const SubscriptIcon = (props: IconProps) => (
  <Icon icon={DefaultSubscriptIcon} {...props} />
);

import { default as DefaultSunIcon } from '~icons/lucide/sun';

/**
 * @see https://lucide.dev/icons/sun
 */
export const SunIcon = (props: IconProps) => (
  <Icon icon={DefaultSunIcon} {...props} />
);

import { default as DefaultSunDimIcon } from '~icons/lucide/sun-dim';

/**
 * @see https://lucide.dev/icons/sun-dim
 */
export const SunDimIcon = (props: IconProps) => (
  <Icon icon={DefaultSunDimIcon} {...props} />
);

import { default as DefaultSunMediumIcon } from '~icons/lucide/sun-medium';

/**
 * @see https://lucide.dev/icons/sun-medium
 */
export const SunMediumIcon = (props: IconProps) => (
  <Icon icon={DefaultSunMediumIcon} {...props} />
);

import { default as DefaultSunMoonIcon } from '~icons/lucide/sun-moon';

/**
 * @see https://lucide.dev/icons/sun-moon
 */
export const SunMoonIcon = (props: IconProps) => (
  <Icon icon={DefaultSunMoonIcon} {...props} />
);

import { default as DefaultSunSnowIcon } from '~icons/lucide/sun-snow';

/**
 * @see https://lucide.dev/icons/sun-snow
 */
export const SunSnowIcon = (props: IconProps) => (
  <Icon icon={DefaultSunSnowIcon} {...props} />
);

import { default as DefaultSunriseIcon } from '~icons/lucide/sunrise';

/**
 * @see https://lucide.dev/icons/sunrise
 */
export const SunriseIcon = (props: IconProps) => (
  <Icon icon={DefaultSunriseIcon} {...props} />
);

import { default as DefaultSunsetIcon } from '~icons/lucide/sunset';

/**
 * @see https://lucide.dev/icons/sunset
 */
export const SunsetIcon = (props: IconProps) => (
  <Icon icon={DefaultSunsetIcon} {...props} />
);

import { default as DefaultSuperscriptIcon } from '~icons/lucide/superscript';

/**
 * @see https://lucide.dev/icons/superscript
 */
export const SuperscriptIcon = (props: IconProps) => (
  <Icon icon={DefaultSuperscriptIcon} {...props} />
);

import { default as DefaultSwatchBookIcon } from '~icons/lucide/swatch-book';

/**
 * @see https://lucide.dev/icons/swatch-book
 */
export const SwatchBookIcon = (props: IconProps) => (
  <Icon icon={DefaultSwatchBookIcon} {...props} />
);

import { default as DefaultSwissFrancIcon } from '~icons/lucide/swiss-franc';

/**
 * @see https://lucide.dev/icons/swiss-franc
 */
export const SwissFrancIcon = (props: IconProps) => (
  <Icon icon={DefaultSwissFrancIcon} {...props} />
);

import { default as DefaultSwitchCameraIcon } from '~icons/lucide/switch-camera';

/**
 * @see https://lucide.dev/icons/switch-camera
 */
export const SwitchCameraIcon = (props: IconProps) => (
  <Icon icon={DefaultSwitchCameraIcon} {...props} />
);

import { default as DefaultSwordIcon } from '~icons/lucide/sword';

/**
 * @see https://lucide.dev/icons/sword
 */
export const SwordIcon = (props: IconProps) => (
  <Icon icon={DefaultSwordIcon} {...props} />
);

import { default as DefaultSwordsIcon } from '~icons/lucide/swords';

/**
 * @see https://lucide.dev/icons/swords
 */
export const SwordsIcon = (props: IconProps) => (
  <Icon icon={DefaultSwordsIcon} {...props} />
);

import { default as DefaultSyringeIcon } from '~icons/lucide/syringe';

/**
 * @see https://lucide.dev/icons/syringe
 */
export const SyringeIcon = (props: IconProps) => (
  <Icon icon={DefaultSyringeIcon} {...props} />
);

import { default as DefaultTableIcon } from '~icons/lucide/table';

/**
 * @see https://lucide.dev/icons/table
 */
export const TableIcon = (props: IconProps) => (
  <Icon icon={DefaultTableIcon} {...props} />
);

import { default as DefaultTable2Icon } from '~icons/lucide/table-2';

/**
 * @see https://lucide.dev/icons/table-2
 */
export const Table2Icon = (props: IconProps) => (
  <Icon icon={DefaultTable2Icon} {...props} />
);

import { default as DefaultTableCellsMergeIcon } from '~icons/lucide/table-cells-merge';

/**
 * @see https://lucide.dev/icons/table-cells-merge
 */
export const TableCellsMergeIcon = (props: IconProps) => (
  <Icon icon={DefaultTableCellsMergeIcon} {...props} />
);

import { default as DefaultTableCellsSplitIcon } from '~icons/lucide/table-cells-split';

/**
 * @see https://lucide.dev/icons/table-cells-split
 */
export const TableCellsSplitIcon = (props: IconProps) => (
  <Icon icon={DefaultTableCellsSplitIcon} {...props} />
);

import { default as DefaultTableColumnsSplitIcon } from '~icons/lucide/table-columns-split';

/**
 * @see https://lucide.dev/icons/table-columns-split
 */
export const TableColumnsSplitIcon = (props: IconProps) => (
  <Icon icon={DefaultTableColumnsSplitIcon} {...props} />
);

import { default as DefaultTableOfContentsIcon } from '~icons/lucide/table-of-contents';

/**
 * @see https://lucide.dev/icons/table-of-contents
 */
export const TableOfContentsIcon = (props: IconProps) => (
  <Icon icon={DefaultTableOfContentsIcon} {...props} />
);

import { default as DefaultTablePropertiesIcon } from '~icons/lucide/table-properties';

/**
 * @see https://lucide.dev/icons/table-properties
 */
export const TablePropertiesIcon = (props: IconProps) => (
  <Icon icon={DefaultTablePropertiesIcon} {...props} />
);

import { default as DefaultTableRowsSplitIcon } from '~icons/lucide/table-rows-split';

/**
 * @see https://lucide.dev/icons/table-rows-split
 */
export const TableRowsSplitIcon = (props: IconProps) => (
  <Icon icon={DefaultTableRowsSplitIcon} {...props} />
);

import { default as DefaultTabletIcon } from '~icons/lucide/tablet';

/**
 * @see https://lucide.dev/icons/tablet
 */
export const TabletIcon = (props: IconProps) => (
  <Icon icon={DefaultTabletIcon} {...props} />
);

import { default as DefaultTabletSmartphoneIcon } from '~icons/lucide/tablet-smartphone';

/**
 * @see https://lucide.dev/icons/tablet-smartphone
 */
export const TabletSmartphoneIcon = (props: IconProps) => (
  <Icon icon={DefaultTabletSmartphoneIcon} {...props} />
);

import { default as DefaultTabletsIcon } from '~icons/lucide/tablets';

/**
 * @see https://lucide.dev/icons/tablets
 */
export const TabletsIcon = (props: IconProps) => (
  <Icon icon={DefaultTabletsIcon} {...props} />
);

import { default as DefaultTagIcon } from '~icons/lucide/tag';

/**
 * @see https://lucide.dev/icons/tag
 */
export const TagIcon = (props: IconProps) => (
  <Icon icon={DefaultTagIcon} {...props} />
);

import { default as DefaultTagsIcon } from '~icons/lucide/tags';

/**
 * @see https://lucide.dev/icons/tags
 */
export const TagsIcon = (props: IconProps) => (
  <Icon icon={DefaultTagsIcon} {...props} />
);

import { default as DefaultTally1Icon } from '~icons/lucide/tally-1';

/**
 * @see https://lucide.dev/icons/tally-1
 */
export const Tally1Icon = (props: IconProps) => (
  <Icon icon={DefaultTally1Icon} {...props} />
);

import { default as DefaultTally2Icon } from '~icons/lucide/tally-2';

/**
 * @see https://lucide.dev/icons/tally-2
 */
export const Tally2Icon = (props: IconProps) => (
  <Icon icon={DefaultTally2Icon} {...props} />
);

import { default as DefaultTally3Icon } from '~icons/lucide/tally-3';

/**
 * @see https://lucide.dev/icons/tally-3
 */
export const Tally3Icon = (props: IconProps) => (
  <Icon icon={DefaultTally3Icon} {...props} />
);

import { default as DefaultTally4Icon } from '~icons/lucide/tally-4';

/**
 * @see https://lucide.dev/icons/tally-4
 */
export const Tally4Icon = (props: IconProps) => (
  <Icon icon={DefaultTally4Icon} {...props} />
);

import { default as DefaultTally5Icon } from '~icons/lucide/tally-5';

/**
 * @see https://lucide.dev/icons/tally-5
 */
export const Tally5Icon = (props: IconProps) => (
  <Icon icon={DefaultTally5Icon} {...props} />
);

import { default as DefaultTangentIcon } from '~icons/lucide/tangent';

/**
 * @see https://lucide.dev/icons/tangent
 */
export const TangentIcon = (props: IconProps) => (
  <Icon icon={DefaultTangentIcon} {...props} />
);

import { default as DefaultTargetIcon } from '~icons/lucide/target';

/**
 * @see https://lucide.dev/icons/target
 */
export const TargetIcon = (props: IconProps) => (
  <Icon icon={DefaultTargetIcon} {...props} />
);

import { default as DefaultTelescopeIcon } from '~icons/lucide/telescope';

/**
 * @see https://lucide.dev/icons/telescope
 */
export const TelescopeIcon = (props: IconProps) => (
  <Icon icon={DefaultTelescopeIcon} {...props} />
);

import { default as DefaultTentIcon } from '~icons/lucide/tent';

/**
 * @see https://lucide.dev/icons/tent
 */
export const TentIcon = (props: IconProps) => (
  <Icon icon={DefaultTentIcon} {...props} />
);

import { default as DefaultTentTreeIcon } from '~icons/lucide/tent-tree';

/**
 * @see https://lucide.dev/icons/tent-tree
 */
export const TentTreeIcon = (props: IconProps) => (
  <Icon icon={DefaultTentTreeIcon} {...props} />
);

import { default as DefaultTerminalIcon } from '~icons/lucide/terminal';

/**
 * @see https://lucide.dev/icons/terminal
 */
export const TerminalIcon = (props: IconProps) => (
  <Icon icon={DefaultTerminalIcon} {...props} />
);

import { default as DefaultTestTubeIcon } from '~icons/lucide/test-tube';

/**
 * @see https://lucide.dev/icons/test-tube
 */
export const TestTubeIcon = (props: IconProps) => (
  <Icon icon={DefaultTestTubeIcon} {...props} />
);

import { default as DefaultTestTubeDiagonalIcon } from '~icons/lucide/test-tube-diagonal';

/**
 * @see https://lucide.dev/icons/test-tube-diagonal
 */
export const TestTubeDiagonalIcon = (props: IconProps) => (
  <Icon icon={DefaultTestTubeDiagonalIcon} {...props} />
);

import { default as DefaultTestTubesIcon } from '~icons/lucide/test-tubes';

/**
 * @see https://lucide.dev/icons/test-tubes
 */
export const TestTubesIcon = (props: IconProps) => (
  <Icon icon={DefaultTestTubesIcon} {...props} />
);

import { default as DefaultTextIcon } from '~icons/lucide/text';

/**
 * @see https://lucide.dev/icons/text
 */
export const TextIcon = (props: IconProps) => (
  <Icon icon={DefaultTextIcon} {...props} />
);

import { default as DefaultTextCursorIcon } from '~icons/lucide/text-cursor';

/**
 * @see https://lucide.dev/icons/text-cursor
 */
export const TextCursorIcon = (props: IconProps) => (
  <Icon icon={DefaultTextCursorIcon} {...props} />
);

import { default as DefaultTextCursorInputIcon } from '~icons/lucide/text-cursor-input';

/**
 * @see https://lucide.dev/icons/text-cursor-input
 */
export const TextCursorInputIcon = (props: IconProps) => (
  <Icon icon={DefaultTextCursorInputIcon} {...props} />
);

import { default as DefaultTextQuoteIcon } from '~icons/lucide/text-quote';

/**
 * @see https://lucide.dev/icons/text-quote
 */
export const TextQuoteIcon = (props: IconProps) => (
  <Icon icon={DefaultTextQuoteIcon} {...props} />
);

import { default as DefaultTextSearchIcon } from '~icons/lucide/text-search';

/**
 * @see https://lucide.dev/icons/text-search
 */
export const TextSearchIcon = (props: IconProps) => (
  <Icon icon={DefaultTextSearchIcon} {...props} />
);

import { default as DefaultTextSelectIcon } from '~icons/lucide/text-select';

/**
 * @see https://lucide.dev/icons/text-select
 */
export const TextSelectIcon = (props: IconProps) => (
  <Icon icon={DefaultTextSelectIcon} {...props} />
);

import { default as DefaultTheaterIcon } from '~icons/lucide/theater';

/**
 * @see https://lucide.dev/icons/theater
 */
export const TheaterIcon = (props: IconProps) => (
  <Icon icon={DefaultTheaterIcon} {...props} />
);

import { default as DefaultThermometerIcon } from '~icons/lucide/thermometer';

/**
 * @see https://lucide.dev/icons/thermometer
 */
export const ThermometerIcon = (props: IconProps) => (
  <Icon icon={DefaultThermometerIcon} {...props} />
);

import { default as DefaultThermometerSnowflakeIcon } from '~icons/lucide/thermometer-snowflake';

/**
 * @see https://lucide.dev/icons/thermometer-snowflake
 */
export const ThermometerSnowflakeIcon = (props: IconProps) => (
  <Icon icon={DefaultThermometerSnowflakeIcon} {...props} />
);

import { default as DefaultThermometerSunIcon } from '~icons/lucide/thermometer-sun';

/**
 * @see https://lucide.dev/icons/thermometer-sun
 */
export const ThermometerSunIcon = (props: IconProps) => (
  <Icon icon={DefaultThermometerSunIcon} {...props} />
);

import { default as DefaultThumbsDownIcon } from '~icons/lucide/thumbs-down';

/**
 * @see https://lucide.dev/icons/thumbs-down
 */
export const ThumbsDownIcon = (props: IconProps) => (
  <Icon icon={DefaultThumbsDownIcon} {...props} />
);

import { default as DefaultThumbsUpIcon } from '~icons/lucide/thumbs-up';

/**
 * @see https://lucide.dev/icons/thumbs-up
 */
export const ThumbsUpIcon = (props: IconProps) => (
  <Icon icon={DefaultThumbsUpIcon} {...props} />
);

import { default as DefaultTicketIcon } from '~icons/lucide/ticket';

/**
 * @see https://lucide.dev/icons/ticket
 */
export const TicketIcon = (props: IconProps) => (
  <Icon icon={DefaultTicketIcon} {...props} />
);

import { default as DefaultTicketCheckIcon } from '~icons/lucide/ticket-check';

/**
 * @see https://lucide.dev/icons/ticket-check
 */
export const TicketCheckIcon = (props: IconProps) => (
  <Icon icon={DefaultTicketCheckIcon} {...props} />
);

import { default as DefaultTicketMinusIcon } from '~icons/lucide/ticket-minus';

/**
 * @see https://lucide.dev/icons/ticket-minus
 */
export const TicketMinusIcon = (props: IconProps) => (
  <Icon icon={DefaultTicketMinusIcon} {...props} />
);

import { default as DefaultTicketPercentIcon } from '~icons/lucide/ticket-percent';

/**
 * @see https://lucide.dev/icons/ticket-percent
 */
export const TicketPercentIcon = (props: IconProps) => (
  <Icon icon={DefaultTicketPercentIcon} {...props} />
);

import { default as DefaultTicketPlusIcon } from '~icons/lucide/ticket-plus';

/**
 * @see https://lucide.dev/icons/ticket-plus
 */
export const TicketPlusIcon = (props: IconProps) => (
  <Icon icon={DefaultTicketPlusIcon} {...props} />
);

import { default as DefaultTicketSlashIcon } from '~icons/lucide/ticket-slash';

/**
 * @see https://lucide.dev/icons/ticket-slash
 */
export const TicketSlashIcon = (props: IconProps) => (
  <Icon icon={DefaultTicketSlashIcon} {...props} />
);

import { default as DefaultTicketXIcon } from '~icons/lucide/ticket-x';

/**
 * @see https://lucide.dev/icons/ticket-x
 */
export const TicketXIcon = (props: IconProps) => (
  <Icon icon={DefaultTicketXIcon} {...props} />
);

import { default as DefaultTicketsIcon } from '~icons/lucide/tickets';

/**
 * @see https://lucide.dev/icons/tickets
 */
export const TicketsIcon = (props: IconProps) => (
  <Icon icon={DefaultTicketsIcon} {...props} />
);

import { default as DefaultTicketsPlaneIcon } from '~icons/lucide/tickets-plane';

/**
 * @see https://lucide.dev/icons/tickets-plane
 */
export const TicketsPlaneIcon = (props: IconProps) => (
  <Icon icon={DefaultTicketsPlaneIcon} {...props} />
);

import { default as DefaultTimerIcon } from '~icons/lucide/timer';

/**
 * @see https://lucide.dev/icons/timer
 */
export const TimerIcon = (props: IconProps) => (
  <Icon icon={DefaultTimerIcon} {...props} />
);

import { default as DefaultTimerOffIcon } from '~icons/lucide/timer-off';

/**
 * @see https://lucide.dev/icons/timer-off
 */
export const TimerOffIcon = (props: IconProps) => (
  <Icon icon={DefaultTimerOffIcon} {...props} />
);

import { default as DefaultTimerResetIcon } from '~icons/lucide/timer-reset';

/**
 * @see https://lucide.dev/icons/timer-reset
 */
export const TimerResetIcon = (props: IconProps) => (
  <Icon icon={DefaultTimerResetIcon} {...props} />
);

import { default as DefaultToggleLeftIcon } from '~icons/lucide/toggle-left';

/**
 * @see https://lucide.dev/icons/toggle-left
 */
export const ToggleLeftIcon = (props: IconProps) => (
  <Icon icon={DefaultToggleLeftIcon} {...props} />
);

import { default as DefaultToggleRightIcon } from '~icons/lucide/toggle-right';

/**
 * @see https://lucide.dev/icons/toggle-right
 */
export const ToggleRightIcon = (props: IconProps) => (
  <Icon icon={DefaultToggleRightIcon} {...props} />
);

import { default as DefaultToiletIcon } from '~icons/lucide/toilet';

/**
 * @see https://lucide.dev/icons/toilet
 */
export const ToiletIcon = (props: IconProps) => (
  <Icon icon={DefaultToiletIcon} {...props} />
);

import { default as DefaultToolCaseIcon } from '~icons/lucide/tool-case';

/**
 * @see https://lucide.dev/icons/tool-case
 */
export const ToolCaseIcon = (props: IconProps) => (
  <Icon icon={DefaultToolCaseIcon} {...props} />
);

import { default as DefaultTornadoIcon } from '~icons/lucide/tornado';

/**
 * @see https://lucide.dev/icons/tornado
 */
export const TornadoIcon = (props: IconProps) => (
  <Icon icon={DefaultTornadoIcon} {...props} />
);

import { default as DefaultTorusIcon } from '~icons/lucide/torus';

/**
 * @see https://lucide.dev/icons/torus
 */
export const TorusIcon = (props: IconProps) => (
  <Icon icon={DefaultTorusIcon} {...props} />
);

import { default as DefaultTouchpadIcon } from '~icons/lucide/touchpad';

/**
 * @see https://lucide.dev/icons/touchpad
 */
export const TouchpadIcon = (props: IconProps) => (
  <Icon icon={DefaultTouchpadIcon} {...props} />
);

import { default as DefaultTouchpadOffIcon } from '~icons/lucide/touchpad-off';

/**
 * @see https://lucide.dev/icons/touchpad-off
 */
export const TouchpadOffIcon = (props: IconProps) => (
  <Icon icon={DefaultTouchpadOffIcon} {...props} />
);

import { default as DefaultTowerControlIcon } from '~icons/lucide/tower-control';

/**
 * @see https://lucide.dev/icons/tower-control
 */
export const TowerControlIcon = (props: IconProps) => (
  <Icon icon={DefaultTowerControlIcon} {...props} />
);

import { default as DefaultToyBrickIcon } from '~icons/lucide/toy-brick';

/**
 * @see https://lucide.dev/icons/toy-brick
 */
export const ToyBrickIcon = (props: IconProps) => (
  <Icon icon={DefaultToyBrickIcon} {...props} />
);

import { default as DefaultTractorIcon } from '~icons/lucide/tractor';

/**
 * @see https://lucide.dev/icons/tractor
 */
export const TractorIcon = (props: IconProps) => (
  <Icon icon={DefaultTractorIcon} {...props} />
);

import { default as DefaultTrafficConeIcon } from '~icons/lucide/traffic-cone';

/**
 * @see https://lucide.dev/icons/traffic-cone
 */
export const TrafficConeIcon = (props: IconProps) => (
  <Icon icon={DefaultTrafficConeIcon} {...props} />
);

import { default as DefaultTrainFrontIcon } from '~icons/lucide/train-front';

/**
 * @see https://lucide.dev/icons/train-front
 */
export const TrainFrontIcon = (props: IconProps) => (
  <Icon icon={DefaultTrainFrontIcon} {...props} />
);

import { default as DefaultTrainFrontTunnelIcon } from '~icons/lucide/train-front-tunnel';

/**
 * @see https://lucide.dev/icons/train-front-tunnel
 */
export const TrainFrontTunnelIcon = (props: IconProps) => (
  <Icon icon={DefaultTrainFrontTunnelIcon} {...props} />
);

import { default as DefaultTrainTrackIcon } from '~icons/lucide/train-track';

/**
 * @see https://lucide.dev/icons/train-track
 */
export const TrainTrackIcon = (props: IconProps) => (
  <Icon icon={DefaultTrainTrackIcon} {...props} />
);

import { default as DefaultTramFrontIcon } from '~icons/lucide/tram-front';

/**
 * @see https://lucide.dev/icons/tram-front
 */
export const TramFrontIcon = (props: IconProps) => (
  <Icon icon={DefaultTramFrontIcon} {...props} />
);

import { default as DefaultTransgenderIcon } from '~icons/lucide/transgender';

/**
 * @see https://lucide.dev/icons/transgender
 */
export const TransgenderIcon = (props: IconProps) => (
  <Icon icon={DefaultTransgenderIcon} {...props} />
);

import { default as DefaultTrashIcon } from '~icons/lucide/trash';

/**
 * @see https://lucide.dev/icons/trash
 */
export const TrashIcon = (props: IconProps) => (
  <Icon icon={DefaultTrashIcon} {...props} />
);

import { default as DefaultTrash2Icon } from '~icons/lucide/trash-2';

/**
 * @see https://lucide.dev/icons/trash-2
 */
export const Trash2Icon = (props: IconProps) => (
  <Icon icon={DefaultTrash2Icon} {...props} />
);

import { default as DefaultTreeDeciduousIcon } from '~icons/lucide/tree-deciduous';

/**
 * @see https://lucide.dev/icons/tree-deciduous
 */
export const TreeDeciduousIcon = (props: IconProps) => (
  <Icon icon={DefaultTreeDeciduousIcon} {...props} />
);

import { default as DefaultTreePalmIcon } from '~icons/lucide/tree-palm';

/**
 * @see https://lucide.dev/icons/tree-palm
 */
export const TreePalmIcon = (props: IconProps) => (
  <Icon icon={DefaultTreePalmIcon} {...props} />
);

import { default as DefaultTreePineIcon } from '~icons/lucide/tree-pine';

/**
 * @see https://lucide.dev/icons/tree-pine
 */
export const TreePineIcon = (props: IconProps) => (
  <Icon icon={DefaultTreePineIcon} {...props} />
);

import { default as DefaultTreesIcon } from '~icons/lucide/trees';

/**
 * @see https://lucide.dev/icons/trees
 */
export const TreesIcon = (props: IconProps) => (
  <Icon icon={DefaultTreesIcon} {...props} />
);

import { default as DefaultTrelloIcon } from '~icons/lucide/trello';

/**
 * @see https://lucide.dev/icons/trello
 */
export const TrelloIcon = (props: IconProps) => (
  <Icon icon={DefaultTrelloIcon} {...props} />
);

import { default as DefaultTrendingDownIcon } from '~icons/lucide/trending-down';

/**
 * @see https://lucide.dev/icons/trending-down
 */
export const TrendingDownIcon = (props: IconProps) => (
  <Icon icon={DefaultTrendingDownIcon} {...props} />
);

import { default as DefaultTrendingUpIcon } from '~icons/lucide/trending-up';

/**
 * @see https://lucide.dev/icons/trending-up
 */
export const TrendingUpIcon = (props: IconProps) => (
  <Icon icon={DefaultTrendingUpIcon} {...props} />
);

import { default as DefaultTrendingUpDownIcon } from '~icons/lucide/trending-up-down';

/**
 * @see https://lucide.dev/icons/trending-up-down
 */
export const TrendingUpDownIcon = (props: IconProps) => (
  <Icon icon={DefaultTrendingUpDownIcon} {...props} />
);

import { default as DefaultTriangleIcon } from '~icons/lucide/triangle';

/**
 * @see https://lucide.dev/icons/triangle
 */
export const TriangleIcon = (props: IconProps) => (
  <Icon icon={DefaultTriangleIcon} {...props} />
);

import { default as DefaultTriangleAlertIcon } from '~icons/lucide/triangle-alert';

/**
 * @see https://lucide.dev/icons/triangle-alert
 */
export const TriangleAlertIcon = (props: IconProps) => (
  <Icon icon={DefaultTriangleAlertIcon} {...props} />
);

import { default as DefaultTriangleDashedIcon } from '~icons/lucide/triangle-dashed';

/**
 * @see https://lucide.dev/icons/triangle-dashed
 */
export const TriangleDashedIcon = (props: IconProps) => (
  <Icon icon={DefaultTriangleDashedIcon} {...props} />
);

import { default as DefaultTriangleRightIcon } from '~icons/lucide/triangle-right';

/**
 * @see https://lucide.dev/icons/triangle-right
 */
export const TriangleRightIcon = (props: IconProps) => (
  <Icon icon={DefaultTriangleRightIcon} {...props} />
);

import { default as DefaultTrophyIcon } from '~icons/lucide/trophy';

/**
 * @see https://lucide.dev/icons/trophy
 */
export const TrophyIcon = (props: IconProps) => (
  <Icon icon={DefaultTrophyIcon} {...props} />
);

import { default as DefaultTruckIcon } from '~icons/lucide/truck';

/**
 * @see https://lucide.dev/icons/truck
 */
export const TruckIcon = (props: IconProps) => (
  <Icon icon={DefaultTruckIcon} {...props} />
);

import { default as DefaultTruckElectricIcon } from '~icons/lucide/truck-electric';

/**
 * @see https://lucide.dev/icons/truck-electric
 */
export const TruckElectricIcon = (props: IconProps) => (
  <Icon icon={DefaultTruckElectricIcon} {...props} />
);

import { default as DefaultTurkishLiraIcon } from '~icons/lucide/turkish-lira';

/**
 * @see https://lucide.dev/icons/turkish-lira
 */
export const TurkishLiraIcon = (props: IconProps) => (
  <Icon icon={DefaultTurkishLiraIcon} {...props} />
);

import { default as DefaultTurtleIcon } from '~icons/lucide/turtle';

/**
 * @see https://lucide.dev/icons/turtle
 */
export const TurtleIcon = (props: IconProps) => (
  <Icon icon={DefaultTurtleIcon} {...props} />
);

import { default as DefaultTvIcon } from '~icons/lucide/tv';

/**
 * @see https://lucide.dev/icons/tv
 */
export const TvIcon = (props: IconProps) => (
  <Icon icon={DefaultTvIcon} {...props} />
);

import { default as DefaultTvMinimalIcon } from '~icons/lucide/tv-minimal';

/**
 * @see https://lucide.dev/icons/tv-minimal
 */
export const TvMinimalIcon = (props: IconProps) => (
  <Icon icon={DefaultTvMinimalIcon} {...props} />
);

import { default as DefaultTvMinimalPlayIcon } from '~icons/lucide/tv-minimal-play';

/**
 * @see https://lucide.dev/icons/tv-minimal-play
 */
export const TvMinimalPlayIcon = (props: IconProps) => (
  <Icon icon={DefaultTvMinimalPlayIcon} {...props} />
);

import { default as DefaultTwitchIcon } from '~icons/lucide/twitch';

/**
 * @see https://lucide.dev/icons/twitch
 */
export const TwitchIcon = (props: IconProps) => (
  <Icon icon={DefaultTwitchIcon} {...props} />
);

import { default as DefaultTwitterIcon } from '~icons/lucide/twitter';

/**
 * @see https://lucide.dev/icons/twitter
 */
export const TwitterIcon = (props: IconProps) => (
  <Icon icon={DefaultTwitterIcon} {...props} />
);

import { default as DefaultTypeIcon } from '~icons/lucide/type';

/**
 * @see https://lucide.dev/icons/type
 */
export const TypeIcon = (props: IconProps) => (
  <Icon icon={DefaultTypeIcon} {...props} />
);

import { default as DefaultTypeOutlineIcon } from '~icons/lucide/type-outline';

/**
 * @see https://lucide.dev/icons/type-outline
 */
export const TypeOutlineIcon = (props: IconProps) => (
  <Icon icon={DefaultTypeOutlineIcon} {...props} />
);

import { default as DefaultUmbrellaIcon } from '~icons/lucide/umbrella';

/**
 * @see https://lucide.dev/icons/umbrella
 */
export const UmbrellaIcon = (props: IconProps) => (
  <Icon icon={DefaultUmbrellaIcon} {...props} />
);

import { default as DefaultUmbrellaOffIcon } from '~icons/lucide/umbrella-off';

/**
 * @see https://lucide.dev/icons/umbrella-off
 */
export const UmbrellaOffIcon = (props: IconProps) => (
  <Icon icon={DefaultUmbrellaOffIcon} {...props} />
);

import { default as DefaultUnderlineIcon } from '~icons/lucide/underline';

/**
 * @see https://lucide.dev/icons/underline
 */
export const UnderlineIcon = (props: IconProps) => (
  <Icon icon={DefaultUnderlineIcon} {...props} />
);

import { default as DefaultUndoIcon } from '~icons/lucide/undo';

/**
 * @see https://lucide.dev/icons/undo
 */
export const UndoIcon = (props: IconProps) => (
  <Icon icon={DefaultUndoIcon} {...props} />
);

import { default as DefaultUndo2Icon } from '~icons/lucide/undo-2';

/**
 * @see https://lucide.dev/icons/undo-2
 */
export const Undo2Icon = (props: IconProps) => (
  <Icon icon={DefaultUndo2Icon} {...props} />
);

import { default as DefaultUndoDotIcon } from '~icons/lucide/undo-dot';

/**
 * @see https://lucide.dev/icons/undo-dot
 */
export const UndoDotIcon = (props: IconProps) => (
  <Icon icon={DefaultUndoDotIcon} {...props} />
);

import { default as DefaultUnfoldHorizontalIcon } from '~icons/lucide/unfold-horizontal';

/**
 * @see https://lucide.dev/icons/unfold-horizontal
 */
export const UnfoldHorizontalIcon = (props: IconProps) => (
  <Icon icon={DefaultUnfoldHorizontalIcon} {...props} />
);

import { default as DefaultUnfoldVerticalIcon } from '~icons/lucide/unfold-vertical';

/**
 * @see https://lucide.dev/icons/unfold-vertical
 */
export const UnfoldVerticalIcon = (props: IconProps) => (
  <Icon icon={DefaultUnfoldVerticalIcon} {...props} />
);

import { default as DefaultUngroupIcon } from '~icons/lucide/ungroup';

/**
 * @see https://lucide.dev/icons/ungroup
 */
export const UngroupIcon = (props: IconProps) => (
  <Icon icon={DefaultUngroupIcon} {...props} />
);

import { default as DefaultUniversityIcon } from '~icons/lucide/university';

/**
 * @see https://lucide.dev/icons/university
 */
export const UniversityIcon = (props: IconProps) => (
  <Icon icon={DefaultUniversityIcon} {...props} />
);

import { default as DefaultUnlinkIcon } from '~icons/lucide/unlink';

/**
 * @see https://lucide.dev/icons/unlink
 */
export const UnlinkIcon = (props: IconProps) => (
  <Icon icon={DefaultUnlinkIcon} {...props} />
);

import { default as DefaultUnlink2Icon } from '~icons/lucide/unlink-2';

/**
 * @see https://lucide.dev/icons/unlink-2
 */
export const Unlink2Icon = (props: IconProps) => (
  <Icon icon={DefaultUnlink2Icon} {...props} />
);

import { default as DefaultUnplugIcon } from '~icons/lucide/unplug';

/**
 * @see https://lucide.dev/icons/unplug
 */
export const UnplugIcon = (props: IconProps) => (
  <Icon icon={DefaultUnplugIcon} {...props} />
);

import { default as DefaultUploadIcon } from '~icons/lucide/upload';

/**
 * @see https://lucide.dev/icons/upload
 */
export const UploadIcon = (props: IconProps) => (
  <Icon icon={DefaultUploadIcon} {...props} />
);

import { default as DefaultUsbIcon } from '~icons/lucide/usb';

/**
 * @see https://lucide.dev/icons/usb
 */
export const UsbIcon = (props: IconProps) => (
  <Icon icon={DefaultUsbIcon} {...props} />
);

import { default as DefaultUserIcon } from '~icons/lucide/user';

/**
 * @see https://lucide.dev/icons/user
 */
export const UserIcon = (props: IconProps) => (
  <Icon icon={DefaultUserIcon} {...props} />
);

import { default as DefaultUserCheckIcon } from '~icons/lucide/user-check';

/**
 * @see https://lucide.dev/icons/user-check
 */
export const UserCheckIcon = (props: IconProps) => (
  <Icon icon={DefaultUserCheckIcon} {...props} />
);

import { default as DefaultUserCogIcon } from '~icons/lucide/user-cog';

/**
 * @see https://lucide.dev/icons/user-cog
 */
export const UserCogIcon = (props: IconProps) => (
  <Icon icon={DefaultUserCogIcon} {...props} />
);

import { default as DefaultUserLockIcon } from '~icons/lucide/user-lock';

/**
 * @see https://lucide.dev/icons/user-lock
 */
export const UserLockIcon = (props: IconProps) => (
  <Icon icon={DefaultUserLockIcon} {...props} />
);

import { default as DefaultUserMinusIcon } from '~icons/lucide/user-minus';

/**
 * @see https://lucide.dev/icons/user-minus
 */
export const UserMinusIcon = (props: IconProps) => (
  <Icon icon={DefaultUserMinusIcon} {...props} />
);

import { default as DefaultUserPenIcon } from '~icons/lucide/user-pen';

/**
 * @see https://lucide.dev/icons/user-pen
 */
export const UserPenIcon = (props: IconProps) => (
  <Icon icon={DefaultUserPenIcon} {...props} />
);

import { default as DefaultUserPlusIcon } from '~icons/lucide/user-plus';

/**
 * @see https://lucide.dev/icons/user-plus
 */
export const UserPlusIcon = (props: IconProps) => (
  <Icon icon={DefaultUserPlusIcon} {...props} />
);

import { default as DefaultUserRoundIcon } from '~icons/lucide/user-round';

/**
 * @see https://lucide.dev/icons/user-round
 */
export const UserRoundIcon = (props: IconProps) => (
  <Icon icon={DefaultUserRoundIcon} {...props} />
);

import { default as DefaultUserRoundCheckIcon } from '~icons/lucide/user-round-check';

/**
 * @see https://lucide.dev/icons/user-round-check
 */
export const UserRoundCheckIcon = (props: IconProps) => (
  <Icon icon={DefaultUserRoundCheckIcon} {...props} />
);

import { default as DefaultUserRoundCogIcon } from '~icons/lucide/user-round-cog';

/**
 * @see https://lucide.dev/icons/user-round-cog
 */
export const UserRoundCogIcon = (props: IconProps) => (
  <Icon icon={DefaultUserRoundCogIcon} {...props} />
);

import { default as DefaultUserRoundMinusIcon } from '~icons/lucide/user-round-minus';

/**
 * @see https://lucide.dev/icons/user-round-minus
 */
export const UserRoundMinusIcon = (props: IconProps) => (
  <Icon icon={DefaultUserRoundMinusIcon} {...props} />
);

import { default as DefaultUserRoundPenIcon } from '~icons/lucide/user-round-pen';

/**
 * @see https://lucide.dev/icons/user-round-pen
 */
export const UserRoundPenIcon = (props: IconProps) => (
  <Icon icon={DefaultUserRoundPenIcon} {...props} />
);

import { default as DefaultUserRoundPlusIcon } from '~icons/lucide/user-round-plus';

/**
 * @see https://lucide.dev/icons/user-round-plus
 */
export const UserRoundPlusIcon = (props: IconProps) => (
  <Icon icon={DefaultUserRoundPlusIcon} {...props} />
);

import { default as DefaultUserRoundSearchIcon } from '~icons/lucide/user-round-search';

/**
 * @see https://lucide.dev/icons/user-round-search
 */
export const UserRoundSearchIcon = (props: IconProps) => (
  <Icon icon={DefaultUserRoundSearchIcon} {...props} />
);

import { default as DefaultUserRoundXIcon } from '~icons/lucide/user-round-x';

/**
 * @see https://lucide.dev/icons/user-round-x
 */
export const UserRoundXIcon = (props: IconProps) => (
  <Icon icon={DefaultUserRoundXIcon} {...props} />
);

import { default as DefaultUserSearchIcon } from '~icons/lucide/user-search';

/**
 * @see https://lucide.dev/icons/user-search
 */
export const UserSearchIcon = (props: IconProps) => (
  <Icon icon={DefaultUserSearchIcon} {...props} />
);

import { default as DefaultUserXIcon } from '~icons/lucide/user-x';

/**
 * @see https://lucide.dev/icons/user-x
 */
export const UserXIcon = (props: IconProps) => (
  <Icon icon={DefaultUserXIcon} {...props} />
);

import { default as DefaultUsersIcon } from '~icons/lucide/users';

/**
 * @see https://lucide.dev/icons/users
 */
export const UsersIcon = (props: IconProps) => (
  <Icon icon={DefaultUsersIcon} {...props} />
);

import { default as DefaultUsersRoundIcon } from '~icons/lucide/users-round';

/**
 * @see https://lucide.dev/icons/users-round
 */
export const UsersRoundIcon = (props: IconProps) => (
  <Icon icon={DefaultUsersRoundIcon} {...props} />
);

import { default as DefaultUtensilsIcon } from '~icons/lucide/utensils';

/**
 * @see https://lucide.dev/icons/utensils
 */
export const UtensilsIcon = (props: IconProps) => (
  <Icon icon={DefaultUtensilsIcon} {...props} />
);

import { default as DefaultUtensilsCrossedIcon } from '~icons/lucide/utensils-crossed';

/**
 * @see https://lucide.dev/icons/utensils-crossed
 */
export const UtensilsCrossedIcon = (props: IconProps) => (
  <Icon icon={DefaultUtensilsCrossedIcon} {...props} />
);

import { default as DefaultUtilityPoleIcon } from '~icons/lucide/utility-pole';

/**
 * @see https://lucide.dev/icons/utility-pole
 */
export const UtilityPoleIcon = (props: IconProps) => (
  <Icon icon={DefaultUtilityPoleIcon} {...props} />
);

import { default as DefaultVariableIcon } from '~icons/lucide/variable';

/**
 * @see https://lucide.dev/icons/variable
 */
export const VariableIcon = (props: IconProps) => (
  <Icon icon={DefaultVariableIcon} {...props} />
);

import { default as DefaultVaultIcon } from '~icons/lucide/vault';

/**
 * @see https://lucide.dev/icons/vault
 */
export const VaultIcon = (props: IconProps) => (
  <Icon icon={DefaultVaultIcon} {...props} />
);

import { default as DefaultVectorSquareIcon } from '~icons/lucide/vector-square';

/**
 * @see https://lucide.dev/icons/vector-square
 */
export const VectorSquareIcon = (props: IconProps) => (
  <Icon icon={DefaultVectorSquareIcon} {...props} />
);

import { default as DefaultVeganIcon } from '~icons/lucide/vegan';

/**
 * @see https://lucide.dev/icons/vegan
 */
export const VeganIcon = (props: IconProps) => (
  <Icon icon={DefaultVeganIcon} {...props} />
);

import { default as DefaultVenetianMaskIcon } from '~icons/lucide/venetian-mask';

/**
 * @see https://lucide.dev/icons/venetian-mask
 */
export const VenetianMaskIcon = (props: IconProps) => (
  <Icon icon={DefaultVenetianMaskIcon} {...props} />
);

import { default as DefaultVenusIcon } from '~icons/lucide/venus';

/**
 * @see https://lucide.dev/icons/venus
 */
export const VenusIcon = (props: IconProps) => (
  <Icon icon={DefaultVenusIcon} {...props} />
);

import { default as DefaultVenusAndMarsIcon } from '~icons/lucide/venus-and-mars';

/**
 * @see https://lucide.dev/icons/venus-and-mars
 */
export const VenusAndMarsIcon = (props: IconProps) => (
  <Icon icon={DefaultVenusAndMarsIcon} {...props} />
);

import { default as DefaultVibrateIcon } from '~icons/lucide/vibrate';

/**
 * @see https://lucide.dev/icons/vibrate
 */
export const VibrateIcon = (props: IconProps) => (
  <Icon icon={DefaultVibrateIcon} {...props} />
);

import { default as DefaultVibrateOffIcon } from '~icons/lucide/vibrate-off';

/**
 * @see https://lucide.dev/icons/vibrate-off
 */
export const VibrateOffIcon = (props: IconProps) => (
  <Icon icon={DefaultVibrateOffIcon} {...props} />
);

import { default as DefaultVideoIcon } from '~icons/lucide/video';

/**
 * @see https://lucide.dev/icons/video
 */
export const VideoIcon = (props: IconProps) => (
  <Icon icon={DefaultVideoIcon} {...props} />
);

import { default as DefaultVideoOffIcon } from '~icons/lucide/video-off';

/**
 * @see https://lucide.dev/icons/video-off
 */
export const VideoOffIcon = (props: IconProps) => (
  <Icon icon={DefaultVideoOffIcon} {...props} />
);

import { default as DefaultVideotapeIcon } from '~icons/lucide/videotape';

/**
 * @see https://lucide.dev/icons/videotape
 */
export const VideotapeIcon = (props: IconProps) => (
  <Icon icon={DefaultVideotapeIcon} {...props} />
);

import { default as DefaultViewIcon } from '~icons/lucide/view';

/**
 * @see https://lucide.dev/icons/view
 */
export const ViewIcon = (props: IconProps) => (
  <Icon icon={DefaultViewIcon} {...props} />
);

import { default as DefaultVoicemailIcon } from '~icons/lucide/voicemail';

/**
 * @see https://lucide.dev/icons/voicemail
 */
export const VoicemailIcon = (props: IconProps) => (
  <Icon icon={DefaultVoicemailIcon} {...props} />
);

import { default as DefaultVolleyballIcon } from '~icons/lucide/volleyball';

/**
 * @see https://lucide.dev/icons/volleyball
 */
export const VolleyballIcon = (props: IconProps) => (
  <Icon icon={DefaultVolleyballIcon} {...props} />
);

import { default as DefaultVolumeIcon } from '~icons/lucide/volume';

/**
 * @see https://lucide.dev/icons/volume
 */
export const VolumeIcon = (props: IconProps) => (
  <Icon icon={DefaultVolumeIcon} {...props} />
);

import { default as DefaultVolume1Icon } from '~icons/lucide/volume-1';

/**
 * @see https://lucide.dev/icons/volume-1
 */
export const Volume1Icon = (props: IconProps) => (
  <Icon icon={DefaultVolume1Icon} {...props} />
);

import { default as DefaultVolume2Icon } from '~icons/lucide/volume-2';

/**
 * @see https://lucide.dev/icons/volume-2
 */
export const Volume2Icon = (props: IconProps) => (
  <Icon icon={DefaultVolume2Icon} {...props} />
);

import { default as DefaultVolumeOffIcon } from '~icons/lucide/volume-off';

/**
 * @see https://lucide.dev/icons/volume-off
 */
export const VolumeOffIcon = (props: IconProps) => (
  <Icon icon={DefaultVolumeOffIcon} {...props} />
);

import { default as DefaultVolumeXIcon } from '~icons/lucide/volume-x';

/**
 * @see https://lucide.dev/icons/volume-x
 */
export const VolumeXIcon = (props: IconProps) => (
  <Icon icon={DefaultVolumeXIcon} {...props} />
);

import { default as DefaultVoteIcon } from '~icons/lucide/vote';

/**
 * @see https://lucide.dev/icons/vote
 */
export const VoteIcon = (props: IconProps) => (
  <Icon icon={DefaultVoteIcon} {...props} />
);

import { default as DefaultWalletIcon } from '~icons/lucide/wallet';

/**
 * @see https://lucide.dev/icons/wallet
 */
export const WalletIcon = (props: IconProps) => (
  <Icon icon={DefaultWalletIcon} {...props} />
);

import { default as DefaultWalletCardsIcon } from '~icons/lucide/wallet-cards';

/**
 * @see https://lucide.dev/icons/wallet-cards
 */
export const WalletCardsIcon = (props: IconProps) => (
  <Icon icon={DefaultWalletCardsIcon} {...props} />
);

import { default as DefaultWalletMinimalIcon } from '~icons/lucide/wallet-minimal';

/**
 * @see https://lucide.dev/icons/wallet-minimal
 */
export const WalletMinimalIcon = (props: IconProps) => (
  <Icon icon={DefaultWalletMinimalIcon} {...props} />
);

import { default as DefaultWallpaperIcon } from '~icons/lucide/wallpaper';

/**
 * @see https://lucide.dev/icons/wallpaper
 */
export const WallpaperIcon = (props: IconProps) => (
  <Icon icon={DefaultWallpaperIcon} {...props} />
);

import { default as DefaultWandIcon } from '~icons/lucide/wand';

/**
 * @see https://lucide.dev/icons/wand
 */
export const WandIcon = (props: IconProps) => (
  <Icon icon={DefaultWandIcon} {...props} />
);

import { default as DefaultWandSparklesIcon } from '~icons/lucide/wand-sparkles';

/**
 * @see https://lucide.dev/icons/wand-sparkles
 */
export const WandSparklesIcon = (props: IconProps) => (
  <Icon icon={DefaultWandSparklesIcon} {...props} />
);

import { default as DefaultWarehouseIcon } from '~icons/lucide/warehouse';

/**
 * @see https://lucide.dev/icons/warehouse
 */
export const WarehouseIcon = (props: IconProps) => (
  <Icon icon={DefaultWarehouseIcon} {...props} />
);

import { default as DefaultWashingMachineIcon } from '~icons/lucide/washing-machine';

/**
 * @see https://lucide.dev/icons/washing-machine
 */
export const WashingMachineIcon = (props: IconProps) => (
  <Icon icon={DefaultWashingMachineIcon} {...props} />
);

import { default as DefaultWatchIcon } from '~icons/lucide/watch';

/**
 * @see https://lucide.dev/icons/watch
 */
export const WatchIcon = (props: IconProps) => (
  <Icon icon={DefaultWatchIcon} {...props} />
);

import { default as DefaultWavesIcon } from '~icons/lucide/waves';

/**
 * @see https://lucide.dev/icons/waves
 */
export const WavesIcon = (props: IconProps) => (
  <Icon icon={DefaultWavesIcon} {...props} />
);

import { default as DefaultWavesLadderIcon } from '~icons/lucide/waves-ladder';

/**
 * @see https://lucide.dev/icons/waves-ladder
 */
export const WavesLadderIcon = (props: IconProps) => (
  <Icon icon={DefaultWavesLadderIcon} {...props} />
);

import { default as DefaultWaypointsIcon } from '~icons/lucide/waypoints';

/**
 * @see https://lucide.dev/icons/waypoints
 */
export const WaypointsIcon = (props: IconProps) => (
  <Icon icon={DefaultWaypointsIcon} {...props} />
);

import { default as DefaultWebcamIcon } from '~icons/lucide/webcam';

/**
 * @see https://lucide.dev/icons/webcam
 */
export const WebcamIcon = (props: IconProps) => (
  <Icon icon={DefaultWebcamIcon} {...props} />
);

import { default as DefaultWebhookIcon } from '~icons/lucide/webhook';

/**
 * @see https://lucide.dev/icons/webhook
 */
export const WebhookIcon = (props: IconProps) => (
  <Icon icon={DefaultWebhookIcon} {...props} />
);

import { default as DefaultWebhookOffIcon } from '~icons/lucide/webhook-off';

/**
 * @see https://lucide.dev/icons/webhook-off
 */
export const WebhookOffIcon = (props: IconProps) => (
  <Icon icon={DefaultWebhookOffIcon} {...props} />
);

import { default as DefaultWeightIcon } from '~icons/lucide/weight';

/**
 * @see https://lucide.dev/icons/weight
 */
export const WeightIcon = (props: IconProps) => (
  <Icon icon={DefaultWeightIcon} {...props} />
);

import { default as DefaultWheatIcon } from '~icons/lucide/wheat';

/**
 * @see https://lucide.dev/icons/wheat
 */
export const WheatIcon = (props: IconProps) => (
  <Icon icon={DefaultWheatIcon} {...props} />
);

import { default as DefaultWheatOffIcon } from '~icons/lucide/wheat-off';

/**
 * @see https://lucide.dev/icons/wheat-off
 */
export const WheatOffIcon = (props: IconProps) => (
  <Icon icon={DefaultWheatOffIcon} {...props} />
);

import { default as DefaultWholeWordIcon } from '~icons/lucide/whole-word';

/**
 * @see https://lucide.dev/icons/whole-word
 */
export const WholeWordIcon = (props: IconProps) => (
  <Icon icon={DefaultWholeWordIcon} {...props} />
);

import { default as DefaultWifiIcon } from '~icons/lucide/wifi';

/**
 * @see https://lucide.dev/icons/wifi
 */
export const WifiIcon = (props: IconProps) => (
  <Icon icon={DefaultWifiIcon} {...props} />
);

import { default as DefaultWifiCogIcon } from '~icons/lucide/wifi-cog';

/**
 * @see https://lucide.dev/icons/wifi-cog
 */
export const WifiCogIcon = (props: IconProps) => (
  <Icon icon={DefaultWifiCogIcon} {...props} />
);

import { default as DefaultWifiHighIcon } from '~icons/lucide/wifi-high';

/**
 * @see https://lucide.dev/icons/wifi-high
 */
export const WifiHighIcon = (props: IconProps) => (
  <Icon icon={DefaultWifiHighIcon} {...props} />
);

import { default as DefaultWifiLowIcon } from '~icons/lucide/wifi-low';

/**
 * @see https://lucide.dev/icons/wifi-low
 */
export const WifiLowIcon = (props: IconProps) => (
  <Icon icon={DefaultWifiLowIcon} {...props} />
);

import { default as DefaultWifiOffIcon } from '~icons/lucide/wifi-off';

/**
 * @see https://lucide.dev/icons/wifi-off
 */
export const WifiOffIcon = (props: IconProps) => (
  <Icon icon={DefaultWifiOffIcon} {...props} />
);

import { default as DefaultWifiPenIcon } from '~icons/lucide/wifi-pen';

/**
 * @see https://lucide.dev/icons/wifi-pen
 */
export const WifiPenIcon = (props: IconProps) => (
  <Icon icon={DefaultWifiPenIcon} {...props} />
);

import { default as DefaultWifiZeroIcon } from '~icons/lucide/wifi-zero';

/**
 * @see https://lucide.dev/icons/wifi-zero
 */
export const WifiZeroIcon = (props: IconProps) => (
  <Icon icon={DefaultWifiZeroIcon} {...props} />
);

import { default as DefaultWindIcon } from '~icons/lucide/wind';

/**
 * @see https://lucide.dev/icons/wind
 */
export const WindIcon = (props: IconProps) => (
  <Icon icon={DefaultWindIcon} {...props} />
);

import { default as DefaultWindArrowDownIcon } from '~icons/lucide/wind-arrow-down';

/**
 * @see https://lucide.dev/icons/wind-arrow-down
 */
export const WindArrowDownIcon = (props: IconProps) => (
  <Icon icon={DefaultWindArrowDownIcon} {...props} />
);

import { default as DefaultWineIcon } from '~icons/lucide/wine';

/**
 * @see https://lucide.dev/icons/wine
 */
export const WineIcon = (props: IconProps) => (
  <Icon icon={DefaultWineIcon} {...props} />
);

import { default as DefaultWineOffIcon } from '~icons/lucide/wine-off';

/**
 * @see https://lucide.dev/icons/wine-off
 */
export const WineOffIcon = (props: IconProps) => (
  <Icon icon={DefaultWineOffIcon} {...props} />
);

import { default as DefaultWorkflowIcon } from '~icons/lucide/workflow';

/**
 * @see https://lucide.dev/icons/workflow
 */
export const WorkflowIcon = (props: IconProps) => (
  <Icon icon={DefaultWorkflowIcon} {...props} />
);

import { default as DefaultWormIcon } from '~icons/lucide/worm';

/**
 * @see https://lucide.dev/icons/worm
 */
export const WormIcon = (props: IconProps) => (
  <Icon icon={DefaultWormIcon} {...props} />
);

import { default as DefaultWrapTextIcon } from '~icons/lucide/wrap-text';

/**
 * @see https://lucide.dev/icons/wrap-text
 */
export const WrapTextIcon = (props: IconProps) => (
  <Icon icon={DefaultWrapTextIcon} {...props} />
);

import { default as DefaultWrenchIcon } from '~icons/lucide/wrench';

/**
 * @see https://lucide.dev/icons/wrench
 */
export const WrenchIcon = (props: IconProps) => (
  <Icon icon={DefaultWrenchIcon} {...props} />
);

import { default as DefaultXIcon } from '~icons/lucide/x';

/**
 * @see https://lucide.dev/icons/x
 */
export const XIcon = (props: IconProps) => (
  <Icon icon={DefaultXIcon} {...props} />
);

import { default as DefaultYoutubeIcon } from '~icons/lucide/youtube';

/**
 * @see https://lucide.dev/icons/youtube
 */
export const YoutubeIcon = (props: IconProps) => (
  <Icon icon={DefaultYoutubeIcon} {...props} />
);

import { default as DefaultZapIcon } from '~icons/lucide/zap';

/**
 * @see https://lucide.dev/icons/zap
 */
export const ZapIcon = (props: IconProps) => (
  <Icon icon={DefaultZapIcon} {...props} />
);

import { default as DefaultZapOffIcon } from '~icons/lucide/zap-off';

/**
 * @see https://lucide.dev/icons/zap-off
 */
export const ZapOffIcon = (props: IconProps) => (
  <Icon icon={DefaultZapOffIcon} {...props} />
);

import { default as DefaultZoomInIcon } from '~icons/lucide/zoom-in';

/**
 * @see https://lucide.dev/icons/zoom-in
 */
export const ZoomInIcon = (props: IconProps) => (
  <Icon icon={DefaultZoomInIcon} {...props} />
);

import { default as DefaultZoomOutIcon } from '~icons/lucide/zoom-out';

/**
 * @see https://lucide.dev/icons/zoom-out
 */
export const ZoomOutIcon = (props: IconProps) => (
  <Icon icon={DefaultZoomOutIcon} {...props} />
);

import { default as DefaultMarketMessagesIcon } from '~icons/prismacide/market-messages';

export const MarketMessagesIcon = (props: IconProps) => (
  <Icon icon={DefaultMarketMessagesIcon} {...props} />
);

import { default as DefaultShippersIcon } from '~icons/prismacide/shippers';

export const ShippersIcon = (props: IconProps) => (
  <Icon icon={DefaultShippersIcon} {...props} />
);
